var Uo = Object.defineProperty;
var Wo = (e, n, t) => n in e ? Uo(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var Vt = (e, n, t) => Wo(e, typeof n != "symbol" ? n + "" : n, t);
import { provide as Nt, inject as Pt, defineComponent as K, mergeModels as De, useModel as Me, ref as N, computed as D, watch as re, openBlock as v, createElementBlock as g, Fragment as G, withDirectives as be, createElementVNode as w, mergeProps as et, vModelDynamic as Zr, normalizeClass as j, toDisplayString as S, createStaticVNode as an, onMounted as we, onBeforeUnmount as Ze, nextTick as He, createBlock as Z, resolveDynamicComponent as tt, withModifiers as Ee, normalizeStyle as xe, withCtx as le, unref as ee, renderSlot as ce, createCommentVNode as I, renderList as Q, useTemplateRef as Ge, createVNode as z, vModelText as pt, useSlots as Dt, createTextVNode as he, watchEffect as Wn, resolveComponent as zr, useAttrs as Zo, onUnmounted as lt, vModelCheckbox as jr, vModelRadio as Zt, resolveDirective as ze, reactive as Zn, isRef as Yr, useId as Mn, toRef as zo, Teleport as jo, normalizeProps as Yo, isReactive as nr, vShow as qo, createApp as Xo } from "vue";
const qr = Symbol("FormFieldContext"), Xr = Symbol("FormContext");
function Jo(e) {
  Nt(qr, e);
}
function ln() {
  return Pt(qr, void 0);
}
function Jr(e) {
  Nt(Xr, e);
}
function Qo() {
  return Pt(Xr, void 0);
}
const ea = ["type", "autocomplete", "name", "placeholder", "disabled"], Ve = /* @__PURE__ */ K({
  __name: "TextInput",
  props: /* @__PURE__ */ De({
    placeholder: {},
    name: {},
    type: {},
    disabled: { type: Boolean },
    autocomplete: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ De(["blur", "focus", "keypress", "keydown", "keyenter"], ["update:modelValue"]),
  setup(e, { expose: n, emit: t }) {
    const [r, a] = Me(e, "modelValue"), o = t;
    n({
      setError: m,
      focus: $,
      blur: y,
      select: p,
      scrollIntoView: b
    });
    const l = N(), i = N(r.value), s = N(!1);
    let u;
    const c = ln(), f = D(() => {
      if (!c) return {};
      const x = [
        c.hasDescription.value ? c.descriptionId : null,
        c.hasError.value ? c.errorId : null
      ].filter(Boolean).join(" "), _ = c.invalid.value || !!s.value;
      return {
        id: c.fieldId,
        "aria-invalid": _ ? "true" : void 0,
        "aria-errormessage": c.hasError.value ? c.errorId : void 0,
        "aria-describedby": x || void 0
      };
    });
    re(() => r.value, (x) => {
      i.value = x;
    }), re(i, (x) => {
      x !== r.value && x !== void 0 && x !== null && (s.value = !1, u && clearTimeout(u), a.debounce ? u = setTimeout(() => {
        r.value = x;
      }, 200) : a.lazy || (r.value = x));
    });
    const d = D(() => {
      var x = ["text-input"];
      return s.value && x.push("text-input--error"), typeof r.value == "string" && r.value.trim().length > 0 ? x.push("text-input--has-value") : x.push("text-input--empty"), x;
    });
    function m(x) {
      x ? s.value = x : s.value = !0;
    }
    function $() {
      var x;
      (x = l.value) == null || x.focus();
    }
    function y() {
      var x;
      (x = l.value) == null || x.blur();
    }
    function p() {
      l.value && l.value.select();
    }
    function h(x) {
      o("keydown", x), x.key === "Enter" && o("keyenter", x);
    }
    function b() {
      l.value && l.value.scrollIntoView();
    }
    function C(x) {
      o("blur", x), a.lazy && (r.value = i.value);
    }
    return (x, _) => (v(), g(G, null, [
      be(w("input", et({
        class: d.value,
        type: e.type ? e.type : "text",
        autocomplete: e.autocomplete ? e.autocomplete : "on",
        name: e.name,
        "onUpdate:modelValue": _[0] || (_[0] = (T) => i.value = T),
        placeholder: e.placeholder,
        onBlur: C,
        onFocus: _[1] || (_[1] = (T) => o("focus", T)),
        onKeypress: _[2] || (_[2] = (T) => o("keypress", T)),
        onKeydown: h,
        ref_key: "element",
        ref: l,
        disabled: e.disabled
      }, { ...f.value, ...x.$attrs }), null, 16, ea), [
        [Zr, i.value]
      ]),
      w("div", {
        class: j(["text-input__error-message", { "text-input__error-message--hidden": typeof s.value != "string" }])
      }, S(s.value), 3)
    ], 64));
  }
}), Y = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [r, a] of n)
    t[r] = a;
  return t;
}, ta = {}, na = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function ra(e, n) {
  return v(), g("svg", na, [...n[0] || (n[0] = [
    an('<rect width="256" height="256" fill="none"></rect><rect x="40" y="40" width="176" height="176" rx="8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></rect><line x1="176" y1="24" x2="176" y2="56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="80" y1="24" x2="80" y2="56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="40" y1="88" x2="216" y2="88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>', 5)
  ])]);
}
const It = /* @__PURE__ */ Y(ta, [["render", ra]]), sn = Symbol("close");
function oa() {
  const e = Pt(sn);
  return () => {
    e == null || e();
  };
}
const aa = { class: "dropdown-menu__items" }, la = /* @__PURE__ */ K({
  // Prevent parent from adding "open" dialog attribute
  inheritAttrs: !1,
  __name: "DropdownMenu",
  props: {
    target: {},
    popover: { type: Boolean }
  },
  emits: ["close", "open"],
  setup(e, { expose: n, emit: t }) {
    const r = e;
    n({
      open: u,
      close: f,
      isOpen: s
    });
    const a = t, o = N(), l = N({});
    let i = !1;
    Nt(sn, f);
    function s() {
      return i;
    }
    function u() {
      var h, b;
      r.popover ? (h = o.value) == null || h.showPopover({
        source: r.target instanceof Element ? r.target : void 0
      }) : (b = o.value) == null || b.showModal(), i = !0, $(), a("open");
    }
    function c() {
      var h, b;
      r.popover ? (h = o.value) == null || h.hidePopover() : (b = o.value) == null || b.close();
    }
    function f() {
      c(), i = !1, a("close");
    }
    const d = new MutationObserver($);
    we(() => {
      var h;
      (h = o.value) == null || h.addEventListener("close", f), d.observe(o.value, {
        attributes: !0,
        childList: !0,
        subtree: !0
      });
    }), Ze(() => {
      var h;
      (h = o.value) == null || h.removeEventListener("close", f), i && c(), d.disconnect();
    });
    function m(h) {
      o.value && h.target === o.value && f();
    }
    function $() {
      if (o.value)
        if (r.target instanceof Element) {
          const h = r.target.getBoundingClientRect();
          l.value = { visibility: "hidden" }, He(() => {
            if (!o.value)
              return;
            const b = o.value.getBoundingClientRect(), C = h.left - Math.max(0, h.left + b.width + 5 - document.documentElement.clientWidth);
            let x = Math.min(document.documentElement.clientHeight - h.top - h.height, 500), _ = h.width;
            if (_ < 200 && (_ = 200), x < b.height && h.top > x) {
              x = Math.min(b.height, h.top, 500), l.value = {
                top: `${h.top - x}px`,
                left: `${C}px`,
                minWidth: `${_}px`,
                visibility: "visible",
                maxHeight: `${x}px`
              };
              return;
            }
            l.value = {
              top: `${h.top + h.height}px`,
              left: `${C}px`,
              minWidth: `${_}px`,
              visibility: "visible",
              maxHeight: `${x}px`
            };
          });
        } else {
          const h = r.target;
          if (!h)
            return;
          const b = o.value.getBoundingClientRect(), C = h.x - Math.max(0, h.x + 5 - document.documentElement.clientWidth);
          let x = h.y;
          x + b.height > document.documentElement.clientHeight && (h.y - b.height > 0 ? x = h.y - b.height : x = document.documentElement.clientHeight - b.height), l.value = {
            top: `${x}px`,
            left: `${C}px`,
            minWidth: "100px",
            visibility: "visible"
          };
        }
    }
    const y = D(() => r.popover ? "div" : "dialog"), p = D(() => {
      if (r.popover)
        return "manual";
    });
    return (h, b) => (v(), Z(tt(y.value), {
      ref_key: "dropdown",
      ref: o,
      onClick: Ee(m, ["stop"]),
      onContextmenu: Ee(m, ["stop", "prevent"]),
      class: "dropdown-menu neat-scroll",
      style: xe(l.value),
      popover: p.value
    }, {
      default: le(() => [
        w("ul", aa, [
          ee(i) ? ce(h.$slots, "default", { key: 0 }, void 0, !0) : I("", !0),
          b[0] || (b[0] = w("li", { class: "no-options" }, " No available options ", -1))
        ])
      ]),
      _: 3
    }, 40, ["style", "popover"]));
  }
}), je = /* @__PURE__ */ Y(la, [["__scopeId", "data-v-bab3ebe1"]]);
/*!
 *  decimal.js v10.4.3
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var Ct = 9e15, vt = 1e9, Pn = "0123456789abcdef", qt = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", Xt = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", In = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -Ct,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: Ct,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, Qr, at, fe = !0, un = "[DecimalError] ", ft = un + "Invalid argument: ", eo = un + "Precision limit exceeded", to = un + "crypto unavailable", no = "[object Decimal]", Oe = Math.floor, Pe = Math.pow, ia = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, sa = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, ua = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, ro = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Je = 1e7, se = 7, da = 9007199254740991, ca = qt.length - 1, Fn = Xt.length - 1, V = { toStringTag: no };
V.absoluteValue = V.abs = function() {
  var e = new this.constructor(this);
  return e.s < 0 && (e.s = 1), ae(e);
};
V.ceil = function() {
  return ae(new this.constructor(this), this.e + 1, 2);
};
V.clampedTo = V.clamp = function(e, n) {
  var t, r = this, a = r.constructor;
  if (e = new a(e), n = new a(n), !e.s || !n.s) return new a(NaN);
  if (e.gt(n)) throw Error(ft + n);
  return t = r.cmp(e), t < 0 ? e : r.cmp(n) > 0 ? n : new a(r);
};
V.comparedTo = V.cmp = function(e) {
  var n, t, r, a, o = this, l = o.d, i = (e = new o.constructor(e)).d, s = o.s, u = e.s;
  if (!l || !i)
    return !s || !u ? NaN : s !== u ? s : l === i ? 0 : !l ^ s < 0 ? 1 : -1;
  if (!l[0] || !i[0]) return l[0] ? s : i[0] ? -u : 0;
  if (s !== u) return s;
  if (o.e !== e.e) return o.e > e.e ^ s < 0 ? 1 : -1;
  for (r = l.length, a = i.length, n = 0, t = r < a ? r : a; n < t; ++n)
    if (l[n] !== i[n]) return l[n] > i[n] ^ s < 0 ? 1 : -1;
  return r === a ? 0 : r > a ^ s < 0 ? 1 : -1;
};
V.cosine = V.cos = function() {
  var e, n, t = this, r = t.constructor;
  return t.d ? t.d[0] ? (e = r.precision, n = r.rounding, r.precision = e + Math.max(t.e, t.sd()) + se, r.rounding = 1, t = fa(r, so(r, t)), r.precision = e, r.rounding = n, ae(at == 2 || at == 3 ? t.neg() : t, e, n, !0)) : new r(1) : new r(NaN);
};
V.cubeRoot = V.cbrt = function() {
  var e, n, t, r, a, o, l, i, s, u, c = this, f = c.constructor;
  if (!c.isFinite() || c.isZero()) return new f(c);
  for (fe = !1, o = c.s * Pe(c.s * c, 1 / 3), !o || Math.abs(o) == 1 / 0 ? (t = Re(c.d), e = c.e, (o = (e - t.length + 1) % 3) && (t += o == 1 || o == -2 ? "0" : "00"), o = Pe(t, 1 / 3), e = Oe((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2)), o == 1 / 0 ? t = "5e" + e : (t = o.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), r = new f(t), r.s = c.s) : r = new f(o.toString()), l = (e = f.precision) + 3; ; )
    if (i = r, s = i.times(i).times(i), u = s.plus(c), r = _e(u.plus(c).times(i), u.plus(s), l + 2, 1), Re(i.d).slice(0, l) === (t = Re(r.d)).slice(0, l))
      if (t = t.slice(l - 3, l + 1), t == "9999" || !a && t == "4999") {
        if (!a && (ae(i, e + 1, 0), i.times(i).times(i).eq(c))) {
          r = i;
          break;
        }
        l += 4, a = 1;
      } else {
        (!+t || !+t.slice(1) && t.charAt(0) == "5") && (ae(r, e + 1, 1), n = !r.times(r).times(r).eq(c));
        break;
      }
  return fe = !0, ae(r, e, f.rounding, n);
};
V.decimalPlaces = V.dp = function() {
  var e, n = this.d, t = NaN;
  if (n) {
    if (e = n.length - 1, t = (e - Oe(this.e / se)) * se, e = n[e], e) for (; e % 10 == 0; e /= 10) t--;
    t < 0 && (t = 0);
  }
  return t;
};
V.dividedBy = V.div = function(e) {
  return _e(this, new this.constructor(e));
};
V.dividedToIntegerBy = V.divToInt = function(e) {
  var n = this, t = n.constructor;
  return ae(_e(n, new t(e), 0, 1, 1), t.precision, t.rounding);
};
V.equals = V.eq = function(e) {
  return this.cmp(e) === 0;
};
V.floor = function() {
  return ae(new this.constructor(this), this.e + 1, 3);
};
V.greaterThan = V.gt = function(e) {
  return this.cmp(e) > 0;
};
V.greaterThanOrEqualTo = V.gte = function(e) {
  var n = this.cmp(e);
  return n == 1 || n === 0;
};
V.hyperbolicCosine = V.cosh = function() {
  var e, n, t, r, a, o = this, l = o.constructor, i = new l(1);
  if (!o.isFinite()) return new l(o.s ? 1 / 0 : NaN);
  if (o.isZero()) return i;
  t = l.precision, r = l.rounding, l.precision = t + Math.max(o.e, o.sd()) + 4, l.rounding = 1, a = o.d.length, a < 32 ? (e = Math.ceil(a / 3), n = (1 / cn(4, e)).toString()) : (e = 16, n = "2.3283064365386962890625e-10"), o = _t(l, 1, o.times(n), new l(1), !0);
  for (var s, u = e, c = new l(8); u--; )
    s = o.times(o), o = i.minus(s.times(c.minus(s.times(c))));
  return ae(o, l.precision = t, l.rounding = r, !0);
};
V.hyperbolicSine = V.sinh = function() {
  var e, n, t, r, a = this, o = a.constructor;
  if (!a.isFinite() || a.isZero()) return new o(a);
  if (n = o.precision, t = o.rounding, o.precision = n + Math.max(a.e, a.sd()) + 4, o.rounding = 1, r = a.d.length, r < 3)
    a = _t(o, 2, a, a, !0);
  else {
    e = 1.4 * Math.sqrt(r), e = e > 16 ? 16 : e | 0, a = a.times(1 / cn(5, e)), a = _t(o, 2, a, a, !0);
    for (var l, i = new o(5), s = new o(16), u = new o(20); e--; )
      l = a.times(a), a = a.times(i.plus(l.times(s.times(l).plus(u))));
  }
  return o.precision = n, o.rounding = t, ae(a, n, t, !0);
};
V.hyperbolicTangent = V.tanh = function() {
  var e, n, t = this, r = t.constructor;
  return t.isFinite() ? t.isZero() ? new r(t) : (e = r.precision, n = r.rounding, r.precision = e + 7, r.rounding = 1, _e(t.sinh(), t.cosh(), r.precision = e, r.rounding = n)) : new r(t.s);
};
V.inverseCosine = V.acos = function() {
  var e, n = this, t = n.constructor, r = n.abs().cmp(1), a = t.precision, o = t.rounding;
  return r !== -1 ? r === 0 ? n.isNeg() ? Xe(t, a, o) : new t(0) : new t(NaN) : n.isZero() ? Xe(t, a + 4, o).times(0.5) : (t.precision = a + 6, t.rounding = 1, n = n.asin(), e = Xe(t, a + 4, o).times(0.5), t.precision = a, t.rounding = o, e.minus(n));
};
V.inverseHyperbolicCosine = V.acosh = function() {
  var e, n, t = this, r = t.constructor;
  return t.lte(1) ? new r(t.eq(1) ? 0 : NaN) : t.isFinite() ? (e = r.precision, n = r.rounding, r.precision = e + Math.max(Math.abs(t.e), t.sd()) + 4, r.rounding = 1, fe = !1, t = t.times(t).minus(1).sqrt().plus(t), fe = !0, r.precision = e, r.rounding = n, t.ln()) : new r(t);
};
V.inverseHyperbolicSine = V.asinh = function() {
  var e, n, t = this, r = t.constructor;
  return !t.isFinite() || t.isZero() ? new r(t) : (e = r.precision, n = r.rounding, r.precision = e + 2 * Math.max(Math.abs(t.e), t.sd()) + 6, r.rounding = 1, fe = !1, t = t.times(t).plus(1).sqrt().plus(t), fe = !0, r.precision = e, r.rounding = n, t.ln());
};
V.inverseHyperbolicTangent = V.atanh = function() {
  var e, n, t, r, a = this, o = a.constructor;
  return a.isFinite() ? a.e >= 0 ? new o(a.abs().eq(1) ? a.s / 0 : a.isZero() ? a : NaN) : (e = o.precision, n = o.rounding, r = a.sd(), Math.max(r, e) < 2 * -a.e - 1 ? ae(new o(a), e, n, !0) : (o.precision = t = r - a.e, a = _e(a.plus(1), new o(1).minus(a), t + e, 1), o.precision = e + 4, o.rounding = 1, a = a.ln(), o.precision = e, o.rounding = n, a.times(0.5))) : new o(NaN);
};
V.inverseSine = V.asin = function() {
  var e, n, t, r, a = this, o = a.constructor;
  return a.isZero() ? new o(a) : (n = a.abs().cmp(1), t = o.precision, r = o.rounding, n !== -1 ? n === 0 ? (e = Xe(o, t + 4, r).times(0.5), e.s = a.s, e) : new o(NaN) : (o.precision = t + 6, o.rounding = 1, a = a.div(new o(1).minus(a.times(a)).sqrt().plus(1)).atan(), o.precision = t, o.rounding = r, a.times(2)));
};
V.inverseTangent = V.atan = function() {
  var e, n, t, r, a, o, l, i, s, u = this, c = u.constructor, f = c.precision, d = c.rounding;
  if (u.isFinite()) {
    if (u.isZero())
      return new c(u);
    if (u.abs().eq(1) && f + 4 <= Fn)
      return l = Xe(c, f + 4, d).times(0.25), l.s = u.s, l;
  } else {
    if (!u.s) return new c(NaN);
    if (f + 4 <= Fn)
      return l = Xe(c, f + 4, d).times(0.5), l.s = u.s, l;
  }
  for (c.precision = i = f + 10, c.rounding = 1, t = Math.min(28, i / se + 2 | 0), e = t; e; --e) u = u.div(u.times(u).plus(1).sqrt().plus(1));
  for (fe = !1, n = Math.ceil(i / se), r = 1, s = u.times(u), l = new c(u), a = u; e !== -1; )
    if (a = a.times(s), o = l.minus(a.div(r += 2)), a = a.times(s), l = o.plus(a.div(r += 2)), l.d[n] !== void 0) for (e = n; l.d[e] === o.d[e] && e--; ) ;
  return t && (l = l.times(2 << t - 1)), fe = !0, ae(l, c.precision = f, c.rounding = d, !0);
};
V.isFinite = function() {
  return !!this.d;
};
V.isInteger = V.isInt = function() {
  return !!this.d && Oe(this.e / se) > this.d.length - 2;
};
V.isNaN = function() {
  return !this.s;
};
V.isNegative = V.isNeg = function() {
  return this.s < 0;
};
V.isPositive = V.isPos = function() {
  return this.s > 0;
};
V.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
V.lessThan = V.lt = function(e) {
  return this.cmp(e) < 0;
};
V.lessThanOrEqualTo = V.lte = function(e) {
  return this.cmp(e) < 1;
};
V.logarithm = V.log = function(e) {
  var n, t, r, a, o, l, i, s, u = this, c = u.constructor, f = c.precision, d = c.rounding, m = 5;
  if (e == null)
    e = new c(10), n = !0;
  else {
    if (e = new c(e), t = e.d, e.s < 0 || !t || !t[0] || e.eq(1)) return new c(NaN);
    n = e.eq(10);
  }
  if (t = u.d, u.s < 0 || !t || !t[0] || u.eq(1))
    return new c(t && !t[0] ? -1 / 0 : u.s != 1 ? NaN : t ? 0 : 1 / 0);
  if (n)
    if (t.length > 1)
      o = !0;
    else {
      for (a = t[0]; a % 10 === 0; ) a /= 10;
      o = a !== 1;
    }
  if (fe = !1, i = f + m, l = ut(u, i), r = n ? Jt(c, i + 10) : ut(e, i), s = _e(l, r, i, 1), St(s.d, a = f, d))
    do
      if (i += 10, l = ut(u, i), r = n ? Jt(c, i + 10) : ut(e, i), s = _e(l, r, i, 1), !o) {
        +Re(s.d).slice(a + 1, a + 15) + 1 == 1e14 && (s = ae(s, f + 1, 0));
        break;
      }
    while (St(s.d, a += 10, d));
  return fe = !0, ae(s, f, d);
};
V.minus = V.sub = function(e) {
  var n, t, r, a, o, l, i, s, u, c, f, d, m = this, $ = m.constructor;
  if (e = new $(e), !m.d || !e.d)
    return !m.s || !e.s ? e = new $(NaN) : m.d ? e.s = -e.s : e = new $(e.d || m.s !== e.s ? m : NaN), e;
  if (m.s != e.s)
    return e.s = -e.s, m.plus(e);
  if (u = m.d, d = e.d, i = $.precision, s = $.rounding, !u[0] || !d[0]) {
    if (d[0]) e.s = -e.s;
    else if (u[0]) e = new $(m);
    else return new $(s === 3 ? -0 : 0);
    return fe ? ae(e, i, s) : e;
  }
  if (t = Oe(e.e / se), c = Oe(m.e / se), u = u.slice(), o = c - t, o) {
    for (f = o < 0, f ? (n = u, o = -o, l = d.length) : (n = d, t = c, l = u.length), r = Math.max(Math.ceil(i / se), l) + 2, o > r && (o = r, n.length = 1), n.reverse(), r = o; r--; ) n.push(0);
    n.reverse();
  } else {
    for (r = u.length, l = d.length, f = r < l, f && (l = r), r = 0; r < l; r++)
      if (u[r] != d[r]) {
        f = u[r] < d[r];
        break;
      }
    o = 0;
  }
  for (f && (n = u, u = d, d = n, e.s = -e.s), l = u.length, r = d.length - l; r > 0; --r) u[l++] = 0;
  for (r = d.length; r > o; ) {
    if (u[--r] < d[r]) {
      for (a = r; a && u[--a] === 0; ) u[a] = Je - 1;
      --u[a], u[r] += Je;
    }
    u[r] -= d[r];
  }
  for (; u[--l] === 0; ) u.pop();
  for (; u[0] === 0; u.shift()) --t;
  return u[0] ? (e.d = u, e.e = dn(u, t), fe ? ae(e, i, s) : e) : new $(s === 3 ? -0 : 0);
};
V.modulo = V.mod = function(e) {
  var n, t = this, r = t.constructor;
  return e = new r(e), !t.d || !e.s || e.d && !e.d[0] ? new r(NaN) : !e.d || t.d && !t.d[0] ? ae(new r(t), r.precision, r.rounding) : (fe = !1, r.modulo == 9 ? (n = _e(t, e.abs(), 0, 3, 1), n.s *= e.s) : n = _e(t, e, 0, r.modulo, 1), n = n.times(e), fe = !0, t.minus(n));
};
V.naturalExponential = V.exp = function() {
  return An(this);
};
V.naturalLogarithm = V.ln = function() {
  return ut(this);
};
V.negated = V.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s, ae(e);
};
V.plus = V.add = function(e) {
  var n, t, r, a, o, l, i, s, u, c, f = this, d = f.constructor;
  if (e = new d(e), !f.d || !e.d)
    return !f.s || !e.s ? e = new d(NaN) : f.d || (e = new d(e.d || f.s === e.s ? f : NaN)), e;
  if (f.s != e.s)
    return e.s = -e.s, f.minus(e);
  if (u = f.d, c = e.d, i = d.precision, s = d.rounding, !u[0] || !c[0])
    return c[0] || (e = new d(f)), fe ? ae(e, i, s) : e;
  if (o = Oe(f.e / se), r = Oe(e.e / se), u = u.slice(), a = o - r, a) {
    for (a < 0 ? (t = u, a = -a, l = c.length) : (t = c, r = o, l = u.length), o = Math.ceil(i / se), l = o > l ? o + 1 : l + 1, a > l && (a = l, t.length = 1), t.reverse(); a--; ) t.push(0);
    t.reverse();
  }
  for (l = u.length, a = c.length, l - a < 0 && (a = l, t = c, c = u, u = t), n = 0; a; )
    n = (u[--a] = u[a] + c[a] + n) / Je | 0, u[a] %= Je;
  for (n && (u.unshift(n), ++r), l = u.length; u[--l] == 0; ) u.pop();
  return e.d = u, e.e = dn(u, r), fe ? ae(e, i, s) : e;
};
V.precision = V.sd = function(e) {
  var n, t = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(ft + e);
  return t.d ? (n = oo(t.d), e && t.e + 1 > n && (n = t.e + 1)) : n = NaN, n;
};
V.round = function() {
  var e = this, n = e.constructor;
  return ae(new n(e), e.e + 1, n.rounding);
};
V.sine = V.sin = function() {
  var e, n, t = this, r = t.constructor;
  return t.isFinite() ? t.isZero() ? new r(t) : (e = r.precision, n = r.rounding, r.precision = e + Math.max(t.e, t.sd()) + se, r.rounding = 1, t = va(r, so(r, t)), r.precision = e, r.rounding = n, ae(at > 2 ? t.neg() : t, e, n, !0)) : new r(NaN);
};
V.squareRoot = V.sqrt = function() {
  var e, n, t, r, a, o, l = this, i = l.d, s = l.e, u = l.s, c = l.constructor;
  if (u !== 1 || !i || !i[0])
    return new c(!u || u < 0 && (!i || i[0]) ? NaN : i ? l : 1 / 0);
  for (fe = !1, u = Math.sqrt(+l), u == 0 || u == 1 / 0 ? (n = Re(i), (n.length + s) % 2 == 0 && (n += "0"), u = Math.sqrt(n), s = Oe((s + 1) / 2) - (s < 0 || s % 2), u == 1 / 0 ? n = "5e" + s : (n = u.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + s), r = new c(n)) : r = new c(u.toString()), t = (s = c.precision) + 3; ; )
    if (o = r, r = o.plus(_e(l, o, t + 2, 1)).times(0.5), Re(o.d).slice(0, t) === (n = Re(r.d)).slice(0, t))
      if (n = n.slice(t - 3, t + 1), n == "9999" || !a && n == "4999") {
        if (!a && (ae(o, s + 1, 0), o.times(o).eq(l))) {
          r = o;
          break;
        }
        t += 4, a = 1;
      } else {
        (!+n || !+n.slice(1) && n.charAt(0) == "5") && (ae(r, s + 1, 1), e = !r.times(r).eq(l));
        break;
      }
  return fe = !0, ae(r, s, c.rounding, e);
};
V.tangent = V.tan = function() {
  var e, n, t = this, r = t.constructor;
  return t.isFinite() ? t.isZero() ? new r(t) : (e = r.precision, n = r.rounding, r.precision = e + 10, r.rounding = 1, t = t.sin(), t.s = 1, t = _e(t, new r(1).minus(t.times(t)).sqrt(), e + 10, 0), r.precision = e, r.rounding = n, ae(at == 2 || at == 4 ? t.neg() : t, e, n, !0)) : new r(NaN);
};
V.times = V.mul = function(e) {
  var n, t, r, a, o, l, i, s, u, c = this, f = c.constructor, d = c.d, m = (e = new f(e)).d;
  if (e.s *= c.s, !d || !d[0] || !m || !m[0])
    return new f(!e.s || d && !d[0] && !m || m && !m[0] && !d ? NaN : !d || !m ? e.s / 0 : e.s * 0);
  for (t = Oe(c.e / se) + Oe(e.e / se), s = d.length, u = m.length, s < u && (o = d, d = m, m = o, l = s, s = u, u = l), o = [], l = s + u, r = l; r--; ) o.push(0);
  for (r = u; --r >= 0; ) {
    for (n = 0, a = s + r; a > r; )
      i = o[a] + m[r] * d[a - r - 1] + n, o[a--] = i % Je | 0, n = i / Je | 0;
    o[a] = (o[a] + n) % Je | 0;
  }
  for (; !o[--l]; ) o.pop();
  return n ? ++t : o.shift(), e.d = o, e.e = dn(o, t), fe ? ae(e, f.precision, f.rounding) : e;
};
V.toBinary = function(e, n) {
  return zn(this, 2, e, n);
};
V.toDecimalPlaces = V.toDP = function(e, n) {
  var t = this, r = t.constructor;
  return t = new r(t), e === void 0 ? t : (Ue(e, 0, vt), n === void 0 ? n = r.rounding : Ue(n, 0, 8), ae(t, e + t.e + 1, n));
};
V.toExponential = function(e, n) {
  var t, r = this, a = r.constructor;
  return e === void 0 ? t = nt(r, !0) : (Ue(e, 0, vt), n === void 0 ? n = a.rounding : Ue(n, 0, 8), r = ae(new a(r), e + 1, n), t = nt(r, !0, e + 1)), r.isNeg() && !r.isZero() ? "-" + t : t;
};
V.toFixed = function(e, n) {
  var t, r, a = this, o = a.constructor;
  return e === void 0 ? t = nt(a) : (Ue(e, 0, vt), n === void 0 ? n = o.rounding : Ue(n, 0, 8), r = ae(new o(a), e + a.e + 1, n), t = nt(r, !1, e + r.e + 1)), a.isNeg() && !a.isZero() ? "-" + t : t;
};
V.toFraction = function(e) {
  var n, t, r, a, o, l, i, s, u, c, f, d, m = this, $ = m.d, y = m.constructor;
  if (!$) return new y(m);
  if (u = t = new y(1), r = s = new y(0), n = new y(r), o = n.e = oo($) - m.e - 1, l = o % se, n.d[0] = Pe(10, l < 0 ? se + l : l), e == null)
    e = o > 0 ? n : u;
  else {
    if (i = new y(e), !i.isInt() || i.lt(u)) throw Error(ft + i);
    e = i.gt(n) ? o > 0 ? n : u : i;
  }
  for (fe = !1, i = new y(Re($)), c = y.precision, y.precision = o = $.length * se * 2; f = _e(i, n, 0, 1, 1), a = t.plus(f.times(r)), a.cmp(e) != 1; )
    t = r, r = a, a = u, u = s.plus(f.times(a)), s = a, a = n, n = i.minus(f.times(a)), i = a;
  return a = _e(e.minus(t), r, 0, 1, 1), s = s.plus(a.times(u)), t = t.plus(a.times(r)), s.s = u.s = m.s, d = _e(u, r, o, 1).minus(m).abs().cmp(_e(s, t, o, 1).minus(m).abs()) < 1 ? [u, r] : [s, t], y.precision = c, fe = !0, d;
};
V.toHexadecimal = V.toHex = function(e, n) {
  return zn(this, 16, e, n);
};
V.toNearest = function(e, n) {
  var t = this, r = t.constructor;
  if (t = new r(t), e == null) {
    if (!t.d) return t;
    e = new r(1), n = r.rounding;
  } else {
    if (e = new r(e), n === void 0 ? n = r.rounding : Ue(n, 0, 8), !t.d) return e.s ? t : e;
    if (!e.d)
      return e.s && (e.s = t.s), e;
  }
  return e.d[0] ? (fe = !1, t = _e(t, e, 0, n, 1).times(e), fe = !0, ae(t)) : (e.s = t.s, t = e), t;
};
V.toNumber = function() {
  return +this;
};
V.toOctal = function(e, n) {
  return zn(this, 8, e, n);
};
V.toPower = V.pow = function(e) {
  var n, t, r, a, o, l, i = this, s = i.constructor, u = +(e = new s(e));
  if (!i.d || !e.d || !i.d[0] || !e.d[0]) return new s(Pe(+i, u));
  if (i = new s(i), i.eq(1)) return i;
  if (r = s.precision, o = s.rounding, e.eq(1)) return ae(i, r, o);
  if (n = Oe(e.e / se), n >= e.d.length - 1 && (t = u < 0 ? -u : u) <= da)
    return a = ao(s, i, t, r), e.s < 0 ? new s(1).div(a) : ae(a, r, o);
  if (l = i.s, l < 0) {
    if (n < e.d.length - 1) return new s(NaN);
    if (e.d[n] & 1 || (l = 1), i.e == 0 && i.d[0] == 1 && i.d.length == 1)
      return i.s = l, i;
  }
  return t = Pe(+i, u), n = t == 0 || !isFinite(t) ? Oe(u * (Math.log("0." + Re(i.d)) / Math.LN10 + i.e + 1)) : new s(t + "").e, n > s.maxE + 1 || n < s.minE - 1 ? new s(n > 0 ? l / 0 : 0) : (fe = !1, s.rounding = i.s = 1, t = Math.min(12, (n + "").length), a = An(e.times(ut(i, r + t)), r), a.d && (a = ae(a, r + 5, 1), St(a.d, r, o) && (n = r + 10, a = ae(An(e.times(ut(i, n + t)), n), n + 5, 1), +Re(a.d).slice(r + 1, r + 15) + 1 == 1e14 && (a = ae(a, r + 1, 0)))), a.s = l, fe = !0, s.rounding = o, ae(a, r, o));
};
V.toPrecision = function(e, n) {
  var t, r = this, a = r.constructor;
  return e === void 0 ? t = nt(r, r.e <= a.toExpNeg || r.e >= a.toExpPos) : (Ue(e, 1, vt), n === void 0 ? n = a.rounding : Ue(n, 0, 8), r = ae(new a(r), e, n), t = nt(r, e <= r.e || r.e <= a.toExpNeg, e)), r.isNeg() && !r.isZero() ? "-" + t : t;
};
V.toSignificantDigits = V.toSD = function(e, n) {
  var t = this, r = t.constructor;
  return e === void 0 ? (e = r.precision, n = r.rounding) : (Ue(e, 1, vt), n === void 0 ? n = r.rounding : Ue(n, 0, 8)), ae(new r(t), e, n);
};
V.toString = function() {
  var e = this, n = e.constructor, t = nt(e, e.e <= n.toExpNeg || e.e >= n.toExpPos);
  return e.isNeg() && !e.isZero() ? "-" + t : t;
};
V.truncated = V.trunc = function() {
  return ae(new this.constructor(this), this.e + 1, 1);
};
V.valueOf = V.toJSON = function() {
  var e = this, n = e.constructor, t = nt(e, e.e <= n.toExpNeg || e.e >= n.toExpPos);
  return e.isNeg() ? "-" + t : t;
};
function Re(e) {
  var n, t, r, a = e.length - 1, o = "", l = e[0];
  if (a > 0) {
    for (o += l, n = 1; n < a; n++)
      r = e[n] + "", t = se - r.length, t && (o += st(t)), o += r;
    l = e[n], r = l + "", t = se - r.length, t && (o += st(t));
  } else if (l === 0)
    return "0";
  for (; l % 10 === 0; ) l /= 10;
  return o + l;
}
function Ue(e, n, t) {
  if (e !== ~~e || e < n || e > t)
    throw Error(ft + e);
}
function St(e, n, t, r) {
  var a, o, l, i;
  for (o = e[0]; o >= 10; o /= 10) --n;
  return --n < 0 ? (n += se, a = 0) : (a = Math.ceil((n + 1) / se), n %= se), o = Pe(10, se - n), i = e[a] % o | 0, r == null ? n < 3 ? (n == 0 ? i = i / 100 | 0 : n == 1 && (i = i / 10 | 0), l = t < 4 && i == 99999 || t > 3 && i == 49999 || i == 5e4 || i == 0) : l = (t < 4 && i + 1 == o || t > 3 && i + 1 == o / 2) && (e[a + 1] / o / 100 | 0) == Pe(10, n - 2) - 1 || (i == o / 2 || i == 0) && (e[a + 1] / o / 100 | 0) == 0 : n < 4 ? (n == 0 ? i = i / 1e3 | 0 : n == 1 ? i = i / 100 | 0 : n == 2 && (i = i / 10 | 0), l = (r || t < 4) && i == 9999 || !r && t > 3 && i == 4999) : l = ((r || t < 4) && i + 1 == o || !r && t > 3 && i + 1 == o / 2) && (e[a + 1] / o / 1e3 | 0) == Pe(10, n - 3) - 1, l;
}
function zt(e, n, t) {
  for (var r, a = [0], o, l = 0, i = e.length; l < i; ) {
    for (o = a.length; o--; ) a[o] *= n;
    for (a[0] += Pn.indexOf(e.charAt(l++)), r = 0; r < a.length; r++)
      a[r] > t - 1 && (a[r + 1] === void 0 && (a[r + 1] = 0), a[r + 1] += a[r] / t | 0, a[r] %= t);
  }
  return a.reverse();
}
function fa(e, n) {
  var t, r, a;
  if (n.isZero()) return n;
  r = n.d.length, r < 32 ? (t = Math.ceil(r / 3), a = (1 / cn(4, t)).toString()) : (t = 16, a = "2.3283064365386962890625e-10"), e.precision += t, n = _t(e, 1, n.times(a), new e(1));
  for (var o = t; o--; ) {
    var l = n.times(n);
    n = l.times(l).minus(l).times(8).plus(1);
  }
  return e.precision -= t, n;
}
var _e = /* @__PURE__ */ function() {
  function e(r, a, o) {
    var l, i = 0, s = r.length;
    for (r = r.slice(); s--; )
      l = r[s] * a + i, r[s] = l % o | 0, i = l / o | 0;
    return i && r.unshift(i), r;
  }
  function n(r, a, o, l) {
    var i, s;
    if (o != l)
      s = o > l ? 1 : -1;
    else
      for (i = s = 0; i < o; i++)
        if (r[i] != a[i]) {
          s = r[i] > a[i] ? 1 : -1;
          break;
        }
    return s;
  }
  function t(r, a, o, l) {
    for (var i = 0; o--; )
      r[o] -= i, i = r[o] < a[o] ? 1 : 0, r[o] = i * l + r[o] - a[o];
    for (; !r[0] && r.length > 1; ) r.shift();
  }
  return function(r, a, o, l, i, s) {
    var u, c, f, d, m, $, y, p, h, b, C, x, _, T, W, F, P, E, L, J, ie = r.constructor, oe = r.s == a.s ? 1 : -1, O = r.d, H = a.d;
    if (!O || !O[0] || !H || !H[0])
      return new ie(
        // Return NaN if either NaN, or both Infinity or 0.
        !r.s || !a.s || (O ? H && O[0] == H[0] : !H) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          O && O[0] == 0 || !H ? oe * 0 : oe / 0
        )
      );
    for (s ? (m = 1, c = r.e - a.e) : (s = Je, m = se, c = Oe(r.e / m) - Oe(a.e / m)), L = H.length, P = O.length, h = new ie(oe), b = h.d = [], f = 0; H[f] == (O[f] || 0); f++) ;
    if (H[f] > (O[f] || 0) && c--, o == null ? (T = o = ie.precision, l = ie.rounding) : i ? T = o + (r.e - a.e) + 1 : T = o, T < 0)
      b.push(1), $ = !0;
    else {
      if (T = T / m + 2 | 0, f = 0, L == 1) {
        for (d = 0, H = H[0], T++; (f < P || d) && T--; f++)
          W = d * s + (O[f] || 0), b[f] = W / H | 0, d = W % H | 0;
        $ = d || f < P;
      } else {
        for (d = s / (H[0] + 1) | 0, d > 1 && (H = e(H, d, s), O = e(O, d, s), L = H.length, P = O.length), F = L, C = O.slice(0, L), x = C.length; x < L; ) C[x++] = 0;
        J = H.slice(), J.unshift(0), E = H[0], H[1] >= s / 2 && ++E;
        do
          d = 0, u = n(H, C, L, x), u < 0 ? (_ = C[0], L != x && (_ = _ * s + (C[1] || 0)), d = _ / E | 0, d > 1 ? (d >= s && (d = s - 1), y = e(H, d, s), p = y.length, x = C.length, u = n(y, C, p, x), u == 1 && (d--, t(y, L < p ? J : H, p, s))) : (d == 0 && (u = d = 1), y = H.slice()), p = y.length, p < x && y.unshift(0), t(C, y, x, s), u == -1 && (x = C.length, u = n(H, C, L, x), u < 1 && (d++, t(C, L < x ? J : H, x, s))), x = C.length) : u === 0 && (d++, C = [0]), b[f++] = d, u && C[0] ? C[x++] = O[F] || 0 : (C = [O[F]], x = 1);
        while ((F++ < P || C[0] !== void 0) && T--);
        $ = C[0] !== void 0;
      }
      b[0] || b.shift();
    }
    if (m == 1)
      h.e = c, Qr = $;
    else {
      for (f = 1, d = b[0]; d >= 10; d /= 10) f++;
      h.e = f + c * m - 1, ae(h, i ? o + h.e + 1 : o, l, $);
    }
    return h;
  };
}();
function ae(e, n, t, r) {
  var a, o, l, i, s, u, c, f, d, m = e.constructor;
  e: if (n != null) {
    if (f = e.d, !f) return e;
    for (a = 1, i = f[0]; i >= 10; i /= 10) a++;
    if (o = n - a, o < 0)
      o += se, l = n, c = f[d = 0], s = c / Pe(10, a - l - 1) % 10 | 0;
    else if (d = Math.ceil((o + 1) / se), i = f.length, d >= i)
      if (r) {
        for (; i++ <= d; ) f.push(0);
        c = s = 0, a = 1, o %= se, l = o - se + 1;
      } else
        break e;
    else {
      for (c = i = f[d], a = 1; i >= 10; i /= 10) a++;
      o %= se, l = o - se + a, s = l < 0 ? 0 : c / Pe(10, a - l - 1) % 10 | 0;
    }
    if (r = r || n < 0 || f[d + 1] !== void 0 || (l < 0 ? c : c % Pe(10, a - l - 1)), u = t < 4 ? (s || r) && (t == 0 || t == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (t == 4 || r || t == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (o > 0 ? l > 0 ? c / Pe(10, a - l) : 0 : f[d - 1]) % 10 & 1 || t == (e.s < 0 ? 8 : 7)), n < 1 || !f[0])
      return f.length = 0, u ? (n -= e.e + 1, f[0] = Pe(10, (se - n % se) % se), e.e = -n || 0) : f[0] = e.e = 0, e;
    if (o == 0 ? (f.length = d, i = 1, d--) : (f.length = d + 1, i = Pe(10, se - o), f[d] = l > 0 ? (c / Pe(10, a - l) % Pe(10, l) | 0) * i : 0), u)
      for (; ; )
        if (d == 0) {
          for (o = 1, l = f[0]; l >= 10; l /= 10) o++;
          for (l = f[0] += i, i = 1; l >= 10; l /= 10) i++;
          o != i && (e.e++, f[0] == Je && (f[0] = 1));
          break;
        } else {
          if (f[d] += i, f[d] != Je) break;
          f[d--] = 0, i = 1;
        }
    for (o = f.length; f[--o] === 0; ) f.pop();
  }
  return fe && (e.e > m.maxE ? (e.d = null, e.e = NaN) : e.e < m.minE && (e.e = 0, e.d = [0])), e;
}
function nt(e, n, t) {
  if (!e.isFinite()) return io(e);
  var r, a = e.e, o = Re(e.d), l = o.length;
  return n ? (t && (r = t - l) > 0 ? o = o.charAt(0) + "." + o.slice(1) + st(r) : l > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (e.e < 0 ? "e" : "e+") + e.e) : a < 0 ? (o = "0." + st(-a - 1) + o, t && (r = t - l) > 0 && (o += st(r))) : a >= l ? (o += st(a + 1 - l), t && (r = t - a - 1) > 0 && (o = o + "." + st(r))) : ((r = a + 1) < l && (o = o.slice(0, r) + "." + o.slice(r)), t && (r = t - l) > 0 && (a + 1 === l && (o += "."), o += st(r))), o;
}
function dn(e, n) {
  var t = e[0];
  for (n *= se; t >= 10; t /= 10) n++;
  return n;
}
function Jt(e, n, t) {
  if (n > ca)
    throw fe = !0, t && (e.precision = t), Error(eo);
  return ae(new e(qt), n, 1, !0);
}
function Xe(e, n, t) {
  if (n > Fn) throw Error(eo);
  return ae(new e(Xt), n, t, !0);
}
function oo(e) {
  var n = e.length - 1, t = n * se + 1;
  if (n = e[n], n) {
    for (; n % 10 == 0; n /= 10) t--;
    for (n = e[0]; n >= 10; n /= 10) t++;
  }
  return t;
}
function st(e) {
  for (var n = ""; e--; ) n += "0";
  return n;
}
function ao(e, n, t, r) {
  var a, o = new e(1), l = Math.ceil(r / se + 4);
  for (fe = !1; ; ) {
    if (t % 2 && (o = o.times(n), or(o.d, l) && (a = !0)), t = Oe(t / 2), t === 0) {
      t = o.d.length - 1, a && o.d[t] === 0 && ++o.d[t];
      break;
    }
    n = n.times(n), or(n.d, l);
  }
  return fe = !0, o;
}
function rr(e) {
  return e.d[e.d.length - 1] & 1;
}
function lo(e, n, t) {
  for (var r, a = new e(n[0]), o = 0; ++o < n.length; )
    if (r = new e(n[o]), r.s)
      a[t](r) && (a = r);
    else {
      a = r;
      break;
    }
  return a;
}
function An(e, n) {
  var t, r, a, o, l, i, s, u = 0, c = 0, f = 0, d = e.constructor, m = d.rounding, $ = d.precision;
  if (!e.d || !e.d[0] || e.e > 17)
    return new d(e.d ? e.d[0] ? e.s < 0 ? 0 : 1 / 0 : 1 : e.s ? e.s < 0 ? 0 : e : NaN);
  for (n == null ? (fe = !1, s = $) : s = n, i = new d(0.03125); e.e > -2; )
    e = e.times(i), f += 5;
  for (r = Math.log(Pe(2, f)) / Math.LN10 * 2 + 5 | 0, s += r, t = o = l = new d(1), d.precision = s; ; ) {
    if (o = ae(o.times(e), s, 1), t = t.times(++c), i = l.plus(_e(o, t, s, 1)), Re(i.d).slice(0, s) === Re(l.d).slice(0, s)) {
      for (a = f; a--; ) l = ae(l.times(l), s, 1);
      if (n == null)
        if (u < 3 && St(l.d, s - r, m, u))
          d.precision = s += 10, t = o = i = new d(1), c = 0, u++;
        else
          return ae(l, d.precision = $, m, fe = !0);
      else
        return d.precision = $, l;
    }
    l = i;
  }
}
function ut(e, n) {
  var t, r, a, o, l, i, s, u, c, f, d, m = 1, $ = 10, y = e, p = y.d, h = y.constructor, b = h.rounding, C = h.precision;
  if (y.s < 0 || !p || !p[0] || !y.e && p[0] == 1 && p.length == 1)
    return new h(p && !p[0] ? -1 / 0 : y.s != 1 ? NaN : p ? 0 : y);
  if (n == null ? (fe = !1, c = C) : c = n, h.precision = c += $, t = Re(p), r = t.charAt(0), Math.abs(o = y.e) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && t.charAt(1) > 3; )
      y = y.times(e), t = Re(y.d), r = t.charAt(0), m++;
    o = y.e, r > 1 ? (y = new h("0." + t), o++) : y = new h(r + "." + t.slice(1));
  } else
    return u = Jt(h, c + 2, C).times(o + ""), y = ut(new h(r + "." + t.slice(1)), c - $).plus(u), h.precision = C, n == null ? ae(y, C, b, fe = !0) : y;
  for (f = y, s = l = y = _e(y.minus(1), y.plus(1), c, 1), d = ae(y.times(y), c, 1), a = 3; ; ) {
    if (l = ae(l.times(d), c, 1), u = s.plus(_e(l, new h(a), c, 1)), Re(u.d).slice(0, c) === Re(s.d).slice(0, c))
      if (s = s.times(2), o !== 0 && (s = s.plus(Jt(h, c + 2, C).times(o + ""))), s = _e(s, new h(m), c, 1), n == null)
        if (St(s.d, c - $, b, i))
          h.precision = c += $, u = l = y = _e(f.minus(1), f.plus(1), c, 1), d = ae(y.times(y), c, 1), a = i = 1;
        else
          return ae(s, h.precision = C, b, fe = !0);
      else
        return h.precision = C, s;
    s = u, a += 2;
  }
}
function io(e) {
  return String(e.s * e.s / 0);
}
function Ln(e, n) {
  var t, r, a;
  for ((t = n.indexOf(".")) > -1 && (n = n.replace(".", "")), (r = n.search(/e/i)) > 0 ? (t < 0 && (t = r), t += +n.slice(r + 1), n = n.substring(0, r)) : t < 0 && (t = n.length), r = 0; n.charCodeAt(r) === 48; r++) ;
  for (a = n.length; n.charCodeAt(a - 1) === 48; --a) ;
  if (n = n.slice(r, a), n) {
    if (a -= r, e.e = t = t - r - 1, e.d = [], r = (t + 1) % se, t < 0 && (r += se), r < a) {
      for (r && e.d.push(+n.slice(0, r)), a -= se; r < a; ) e.d.push(+n.slice(r, r += se));
      n = n.slice(r), r = se - n.length;
    } else
      r -= a;
    for (; r--; ) n += "0";
    e.d.push(+n), fe && (e.e > e.constructor.maxE ? (e.d = null, e.e = NaN) : e.e < e.constructor.minE && (e.e = 0, e.d = [0]));
  } else
    e.e = 0, e.d = [0];
  return e;
}
function ma(e, n) {
  var t, r, a, o, l, i, s, u, c;
  if (n.indexOf("_") > -1) {
    if (n = n.replace(/(\d)_(?=\d)/g, "$1"), ro.test(n)) return Ln(e, n);
  } else if (n === "Infinity" || n === "NaN")
    return +n || (e.s = NaN), e.e = NaN, e.d = null, e;
  if (sa.test(n))
    t = 16, n = n.toLowerCase();
  else if (ia.test(n))
    t = 2;
  else if (ua.test(n))
    t = 8;
  else
    throw Error(ft + n);
  for (o = n.search(/p/i), o > 0 ? (s = +n.slice(o + 1), n = n.substring(2, o)) : n = n.slice(2), o = n.indexOf("."), l = o >= 0, r = e.constructor, l && (n = n.replace(".", ""), i = n.length, o = i - o, a = ao(r, new r(t), o, o * 2)), u = zt(n, t, Je), c = u.length - 1, o = c; u[o] === 0; --o) u.pop();
  return o < 0 ? new r(e.s * 0) : (e.e = dn(u, c), e.d = u, fe = !1, l && (e = _e(e, a, i * 4)), s && (e = e.times(Math.abs(s) < 54 ? Pe(2, s) : Ne.pow(2, s))), fe = !0, e);
}
function va(e, n) {
  var t, r = n.d.length;
  if (r < 3)
    return n.isZero() ? n : _t(e, 2, n, n);
  t = 1.4 * Math.sqrt(r), t = t > 16 ? 16 : t | 0, n = n.times(1 / cn(5, t)), n = _t(e, 2, n, n);
  for (var a, o = new e(5), l = new e(16), i = new e(20); t--; )
    a = n.times(n), n = n.times(o.plus(a.times(l.times(a).minus(i))));
  return n;
}
function _t(e, n, t, r, a) {
  var o, l, i, s, u = e.precision, c = Math.ceil(u / se);
  for (fe = !1, s = t.times(t), i = new e(r); ; ) {
    if (l = _e(i.times(s), new e(n++ * n++), u, 1), i = a ? r.plus(l) : r.minus(l), r = _e(l.times(s), new e(n++ * n++), u, 1), l = i.plus(r), l.d[c] !== void 0) {
      for (o = c; l.d[o] === i.d[o] && o--; ) ;
      if (o == -1) break;
    }
    o = i, i = r, r = l, l = o;
  }
  return fe = !0, l.d.length = c + 1, l;
}
function cn(e, n) {
  for (var t = e; --n; ) t *= e;
  return t;
}
function so(e, n) {
  var t, r = n.s < 0, a = Xe(e, e.precision, 1), o = a.times(0.5);
  if (n = n.abs(), n.lte(o))
    return at = r ? 4 : 1, n;
  if (t = n.divToInt(a), t.isZero())
    at = r ? 3 : 2;
  else {
    if (n = n.minus(t.times(a)), n.lte(o))
      return at = rr(t) ? r ? 2 : 3 : r ? 4 : 1, n;
    at = rr(t) ? r ? 1 : 4 : r ? 3 : 2;
  }
  return n.minus(a).abs();
}
function zn(e, n, t, r) {
  var a, o, l, i, s, u, c, f, d, m = e.constructor, $ = t !== void 0;
  if ($ ? (Ue(t, 1, vt), r === void 0 ? r = m.rounding : Ue(r, 0, 8)) : (t = m.precision, r = m.rounding), !e.isFinite())
    c = io(e);
  else {
    for (c = nt(e), l = c.indexOf("."), $ ? (a = 2, n == 16 ? t = t * 4 - 3 : n == 8 && (t = t * 3 - 2)) : a = n, l >= 0 && (c = c.replace(".", ""), d = new m(1), d.e = c.length - l, d.d = zt(nt(d), 10, a), d.e = d.d.length), f = zt(c, 10, a), o = s = f.length; f[--s] == 0; ) f.pop();
    if (!f[0])
      c = $ ? "0p+0" : "0";
    else {
      if (l < 0 ? o-- : (e = new m(e), e.d = f, e.e = o, e = _e(e, d, t, r, 0, a), f = e.d, o = e.e, u = Qr), l = f[t], i = a / 2, u = u || f[t + 1] !== void 0, u = r < 4 ? (l !== void 0 || u) && (r === 0 || r === (e.s < 0 ? 3 : 2)) : l > i || l === i && (r === 4 || u || r === 6 && f[t - 1] & 1 || r === (e.s < 0 ? 8 : 7)), f.length = t, u)
        for (; ++f[--t] > a - 1; )
          f[t] = 0, t || (++o, f.unshift(1));
      for (s = f.length; !f[s - 1]; --s) ;
      for (l = 0, c = ""; l < s; l++) c += Pn.charAt(f[l]);
      if ($) {
        if (s > 1)
          if (n == 16 || n == 8) {
            for (l = n == 16 ? 4 : 3, --s; s % l; s++) c += "0";
            for (f = zt(c, a, n), s = f.length; !f[s - 1]; --s) ;
            for (l = 1, c = "1."; l < s; l++) c += Pn.charAt(f[l]);
          } else
            c = c.charAt(0) + "." + c.slice(1);
        c = c + (o < 0 ? "p" : "p+") + o;
      } else if (o < 0) {
        for (; ++o; ) c = "0" + c;
        c = "0." + c;
      } else if (++o > s) for (o -= s; o--; ) c += "0";
      else o < s && (c = c.slice(0, o) + "." + c.slice(o));
    }
    c = (n == 16 ? "0x" : n == 2 ? "0b" : n == 8 ? "0o" : "") + c;
  }
  return e.s < 0 ? "-" + c : c;
}
function or(e, n) {
  if (e.length > n)
    return e.length = n, !0;
}
function $a(e) {
  return new this(e).abs();
}
function ha(e) {
  return new this(e).acos();
}
function pa(e) {
  return new this(e).acosh();
}
function ga(e, n) {
  return new this(e).plus(n);
}
function ya(e) {
  return new this(e).asin();
}
function ba(e) {
  return new this(e).asinh();
}
function wa(e) {
  return new this(e).atan();
}
function Ca(e) {
  return new this(e).atanh();
}
function ka(e, n) {
  e = new this(e), n = new this(n);
  var t, r = this.precision, a = this.rounding, o = r + 4;
  return !e.s || !n.s ? t = new this(NaN) : !e.d && !n.d ? (t = Xe(this, o, 1).times(n.s > 0 ? 0.25 : 0.75), t.s = e.s) : !n.d || e.isZero() ? (t = n.s < 0 ? Xe(this, r, a) : new this(0), t.s = e.s) : !e.d || n.isZero() ? (t = Xe(this, o, 1).times(0.5), t.s = e.s) : n.s < 0 ? (this.precision = o, this.rounding = 1, t = this.atan(_e(e, n, o, 1)), n = Xe(this, o, 1), this.precision = r, this.rounding = a, t = e.s < 0 ? t.minus(n) : t.plus(n)) : t = this.atan(_e(e, n, o, 1)), t;
}
function xa(e) {
  return new this(e).cbrt();
}
function _a(e) {
  return ae(e = new this(e), e.e + 1, 2);
}
function Na(e, n, t) {
  return new this(e).clamp(n, t);
}
function Da(e) {
  if (!e || typeof e != "object") throw Error(un + "Object expected");
  var n, t, r, a = e.defaults === !0, o = [
    "precision",
    1,
    vt,
    "rounding",
    0,
    8,
    "toExpNeg",
    -Ct,
    0,
    "toExpPos",
    0,
    Ct,
    "maxE",
    0,
    Ct,
    "minE",
    -Ct,
    0,
    "modulo",
    0,
    9
  ];
  for (n = 0; n < o.length; n += 3)
    if (t = o[n], a && (this[t] = In[t]), (r = e[t]) !== void 0)
      if (Oe(r) === r && r >= o[n + 1] && r <= o[n + 2]) this[t] = r;
      else throw Error(ft + t + ": " + r);
  if (t = "crypto", a && (this[t] = In[t]), (r = e[t]) !== void 0)
    if (r === !0 || r === !1 || r === 0 || r === 1)
      if (r)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[t] = !0;
        else
          throw Error(to);
      else
        this[t] = !1;
    else
      throw Error(ft + t + ": " + r);
  return this;
}
function Ea(e) {
  return new this(e).cos();
}
function Ta(e) {
  return new this(e).cosh();
}
function uo(e) {
  var n, t, r;
  function a(o) {
    var l, i, s, u = this;
    if (!(u instanceof a)) return new a(o);
    if (u.constructor = a, ar(o)) {
      u.s = o.s, fe ? !o.d || o.e > a.maxE ? (u.e = NaN, u.d = null) : o.e < a.minE ? (u.e = 0, u.d = [0]) : (u.e = o.e, u.d = o.d.slice()) : (u.e = o.e, u.d = o.d ? o.d.slice() : o.d);
      return;
    }
    if (s = typeof o, s === "number") {
      if (o === 0) {
        u.s = 1 / o < 0 ? -1 : 1, u.e = 0, u.d = [0];
        return;
      }
      if (o < 0 ? (o = -o, u.s = -1) : u.s = 1, o === ~~o && o < 1e7) {
        for (l = 0, i = o; i >= 10; i /= 10) l++;
        fe ? l > a.maxE ? (u.e = NaN, u.d = null) : l < a.minE ? (u.e = 0, u.d = [0]) : (u.e = l, u.d = [o]) : (u.e = l, u.d = [o]);
        return;
      } else if (o * 0 !== 0) {
        o || (u.s = NaN), u.e = NaN, u.d = null;
        return;
      }
      return Ln(u, o.toString());
    } else if (s !== "string")
      throw Error(ft + o);
    return (i = o.charCodeAt(0)) === 45 ? (o = o.slice(1), u.s = -1) : (i === 43 && (o = o.slice(1)), u.s = 1), ro.test(o) ? Ln(u, o) : ma(u, o);
  }
  if (a.prototype = V, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.EUCLID = 9, a.config = a.set = Da, a.clone = uo, a.isDecimal = ar, a.abs = $a, a.acos = ha, a.acosh = pa, a.add = ga, a.asin = ya, a.asinh = ba, a.atan = wa, a.atanh = Ca, a.atan2 = ka, a.cbrt = xa, a.ceil = _a, a.clamp = Na, a.cos = Ea, a.cosh = Ta, a.div = Sa, a.exp = Ma, a.floor = Pa, a.hypot = Ia, a.ln = Fa, a.log = Aa, a.log10 = Ra, a.log2 = La, a.max = Oa, a.min = Ba, a.mod = Va, a.mul = Ka, a.pow = Ha, a.random = Ga, a.round = Ua, a.sign = Wa, a.sin = Za, a.sinh = za, a.sqrt = ja, a.sub = Ya, a.sum = qa, a.tan = Xa, a.tanh = Ja, a.trunc = Qa, e === void 0 && (e = {}), e && e.defaults !== !0)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], n = 0; n < r.length; ) e.hasOwnProperty(t = r[n++]) || (e[t] = this[t]);
  return a.config(e), a;
}
function Sa(e, n) {
  return new this(e).div(n);
}
function Ma(e) {
  return new this(e).exp();
}
function Pa(e) {
  return ae(e = new this(e), e.e + 1, 3);
}
function Ia() {
  var e, n, t = new this(0);
  for (fe = !1, e = 0; e < arguments.length; )
    if (n = new this(arguments[e++]), n.d)
      t.d && (t = t.plus(n.times(n)));
    else {
      if (n.s)
        return fe = !0, new this(1 / 0);
      t = n;
    }
  return fe = !0, t.sqrt();
}
function ar(e) {
  return e instanceof Ne || e && e.toStringTag === no || !1;
}
function Fa(e) {
  return new this(e).ln();
}
function Aa(e, n) {
  return new this(e).log(n);
}
function La(e) {
  return new this(e).log(2);
}
function Ra(e) {
  return new this(e).log(10);
}
function Oa() {
  return lo(this, arguments, "lt");
}
function Ba() {
  return lo(this, arguments, "gt");
}
function Va(e, n) {
  return new this(e).mod(n);
}
function Ka(e, n) {
  return new this(e).mul(n);
}
function Ha(e, n) {
  return new this(e).pow(n);
}
function Ga(e) {
  var n, t, r, a, o = 0, l = new this(1), i = [];
  if (e === void 0 ? e = this.precision : Ue(e, 1, vt), r = Math.ceil(e / se), this.crypto)
    if (crypto.getRandomValues)
      for (n = crypto.getRandomValues(new Uint32Array(r)); o < r; )
        a = n[o], a >= 429e7 ? n[o] = crypto.getRandomValues(new Uint32Array(1))[0] : i[o++] = a % 1e7;
    else if (crypto.randomBytes) {
      for (n = crypto.randomBytes(r *= 4); o < r; )
        a = n[o] + (n[o + 1] << 8) + (n[o + 2] << 16) + ((n[o + 3] & 127) << 24), a >= 214e7 ? crypto.randomBytes(4).copy(n, o) : (i.push(a % 1e7), o += 4);
      o = r / 4;
    } else
      throw Error(to);
  else for (; o < r; ) i[o++] = Math.random() * 1e7 | 0;
  for (r = i[--o], e %= se, r && e && (a = Pe(10, se - e), i[o] = (r / a | 0) * a); i[o] === 0; o--) i.pop();
  if (o < 0)
    t = 0, i = [0];
  else {
    for (t = -1; i[0] === 0; t -= se) i.shift();
    for (r = 1, a = i[0]; a >= 10; a /= 10) r++;
    r < se && (t -= se - r);
  }
  return l.e = t, l.d = i, l;
}
function Ua(e) {
  return ae(e = new this(e), e.e + 1, this.rounding);
}
function Wa(e) {
  return e = new this(e), e.d ? e.d[0] ? e.s : 0 * e.s : e.s || NaN;
}
function Za(e) {
  return new this(e).sin();
}
function za(e) {
  return new this(e).sinh();
}
function ja(e) {
  return new this(e).sqrt();
}
function Ya(e, n) {
  return new this(e).sub(n);
}
function qa() {
  var e = 0, n = arguments, t = new this(n[e]);
  for (fe = !1; t.s && ++e < n.length; ) t = t.plus(n[e]);
  return fe = !0, ae(t, this.precision, this.rounding);
}
function Xa(e) {
  return new this(e).tan();
}
function Ja(e) {
  return new this(e).tanh();
}
function Qa(e) {
  return ae(e = new this(e), e.e + 1, 1);
}
V[Symbol.for("nodejs.util.inspect.custom")] = V.toString;
V[Symbol.toStringTag] = "Decimal";
var Ne = V.constructor = uo(In);
qt = new Ne(qt);
Xt = new Ne(Xt);
class ye {
  constructor(n, t, r) {
    Vt(this, "year");
    Vt(this, "month");
    Vt(this, "day");
    const a = new Date(n, t - 1, r);
    this.year = a.getFullYear(), this.month = a.getMonth() + 1, this.day = a.getDate();
  }
  static fromDate(n) {
    return new ye(n.getFullYear(), n.getMonth() + 1, n.getDate());
  }
  static parse(n) {
    const t = n.split("-");
    if (t.length !== 3) throw new Error(`Invalid date string: ${n}`);
    const r = parseInt(t[0], 10), a = parseInt(t[1], 10), o = parseInt(t[2], 10);
    if (isNaN(r) || isNaN(a) || isNaN(o)) throw new Error(`Invalid date string: ${n}`);
    return new ye(r, a, o);
  }
  static today() {
    return ye.fromDate(/* @__PURE__ */ new Date());
  }
  toDate() {
    return new Date(this.year, this.month - 1, this.day);
  }
  toJSON() {
    return this.toString();
  }
  toString() {
    const n = String(this.year).padStart(4, "0"), t = String(this.month).padStart(2, "0"), r = String(this.day).padStart(2, "0");
    return `${n}-${t}-${r}`;
  }
  equals(n) {
    return this.year === n.year && this.month === n.month && this.day === n.day;
  }
  isBefore(n) {
    return this.year !== n.year ? this.year < n.year : this.month !== n.month ? this.month < n.month : this.day < n.day;
  }
  isAfter(n) {
    return this.year !== n.year ? this.year > n.year : this.month !== n.month ? this.month > n.month : this.day > n.day;
  }
  isBeforeOrEqual(n) {
    return this.equals(n) || this.isBefore(n);
  }
  isAfterOrEqual(n) {
    return this.equals(n) || this.isAfter(n);
  }
  addDays(n) {
    Ne.isDecimal(n) && (n = n.toNumber());
    const t = this.toDate();
    return t.setDate(t.getDate() + n), ye.fromDate(t);
  }
  addMonths(n) {
    Ne.isDecimal(n) && (n = n.toNumber());
    const t = this.toDate();
    return t.setMonth(t.getMonth() + n), ye.fromDate(t);
  }
}
const el = ["title"], tl = { class: "date-label" }, nl = /* @__PURE__ */ K({
  __name: "CalendarDate",
  props: {
    date: {},
    disabled: { type: Boolean },
    currentMonth: { type: Boolean },
    selectedDate: {},
    rangeFrom: {},
    rangeTo: {},
    rangeAnchor: {},
    previewDate: {}
  },
  setup(e) {
    const n = e, t = ye.today(), r = new Intl.DateTimeFormat(document.documentElement.dataset.formatting ?? navigator.language, {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    }), a = D(() => {
      const l = [];
      n.date.equals(t) && l.push("today");
      let i, s;
      return n.previewDate && n.rangeAnchor ? (l.push("preview"), n.rangeAnchor.isBefore(n.previewDate) ? (i = n.rangeAnchor, s = n.previewDate) : (i = n.previewDate, s = n.rangeAnchor), l.push("disable-transitions")) : n.rangeFrom && n.rangeTo ? (i = n.rangeFrom, s = n.rangeTo) : n.selectedDate && (i = n.selectedDate, s = n.selectedDate), !i || !s ? (l.push("disable-transitions"), l) : (i.isBefore(n.date) && n.date.isBefore(s) && l.push("in-range"), n.date.equals(i) && n.date.equals(s) ? l.push("single") : n.date.equals(i) ? l.push("start") : n.date.equals(s) && l.push("end"), l);
    }), o = D(() => r.format(n.date.toDate()));
    return (l, i) => (v(), g("div", {
      class: j(["date-margin", { disabled: e.disabled, "pad-date": !e.currentMonth }])
    }, [
      w("div", {
        class: j(["date", a.value]),
        title: o.value
      }, [
        i[0] || (i[0] = w("div", { class: "date-bg" }, null, -1)),
        i[1] || (i[1] = w("div", { class: "date-hover" }, null, -1)),
        w("div", tl, S(e.date.day), 1)
      ], 10, el)
    ], 2));
  }
}), yn = /* @__PURE__ */ Y(nl, [["__scopeId", "data-v-b804228b"]]);
function We(e, n, t) {
  return new Date(e, n, t);
}
const rl = { class: "weekday-label" }, ol = {
  key: 0,
  class: "week-numbers"
}, al = ["onClick"], ll = /* @__PURE__ */ K({
  __name: "CalendarGrid",
  props: {
    year: {},
    month: {},
    minDate: {},
    maxDate: {},
    startOfWeek: {},
    weekNumbers: {},
    selectedDate: {},
    rangeFrom: {},
    rangeTo: {},
    rangeAnchor: {},
    previewDate: {}
  },
  emits: ["dateClick", "dateHover", "weekClick"],
  setup(e, { emit: n }) {
    const t = e, r = n;
    function a(p, h) {
      return (p % h + h) % h;
    }
    function o(p) {
      return !!t.minDate && p.isBefore(t.minDate) || !!t.maxDate && p.isAfter(t.maxDate);
    }
    function l(p) {
      return a(p.getDay() - t.startOfWeek, 7);
    }
    const i = D(() => t.month - 1), s = D(() => {
      const p = We(t.year, i.value, 0), h = p.getDay() - t.startOfWeek, b = a(7 - a(7 - h, 7) + t.startOfWeek, 7), C = [];
      for (let x = b - 1; x >= 0; x--) {
        const _ = We(p.getFullYear(), p.getMonth(), p.getDate() - x), T = ye.fromDate(_);
        C.push({
          date: T,
          disabled: o(T),
          currentMonth: !1
        });
      }
      return C;
    }), u = D(() => {
      const p = We(t.year, i.value + 1, 0).getDate(), h = [];
      for (let b = 0; b < p; b++) {
        const C = new ye(t.year, t.month, b + 1);
        h.push({
          date: C,
          disabled: o(C),
          currentMonth: !0
        });
      }
      return h;
    }), c = D(() => {
      const p = We(t.year, i.value + 1, 1), h = 42 - s.value.length - u.value.length, b = [];
      for (let C = 0; C < h; C++) {
        const x = We(p.getFullYear(), p.getMonth(), C + 1), _ = ye.fromDate(x);
        b.push({
          date: _,
          disabled: o(_),
          currentMonth: !1
        });
      }
      return b;
    }), f = D(() => {
      const p = new Intl.DateTimeFormat(document.documentElement.lang, { weekday: "short" }), h = We(2025, 0, 5), b = [];
      for (let C = 0; C < 7; C++)
        b.push(p.format(
          We(h.getFullYear(), h.getMonth(), h.getDate() + C + t.startOfWeek)
        ));
      return b;
    }), d = D(() => {
      if (!(!t.weekNumbers || t.weekNumbers === "none") && t.weekNumbers === "firstFourDays") {
        const p = We(t.year, 0, 1), h = l(p);
        let b;
        h < 3 ? b = We(t.year, 0, 1 - h) : b = We(t.year, 0, 7 - h);
        const x = (We(t.year, i.value, 1).getTime() - b.getTime()) / (1e3 * 60 * 60 * 24), _ = Math.floor(x / 7) + 1, T = [];
        for (let W = 0; W < 6; W++) {
          const F = We(
            b.getFullYear(),
            b.getMonth(),
            b.getDate() + (_ - 1) * 7 + W * 7
          ), P = We(
            F.getFullYear(),
            F.getMonth(),
            F.getDate() + 6
          );
          T.push({
            weekNumber: _ + W,
            from: ye.fromDate(F),
            to: ye.fromDate(P)
          });
        }
        return T;
      }
    });
    function m(p) {
      o(p) || r("dateClick", p);
    }
    function $(p) {
      r("dateHover", p);
    }
    function y(p) {
      r("weekClick", p);
    }
    return (p, h) => (v(), g("div", {
      class: j(["calendar", { "with-weeks": e.weekNumbers && e.weekNumbers !== "none" }]),
      onClick: h[0] || (h[0] = Ee(() => {
      }, ["stop"]))
    }, [
      (v(!0), g(G, null, Q(f.value, (b) => (v(), g("div", rl, S(b), 1))), 256)),
      e.weekNumbers && e.weekNumbers !== "none" ? (v(), g("div", ol, [
        h[1] || (h[1] = w("div", null, " ", -1)),
        (v(!0), g(G, null, Q(d.value, (b) => (v(), g("div", {
          key: b.weekNumber,
          class: "week-label",
          onClick: (C) => y(b)
        }, S(b.weekNumber), 9, al))), 128))
      ])) : I("", !0),
      (v(!0), g(G, null, Q(s.value, (b) => (v(), Z(yn, {
        key: b.date.toString(),
        date: b.date,
        disabled: b.disabled,
        "current-month": !1,
        "selected-date": e.selectedDate,
        "range-from": e.rangeFrom,
        "range-to": e.rangeTo,
        "range-anchor": e.rangeAnchor,
        "preview-date": e.previewDate,
        onClick: () => m(b.date),
        onMouseenter: () => $(b.date)
      }, null, 8, ["date", "disabled", "selected-date", "range-from", "range-to", "range-anchor", "preview-date", "onClick", "onMouseenter"]))), 128)),
      (v(!0), g(G, null, Q(u.value, (b) => (v(), Z(yn, {
        key: b.date.toString(),
        date: b.date,
        disabled: b.disabled,
        "current-month": !0,
        "selected-date": e.selectedDate,
        "range-from": e.rangeFrom,
        "range-to": e.rangeTo,
        "range-anchor": e.rangeAnchor,
        "preview-date": e.previewDate,
        onClick: () => m(b.date),
        onMouseenter: () => $(b.date)
      }, null, 8, ["date", "disabled", "selected-date", "range-from", "range-to", "range-anchor", "preview-date", "onClick", "onMouseenter"]))), 128)),
      (v(!0), g(G, null, Q(c.value, (b) => (v(), Z(yn, {
        key: b.date.toString(),
        date: b.date,
        disabled: b.disabled,
        "current-month": !1,
        "selected-date": e.selectedDate,
        "range-from": e.rangeFrom,
        "range-to": e.rangeTo,
        "range-anchor": e.rangeAnchor,
        "preview-date": e.previewDate,
        onClick: () => m(b.date),
        onMouseenter: () => $(b.date)
      }, null, 8, ["date", "disabled", "selected-date", "range-from", "range-to", "range-anchor", "preview-date", "onClick", "onMouseenter"]))), 128))
    ], 2));
  }
}), il = /* @__PURE__ */ Y(ll, [["__scopeId", "data-v-3b8fa91a"]]), sl = {}, ul = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function dl(e, n) {
  return v(), g("svg", ul, [...n[0] || (n[0] = [
    w("polyline", {
      points: "208 96 128 176 48 96",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const gt = /* @__PURE__ */ Y(sl, [["render", dl]]), cl = { class: "controls" }, fl = { class: "calendar-label" }, ml = /* @__PURE__ */ K({
  __name: "CalendarPanel",
  props: {
    mode: {},
    minDate: {},
    maxDate: {},
    startOfWeek: { default: 1 },
    weekNumbers: {},
    selectedDate: {},
    rangeFrom: {},
    rangeTo: {}
  },
  emits: ["selectDate", "selectRange"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = N(), o = N(), l = N("idle"), i = Ge("calendarsElem"), s = t.selectedDate ?? t.rangeFrom ?? ye.today(), u = new Date(s.year, s.month - 1, 1), c = new Date(u.getFullYear(), u.getMonth() - 1, 1), f = new Date(u.getFullYear(), u.getMonth() + 1, 1), d = N([
      { year: c.getFullYear(), month: c.getMonth() + 1 },
      { year: u.getFullYear(), month: u.getMonth() + 1 },
      { year: f.getFullYear(), month: f.getMonth() + 1 }
    ]), m = N(new Date(d.value[1].year, d.value[1].month - 1, 1));
    we(() => {
      var F, P;
      (F = i.value) == null || F.addEventListener("scroll", $), (P = i.value) == null || P.scrollTo({
        left: 260,
        behavior: "instant"
      });
    }), Ze(() => {
      var F;
      (F = i.value) == null || F.removeEventListener("scroll", $);
    });
    function $() {
      if (!i.value) return;
      const F = i.value.scrollLeft, P = i.value.scrollLeft + i.value.clientWidth, E = i.value.scrollWidth;
      if (F === 0) {
        const ie = d.value[0], oe = new Date(ie.year, ie.month - 2, 1);
        if (t.minDate && new Date(ie.year, ie.month - 1, 1) <= t.minDate.toDate())
          return;
        d.value.unshift({
          year: oe.getFullYear(),
          month: oe.getMonth() + 1
        }), He(() => {
          var O, H;
          (H = i.value) == null || H.scrollTo({
            left: (O = i.value) == null ? void 0 : O.clientWidth,
            behavior: "instant"
          });
        });
      } else if (P === E) {
        const ie = d.value[d.value.length - 1], oe = new Date(ie.year, ie.month, 1);
        if (t.maxDate) {
          const O = new Date(oe.getFullYear(), oe.getMonth() + 1, 0);
          if (t.maxDate.toDate() <= O) return;
        }
        d.value.push({
          year: oe.getFullYear(),
          month: oe.getMonth() + 1
        });
      }
      const L = Math.round(F / i.value.clientWidth), J = d.value[L];
      J && (m.value = new Date(J.year, J.month - 1, 1));
    }
    function y() {
      var F;
      (F = i.value) == null || F.scrollTo({
        left: i.value.scrollLeft - i.value.clientWidth,
        behavior: "smooth"
      });
    }
    function p() {
      var F;
      (F = i.value) == null || F.scrollTo({
        left: i.value.scrollLeft + i.value.clientWidth,
        behavior: "smooth"
      });
    }
    const h = new Intl.DateTimeFormat(document.documentElement.lang ?? navigator.language, {
      year: "numeric",
      month: "long"
    }), b = D(() => h.format(m.value));
    function C(F) {
      if (t.mode === "single") {
        r("selectDate", F);
        return;
      }
      if (l.value === "idle")
        a.value = F, o.value = F, l.value = "picking", document.addEventListener("keydown", T);
      else if (l.value === "picking" && a.value) {
        const P = F.isBefore(a.value) ? F : a.value, E = F.isAfter(a.value) ? F : a.value;
        r("selectRange", { from: P, to: E }), W();
      }
    }
    function x(F) {
      l.value === "picking" && (o.value = F);
    }
    function _(F) {
      t.mode === "range" ? (r("selectRange", F), W()) : r("selectDate", F.from);
    }
    function T(F) {
      F.key === "Escape" && W();
    }
    function W() {
      o.value = void 0, a.value = void 0, l.value = "idle", document.removeEventListener("keydown", T);
    }
    return (F, P) => (v(), g("div", {
      class: j(["calendar-panel", { "with-weeks": e.weekNumbers && e.weekNumbers !== "none" }])
    }, [
      w("div", cl, [
        w("button", {
          class: "btn-silent prev",
          onClick: y
        }, [
          z(gt)
        ]),
        w("div", fl, S(b.value), 1),
        w("button", {
          class: "btn-silent next",
          onClick: p
        }, [
          z(gt)
        ])
      ]),
      w("div", {
        class: "calendars",
        ref_key: "calendarsElem",
        ref: i
      }, [
        (v(!0), g(G, null, Q(d.value, (E) => (v(), Z(il, {
          key: E.year + "_" + E.month,
          year: E.year,
          month: E.month,
          "start-of-week": e.startOfWeek,
          "min-date": e.minDate,
          "max-date": e.maxDate,
          "week-numbers": e.weekNumbers,
          "selected-date": e.selectedDate,
          "range-from": e.rangeFrom,
          "range-to": e.rangeTo,
          "range-anchor": a.value,
          "preview-date": o.value,
          onDateClick: C,
          onDateHover: x,
          onWeekClick: _
        }, null, 8, ["year", "month", "start-of-week", "min-date", "max-date", "week-numbers", "selected-date", "range-from", "range-to", "range-anchor", "preview-date"]))), 128))
      ], 512),
      ce(F.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), fn = /* @__PURE__ */ Y(ml, [["__scopeId", "data-v-e8195e60"]]), co = /* @__PURE__ */ K({
  __name: "DatePicker",
  props: /* @__PURE__ */ De({
    minDate: {},
    maxDate: {},
    startOfWeek: { default: 1 },
    weekNumbers: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = Me(e, "modelValue");
    function t(r) {
      n.value = r;
    }
    return (r, a) => (v(), Z(fn, {
      mode: "single",
      "min-date": e.minDate,
      "max-date": e.maxDate,
      "start-of-week": e.startOfWeek,
      "week-numbers": e.weekNumbers,
      "selected-date": n.value,
      onSelectDate: t
    }, null, 8, ["min-date", "max-date", "start-of-week", "week-numbers", "selected-date"]));
  }
}), vl = ["title"], $l = { class: "p" }, hl = /* @__PURE__ */ K({
  __name: "DateInput",
  props: /* @__PURE__ */ De({
    minDate: {},
    maxDate: {},
    startOfWeek: { default: 1 },
    weekNumbers: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = Me(e, "modelValue"), r = N(""), a = N(!1), o = N(), l = N(), i = N(""), s = new Intl.DateTimeFormat(document.documentElement.dataset.formatting ?? navigator.language, {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    });
    re(r, () => {
      i.value && (i.value = "");
    }), re(t, (f, d) => {
      var m;
      if (!f) {
        r.value = "";
        return;
      }
      r.value = s.format(f.toDate()), a.value && d !== void 0 && ((m = l.value) == null || m.close());
    }, { immediate: !0 });
    function u() {
      const f = r.value.trim();
      if (!f) {
        t.value = void 0, i.value = "";
        return;
      }
      const d = new Date(f);
      if (isNaN(d.getTime())) {
        i.value = "Invalid date format";
        return;
      }
      const m = ye.fromDate(d);
      if (n.minDate && m.isBefore(n.minDate)) {
        i.value = `Date must be after ${s.format(n.minDate.toDate())}`;
        return;
      }
      if (n.maxDate && m.isAfter(n.maxDate)) {
        i.value = `Date must be before ${s.format(n.maxDate.toDate())}`;
        return;
      }
      t.value = m, i.value = "";
    }
    function c() {
      var f;
      (f = l.value) == null || f.open();
    }
    return (f, d) => (v(), g(G, null, [
      w("div", {
        class: j(["input", { "date-input--error": i.value }]),
        title: i.value || void 0
      }, [
        z(Ve, {
          modelValue: r.value,
          "onUpdate:modelValue": d[0] || (d[0] = (m) => r.value = m),
          onBlur: u
        }, null, 8, ["modelValue"]),
        w("button", {
          class: "btn-silent",
          onClick: c,
          ref_key: "button",
          ref: o
        }, [
          z(It)
        ], 512)
      ], 10, vl),
      z(je, {
        ref_key: "dropdownMenu",
        ref: l,
        target: o.value,
        onOpen: d[2] || (d[2] = (m) => a.value = !0),
        onClose: d[3] || (d[3] = (m) => a.value = !1)
      }, {
        default: le(() => [
          w("li", $l, [
            z(co, {
              modelValue: t.value,
              "onUpdate:modelValue": d[1] || (d[1] = (m) => t.value = m),
              "min-date": e.minDate,
              "max-date": e.maxDate,
              "start-of-week": e.startOfWeek,
              "week-numbers": e.weekNumbers
            }, null, 8, ["modelValue", "min-date", "max-date", "start-of-week", "week-numbers"])
          ])
        ]),
        _: 1
      }, 8, ["target"])
    ], 64));
  }
}), am = /* @__PURE__ */ Y(hl, [["__scopeId", "data-v-cd599c28"]]), fo = /* @__PURE__ */ K({
  __name: "DateRangePicker",
  props: /* @__PURE__ */ De({
    minDate: {},
    maxDate: {},
    startOfWeek: { default: 1 },
    weekNumbers: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = Me(e, "modelValue");
    function t(r) {
      n.value = r;
    }
    return (r, a) => {
      var o, l;
      return v(), Z(fn, {
        mode: "range",
        "min-date": e.minDate,
        "max-date": e.maxDate,
        "start-of-week": e.startOfWeek,
        "week-numbers": e.weekNumbers,
        "range-from": (o = n.value) == null ? void 0 : o.from,
        "range-to": (l = n.value) == null ? void 0 : l.to,
        onSelectRange: t
      }, null, 8, ["min-date", "max-date", "start-of-week", "week-numbers", "range-from", "range-to"]);
    };
  }
}), pl = ["title"], gl = { class: "p" }, yl = /* @__PURE__ */ K({
  __name: "DateRangeInput",
  props: /* @__PURE__ */ De({
    minDate: {},
    maxDate: {},
    startOfWeek: { default: 1 },
    weekNumbers: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = Me(e, "modelValue"), t = N(""), r = N(!1), a = N(), o = N(), l = N(""), i = new Intl.DateTimeFormat(document.documentElement.dataset.formatting ?? navigator.language, {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    });
    re(t, () => {
      l.value && (l.value = "");
    }), re(n, (f, d) => {
      var y;
      if (!f) {
        t.value = "";
        return;
      }
      const m = i.format(f.from.toDate()), $ = i.format(f.to.toDate());
      t.value = `${m} – ${$}`, r.value && d !== void 0 && ((y = o.value) == null || y.close());
    }, { immediate: !0, deep: !0 });
    function s(f) {
      const d = [" – ", " - ", " to ", " — ", "–", "—"];
      for (const m of d) {
        const $ = f.split(m);
        if ($.length === 2) {
          const y = new Date($[0].trim()), p = new Date($[1].trim());
          if (!isNaN(y.getTime()) && !isNaN(p.getTime()))
            return { from: ye.fromDate(y), to: ye.fromDate(p) };
        }
      }
      return null;
    }
    function u() {
      const f = t.value.trim();
      if (!f) {
        n.value = void 0, l.value = "";
        return;
      }
      const d = s(f);
      if (!d) {
        l.value = "Range format should be: date – date";
        return;
      }
      if (d.from.isAfter(d.to)) {
        l.value = "Start date must be before end date";
        return;
      }
      n.value = d, l.value = "";
    }
    function c() {
      var f;
      (f = o.value) == null || f.open();
    }
    return (f, d) => (v(), g(G, null, [
      w("div", {
        class: j(["input", { "date-input--error": l.value }]),
        title: l.value || void 0
      }, [
        z(Ve, {
          modelValue: t.value,
          "onUpdate:modelValue": d[0] || (d[0] = (m) => t.value = m),
          onBlur: u
        }, null, 8, ["modelValue"]),
        w("button", {
          class: "btn-silent",
          onClick: c,
          ref_key: "button",
          ref: a
        }, [
          z(It)
        ], 512)
      ], 10, pl),
      z(je, {
        ref_key: "dropdownMenu",
        ref: o,
        target: a.value,
        onOpen: d[2] || (d[2] = (m) => r.value = !0),
        onClose: d[3] || (d[3] = (m) => r.value = !1)
      }, {
        default: le(() => [
          w("li", gl, [
            z(fo, {
              modelValue: n.value,
              "onUpdate:modelValue": d[1] || (d[1] = (m) => n.value = m),
              "min-date": e.minDate,
              "max-date": e.maxDate,
              "start-of-week": e.startOfWeek,
              "week-numbers": e.weekNumbers
            }, null, 8, ["modelValue", "min-date", "max-date", "start-of-week", "week-numbers"])
          ])
        ]),
        _: 1
      }, 8, ["target"])
    ], 64));
  }
}), lm = /* @__PURE__ */ Y(yl, [["__scopeId", "data-v-ab8cc443"]]), bl = { class: "time-picker" }, wl = {
  key: 0,
  class: "time-label"
}, Cl = { class: "time-inputs" }, kl = { class: "utc-offset" }, xl = /* @__PURE__ */ K({
  __name: "TimePicker",
  props: /* @__PURE__ */ De({
    label: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = Me(e, "modelValue"), t = N(), r = N(), a = N(l(n.value.hours)), o = N(l(n.value.minutes));
    re(n, (b) => {
      a.value = l(b.hours), o.value = l(b.minutes);
    }, { deep: !0 });
    function l(b) {
      return String(b).padStart(2, "0");
    }
    function i(b, C, x) {
      return Math.max(C, Math.min(x, b));
    }
    const s = D(() => {
      const b = -(/* @__PURE__ */ new Date()).getTimezoneOffset(), C = b >= 0 ? "+" : "-", x = Math.abs(b), _ = Math.floor(x / 60), T = x % 60;
      return T > 0 ? `UTC${C}${_}:${l(T)}` : `UTC${C}${_}`;
    });
    function u() {
      const b = parseInt(a.value, 10);
      if (isNaN(b)) {
        a.value = l(n.value.hours);
        return;
      }
      const C = i(b, 0, 23);
      n.value = { ...n.value, hours: C }, a.value = l(C);
    }
    function c() {
      const b = parseInt(o.value, 10);
      if (isNaN(b)) {
        o.value = l(n.value.minutes);
        return;
      }
      const C = i(b, 0, 59);
      n.value = { ...n.value, minutes: C }, o.value = l(C);
    }
    function f(b) {
      const C = ((n.value.hours + b) % 24 + 24) % 24;
      n.value = { ...n.value, hours: C };
    }
    function d(b) {
      const C = ((n.value.minutes + b) % 60 + 60) % 60;
      n.value = { ...n.value, minutes: C };
    }
    function m(b) {
      b.key === "ArrowUp" ? (b.preventDefault(), f(1)) : b.key === "ArrowDown" && (b.preventDefault(), f(-1));
    }
    function $(b) {
      b.key === "ArrowUp" ? (b.preventDefault(), d(1)) : b.key === "ArrowDown" && (b.preventDefault(), d(-1));
    }
    function y(b) {
      b.preventDefault(), f(b.deltaY < 0 ? 1 : -1);
    }
    function p(b) {
      b.preventDefault(), d(b.deltaY < 0 ? 1 : -1);
    }
    function h(b) {
      b.target.select();
    }
    return (b, C) => (v(), g("div", bl, [
      e.label ? (v(), g("span", wl, S(e.label), 1)) : I("", !0),
      w("div", Cl, [
        be(w("input", {
          ref_key: "hoursInput",
          ref: t,
          class: "time-field",
          type: "text",
          inputmode: "numeric",
          maxlength: "2",
          "onUpdate:modelValue": C[0] || (C[0] = (x) => a.value = x),
          onBlur: u,
          onKeydown: m,
          onWheel: y,
          onFocus: h
        }, null, 544), [
          [pt, a.value]
        ]),
        C[2] || (C[2] = w("span", { class: "time-separator" }, ":", -1)),
        be(w("input", {
          ref_key: "minutesInput",
          ref: r,
          class: "time-field",
          type: "text",
          inputmode: "numeric",
          maxlength: "2",
          "onUpdate:modelValue": C[1] || (C[1] = (x) => o.value = x),
          onBlur: c,
          onKeydown: $,
          onWheel: p,
          onFocus: h
        }, null, 544), [
          [pt, o.value]
        ])
      ]),
      w("span", kl, S(s.value), 1)
    ]));
  }
}), Rn = /* @__PURE__ */ Y(xl, [["__scopeId", "data-v-01b33128"]]), mo = /* @__PURE__ */ K({
  __name: "InstantPicker",
  props: /* @__PURE__ */ De({
    minDate: {},
    maxDate: {},
    startOfWeek: { default: 1 },
    weekNumbers: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = Me(e, "modelValue"), t = D(() => {
      if (n.value)
        return ye.fromDate(n.value);
    }), r = D({
      get() {
        return n.value ? {
          hours: n.value.getHours(),
          minutes: n.value.getMinutes()
        } : { hours: 0, minutes: 0 };
      },
      set(o) {
        if (!n.value) return;
        const l = new Date(n.value);
        l.setHours(o.hours, o.minutes, 0, 0), n.value = l;
      }
    });
    function a(o) {
      const l = o.toDate();
      l.setHours(r.value.hours, r.value.minutes, 0, 0), n.value = l;
    }
    return (o, l) => (v(), Z(fn, {
      mode: "single",
      "min-date": e.minDate,
      "max-date": e.maxDate,
      "start-of-week": e.startOfWeek,
      "week-numbers": e.weekNumbers,
      "selected-date": t.value,
      onSelectDate: a
    }, {
      default: le(() => [
        z(Rn, {
          modelValue: r.value,
          "onUpdate:modelValue": l[0] || (l[0] = (i) => r.value = i)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["min-date", "max-date", "start-of-week", "week-numbers", "selected-date"]));
  }
}), _l = ["title"], Nl = { class: "p picker-dropdown" }, Dl = /* @__PURE__ */ K({
  __name: "InstantInput",
  props: /* @__PURE__ */ De({
    minDate: {},
    maxDate: {},
    startOfWeek: { default: 1 },
    weekNumbers: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = Me(e, "modelValue"), t = N(""), r = N(!1), a = N(), o = N(), l = N(""), i = new Intl.DateTimeFormat(document.documentElement.dataset.formatting ?? navigator.language, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
    re(t, () => {
      l.value && (l.value = "");
    }), re(n, (f) => {
      if (!f) {
        t.value = "";
        return;
      }
      t.value = i.format(f);
    }, { immediate: !0 });
    function s() {
      var f;
      (f = o.value) == null || f.close();
    }
    function u() {
      const f = t.value.trim();
      if (!f) {
        n.value = void 0, l.value = "";
        return;
      }
      const d = new Date(f);
      if (isNaN(d.getTime())) {
        l.value = "Invalid date/time format";
        return;
      }
      n.value = d, l.value = "";
    }
    function c() {
      var f;
      (f = o.value) == null || f.open();
    }
    return (f, d) => (v(), g(G, null, [
      w("div", {
        class: j(["input", { "date-input--error": l.value }]),
        title: l.value || void 0
      }, [
        z(Ve, {
          modelValue: t.value,
          "onUpdate:modelValue": d[0] || (d[0] = (m) => t.value = m),
          onBlur: u
        }, null, 8, ["modelValue"]),
        w("button", {
          class: "btn-silent",
          onClick: c,
          ref_key: "button",
          ref: a
        }, [
          z(It)
        ], 512)
      ], 10, _l),
      z(je, {
        ref_key: "dropdownMenu",
        ref: o,
        target: a.value,
        onOpen: d[2] || (d[2] = (m) => r.value = !0),
        onClose: d[3] || (d[3] = (m) => r.value = !1)
      }, {
        default: le(() => [
          w("li", Nl, [
            z(mo, {
              modelValue: n.value,
              "onUpdate:modelValue": d[1] || (d[1] = (m) => n.value = m),
              "min-date": e.minDate,
              "max-date": e.maxDate,
              "start-of-week": e.startOfWeek,
              "week-numbers": e.weekNumbers
            }, null, 8, ["modelValue", "min-date", "max-date", "start-of-week", "week-numbers"]),
            w("div", { class: "picker-actions" }, [
              w("button", {
                class: "btn-primary",
                onClick: s
              }, "Apply")
            ])
          ])
        ]),
        _: 1
      }, 8, ["target"])
    ], 64));
  }
}), im = /* @__PURE__ */ Y(Dl, [["__scopeId", "data-v-3ed99f8c"]]), El = ["title"], Tl = { class: "dropdown-item__padding" }, Ie = /* @__PURE__ */ K({
  isDropdownItem: !0,
  __name: "DropdownItem",
  props: {
    disabled: { type: Boolean },
    title: {},
    onClick: {}
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = oa(), o = D(() => typeof t.onClick == "function");
    function l(i) {
      if (i.preventDefault(), !o.value)
        return;
      let s = !1;
      r("click", () => {
        s = !0;
      }), s || a();
    }
    return (i, s) => (v(), g("li", et({ class: "dropdown-item" }, i.$attrs, {
      class: {
        "dropdown-item--clickable": !e.disabled && o.value,
        "dropdown-item--disabled": e.disabled
      },
      onClick: l,
      title: e.title
    }), [
      w("div", Tl, [
        ce(i.$slots, "default")
      ])
    ], 16, El));
  }
}), Sl = { class: "dropdown-divider" }, lr = /* @__PURE__ */ K({
  __name: "DropdownDivider",
  setup(e) {
    return (n, t) => (v(), g("li", Sl));
  }
}), Ml = ["disabled"], Pl = { class: "chevron" }, Il = { class: "icon" }, Fl = /* @__PURE__ */ K({
  __name: "DropdownButton",
  props: {
    label: {},
    disabled: { type: Boolean },
    buttonStyle: {},
    hue: {}
  },
  setup(e) {
    const n = e, t = N(), r = Ge("dropdownMenu"), a = Dt(), o = N(!1);
    function l() {
      var u;
      n.disabled || (u = r.value) == null || u.open();
    }
    const i = D(() => a.label || n.label), s = D(() => {
      if (n.hue != null)
        return {
          "--color-hue": Number(n.hue),
          "--color-saturation": "80%",
          "--color-lightness": "48%",
          "--color-text": "0, 0%, 100%"
        };
    });
    return (u, c) => (v(), g("div", null, [
      w("button", et({
        class: ["btn-toggle btn-dropdown", {
          btn: !n.buttonStyle,
          "btn-primary": n.buttonStyle === "primary",
          "btn-warning": n.buttonStyle === "warning",
          "btn-danger": n.buttonStyle === "danger",
          "btn-silent": n.buttonStyle === "silent",
          "btn--pressed": o.value
        }],
        ref_key: "button",
        ref: t,
        onClick: l,
        disabled: e.disabled,
        style: s.value
      }, u.$attrs, { type: "button" }), [
        i.value ? ce(u.$slots, "label", { key: 0 }, () => [
          w("div", null, S(e.label), 1)
        ], !0) : I("", !0),
        w("div", Pl, [
          w("div", Il, [
            ce(u.$slots, "icon", {}, () => [
              z(gt)
            ], !0)
          ])
        ])
      ], 16, Ml),
      t.value ? (v(), Z(je, {
        key: 0,
        ref_key: "dropdownMenu",
        ref: r,
        target: t.value,
        onOpen: c[0] || (c[0] = (f) => o.value = !0),
        onClose: c[1] || (c[1] = (f) => o.value = !1)
      }, {
        default: le(() => [
          ce(u.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["target"])) : I("", !0)
    ]));
  }
}), dt = /* @__PURE__ */ Y(Fl, [["__scopeId", "data-v-d315144a"]]), Al = {
  key: 0,
  class: "time-pickers"
}, Ll = {
  key: 1,
  class: "time-toggle-row"
}, Rl = /* @__PURE__ */ K({
  __name: "InstantRangePicker",
  props: /* @__PURE__ */ De({
    minDate: {},
    maxDate: {},
    startOfWeek: { default: 1 },
    weekNumbers: {},
    collapsibleTime: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = Me(e, "modelValue"), r = N(!1);
    re(t, (d) => {
      if (!n.collapsibleTime || !d || r.value) return;
      const m = d.from.getHours() === 0 && d.from.getMinutes() === 0, $ = d.to.getHours() === 23 && d.to.getMinutes() === 59;
      (!m || !$) && (r.value = !0);
    }, { immediate: !0 });
    const a = D(() => {
      if (t.value)
        return ye.fromDate(t.value.from);
    }), o = D(() => {
      if (t.value)
        return ye.fromDate(t.value.to);
    }), l = D({
      get() {
        return t.value ? {
          hours: t.value.from.getHours(),
          minutes: t.value.from.getMinutes()
        } : { hours: 0, minutes: 0 };
      },
      set(d) {
        if (!t.value) return;
        const m = new Date(t.value.from);
        m.setHours(d.hours, d.minutes, 0, 0), t.value = { ...t.value, from: m };
      }
    }), i = D({
      get() {
        return t.value ? {
          hours: t.value.to.getHours(),
          minutes: t.value.to.getMinutes()
        } : { hours: 23, minutes: 59 };
      },
      set(d) {
        if (!t.value) return;
        const m = new Date(t.value.to);
        m.setHours(d.hours, d.minutes, 0, 0), t.value = { ...t.value, to: m };
      }
    }), s = D(() => n.collapsibleTime && !r.value);
    function u(d) {
      const m = d.from.toDate(), $ = d.to.toDate();
      s.value ? (m.setHours(0, 0, 0, 0), $.setHours(23, 59, 59, 999)) : (m.setHours(l.value.hours, l.value.minutes, 0, 0), $.setHours(i.value.hours, i.value.minutes, 0, 0)), t.value = { from: m, to: $ };
    }
    function c() {
      r.value = !0;
    }
    function f() {
      if (r.value = !1, !t.value) return;
      const d = new Date(t.value.from);
      d.setHours(0, 0, 0, 0);
      const m = new Date(t.value.to);
      m.setHours(23, 59, 59, 999), t.value = { from: d, to: m };
    }
    return (d, m) => (v(), Z(fn, {
      mode: "range",
      "min-date": e.minDate,
      "max-date": e.maxDate,
      "start-of-week": e.startOfWeek,
      "week-numbers": e.weekNumbers,
      "range-from": a.value,
      "range-to": o.value,
      onSelectRange: u
    }, {
      default: le(() => [
        s.value ? e.collapsibleTime ? (v(), g("div", Ll, [
          w("button", {
            class: "time-toggle btn-silent",
            onClick: c
          }, "Set specific times")
        ])) : I("", !0) : (v(), g("div", Al, [
          z(Rn, {
            modelValue: l.value,
            "onUpdate:modelValue": m[0] || (m[0] = ($) => l.value = $),
            label: "From"
          }, null, 8, ["modelValue"]),
          z(Rn, {
            modelValue: i.value,
            "onUpdate:modelValue": m[1] || (m[1] = ($) => i.value = $),
            label: "To"
          }, null, 8, ["modelValue"]),
          e.collapsibleTime ? (v(), g("button", {
            key: 0,
            class: "time-toggle btn-silent",
            onClick: f
          }, "Clear times")) : I("", !0)
        ]))
      ]),
      _: 1
    }, 8, ["min-date", "max-date", "start-of-week", "week-numbers", "range-from", "range-to"]));
  }
}), vo = /* @__PURE__ */ Y(Rl, [["__scopeId", "data-v-ae83a618"]]), Ol = {
  minutes: 6e4,
  hours: 36e5,
  days: 864e5
}, ir = [
  { amount: 5, unit: "minutes" },
  { amount: 15, unit: "minutes" },
  { amount: 60, unit: "minutes" },
  { amount: 6, unit: "hours" },
  { amount: 24, unit: "hours" },
  { amount: 7, unit: "days" }
];
function Bl(e, n = /* @__PURE__ */ new Date()) {
  const t = new Date(n.getTime());
  return { from: new Date(t.getTime() - e.amount * Ol[e.unit]), to: t };
}
function sr(e, n = /* @__PURE__ */ new Date()) {
  return { ...Bl(e, n), rolling: { ...e } };
}
function Vl(e, n) {
  return !e || !n ? !1 : e.amount === n.amount && e.unit === n.unit;
}
function Kt(e) {
  const n = e.amount === 1 ? e.unit.slice(0, -1) : e.unit;
  return `Last ${e.amount} ${n}`;
}
const Kl = /^last\s+(\d+)\s*(m|min|mins|minute|minutes|h|hr|hrs|hour|hours|d|day|days)$/i;
function Hl(e) {
  const n = Kl.exec(e.trim());
  if (!n) return null;
  const t = Number(n[1]);
  if (!Number.isFinite(t) || t <= 0) return null;
  const r = n[2].toLowerCase(), a = r.startsWith("d") ? "days" : r.startsWith("h") ? "hours" : "minutes";
  return { amount: t, unit: a };
}
const Gl = ["title"], Ul = { class: "preset-check" }, Wl = { class: "preset-check" }, Zl = {
  key: 2,
  class: "p picker-dropdown"
}, zl = /* @__PURE__ */ K({
  __name: "InstantRangeInput",
  props: /* @__PURE__ */ De({
    minDate: {},
    maxDate: {},
    startOfWeek: { default: 1 },
    weekNumbers: {},
    collapsibleTime: { type: Boolean },
    rolling: { type: Boolean },
    allTime: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = Me(e, "modelValue"), r = N(""), a = N(!1), o = N(), l = N(), i = N(""), s = N(!1), u = new Intl.DateTimeFormat(document.documentElement.dataset.formatting ?? navigator.language, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    }), c = new Intl.DateTimeFormat(document.documentElement.dataset.formatting ?? navigator.language, {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    }), f = D(() => {
      var P;
      return n.rolling ? (P = t.value) == null ? void 0 : P.rolling : void 0;
    }), d = D(
      () => f.value ? Kt(f.value) : "Custom range"
    ), m = D(() => {
      if (!t.value)
        return !1;
      const P = t.value.from.getHours() === 0 && t.value.from.getMinutes() === 0, E = t.value.to.getHours() === 23 && t.value.to.getMinutes() === 59;
      return !P || !E;
    }), $ = D({
      get: () => t.value ? { from: t.value.from, to: t.value.to } : void 0,
      set: (P) => {
        t.value = P ? { from: P.from, to: P.to } : void 0;
      }
    });
    re(r, () => {
      i.value && (i.value = "");
    }), re(t, (P) => {
      if (!P) {
        r.value = n.allTime ? "All time" : "";
        return;
      }
      if (n.rolling && P.rolling) {
        r.value = Kt(P.rolling);
        return;
      }
      const E = m.value ? u : c, L = E.format(P.from), J = E.format(P.to);
      r.value = `${L} – ${J}`;
    }, { immediate: !0, deep: !0 });
    function y() {
      var P;
      (P = l.value) == null || P.close();
    }
    function p() {
      var P;
      a.value = !0, s.value = n.rolling ? ((P = t.value) == null ? void 0 : P.rolling) == null : !0;
    }
    function h(P) {
      var E;
      t.value = sr(P), i.value = "", (E = l.value) == null || E.close();
    }
    const b = D(() => t.value == null);
    function C() {
      var P;
      t.value = void 0, i.value = "", (P = l.value) == null || P.close();
    }
    function x(P) {
      return /\d{1,2}:\d{2}/.test(P);
    }
    function _(P) {
      const E = P.trim(), L = !x(E), J = new Date(E);
      return isNaN(J.getTime()) ? null : L ? { date: new Date(J.getFullYear(), J.getMonth(), J.getDate()), dateOnly: !0 } : { date: J, dateOnly: !1 };
    }
    function T(P) {
      const E = [" – ", " - ", " to ", " — ", "–", "—"];
      for (const L of E) {
        const J = P.split(L);
        if (J.length === 2) {
          const ie = _(J[0]), oe = _(J[1]);
          if (ie && oe)
            return ie.dateOnly && oe.dateOnly && oe.date.setHours(23, 59, 59, 999), { from: ie.date, to: oe.date };
        }
      }
      return null;
    }
    function W() {
      const P = r.value.trim();
      if (!P) {
        t.value = void 0, i.value = "";
        return;
      }
      if (n.rolling) {
        const L = Hl(P);
        if (L) {
          t.value = sr(L), i.value = "";
          return;
        }
      }
      const E = T(P);
      if (!E) {
        i.value = n.rolling ? 'Use "last 30 minutes" or: datetime – datetime' : "Range format should be: datetime – datetime";
        return;
      }
      if (E.from > E.to) {
        i.value = "Start must be before end";
        return;
      }
      t.value = E, i.value = "";
    }
    function F() {
      var P;
      (P = l.value) == null || P.open();
    }
    return (P, E) => (v(), g(G, null, [
      w("div", {
        class: j(["input", { "date-input--error": i.value }]),
        title: i.value || void 0
      }, [
        z(Ve, {
          modelValue: r.value,
          "onUpdate:modelValue": E[0] || (E[0] = (L) => r.value = L),
          onBlur: W
        }, null, 8, ["modelValue"]),
        w("button", {
          class: "btn-silent",
          onClick: F,
          ref_key: "button",
          ref: o
        }, [
          z(It)
        ], 512)
      ], 10, Gl),
      z(je, {
        ref_key: "dropdownMenu",
        ref: l,
        target: o.value,
        onOpen: p,
        onClose: E[3] || (E[3] = (L) => a.value = !1)
      }, {
        default: le(() => [
          e.allTime ? (v(), g(G, { key: 0 }, [
            z(Ie, { onClick: C }, {
              default: le(() => [
                w("span", Ul, S(b.value ? "✓" : ""), 1),
                E[4] || (E[4] = he(" All time ", -1))
              ]),
              _: 1
            }),
            z(lr)
          ], 64)) : I("", !0),
          e.rolling && !s.value ? (v(), g(G, { key: 1 }, [
            (v(!0), g(G, null, Q(ee(ir), (L) => (v(), Z(Ie, {
              key: `${L.amount}-${L.unit}`,
              onClick: (J) => h(L)
            }, {
              default: le(() => [
                w("span", Wl, S(ee(Vl)(f.value, L) ? "✓" : ""), 1),
                he(" " + S(ee(Kt)(L)), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))), 128)),
            z(lr),
            z(Ie, {
              onClick: E[1] || (E[1] = (L) => {
                L(), s.value = !0;
              })
            }, {
              default: le(() => [...E[5] || (E[5] = [
                w("span", { class: "preset-check" }, null, -1),
                he(" Custom range… ", -1)
              ])]),
              _: 1
            })
          ], 64)) : (v(), g("li", Zl, [
            e.rolling ? (v(), Z(dt, {
              key: 0,
              label: d.value,
              "button-style": "silent",
              class: "rolling-switch"
            }, {
              default: le(() => [
                (v(!0), g(G, null, Q(ee(ir), (L) => (v(), Z(Ie, {
                  key: `${L.amount}-${L.unit}`,
                  onClick: (J) => h(L)
                }, {
                  default: le(() => [
                    he(S(ee(Kt)(L)), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))), 128))
              ]),
              _: 1
            }, 8, ["label"])) : I("", !0),
            z(vo, {
              modelValue: $.value,
              "onUpdate:modelValue": E[2] || (E[2] = (L) => $.value = L),
              "min-date": e.minDate,
              "max-date": e.maxDate,
              "start-of-week": e.startOfWeek,
              "week-numbers": e.weekNumbers,
              "collapsible-time": e.collapsibleTime
            }, null, 8, ["modelValue", "min-date", "max-date", "start-of-week", "week-numbers", "collapsible-time"]),
            w("div", { class: "picker-actions" }, [
              w("button", {
                class: "btn-primary",
                onClick: y
              }, "Apply")
            ])
          ]))
        ]),
        _: 1
      }, 8, ["target"])
    ], 64));
  }
}), sm = /* @__PURE__ */ Y(zl, [["__scopeId", "data-v-30059445"]]), jl = ["name", "disabled", "placeholder", "maxlength"], Yl = /* @__PURE__ */ K({
  __name: "ElasticInput",
  props: /* @__PURE__ */ De({
    name: {},
    disabled: { type: Boolean },
    placeholder: {},
    maxlength: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ De(["blur", "focus", "keypress", "keydown", "keyenter"], ["update:modelValue"]),
  setup(e, { expose: n, emit: t }) {
    const [r, a] = Me(e, "modelValue"), o = t;
    n({
      setError: m,
      focus: p,
      blur: h,
      select: b,
      scrollIntoView: C
    });
    const l = N(), i = N(), s = N(r.value), u = N(!1);
    re(r, () => {
      s.value = r.value, c();
    });
    function c() {
      !i.value || !l.value || (l.value.style.height = l.value.getBoundingClientRect().height + "px", i.value.style.height = "0px", He(() => {
        !i.value || !l.value || (i.value.style.height = i.value.scrollHeight + 2 + "px", l.value.style.height = "");
      }));
    }
    let f = new IntersectionObserver((_) => {
      _[0].isIntersecting && c();
    });
    const d = D(() => {
      const _ = ["input", "elastic-input"];
      return u.value && _.push("elastic-input--error"), typeof r.value == "string" && r.value.trim().length > 0 ? _.push("elastic-input--has-value") : _.push("elastic-input--empty"), _;
    });
    function m(_) {
      _ ? u.value = _ : u.value = !0;
    }
    function $(_) {
      o("keydown", _), _.key === "Enter" && o("keyenter", _);
    }
    we(() => {
      c(), f.observe(i.value);
    }), Ze(() => {
      f.disconnect();
    });
    function y() {
      a.lazy || (r.value = s.value), c();
    }
    function p() {
      var _;
      (_ = i.value) == null || _.focus();
    }
    function h() {
      var _;
      (_ = i.value) == null || _.blur();
    }
    function b() {
      i.value && i.value.select();
    }
    function C() {
      i.value && i.value.scrollIntoView();
    }
    function x(_) {
      o("blur", _), a.lazy && (r.value = s.value);
    }
    return (_, T) => (v(), g(G, null, [
      w("div", et({
        class: d.value,
        ref_key: "container",
        ref: l
      }, _.$attrs), [
        be(w("textarea", {
          class: "elastic-input-area neat-scroll",
          name: e.name,
          "onUpdate:modelValue": T[0] || (T[0] = (W) => s.value = W),
          onInput: y,
          onBlur: x,
          onFocus: T[1] || (T[1] = (W) => o("focus", W)),
          onKeypress: T[2] || (T[2] = (W) => o("keypress", W)),
          onKeydown: $,
          ref_key: "element",
          ref: i,
          disabled: e.disabled,
          placeholder: e.placeholder,
          maxlength: e.maxlength
        }, null, 40, jl), [
          [pt, s.value]
        ])
      ], 16),
      w("div", {
        class: j(["elastic-input__error-message", { "elastic-input__error-message--hidden": typeof u.value != "string" }])
      }, S(u.value), 3)
    ], 64));
  }
}), um = /* @__PURE__ */ Y(Yl, [["__scopeId", "data-v-bfc63cd7"]]), ql = ["name", "disabled"], dm = /* @__PURE__ */ K({
  __name: "DecimalInput",
  props: /* @__PURE__ */ De({
    name: {},
    selectOnFocus: { type: Boolean },
    disabled: { type: Boolean },
    maxValue: {},
    minValue: {},
    allowPercentage: { type: Boolean },
    allowEmpty: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ De(["blur", "focus", "keypress", "keydown", "keyenter", "change"], ["update:modelValue"]),
  setup(e, { expose: n, emit: t }) {
    var L, J, ie, oe;
    const r = e, [a, o] = Me(e, "modelValue"), l = t;
    n({
      setError: b,
      focus: C,
      select: x
    }), Wn(() => {
      if (!(typeof a.value > "u") && Ne.isDecimal(a.value) == r.allowPercentage)
        throw new Error(
          `DecimalInput modelValue must be { value: Decimal, isPercentage: boolean } if allowPercentage
is true, or Decimal if allowPercentage is false. Got ${JSON.stringify(a.value)}`
        );
    });
    const i = new Intl.NumberFormat(document.documentElement.dataset.formatting ?? navigator.language, {}), s = N(), u = N(a.value), c = N(P()), f = N(!1);
    re(() => a.value, (O) => {
      u.value = a.value, s.value !== document.activeElement && (c.value = P());
    });
    function d() {
      var O;
      return r.allowPercentage ? (O = u.value) == null ? void 0 : O.value : u.value;
    }
    typeof r.minValue < "u" && u.value !== void 0 && ((L = d()) != null && L.lt(r.minValue)) ? Ne.isDecimal(u.value) ? p(F(r.minValue)) : p({
      value: F(r.minValue),
      isPercentage: ((J = u.value) == null ? void 0 : J.isPercentage) ?? !1
    }) : typeof r.minValue < "u" && u.value === void 0 && !r.allowEmpty && (r.allowPercentage ? p({ value: F(r.minValue), isPercentage: !1 }) : p(F(r.minValue))), typeof r.maxValue < "u" && u.value !== void 0 && ((ie = d()) != null && ie.gt(r.maxValue)) && (Ne.isDecimal(u.value) ? p(F(r.maxValue)) : p({
      value: F(r.maxValue),
      isPercentage: ((oe = u.value) == null ? void 0 : oe.isPercentage) ?? !1
    }));
    const m = i.format(1.1).substring(1, 2), $ = new RegExp("[^\\d" + (m == "." ? "\\." : m) + "]", "g");
    re(c, (O, H) => {
      if (typeof O != "string")
        return;
      O = O == null ? void 0 : O.trim(), O = O.replaceAll("−", "-");
      const X = O.length > 0 && O.substring(0, 1) === "-", B = O.length > 0 && O.substring(O.length - 1) === "%";
      if (O = O.replaceAll($, ""), O = O.replaceAll(m, "."), O.length === 0) {
        r.allowEmpty ? p(void 0) : E(
          () => {
            p({
              value: F(r.minValue ?? new Ne(0)),
              isPercentage: !1
            });
          },
          () => {
            p(F(r.minValue ?? new Ne(0)));
          }
        );
        return;
      }
      let R = new Ne(O);
      (X || r.maxValue === 0 && R.gt(0)) && (R = R.neg()), y(R, B);
    });
    function y(O, H, X) {
      E(
        (B) => {
          if (H = r.allowPercentage ? H : !1, typeof r.minValue < "u" && O.lt(r.minValue)) {
            const te = {
              value: F(r.minValue),
              isPercentage: H
            };
            (!B || te.value != B.value || te.isPercentage != B.isPercentage) && (p(te), l("change", te)), c.value = P(te);
            return;
          }
          if (typeof r.maxValue < "u" && O.gt(r.maxValue)) {
            const te = {
              value: F(r.maxValue),
              isPercentage: H
            };
            (!B || te.value != B.value || te.isPercentage != B.isPercentage) && (p(te), l("change", te)), c.value = P(te);
            return;
          }
          const R = {
            value: O,
            isPercentage: H
          };
          (!B || R.value != B.value || R.isPercentage != B.isPercentage) && (p(R), l("change", R)), X && (c.value = P(R));
        },
        (B) => {
          if (typeof r.minValue < "u" && O.lt(r.minValue)) {
            const R = F(r.minValue);
            (!B || R != B) && (p(R), l("change", R)), c.value = P(R);
            return;
          }
          if (typeof r.maxValue < "u" && O.gt(r.maxValue)) {
            const R = F(r.maxValue);
            (!B || R != B) && (p(R), l("change", R)), c.value = P(R);
            return;
          }
          (!B || O != B) && (p(O), l("change", O)), X && (c.value = P(O));
        }
      );
    }
    function p(O, H = !1) {
      u.value = O, (!o.lazy || H) && (a.value = u.value);
    }
    const h = D(() => {
      var O = ["decimal-input"];
      return f.value && O.push("decimal-input--error"), O;
    });
    function b(O) {
      O ? f.value = O : f.value = !0;
    }
    function C() {
      s.value && s.value.focus();
    }
    function x() {
      s.value && s.value.select();
    }
    function _(O) {
      O.key === "ArrowDown" && E(
        (H) => {
          y(
            (H == null ? void 0 : H.value.sub(1)) ?? new Ne(0),
            (H == null ? void 0 : H.isPercentage) ?? !1,
            !0
          );
        },
        (H) => {
          y(
            (H == null ? void 0 : H.sub(1)) ?? new Ne(0),
            !1,
            !0
          );
        }
      ), O.key === "ArrowUp" && E(
        (H) => {
          y(
            (H == null ? void 0 : H.value.add(1)) ?? new Ne(0),
            (H == null ? void 0 : H.isPercentage) ?? !1,
            !0
          );
        },
        (H) => {
          y(
            (H == null ? void 0 : H.add(1)) ?? new Ne(0),
            !1,
            !0
          );
        }
      ), l("keydown", O), O.key === "Enter" && (o.lazy && p(u.value, !0), l("keyenter", O));
    }
    function T(O) {
      c.value = P(), l("blur", O), o.lazy && p(u.value, !0);
    }
    function W(O) {
      r.selectOnFocus && x(), l("focus", O);
    }
    function F(O) {
      return O instanceof Ne ? O : new Ne(O);
    }
    function P(O) {
      return typeof O > "u" && (O = u.value), typeof O > "u" && r.allowEmpty ? "" : E(
        (H) => i.format((Ne.isDecimal(H == null ? void 0 : H.value) ? H.value : new Ne(0)).toNumber()) + (H != null && H.isPercentage ? "%" : ""),
        (H) => i.format((Ne.isDecimal(H) ? H : new Ne(0)).toNumber()),
        O
      );
    }
    function E(O, H, X = u.value) {
      return r.allowPercentage ? O(X) : H(X);
    }
    return (O, H) => (v(), g(G, null, [
      be(w("input", et(O.$attrs, {
        class: ["decimal-input", h.value],
        type: "text",
        name: e.name,
        "onUpdate:modelValue": H[0] || (H[0] = (X) => c.value = X),
        onBlur: T,
        onFocus: W,
        onKeypress: H[1] || (H[1] = (X) => l("keypress", X)),
        onKeydown: _,
        ref_key: "element",
        ref: s,
        disabled: e.disabled
      }), null, 16, ql), [
        [pt, c.value]
      ]),
      w("div", {
        class: j(["decimal-input__error-message", { "decimal-input__error-message--hidden": typeof f.value != "string" }])
      }, S(f.value), 3)
    ], 64));
  }
}), $o = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "60\\d{8}|(?:1\\d|[39])\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function jn(e, n) {
  var t = Array.prototype.slice.call(n);
  return t.push($o), e.apply(this, t);
}
var Xl = 3, Mt = "0-9０-９٠-٩۰-۹", Jl = "-‐-―−ー－", Ql = "／/", ei = "．.", ti = "  ­​⁠　", ni = "()（）［］\\[\\]", ri = "~⁓∼～", ct = "".concat(Jl).concat(Ql).concat(ei).concat(ti).concat(ni).concat(ri), oi = "+＋";
function ur(e, n) {
  e = e.split("-"), n = n.split("-");
  for (var t = e[0].split("."), r = n[0].split("."), a = 0; a < 3; a++) {
    var o = Number(t[a]), l = Number(r[a]);
    if (o > l) return 1;
    if (l > o) return -1;
    if (!isNaN(o) && isNaN(l)) return 1;
    if (isNaN(o) && !isNaN(l)) return -1;
  }
  return e[1] && n[1] ? e[1] > n[1] ? 1 : e[1] < n[1] ? -1 : 0 : !e[1] && n[1] ? 1 : e[1] && !n[1] ? -1 : 0;
}
var ai = {}.constructor;
function jt(e) {
  return e != null && e.constructor === ai;
}
function On(e) {
  "@babel/helpers - typeof";
  return On = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, On(e);
}
function mn(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function li(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function vn(e, n, t) {
  return n && li(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var ii = "1.2.0", si = "1.7.35", dr = " ext. ", ui = /^\d+$/, Be = /* @__PURE__ */ function() {
  function e(n) {
    mn(this, e), mi(n), this.metadata = n, ho.call(this, n);
  }
  return vn(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, r) {
      if (t && ui.test(t) && (r = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new cr(this.getCountryMetadata(t), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new cr(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var r = this.countryCallingCodes()[t];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var r = this.getCountryCodesForCallingCode(t);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var r = this.getCountryCodeForCallingCode(t);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var a = this.nonGeographic()[t];
        if (a)
          return a;
      } else {
        var o = this.countryCallingCodes()[t];
        if (o && o.length === 1 && o[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), cr = /* @__PURE__ */ function() {
  function e(n, t) {
    mn(this, e), this.globalMetadataObject = t, this.metadata = n, ho.call(this, t.metadata);
  }
  return vn(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(a) {
        return new di(a, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && fr(this.types(), t))
        return new fi(fr(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? dr : this.metadata[13] || dr;
    }
  }]), e;
}(), di = /* @__PURE__ */ function() {
  function e(n, t) {
    mn(this, e), this._format = n, this.metadata = t;
  }
  return vn(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !ci.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), ci = /^\(?\$1\)?$/, fi = /* @__PURE__ */ function() {
  function e(n, t) {
    mn(this, e), this.type = n, this.metadata = t;
  }
  return vn(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function fr(e, n) {
  switch (n) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function mi(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!jt(e) || !jt(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(jt(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + vi(e) + ": " + e, "."));
}
var vi = function(n) {
  return On(n);
};
function Yn(e, n) {
  if (n = new Be(n), n.hasCountry(e))
    return n.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function ho(e) {
  var n = e.version;
  typeof n == "number" ? (this.v1 = n === 1, this.v2 = n === 2, this.v3 = n === 3, this.v4 = n === 4) : n ? ur(n, ii) === -1 ? this.v2 = !0 : ur(n, si) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function $i(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = hi(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hi(e, n) {
  if (e) {
    if (typeof e == "string") return mr(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return mr(e, n);
  }
}
function mr(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
var pi = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function gi(e) {
  return pi[e];
}
function Qt(e) {
  for (var n = "", t = $i(e.split("")), r; !(r = t()).done; ) {
    var a = r.value, o = gi(a);
    o && (n += o);
  }
  return n;
}
function $n(e, n) {
  return yi(e, void 0, n);
}
function yi(e, n, t) {
  var r = t.type(n), a = r && r.possibleLengths() || t.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  var o = e.length, l = a[0];
  return l === o ? "IS_POSSIBLE" : l > o ? "TOO_SHORT" : a[a.length - 1] < o ? "TOO_LONG" : a.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function bi(e, n, t) {
  if (n === void 0 && (n = {}), t = new Be(t), n.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    t.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!t.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      t.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      t.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (t.possibleLengths())
    return wi(e.phone || e.nationalNumber, t);
  if (e.countryCallingCode && t.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function wi(e, n) {
  switch ($n(e, n)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function mt(e, n) {
  return e = e || "", new RegExp("^(?:" + n + ")$").test(e);
}
function Ci(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = ki(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ki(e, n) {
  if (e) {
    if (typeof e == "string") return vr(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return vr(e, n);
  }
}
function vr(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
var xi = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function qn(e, n, t) {
  if (n = n || {}, !(!e.country && !e.countryCallingCode)) {
    t = new Be(t), t.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = n.v2 ? e.nationalNumber : e.phone;
    if (mt(r, t.nationalNumberPattern())) {
      if (bn(r, "FIXED_LINE", t))
        return t.type("MOBILE") && t.type("MOBILE").pattern() === "" || !t.type("MOBILE") || bn(r, "MOBILE", t) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var a = Ci(xi), o; !(o = a()).done; ) {
        var l = o.value;
        if (bn(r, l, t))
          return l;
      }
    }
  }
}
function bn(e, n, t) {
  return n = t.type(n), !n || !n.pattern() || n.possibleLengths() && n.possibleLengths().indexOf(e.length) < 0 ? !1 : mt(e, n.pattern());
}
function _i(e, n, t) {
  if (n = n || {}, t = new Be(t), t.selectNumberingPlan(e.country, e.countryCallingCode), t.hasTypes())
    return qn(e, n, t.metadata) !== void 0;
  var r = n.v2 ? e.nationalNumber : e.phone;
  return mt(r, t.nationalNumberPattern());
}
function Ni(e, n, t) {
  var r = new Be(t), a = r.getCountryCodesForCallingCode(e);
  return a ? a.filter(function(o) {
    return Di(n, o, t);
  }) : [];
}
function Di(e, n, t) {
  var r = new Be(t);
  return r.selectNumberingPlan(n), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function po(e) {
  return e.replace(new RegExp("[".concat(ct, "]+"), "g"), " ").trim();
}
var go = /(\$\d)/;
function yo(e, n, t) {
  var r = t.useInternationalFormat, a = t.withNationalPrefix;
  t.carrierCode, t.metadata;
  var o = e.replace(new RegExp(n.pattern()), r ? n.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    a && n.nationalPrefixFormattingRule() ? n.format().replace(go, n.nationalPrefixFormattingRule()) : n.format()
  ));
  return r ? po(o) : o;
}
var Ei = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Ti(e, n, t) {
  var r = new Be(t);
  if (r.selectNumberingPlan(e, n), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (Ei.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
function Si(e) {
  var n = e.number, t = e.ext;
  if (!n)
    return "";
  if (n[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(n).concat(t ? ";ext=" + t : "");
}
function Mi(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Pi(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pi(e, n) {
  if (e) {
    if (typeof e == "string") return $r(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return $r(e, n);
  }
}
function $r(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function hr(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function pr(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? hr(Object(t), !0).forEach(function(r) {
      Ii(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : hr(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function Ii(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
var gr = {
  formatExtension: function(n, t, r) {
    return "".concat(n).concat(r.ext()).concat(t);
  }
};
function Fi(e, n, t, r) {
  if (t ? t = pr(pr({}, gr), t) : t = gr, r = new Be(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var a = r.countryCallingCode(), o = t.v2 ? e.nationalNumber : e.phone, l;
  switch (n) {
    case "NATIONAL":
      return o ? (l = en(o, e.carrierCode, "NATIONAL", r, t), wn(l, e.ext, r, t.formatExtension)) : "";
    case "INTERNATIONAL":
      return o ? (l = en(o, null, "INTERNATIONAL", r, t), l = "+".concat(a, " ").concat(l), wn(l, e.ext, r, t.formatExtension)) : "+".concat(a);
    case "E.164":
      return "+".concat(a).concat(o);
    case "RFC3966":
      return Si({
        number: "+".concat(a).concat(o),
        ext: e.ext
      });
    case "IDD":
      if (!t.fromCountry)
        return;
      var i = Li(o, e.carrierCode, a, t.fromCountry, r);
      return wn(i, e.ext, r, t.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(n, '"'));
  }
}
function en(e, n, t, r, a) {
  var o = Ai(r.formats(), e);
  return o ? yo(e, o, {
    useInternationalFormat: t === "INTERNATIONAL",
    withNationalPrefix: !(o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && a && a.nationalPrefix === !1),
    carrierCode: n,
    metadata: r
  }) : e;
}
function Ai(e, n) {
  for (var t = Mi(e), r; !(r = t()).done; ) {
    var a = r.value;
    if (a.leadingDigitsPatterns().length > 0) {
      var o = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
      if (n.search(o) !== 0)
        continue;
    }
    if (mt(n, a.pattern()))
      return a;
  }
}
function wn(e, n, t, r) {
  return n ? r(e, n, t) : e;
}
function Li(e, n, t, r, a) {
  var o = Yn(r, a.metadata);
  if (o === t) {
    var l = en(e, n, "NATIONAL", a);
    return t === "1" ? t + " " + l : l;
  }
  var i = Ti(r, void 0, a.metadata);
  if (i)
    return "".concat(i, " ").concat(t, " ").concat(en(e, null, "INTERNATIONAL", a));
}
function yr(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function br(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? yr(Object(t), !0).forEach(function(r) {
      Ri(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : yr(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function Ri(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function Oi(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Bi(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Vi(e, n, t) {
  return n && Bi(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var bo = /* @__PURE__ */ function() {
  function e(n, t, r) {
    if (Oi(this, e), !n)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!t)
      throw new TypeError("`nationalNumber` not passed");
    if (!r)
      throw new TypeError("`metadata` not passed");
    var a = Hi(n, r), o = a.country, l = a.countryCallingCode;
    this.country = o, this.countryCallingCode = l, this.nationalNumber = t, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return Vi(e, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : Ni(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return bi(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return _i(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new Be(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return qn(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, r) {
      return Fi(this, t, r ? br(br({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), e;
}(), Ki = function(n) {
  return /^[A-Z]{2}$/.test(n);
};
function Hi(e, n) {
  var t, r, a = new Be(n);
  return Ki(e) ? (t = e, a.selectNumberingPlan(t), r = a.countryCallingCode()) : r = e, {
    country: t,
    countryCallingCode: r
  };
}
var Gi = new RegExp("([" + Mt + "])");
function wo(e, n, t, r) {
  if (n) {
    var a = new Be(r);
    a.selectNumberingPlan(n, t);
    var o = new RegExp(a.IDDPrefix());
    if (e.search(o) === 0) {
      e = e.slice(e.match(o)[0].length);
      var l = e.match(Gi);
      if (!(l && l[1] != null && l[1].length > 0 && l[1] === "0"))
        return e;
    }
  }
}
function Bn(e, n) {
  if (e && n.numberingPlan.nationalPrefixForParsing()) {
    var t = new RegExp("^(?:" + n.numberingPlan.nationalPrefixForParsing() + ")"), r = t.exec(e);
    if (r) {
      var a, o, l = r.length - 1, i = l > 0 && r[l];
      if (n.nationalPrefixTransformRule() && i)
        a = e.replace(t, n.nationalPrefixTransformRule()), l > 1 && (o = r[1]);
      else {
        var s = r[0];
        a = e.slice(s.length), i && (o = r[1]);
      }
      var u;
      if (i) {
        var c = e.indexOf(r[1]), f = e.slice(0, c);
        f === n.numberingPlan.nationalPrefix() && (u = n.numberingPlan.nationalPrefix());
      } else
        u = r[0];
      return {
        nationalNumber: a,
        nationalPrefix: u,
        carrierCode: o
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function wr(e, n) {
  var t = Bn(e, n), r = t.carrierCode, a = t.nationalNumber;
  if (a !== e) {
    if (!Ui(e, a, n))
      return {
        nationalNumber: e
      };
    if (n.possibleLengths() && !Wi(a, n))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: a,
    carrierCode: r
  };
}
function Ui(e, n, t) {
  return !(mt(e, t.nationalNumberPattern()) && !mt(n, t.nationalNumberPattern()));
}
function Wi(e, n) {
  switch ($n(e, n)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Co(e, n, t, r) {
  var a = n ? Yn(n, r) : t;
  if (e.indexOf(a) === 0) {
    r = new Be(r), r.selectNumberingPlan(n, t);
    var o = e.slice(a.length), l = wr(o, r), i = l.nationalNumber, s = wr(e, r), u = s.nationalNumber;
    if (!mt(u, r.nationalNumberPattern()) && mt(i, r.nationalNumberPattern()) || $n(u, r) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: o
      };
  }
  return {
    number: e
  };
}
function Zi(e, n, t, r) {
  if (!e)
    return {};
  var a;
  if (e[0] !== "+") {
    var o = wo(e, n, t, r);
    if (o && o !== e)
      a = !0, e = "+" + o;
    else {
      if (n || t) {
        var l = Co(e, n, t, r), i = l.countryCallingCode, s = l.number;
        if (i)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: i,
            number: s
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new Be(r);
  for (var u = 2; u - 1 <= Xl && u <= e.length; ) {
    var c = e.slice(1, u);
    if (r.hasCallingCode(c))
      return r.selectNumberingPlan(c), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: e.slice(u)
      };
    u++;
  }
  return {};
}
function zi(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = ji(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ji(e, n) {
  if (e) {
    if (typeof e == "string") return Cr(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Cr(e, n);
  }
}
function Cr(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function ko(e, n) {
  var t = n.countries;
  n.defaultCountry;
  var r = n.metadata;
  r = new Be(r);
  for (var a = zi(t), o; !(o = a()).done; ) {
    var l = o.value;
    if (r.country(l), r.leadingDigits()) {
      if (e && e.search(r.leadingDigits()) === 0)
        return l;
    } else if (qn({
      phone: e,
      country: l
    }, void 0, r.metadata))
      return l;
  }
}
function Yi(e, n) {
  var t = n.nationalNumber, r = n.defaultCountry, a = n.metadata, o = a.getCountryCodesForCallingCode(e);
  if (o)
    return o.length === 1 ? o[0] : ko(t, {
      countries: o,
      defaultCountry: r,
      metadata: a.metadata
    });
}
function qi(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Xi(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ji(e, n, t) {
  return n && Xi(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Qi = /* @__PURE__ */ function() {
  function e(n) {
    var t = n.onCountryChange, r = n.onCallingCodeChange;
    qi(this, e), this.onCountryChange = t, this.onCallingCodeChange = r;
  }
  return Ji(e, [{
    key: "reset",
    value: function(t) {
      var r = t.country, a = t.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, a);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(t) {
      for (var r = 0, a = Object.keys(t); r < a.length; r++) {
        var o = a[r];
        this[o] = t[o];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(t, r) {
      this.setCountry(t), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(t) {
      this.country = t, this.onCountryChange(t);
    }
  }, {
    key: "setCallingCode",
    value: function(t) {
      this.callingCode = t, this.onCallingCodeChange(t, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      this.international = !0, this.initCountryAndCallingCode(t, r);
    }
  }, {
    key: "appendDigits",
    value: function(t) {
      this.digits += t;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(t) {
      this.nationalSignificantNumber += t;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function es(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = ts(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ts(e, n) {
  if (e) {
    if (typeof e == "string") return kr(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return kr(e, n);
  }
}
function kr(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
var qe = "x", Cn = new RegExp(qe);
function Yt(e, n) {
  if (n < 1)
    return "";
  for (var t = ""; n > 1; )
    n & 1 && (t += e), n >>= 1, e += e;
  return t + e;
}
function xr(e, n) {
  return e[n] === ")" && n++, ns(e.slice(0, n));
}
function ns(e) {
  for (var n = [], t = 0; t < e.length; )
    e[t] === "(" ? n.push(t) : e[t] === ")" && n.pop(), t++;
  var r = 0, a = "";
  n.push(e.length);
  for (var o = 0, l = n; o < l.length; o++) {
    var i = l[o];
    a += e.slice(r, i), r = i + 1;
  }
  return a;
}
function rs(e, n, t) {
  for (var r = es(t.split("")), a; !(a = r()).done; ) {
    var o = a.value;
    if (e.slice(n + 1).search(Cn) < 0)
      return;
    n = e.search(Cn), e = e.replace(Cn, o);
  }
  return [e, n];
}
function os(e, n, t) {
  var r = t.metadata, a = t.shouldTryNationalPrefixFormattingRule, o = t.getSeparatorAfterNationalPrefix, l = new RegExp("^(?:".concat(n.pattern(), ")$"));
  if (l.test(e.nationalSignificantNumber))
    return ls(e, n, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: a,
      getSeparatorAfterNationalPrefix: o
    });
}
function as(e, n) {
  return $n(e, n) === "IS_POSSIBLE";
}
function ls(e, n, t) {
  var r = t.metadata, a = t.shouldTryNationalPrefixFormattingRule, o = t.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, a(n)) {
    var l = _r(e, n, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: o,
      metadata: r
    });
    if (l)
      return l;
  }
  return _r(e, n, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: o,
    metadata: r
  });
}
function _r(e, n, t) {
  var r = t.metadata, a = t.useNationalPrefixFormattingRule, o = t.getSeparatorAfterNationalPrefix, l = yo(e.nationalSignificantNumber, n, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: a,
    metadata: r
  });
  if (a || (e.nationalPrefix ? l = e.nationalPrefix + o(n) + l : e.complexPrefixBeforeNationalSignificantNumber && (l = e.complexPrefixBeforeNationalSignificantNumber + " " + l)), is(l, e))
    return l;
}
function is(e, n) {
  return Qt(e) === n.getNationalDigits();
}
function ss(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function us(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ds(e, n, t) {
  return n && us(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var cs = /* @__PURE__ */ function() {
  function e() {
    ss(this, e);
  }
  return ds(e, [{
    key: "parse",
    value: function(t) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(t), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], a = r.branches, o = r.instructions;
      if (a)
        return {
          op: "|",
          args: a.concat([kn(o)])
        };
      if (o.length === 0)
        throw new Error("Pattern is required");
      return o.length === 1 ? o[0] : o;
    }
  }, {
    key: "startContext",
    value: function(t) {
      this.context.push(t);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(t) {
      if (!t)
        throw new Error("Pattern is required");
      var r = t.match(vs);
      if (!r) {
        if (ms.test(t))
          throw new Error("Illegal characters found in a pattern: ".concat(t));
        this.getContext().instructions = this.getContext().instructions.concat(t.split(""));
        return;
      }
      var a = r[1], o = t.slice(0, r.index), l = t.slice(r.index + a.length);
      switch (a) {
        case "(?:":
          o && this.parsePattern(o), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (o && this.parsePattern(o), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var i = this.getContext(), s = i.branches;
          s.push(kn(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: s
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (o && this.parsePattern(o), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(kn(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          o && this.parsePattern(o), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: fs(o)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(a));
      }
      l && this.parsePattern(l);
    }
  }]), e;
}();
function fs(e) {
  for (var n = [], t = 0; t < e.length; ) {
    if (e[t] === "-") {
      if (t === 0 || t === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var r = e[t - 1].charCodeAt(0) + 1, a = e[t + 1].charCodeAt(0) - 1, o = r; o <= a; )
        n.push(String.fromCharCode(o)), o++;
    } else
      n.push(e[t]);
    t++;
  }
  return n;
}
var ms = /[\(\)\[\]\?\:\|]/, vs = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function kn(e) {
  return e.length === 1 ? e[0] : e;
}
function Nr(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = $s(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $s(e, n) {
  if (e) {
    if (typeof e == "string") return Dr(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Dr(e, n);
  }
}
function Dr(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function hs(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function ps(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function gs(e, n, t) {
  return n && ps(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var ys = /* @__PURE__ */ function() {
  function e(n) {
    hs(this, e), this.matchTree = new cs().parse(n);
  }
  return gs(e, [{
    key: "match",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.allowOverflow;
      if (!t)
        throw new Error("String is required");
      var o = Vn(t.split(""), this.matchTree, !0);
      if (o && o.match && delete o.matchedChars, !(o && o.overflow && !a))
        return o;
    }
  }]), e;
}();
function Vn(e, n, t) {
  if (typeof n == "string") {
    var r = e.join("");
    return n.indexOf(r) === 0 ? e.length === n.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(n) === 0 ? t && e.length > n.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, n.length)
    } : void 0;
  }
  if (Array.isArray(n)) {
    for (var a = e.slice(), o = 0; o < n.length; ) {
      var l = n[o], i = Vn(a, l, t && o === n.length - 1);
      if (i) {
        if (i.overflow)
          return i;
        if (i.match) {
          if (a = a.slice(i.matchedChars.length), a.length === 0)
            return o === n.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (i.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(i, null, 2)));
        }
      } else return;
      o++;
    }
    return t ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - a.length)
    };
  }
  switch (n.op) {
    case "|":
      for (var s, u = Nr(n.args), c; !(c = u()).done; ) {
        var f = c.value, d = Vn(e, f, t);
        if (d) {
          if (d.overflow)
            return d;
          if (d.match)
            return {
              match: !0,
              matchedChars: d.matchedChars
            };
          if (d.partialMatch)
            s = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(d, null, 2)));
        }
      }
      return s ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var m = Nr(n.args), $; !($ = m()).done; ) {
        var y = $.value;
        if (e[0] === y)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : t ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [y]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(n));
  }
}
function Er(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = bs(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bs(e, n) {
  if (e) {
    if (typeof e == "string") return Tr(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Tr(e, n);
  }
}
function Tr(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function ws(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Cs(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ks(e, n, t) {
  return n && Cs(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Kn = "9", xs = 15, _s = Yt(Kn, xs), Ns = /[- ]/, Ds = function() {
  return /\[([^\[\]])*\]/g;
}, Es = function() {
  return /\d(?=[^,}][^,}])/g;
}, Ts = new RegExp("[" + ct + "]*\\$1[" + ct + "]*(\\$\\d[" + ct + "]*)*$"), Sr = 3, Ss = /* @__PURE__ */ function() {
  function e(n) {
    n.state;
    var t = n.metadata;
    ws(this, e), this.metadata = t, this.resetFormat();
  }
  return ks(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(t, r) {
      this.resetFormat(), t ? (this.isNANP = t.callingCode() === "1", this.matchingFormats = t.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(t, r) {
      var a = this;
      if (as(r.nationalSignificantNumber, this.metadata))
        for (var o = Er(this.matchingFormats), l; !(l = o()).done; ) {
          var i = l.value, s = os(r, i, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(c) {
              return a.shouldTryNationalPrefixFormattingRule(c, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(c) {
              return a.getSeparatorAfterNationalPrefix(c);
            }
          });
          if (s)
            return this.resetFormat(), this.chosenFormat = i, this.setNationalNumberTemplate(s.replace(/\d/g, qe), r), this.populatedNationalNumberTemplate = s, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(qe), s;
        }
      return this.formatNationalNumberWithNextDigits(t, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(t, r) {
      var a = this.chosenFormat, o = this.chooseFormat(r);
      if (o)
        return o === a ? this.formatNextNationalNumberDigits(t) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(t) {
      var r = this, a = t.nationalSignificantNumber, o = t.nationalPrefix, l = t.international, i = a, s = i.length - Sr;
      s < 0 && (s = 0), this.matchingFormats = this.matchingFormats.filter(function(u) {
        return r.formatSuits(u, l, o) && r.formatMatches(u, i, s);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(t, r, a) {
      return !(a && !t.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !t.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !a && t.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(t, r, a) {
      var o = t.leadingDigitsPatterns().length;
      if (o === 0)
        return !0;
      a = Math.min(a, o - 1);
      var l = t.leadingDigitsPatterns()[a];
      if (r.length < Sr)
        try {
          return new ys(l).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (i) {
          return console.error(i), !0;
        }
      return new RegExp("^(".concat(l, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(t, r) {
      return r ? t.internationalFormat() : t.format();
    }
  }, {
    key: "chooseFormat",
    value: function(t) {
      for (var r = this, a = function() {
        var u = l.value;
        return r.chosenFormat === u ? "break" : Ts.test(r.getFormatFormat(u, t.international)) ? r.createTemplateForFormat(u, t) ? (r.chosenFormat = u, "break") : (r.matchingFormats = r.matchingFormats.filter(function(c) {
          return c !== u;
        }), "continue") : "continue";
      }, o = Er(this.matchingFormats.slice()), l; !(l = o()).done; ) {
        var i = a();
        if (i === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(t, r) {
      if (!(t.pattern().indexOf("|") >= 0)) {
        var a = this.getTemplateForFormat(t, r);
        if (a)
          return this.setNationalNumberTemplate(a, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(t) {
      return this.isNANP || t && t.nationalPrefixFormattingRule() && Ns.test(t.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(t, r) {
      var a = t.IDDPrefix, o = t.missingPlus;
      return a ? r && r.spacing === !1 ? a : a + " " : o ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(t) {
      if (this.template) {
        for (var r = -1, a = 0, o = t.international ? this.getInternationalPrefixBeforeCountryCallingCode(t, {
          spacing: !1
        }) : ""; a < o.length + t.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(qe, r + 1), a++;
        return xr(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(t, r) {
      this.nationalNumberTemplate = t, this.populatedNationalNumberTemplate = t, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, qe) + Yt(qe, r.callingCode.length) + " " + t : this.template = t;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(t, r) {
      var a = r.nationalSignificantNumber, o = r.international, l = r.nationalPrefix, i = r.complexPrefixBeforeNationalSignificantNumber, s = t.pattern();
      s = s.replace(Ds(), "\\d").replace(Es(), "\\d");
      var u = _s.match(s)[0];
      if (!(a.length > u.length)) {
        var c = new RegExp("^" + s + "$"), f = a.replace(/\d/g, Kn);
        c.test(f) && (u = f);
        var d = this.getFormatFormat(t, o), m;
        if (this.shouldTryNationalPrefixFormattingRule(t, {
          international: o,
          nationalPrefix: l
        })) {
          var $ = d.replace(go, t.nationalPrefixFormattingRule());
          if (Qt(t.nationalPrefixFormattingRule()) === (l || "") + Qt("$1") && (d = $, m = !0, l))
            for (var y = l.length; y > 0; )
              d = d.replace(/\d/, qe), y--;
        }
        var p = u.replace(new RegExp(s), d).replace(new RegExp(Kn, "g"), qe);
        return m || (i ? p = Yt(qe, i.length) + " " + p : l && (p = Yt(qe, l.length) + this.getSeparatorAfterNationalPrefix(t) + p)), o && (p = po(p)), p;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(t) {
      var r = rs(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, t);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], xr(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(t, r) {
      var a = r.international, o = r.nationalPrefix;
      if (t.nationalPrefixFormattingRule()) {
        var l = t.usesNationalPrefix();
        if (l && o || !l && !a)
          return !0;
      }
    }
  }]), e;
}();
function xo(e, n) {
  return Fs(e) || Is(e, n) || Ps(e, n) || Ms();
}
function Ms() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ps(e, n) {
  if (e) {
    if (typeof e == "string") return Mr(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Mr(e, n);
  }
}
function Mr(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function Is(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r = [], a = !0, o = !1, l, i;
    try {
      for (t = t.call(e); !(a = (l = t.next()).done) && (r.push(l.value), !(n && r.length === n)); a = !0)
        ;
    } catch (s) {
      o = !0, i = s;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (o) throw i;
      }
    }
    return r;
  }
}
function Fs(e) {
  if (Array.isArray(e)) return e;
}
function As(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Ls(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Rs(e, n, t) {
  return n && Ls(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Os = "[" + ct + Mt + "]+", Bs = new RegExp("^" + Os + "$", "i"), Vs = "(?:[" + oi + "][" + ct + Mt + "]*|[" + ct + Mt + "]+)", Ks = new RegExp("[^" + ct + Mt + "]+.*$"), Hs = /[^\d\[\]]/, Gs = /* @__PURE__ */ function() {
  function e(n) {
    var t = n.defaultCountry, r = n.defaultCallingCode, a = n.metadata, o = n.onNationalSignificantNumberChange;
    As(this, e), this.defaultCountry = t, this.defaultCallingCode = r, this.metadata = a, this.onNationalSignificantNumberChange = o;
  }
  return Rs(e, [{
    key: "input",
    value: function(t, r) {
      var a = Zs(t), o = xo(a, 2), l = o[0], i = o[1], s = Qt(l), u;
      return i && (r.digits || (r.startInternationalNumber(), s || (u = !0))), s && this.inputDigits(s, r), {
        digits: s,
        justLeadingPlus: u
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(t, r) {
      var a = r.digits, o = a.length < 3 && a.length + t.length >= 3;
      if (r.appendDigits(t), o && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(t);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(l) {
        return r.update(l);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(t) {
      var r = t.international, a = t.callingCode;
      return r && !a;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(t) {
      var r = Zi("+" + t.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), a = r.countryCallingCode, o = r.number;
      if (a)
        return t.setCallingCode(a), t.update({
          nationalSignificantNumber: o
        }), !0;
    }
  }, {
    key: "reset",
    value: function(t) {
      if (t) {
        this.hasSelectedNumberingPlan = !0;
        var r = t._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && Hs.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(t, r) {
      if (this.hasSelectedNumberingPlan) {
        var a = Bn(t, this.metadata), o = a.nationalPrefix, l = a.nationalNumber, i = a.carrierCode;
        if (l !== t)
          return this.onExtractedNationalNumber(o, i, l, t, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(t, r, a) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(t, a);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var o = Bn(t, this.metadata), l = o.nationalPrefix, i = o.nationalNumber, s = o.carrierCode;
        if (i !== r)
          return this.onExtractedNationalNumber(l, s, i, t, a), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(t, r, a, o, l) {
      var i, s, u = o.lastIndexOf(a);
      if (u >= 0 && u === o.length - a.length) {
        s = !0;
        var c = o.slice(0, u);
        c !== t && (i = c);
      }
      l({
        nationalPrefix: t,
        carrierCode: r,
        nationalSignificantNumber: a,
        nationalSignificantNumberMatchesInput: s,
        complexPrefixBeforeNationalSignificantNumber: i
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(t) {
      if (this.extractAnotherNationalSignificantNumber(t.getNationalDigits(), t.nationalSignificantNumber, function(r) {
        return t.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
      if (this.fixMissingPlus(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(t) {
      var r = t.international, a = t.IDDPrefix, o = t.digits;
      if (t.nationalSignificantNumber, !(r || a)) {
        var l = wo(o, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (l !== void 0 && l !== o)
          return t.update({
            IDDPrefix: o.slice(0, o.length - l.length)
          }), this.startInternationalNumber(t, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(t) {
      if (!t.international) {
        var r = Co(t.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), a = r.countryCallingCode;
        if (r.number, a)
          return t.update({
            missingPlus: !0
          }), this.startInternationalNumber(t, {
            country: t.country,
            callingCode: a
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      var a = r.country, o = r.callingCode;
      t.startInternationalNumber(a, o), t.nationalSignificantNumber && (t.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(t) {
      this.extractCountryCallingCode(t) && this.extractNationalSignificantNumber(t.getNationalDigits(), function(r) {
        return t.update(r);
      });
    }
  }]), e;
}();
function Us(e) {
  var n = e.search(Vs);
  if (!(n < 0)) {
    e = e.slice(n);
    var t;
    return e[0] === "+" && (t = !0, e = e.slice(1)), e = e.replace(Ks, ""), t && (e = "+" + e), e;
  }
}
function Ws(e) {
  var n = Us(e) || "";
  return n[0] === "+" ? [n.slice(1), !0] : [n];
}
function Zs(e) {
  var n = Ws(e), t = xo(n, 2), r = t[0], a = t[1];
  return Bs.test(r) || (r = ""), [r, a];
}
function zs(e, n) {
  return Xs(e) || qs(e, n) || Ys(e, n) || js();
}
function js() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ys(e, n) {
  if (e) {
    if (typeof e == "string") return Pr(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Pr(e, n);
  }
}
function Pr(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function qs(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r = [], a = !0, o = !1, l, i;
    try {
      for (t = t.call(e); !(a = (l = t.next()).done) && (r.push(l.value), !(n && r.length === n)); a = !0)
        ;
    } catch (s) {
      o = !0, i = s;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (o) throw i;
      }
    }
    return r;
  }
}
function Xs(e) {
  if (Array.isArray(e)) return e;
}
function Js(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Qs(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function eu(e, n, t) {
  return n && Qs(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Xn = /* @__PURE__ */ function() {
  function e(n, t) {
    Js(this, e), this.metadata = new Be(t);
    var r = this.getCountryAndCallingCode(n), a = zs(r, 2), o = a[0], l = a[1];
    this.defaultCountry = o, this.defaultCallingCode = l, this.reset();
  }
  return eu(e, [{
    key: "getCountryAndCallingCode",
    value: function(t) {
      var r, a;
      return t && (jt(t) ? (r = t.defaultCountry, a = t.defaultCallingCode) : r = t), r && !this.metadata.hasCountry(r) && (r = void 0), [r, a];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(t) {
      var r = this.parser.input(t, this.state), a = r.digits, o = r.justLeadingPlus;
      if (o)
        this.formattedOutput = "+";
      else if (a) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var l;
        if (this.metadata.hasSelectedNumberingPlan() && (l = this.formatter.format(a, this.state)), l === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var i = this.state.getNationalDigits();
          i && (l = this.formatter.format(i, this.state));
        }
        this.formattedOutput = l ? this.getFullNumber(l) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var t = this;
      return this.state = new Qi({
        onCountryChange: function(a) {
          t.country = a;
        },
        onCallingCodeChange: function(a, o) {
          t.metadata.selectNumberingPlan(o, a), t.formatter.reset(t.metadata.numberingPlan, t.state), t.parser.reset(t.metadata.numberingPlan);
        }
      }), this.formatter = new Ss({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new Gs({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          t.determineTheCountryIfNeeded(), t.formatter.reset(t.metadata.numberingPlan, t.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var t = this.state.digits;
      if (t)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var t = this.state.country;
      return t;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(t) {
      var r = this;
      if (this.isInternational()) {
        var a = function(i) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!i
          }) + i;
        }, o = this.state.callingCode;
        return a(o ? t ? "".concat(o, " ").concat(t) : o : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return t;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, a = t.complexPrefixBeforeNationalSignificantNumber, o = t.nationalPrefix, l = r, i = a || o;
      return i && (l = i + l), l;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var t = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(t ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var t = this.getNonFormattedNumber();
      if (t)
        return t.replace(/[\+\d]/g, qe);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var t = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(t);
      return r && r.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(Yi(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var t = this.state, r = t.digits, a = t.callingCode, o = t.country, l = t.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return a ? "+" + a + l : "+" + r;
        if (o || a) {
          var i = o ? this.metadata.countryCallingCode() : a;
          return "+" + i + l;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, a = t.carrierCode, o = t.callingCode, l = this._getCountry();
      if (r && !(!l && !o)) {
        if (l && l === this.defaultCountry) {
          var i = new Be(this.metadata.metadata);
          i.selectNumberingPlan(l);
          var s = i.numberingPlan.callingCode(), u = this.metadata.getCountryCodesForCallingCode(s);
          if (u.length > 1) {
            var c = ko(r, {
              countries: u,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            c && (l = c);
          }
        }
        var f = new bo(l || o, r, this.metadata.metadata);
        return a && (f.carrierCode = a), f;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var t = this.getNumber();
      return t ? t.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var t = this.getNumber();
      return t ? t.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function tu(e, n, t) {
  if (n[e])
    return new bo(e, n[e], t);
}
function nu(e, n, t) {
  return t || (t = n, n = void 0), new Xn(n, t).input(e);
}
function tn(e) {
  return Xn.call(this, e, $o);
}
tn.prototype = Object.create(Xn.prototype, {});
tn.prototype.constructor = tn;
function Ir() {
  return jn(Yn, arguments);
}
function ru() {
  return jn(tu, arguments);
}
function ou() {
  return jn(nu, arguments);
}
const au = { AC: "40123", AD: "312345", AE: "501234567", AF: "701234567", AG: "2684641234", AI: "2642351234", AL: "672123456", AM: "77123456", AO: "923123456", AR: "91123456789", AS: "6847331234", AT: "664123456", AU: "412345678", AW: "5601234", AX: "412345678", AZ: "401234567", BA: "61123456", BB: "2462501234", BD: "1812345678", BE: "470123456", BF: "70123456", BG: "43012345", BH: "36001234", BI: "79561234", BJ: "90011234", BL: "690001234", BM: "4413701234", BN: "7123456", BO: "71234567", BQ: "3181234", BR: "11961234567", BS: "2423591234", BT: "17123456", BW: "71123456", BY: "294911911", BZ: "6221234", CA: "5062345678", CC: "412345678", CD: "991234567", CF: "70012345", CG: "061234567", CH: "781234567", CI: "0123456789", CK: "71234", CL: "221234567", CM: "671234567", CN: "13123456789", CO: "3211234567", CR: "83123456", CU: "51234567", CV: "9911234", CW: "95181234", CX: "412345678", CY: "96123456", CZ: "601123456", DE: "15123456789", DJ: "77831001", DK: "34412345", DM: "7672251234", DO: "8092345678", DZ: "551234567", EC: "991234567", EE: "51234567", EG: "1001234567", EH: "650123456", ER: "7123456", ES: "612345678", ET: "911234567", FI: "412345678", FJ: "7012345", FK: "51234", FM: "3501234", FO: "211234", FR: "612345678", GA: "06031234", GB: "7400123456", GD: "4734031234", GE: "555123456", GF: "694201234", GG: "7781123456", GH: "231234567", GI: "57123456", GL: "221234", GM: "3012345", GN: "601123456", GP: "690001234", GQ: "222123456", GR: "6912345678", GT: "51234567", GU: "6713001234", GW: "955012345", GY: "6091234", HK: "51234567", HN: "91234567", HR: "921234567", HT: "34101234", HU: "201234567", ID: "812345678", IE: "850123456", IL: "502345678", IM: "7924123456", IN: "8123456789", IO: "3801234", IQ: "7912345678", IR: "9123456789", IS: "6111234", IT: "3123456789", JE: "7797712345", JM: "8762101234", JO: "790123456", JP: "9012345678", KE: "712123456", KG: "700123456", KH: "91234567", KI: "72001234", KM: "3212345", KN: "8697652917", KP: "1921234567", KR: "1020000000", KW: "50012345", KY: "3453231234", KZ: "7710009998", LA: "2023123456", LB: "71123456", LC: "7582845678", LI: "660234567", LK: "712345678", LR: "770123456", LS: "50123456", LT: "61234567", LU: "628123456", LV: "21234567", LY: "912345678", MA: "650123456", MC: "612345678", MD: "62112345", ME: "67622901", MF: "690001234", MG: "321234567", MH: "2351234", MK: "72345678", ML: "65012345", MM: "92123456", MN: "88123456", MO: "66123456", MP: "6702345678", MQ: "696201234", MR: "22123456", MS: "6644923456", MT: "96961234", MU: "52512345", MV: "7712345", MW: "991234567", MX: "2221234567", MY: "123456789", MZ: "821234567", NA: "811234567", NC: "751234", NE: "93123456", NF: "381234", NG: "8021234567", NI: "81234567", NL: "612345678", NO: "40612345", NP: "9841234567", NR: "5551234", NU: "8884012", NZ: "211234567", OM: "92123456", PA: "61234567", PE: "912345678", PF: "87123456", PG: "70123456", PH: "9051234567", PK: "3012345678", PL: "512345678", PM: "551234", PR: "7872345678", PS: "599123456", PT: "912345678", PW: "6201234", PY: "961456789", QA: "33123456", RE: "692123456", RO: "712034567", RS: "601234567", RU: "9123456789", RW: "720123456", SA: "512345678", SB: "7421234", SC: "2510123", SD: "911231234", SE: "701234567", SG: "81234567", SH: "51234", SI: "31234567", SJ: "41234567", SK: "912123456", SL: "25123456", SM: "66661212", SN: "701234567", SO: "71123456", SR: "7412345", SS: "977123456", ST: "9812345", SV: "70123456", SX: "7215205678", SY: "944567890", SZ: "76123456", TA: "8999", TC: "6492311234", TD: "63012345", TG: "90112345", TH: "812345678", TJ: "917123456", TK: "7290", TL: "77212345", TM: "66123456", TN: "20123456", TO: "7715123", TR: "5012345678", TT: "8682911234", TV: "901234", TW: "912345678", TZ: "621234567", UA: "501234567", UG: "712345678", US: "2015550123", UY: "94231234", UZ: "912345678", VA: "3123456789", VC: "7844301234", VE: "4121234567", VG: "2843001234", VI: "3406421234", VN: "912345678", VU: "5912345", WF: "821234", WS: "7212345", XK: "43201234", YE: "712345678", YT: "639012345", ZA: "711234567", ZM: "955123456", ZW: "712345678" }, lu = { class: "phone-input__layout" }, iu = ["id", "name", "placeholder"], su = /* @__PURE__ */ K({
  __name: "PhoneInput",
  props: {
    modelValue: {},
    isValid: { type: Boolean, default: !1 },
    defaultCountry: { default: "SE" },
    name: {},
    id: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue", "update:isValid", "blur", "focus", "keypress", "keydown", "keyenter"],
  setup(e, { expose: n, emit: t }) {
    const r = e, a = t;
    n({
      setError: d,
      focus: m,
      select: $
    });
    const o = N(), l = N(r.modelValue), i = N(!1), s = N(r.defaultCountry.toLowerCase()), u = D(() => {
      var h;
      const p = (h = ru(r.defaultCountry.toUpperCase(), au)) == null ? void 0 : h.number;
      return p ? ou(p) : "";
    });
    re(() => r.modelValue, (p) => {
      l.value = p;
    }), re(l, (p) => {
      var _;
      if (p = p.trim(), p !== r.modelValue && (i.value = !1), !p) {
        r.required || a("update:isValid", !0);
        return;
      }
      const h = new tn(), b = h.input(p);
      if (!h.getCountry() && b.startsWith("+1") ? s.value = "us" : s.value = (h.getCountry() || r.defaultCountry).toLowerCase(), !o.value) {
        a("update:modelValue", b), r.required ? a("update:isValid", h.isValid()) : a("update:isValid", !0);
        return;
      }
      let C = o.value.selectionStart || p.length;
      if (p.startsWith("0")) {
        const T = Ir(r.defaultCountry.toUpperCase());
        C += T.length, l.value = "+" + T + p.substring(1);
      } else if (!p.startsWith("+")) {
        const T = Ir(r.defaultCountry.toUpperCase());
        C += T.length + 1, l.value = "+" + T + p;
      }
      const x = C + c(b.slice(0, C)) - c(p.slice(0, C));
      l.value = b, o.value.value = b, (_ = o.value) == null || _.setSelectionRange(x, x), a("update:modelValue", b), a("update:isValid", h.isValid());
    }, { immediate: !0 });
    function c(p) {
      const h = /\s/g, b = p.match(h);
      return b ? b.length : 0;
    }
    const f = D(() => {
      var p = ["phone-input"];
      return i.value && p.push("phone-input--error"), p;
    });
    function d(p) {
      p ? i.value = p : i.value = !0;
    }
    function m() {
      o.value && o.value.focus();
    }
    function $() {
      o.value && o.value.select();
    }
    function y(p) {
      a("keydown", p), p.key === "Enter" && a("keyenter", p);
    }
    return (p, h) => (v(), g(G, null, [
      w("div", {
        class: j(f.value)
      }, [
        w("div", lu, [
          w("span", {
            class: j(`phone-input__flag fi fi-${s.value}`)
          }, null, 2),
          be(w("input", {
            id: e.id,
            type: "text",
            autocomplete: "tel",
            name: e.name,
            "onUpdate:modelValue": h[0] || (h[0] = (b) => l.value = b),
            placeholder: u.value,
            onBlur: h[1] || (h[1] = (b) => a("blur", b)),
            onFocus: h[2] || (h[2] = (b) => a("focus", b)),
            onKeypress: h[3] || (h[3] = (b) => a("keypress", b)),
            onKeydown: y,
            ref_key: "element",
            ref: o
          }, null, 40, iu), [
            [pt, l.value]
          ])
        ])
      ], 2),
      w("div", {
        class: j(["text-input__error-message", { "text-input__error-message--hidden": typeof i.value != "string" }])
      }, S(i.value), 3)
    ], 64));
  }
}), uu = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
], du = ["disabled"], cu = { class: "country-select__label" }, fu = /* @__PURE__ */ K({
  __name: "CountrySelect",
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    allowedCountries: {}
  },
  emits: ["update:modelValue"],
  setup(e, { expose: n, emit: t }) {
    const r = e, a = t;
    n({
      setError: $
    });
    const o = N(), l = N(), i = N(!1);
    function s(y) {
      if (!y) return "";
      const p = typeof document < "u" ? document.documentElement.lang || navigator.language : "en";
      return new Intl.DisplayNames([p], { type: "region" }).of(y.toUpperCase()) || "";
    }
    const u = uu.map((y) => ({
      code: y,
      name: s(y)
    })).sort((y, p) => y.name.localeCompare(p.name)), c = D(() => {
      if (r.allowedCountries && r.allowedCountries.length > 0) {
        const y = new Set(r.allowedCountries.map((p) => p.toUpperCase()));
        return u.filter((p) => y.has(p.code));
      }
      return u;
    }), f = D(() => s(r.modelValue) || "-");
    function d() {
      var y;
      (y = l.value) == null || y.open();
    }
    function m(y) {
      a("update:modelValue", y);
    }
    function $(y) {
      i.value = y ?? !0;
    }
    return (y, p) => {
      var h;
      return v(), g(G, null, [
        w("button", {
          class: j({
            "country-select": !0,
            "country-select--disabled": e.disabled,
            "country-select--error": typeof i.value == "string"
          }),
          ref_key: "button",
          ref: o,
          onClick: d,
          disabled: e.disabled
        }, [
          w("div", {
            class: j(`fi fi-${(h = e.modelValue) == null ? void 0 : h.toLowerCase()}`)
          }, null, 2),
          w("div", cu, S(f.value), 1),
          p[0] || (p[0] = w("div", { class: "country-select__arrow" }, [
            w("svg", {
              class: "country-select__icon",
              viewBox: "0 0 25 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              w("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0.174789 3.04115L12.2077 15.3069L24.1485 3.13496L20.6194 0.205244L12.2077 8.77975L3.7039 0.111435L0.174789 3.04115Z",
                fill: "currentColor"
              })
            ])
          ], -1))
        ], 10, du),
        w("div", {
          class: j(["country-select__error-message", { "country-select__error-message--hidden": typeof i.value != "string" }])
        }, S(i.value), 3),
        o.value ? (v(), Z(je, {
          key: 0,
          ref_key: "dropdown",
          ref: l,
          target: o.value
        }, {
          default: le(() => [
            (v(!0), g(G, null, Q(c.value, (b) => (v(), Z(Ie, {
              key: b.code,
              onClick: (C) => m(b.code)
            }, {
              default: le(() => [
                w("span", {
                  class: j(`fi fi-${b.code.toLowerCase()}`)
                }, null, 2),
                he(" " + S(b.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))), 128))
          ]),
          _: 1
        }, 8, ["target"])) : I("", !0)
      ], 64);
    };
  }
}), mu = {
  GB: /^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}$/,
  JE: /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  GG: /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  IM: /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  US: /^\d{5}([ \-]\d{4})?$/,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/,
  DE: /^\d{5}$/,
  JP: /^\d{3}-\d{4}$/,
  FR: /^\d{2}[ ]?\d{3}$/,
  AU: /^\d{4}$/,
  IT: /^\d{5}$/,
  CH: /^\d{4}$/,
  AT: /^\d{4}$/,
  ES: /^\d{5}$/,
  NL: /^\d{4}[ ]?[A-Z]{2}$/,
  BE: /^\d{4}$/,
  DK: /^\d{4}$/,
  SE: /^\d{3}[ ]?\d{2}$/,
  NO: /^\d{4}$/,
  BR: /^\d{5}[\-]?\d{3}$/,
  PT: /^\d{4}([\-]\d{3})?$/,
  FI: /^\d{5}$/,
  AX: /^22\d{3}$/,
  KR: /^\d{3}[\-]\d{3}$/,
  CN: /^\d{6}$/,
  TW: /^\d{3}(\d{2})?$/,
  SG: /^\d{6}$/,
  DZ: /^\d{5}$/,
  AD: /^AD\d{3}$/,
  AR: /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/,
  AM: /^(37)?\d{4}$/,
  AZ: /^\d{4}$/,
  BH: /^((1[0-2]|[2-9])\d{2})?$/,
  BD: /^\d{4}$/,
  BB: /^(BB\d{5})?$/,
  BY: /^\d{6}$/,
  BM: /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/,
  BA: /^\d{5}$/,
  IO: /^BBND 1ZZ$/,
  BN: /^[A-Z]{2}[ ]?\d{4}$/,
  BG: /^\d{4}$/,
  KH: /^\d{5}$/,
  CV: /^\d{4}$/,
  CL: /^\d{7}$/,
  CR: /^\d{4,5}|\d{3}-\d{4}$/,
  HR: /^\d{5}$/,
  CY: /^\d{4}$/,
  CZ: /^\d{3}[ ]?\d{2}$/,
  DO: /^\d{5}$/,
  EC: /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/,
  EG: /^\d{5}$/,
  EE: /^\d{5}$/,
  FO: /^\d{3}$/,
  GE: /^\d{4}$/,
  GR: /^\d{3}[ ]?\d{2}$/,
  GL: /^39\d{2}$/,
  GT: /^\d{5}$/,
  HT: /^\d{4}$/,
  HN: /^(?:\d{5})?$/,
  HU: /^\d{4}$/,
  IS: /^\d{3}$/,
  IN: /^\d{6}$/,
  ID: /^\d{5}$/,
  IL: /^\d{5}$/,
  JO: /^\d{5}$/,
  KZ: /^\d{6}$/,
  KE: /^\d{5}$/,
  KW: /^\d{5}$/,
  LA: /^\d{5}$/,
  LV: /^\d{4}$/,
  LB: /^(\d{4}([ ]?\d{4})?)?$/,
  LI: /^(948[5-9])|(949[0-7])$/,
  LT: /^\d{5}$/,
  LU: /^\d{4}$/,
  MK: /^\d{4}$/,
  MY: /^\d{5}$/,
  MV: /^\d{5}$/,
  MT: /^[A-Z]{3}[ ]?\d{2,4}$/,
  MU: /^(\d{3}[A-Z]{2}\d{3})?$/,
  MX: /^\d{5}$/,
  MD: /^\d{4}$/,
  MC: /^980\d{2}$/,
  MA: /^\d{5}$/,
  NP: /^\d{5}$/,
  NZ: /^\d{4}$/,
  NI: /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/,
  NG: /^(\d{6})?$/,
  OM: /^(PC )?\d{3}$/,
  PK: /^\d{5}$/,
  PY: /^\d{4}$/,
  PH: /^\d{4}$/,
  PL: /^\d{2}-\d{3}$/,
  PR: /^00[679]\d{2}([ \-]\d{4})?$/,
  RO: /^\d{6}$/,
  RU: /^\d{6}$/,
  SM: /^4789\d$/,
  SA: /^\d{5}$/,
  SN: /^\d{5}$/,
  SK: /^\d{3}[ ]?\d{2}$/,
  SI: /^\d{4}$/,
  ZA: /^\d{4}$/,
  LK: /^\d{5}$/,
  TJ: /^\d{6}$/,
  TH: /^\d{5}$/,
  TN: /^\d{4}$/,
  TR: /^\d{5}$/,
  TM: /^\d{6}$/,
  UA: /^\d{5}$/,
  UY: /^\d{5}$/,
  UZ: /^\d{6}$/,
  VA: /^00120$/,
  VE: /^\d{4}$/,
  ZM: /^\d{5}$/,
  AS: /^96799$/,
  CC: /^6799$/,
  CK: /^\d{4}$/,
  RS: /^\d{6}$/,
  ME: /^8\d{4}$/,
  CS: /^\d{5}$/,
  YU: /^\d{5}$/,
  CX: /^6798$/,
  ET: /^\d{4}$/,
  FK: /^FIQQ 1ZZ$/,
  NF: /^2899$/,
  FM: /^(9694[1-4])([ \-]\d{4})?$/,
  GF: /^9[78]3\d{2}$/,
  GN: /^\d{3}$/,
  GP: /^9[78][01]\d{2}$/,
  GS: /^SIQQ 1ZZ$/,
  GU: /^969[123]\d([ \-]\d{4})?$/,
  GW: /^\d{4}$/,
  HM: /^\d{4}$/,
  IQ: /^\d{5}$/,
  KG: /^\d{6}$/,
  LR: /^\d{4}$/,
  LS: /^\d{3}$/,
  MG: /^\d{3}$/,
  MH: /^969[67]\d([ \-]\d{4})?$/,
  MN: /^\d{6}$/,
  MP: /^9695[012]([ \-]\d{4})?$/,
  MQ: /^9[78]2\d{2}$/,
  NC: /^988\d{2}$/,
  NE: /^\d{4}$/,
  VI: /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/,
  PF: /^987\d{2}$/,
  PG: /^\d{3}$/,
  PM: /^9[78]5\d{2}$/,
  PN: /^PCRN 1ZZ$/,
  PW: /^96940$/,
  RE: /^9[78]4\d{2}$/,
  SH: /^(ASCN|STHL) 1ZZ$/,
  SJ: /^\d{4}$/,
  SO: /^\d{5}$/,
  SZ: /^[HLMS]\d{3}$/,
  TC: /^TKCA 1ZZ$/,
  WF: /^986\d{2}$/,
  XK: /^\d{5}$/,
  YT: /^976\d{2}$/
};
function vu(e, n) {
  const t = mu[e.toUpperCase()];
  return t ? t.test(n) : !0;
}
const $u = { class: "address-editor__name" }, hu = { class: "address-editor__city" }, pu = { class: "address-editor__postal-code" }, gu = { class: "address-editor__country-and-state" }, yu = { key: 0 }, bu = { key: 1 }, cm = /* @__PURE__ */ K({
  __name: "AddressEditor",
  props: {
    modelValue: {},
    allowedCountries: {},
    showContactInformation: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: n, emit: t }) {
    const r = e;
    n({
      validate: p
    });
    const a = t, o = N({ ...r.modelValue }), l = N(), i = N(), s = N(), u = Ge("elemCountryCode"), c = N(), f = N(), d = N(), m = N(!1);
    re(() => r.modelValue, (h) => {
      JSON.stringify(h) !== JSON.stringify(o.value) && (o.value = { ...h });
    }), re(o, () => {
      a("update:modelValue", o.value);
    }, { deep: !0 });
    const $ = {
      US: ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"],
      CA: ["AB", "BC", "MB", "NB", "NL", "NT", "NS", "NU", "ON", "PE", "QC", "SK", "YT"],
      AU: ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
      GB: ["ENG", "NIR", "SCT", "WLS"],
      DE: ["BW", "BY", "BE", "BB", "HB", "HH", "HE", "MV", "NI", "NW", "RP", "SL", "SN", "ST", "SH", "TH"]
    }, y = D(() => o.value.state && o.value.state.length > 0 ? !1 : !o.value.countryCode || typeof $[o.value.countryCode.toUpperCase()] > "u");
    function p() {
      var b, C, x, _, T, W, F, P;
      let h = !0;
      return o.value.name.trim().length < 2 && ((b = l.value) == null || b.setError("Required"), h = !1), o.value.addressLine1.trim().length < 2 && ((C = i.value) == null || C.setError("Required"), h = !1), o.value.postalCode.trim().length === 0 && ((x = s.value) == null || x.setError("Required"), h = !1), o.value.countryCode.length === 0 ? ((_ = u.value) == null || _.setError("Invalid"), h = !1) : vu(o.value.countryCode, o.value.postalCode) || ((T = s.value) == null || T.setError("Invalid"), h = !1), o.value.city.trim().length < 2 && ((W = c.value) == null || W.setError("Required"), h = !1), r.showContactInformation && (o.value.email.trim().length <= 5 && ((F = f.value) == null || F.setError("Required"), h = !1), m.value || ((P = d.value) == null || P.setError("Invalid"), h = !1)), h;
    }
    return (h, b) => (v(), g("fieldset", null, [
      w("div", $u, [
        w("div", null, [
          b[10] || (b[10] = w("label", null, "Name", -1)),
          z(Ve, {
            modelValue: o.value.name,
            "onUpdate:modelValue": b[0] || (b[0] = (C) => o.value.name = C),
            ref_key: "elemName",
            ref: l,
            autocomplete: "off"
          }, null, 8, ["modelValue"])
        ])
      ]),
      w("div", null, [
        b[11] || (b[11] = w("label", null, "Address", -1)),
        z(Ve, {
          modelValue: o.value.addressLine1,
          "onUpdate:modelValue": b[1] || (b[1] = (C) => o.value.addressLine1 = C),
          ref_key: "elemAddress1",
          ref: i
        }, null, 8, ["modelValue"])
      ]),
      w("div", null, [
        z(Ve, {
          modelValue: o.value.addressLine2,
          "onUpdate:modelValue": b[2] || (b[2] = (C) => o.value.addressLine2 = C)
        }, null, 8, ["modelValue"])
      ]),
      w("div", hu, [
        w("div", pu, [
          b[12] || (b[12] = w("label", null, "Postal code", -1)),
          z(Ve, {
            modelValue: o.value.postalCode,
            "onUpdate:modelValue": b[3] || (b[3] = (C) => o.value.postalCode = C),
            ref_key: "elemPostalCode",
            ref: s
          }, null, 8, ["modelValue"])
        ]),
        w("div", null, [
          b[13] || (b[13] = w("label", null, "City", -1)),
          z(Ve, {
            modelValue: o.value.city,
            "onUpdate:modelValue": b[4] || (b[4] = (C) => o.value.city = C),
            ref_key: "elemCity",
            ref: c
          }, null, 8, ["modelValue"])
        ])
      ]),
      w("div", gu, [
        w("div", null, [
          b[14] || (b[14] = w("label", null, "Country", -1)),
          z(fu, {
            modelValue: o.value.countryCode,
            "onUpdate:modelValue": b[5] || (b[5] = (C) => o.value.countryCode = C),
            ref_key: "elemCountryCode",
            ref: u,
            "allowed-countries": e.allowedCountries
          }, null, 8, ["modelValue", "allowed-countries"])
        ]),
        w("div", null, [
          b[15] || (b[15] = w("label", null, "State", -1)),
          z(Ve, {
            modelValue: o.value.state,
            "onUpdate:modelValue": b[6] || (b[6] = (C) => o.value.state = C),
            disabled: y.value
          }, null, 8, ["modelValue", "disabled"])
        ])
      ]),
      e.showContactInformation ? (v(), g("div", yu, [
        b[16] || (b[16] = w("label", null, "E-mail", -1)),
        z(Ve, {
          modelValue: o.value.email,
          "onUpdate:modelValue": b[7] || (b[7] = (C) => o.value.email = C),
          ref_key: "elemEmail",
          ref: f
        }, null, 8, ["modelValue"])
      ])) : I("", !0),
      e.showContactInformation ? (v(), g("div", bu, [
        b[17] || (b[17] = w("label", null, "Phone", -1)),
        z(su, {
          modelValue: o.value.phone,
          "onUpdate:modelValue": b[8] || (b[8] = (C) => o.value.phone = C),
          ref_key: "elemPhone",
          ref: d,
          "is-valid": m.value,
          "onUpdate:isValid": b[9] || (b[9] = (C) => m.value = C),
          "default-country": o.value.countryCode
        }, null, 8, ["modelValue", "is-valid", "default-country"])
      ])) : I("", !0),
      ce(h.$slots, "default")
    ]));
  }
}), wu = /* @__PURE__ */ K({
  __name: "ContextMenuButton",
  setup(e) {
    return (n, t) => (v(), Z(dt, { "button-style": "silent" }, {
      icon: le(() => [...t[0] || (t[0] = [
        w("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, [
          w("circle", {
            cx: "3",
            cy: "12",
            r: "2.5",
            fill: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          w("circle", {
            cx: "12",
            cy: "12",
            r: "2.5",
            fill: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          w("circle", {
            cx: "21",
            cy: "12",
            r: "2.5",
            fill: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)
      ])]),
      default: le(() => [
        ce(n.$slots, "default")
      ]),
      _: 3
    }));
  }
}), fm = /* @__PURE__ */ K({
  __name: "ListLink",
  props: {
    to: {},
    label: {}
  },
  setup(e) {
    const n = N(), t = N(!1), r = Dt();
    function a(l) {
      t.value = l;
    }
    const o = D(() => r.dropdown !== void 0);
    return (l, i) => {
      const s = zr("router-link");
      return v(), g("li", {
        class: "list-link",
        ref_key: "element",
        ref: n
      }, [
        z(s, {
          to: e.to,
          class: j(["list-link__anchor", { "list-link__anchor--open": t.value }])
        }, {
          default: le(() => [
            ce(l.$slots, "default", {}, () => [
              he(S(e.label), 1)
            ]),
            o.value ? (v(), Z(wu, {
              key: 0,
              onToggled: a,
              class: "list-link__context-menu"
            }, {
              default: le(() => [
                ce(l.$slots, "dropdown")
              ]),
              _: 3
            })) : I("", !0)
          ]),
          _: 3
        }, 8, ["to", "class"])
      ], 512);
    };
  }
}), Cu = {
  key: 0,
  class: "panel__label"
}, mm = /* @__PURE__ */ K({
  __name: "Panel",
  props: {
    label: {},
    isRoot: { type: Boolean }
  },
  setup(e) {
    return (n, t) => (v(), g("div", {
      class: j(["panel", { "panel--root": e.isRoot }])
    }, [
      e.label ? (v(), g("div", Cu, S(e.label), 1)) : I("", !0),
      ce(n.$slots, "default")
    ], 2));
  }
}), ku = {}, xu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function _u(e, n) {
  return v(), g("svg", xu, [...n[0] || (n[0] = [
    w("line", {
      x1: "200",
      y1: "56",
      x2: "56",
      y2: "200",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("line", {
      x1: "200",
      y1: "200",
      x2: "56",
      y2: "56",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const yt = /* @__PURE__ */ Y(ku, [["render", _u]]), Nu = {
  key: 0,
  class: "floating-panel__label"
}, vm = /* @__PURE__ */ K({
  __name: "FloatingPanel",
  props: {
    label: {},
    showClose: { type: Boolean },
    defaultWidth: {}
  },
  emits: ["close"],
  setup(e, { expose: n, emit: t }) {
    const r = e;
    n({
      open: d,
      openModal: m,
      close: y
    });
    const a = t, o = N(), l = N(), i = Zo(), s = N(!1);
    let u = !1;
    const c = N(0), f = N(0);
    function d() {
      var E;
      (E = l.value) == null || E.show(), s.value = !0, $();
    }
    function m() {
      var E;
      (E = l.value) == null || E.showModal(), s.value = !0, $();
    }
    function $() {
      He(() => {
        if (!l.value)
          return;
        const E = l.value.getBoundingClientRect();
        c.value = document.documentElement.clientHeight / 2 - E.height / 2, f.value = document.documentElement.clientWidth / 2 - E.width / 2, u = !1;
      });
    }
    function y() {
      var E;
      (E = l.value) == null || E.close(), s.value = !1, a("close");
    }
    Nt(sn, y);
    const p = new ResizeObserver(() => {
      u ? P() : $();
    }), h = { attributes: !0, childList: !0, subtree: !0 }, b = new MutationObserver(P);
    re(s, () => {
      s.value ? l.value instanceof HTMLElement && (b.observe(l.value, h), p.observe(l.value)) : (b.disconnect(), p.disconnect());
    }), we(() => {
      var E;
      typeof i.open < "u" && ($(), s.value = !0), typeof i["open-modal"] < "u" && m(), (E = l.value) == null || E.addEventListener("close", y), window.addEventListener("resize", P);
    }), lt(() => {
      var E;
      (E = l.value) == null || E.removeEventListener("close", y), window.removeEventListener("resize", P);
    }), Wn(() => {
      C();
    });
    function C() {
      o.value = {
        top: `${c.value}px`,
        left: `${f.value}px`,
        visibility: "visible",
        width: r.defaultWidth
      };
    }
    let x = 0, _ = 0;
    function T(E) {
      if (E.preventDefault(), E.stopPropagation(), !!l.value) {
        document.addEventListener("mousemove", F), document.addEventListener("mouseup", W);
        var L = l.value.getBoundingClientRect();
        x = E.clientX - L.left, _ = E.clientY - L.top;
      }
    }
    function W(E) {
      document.removeEventListener("mousemove", F), document.removeEventListener("mouseup", W);
    }
    function F(E) {
      if (!l.value)
        return;
      var L = l.value.getBoundingClientRect();
      let J = E.clientX - x;
      J < 0 && (J = 0), J + L.width > document.documentElement.clientWidth && (J = document.documentElement.clientWidth - L.width), f.value = J;
      let ie = E.clientY - _;
      ie < 0 && (ie = 0), ie + L.height > document.documentElement.clientHeight && (ie = document.documentElement.clientHeight - L.height), c.value = ie, u = !0;
    }
    function P() {
      if (!l.value)
        return;
      const E = l.value.getBoundingClientRect();
      f.value < 0 && (f.value = 0), f.value + E.width > document.documentElement.clientWidth && (f.value = document.documentElement.clientWidth - E.width), c.value < 0 && (c.value = 0), c.value + E.height > document.documentElement.clientHeight && (c.value = document.documentElement.clientHeight - E.height);
    }
    return (E, L) => (v(), g("dialog", et({
      ref_key: "dialogElem",
      ref: l,
      class: "floating-panel neat-scroll"
    }, E.$attrs, {
      style: o.value,
      onMousedown: T
    }), [
      e.label ? (v(), g("div", Nu, [
        w("div", null, S(e.label), 1),
        e.showClose ? (v(), g("div", {
          key: 0,
          class: "floating-panel__close",
          onClick: L[0] || (L[0] = (J) => y())
        }, [
          z(yt)
        ])) : I("", !0)
      ])) : I("", !0),
      s.value ? (v(), g("div", {
        key: 1,
        onMousedown: L[1] || (L[1] = Ee(() => {
        }, ["stop"])),
        class: "floating-panel__content"
      }, [
        ce(E.$slots, "default")
      ], 32)) : I("", !0)
    ], 16));
  }
}), Du = {
  key: 0,
  class: "box-content-label"
}, $m = /* @__PURE__ */ K({
  __name: "PanelContent",
  props: {
    label: {},
    contentClass: {}
  },
  setup(e) {
    const n = e, t = D(() => {
      var r = ["panel-content__body"];
      if (typeof n.contentClass == "string" && r.push(n.contentClass), Array.isArray(n.contentClass))
        r.push(...n.contentClass);
      else if (typeof n.contentClass == "object")
        for (const a in n.contentClass)
          n.contentClass[a] && r.push(a);
      return r;
    });
    return (r, a) => (v(), g("div", et({ class: "panel-content" }, r.$attrs), [
      e.label ? (v(), g("div", Du, S(e.label), 1)) : I("", !0),
      w("div", {
        class: j(t.value)
      }, [
        ce(r.$slots, "default")
      ], 2)
    ], 16));
  }
}), Eu = ["data-value"], Tu = ["type", "name", "placeholder"], hm = /* @__PURE__ */ K({
  __name: "InlineInput",
  props: {
    modelValue: {},
    name: {},
    type: {},
    placeholder: {},
    autocomplete: {}
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { expose: n, emit: t }) {
    const r = e, a = t;
    n({
      setError: c,
      focus: f,
      select: d
    });
    const o = N(), l = N(r.modelValue), i = N(!1);
    re(() => r.modelValue, ($) => {
      l.value = $;
    }), re(l, ($) => {
      $ !== r.modelValue && (i.value = !1, a("update:modelValue", $ || ""));
    });
    const s = D(() => {
      var $ = ["inline-input__input"];
      return i.value && $.push("inline-input__input--error"), $;
    }), u = D(() => {
      var $ = ["inline-input"];
      return $;
    });
    function c($) {
      $ ? i.value = $ : i.value = !0;
    }
    function f() {
      o.value && o.value.focus();
    }
    function d() {
      o.value && o.value.select();
    }
    function m($) {
      $.code === "Enter" && a("blur", $);
    }
    return ($, y) => (v(), g("span", {
      "data-value": l.value || e.placeholder || "  ",
      class: j(u.value)
    }, [
      be(w("input", {
        class: j(s.value),
        type: e.type ? e.type : "text",
        name: e.name,
        ref_key: "element",
        ref: o,
        "onUpdate:modelValue": y[0] || (y[0] = (p) => l.value = p),
        placeholder: e.placeholder,
        onFocus: y[1] || (y[1] = (p) => a("focus", p)),
        onKeydown: m,
        onBlur: y[2] || (y[2] = (p) => a("blur", p))
      }, null, 42, Tu), [
        [Zr, l.value]
      ]),
      w("div", {
        class: j(["inline-input__error-message", { "inline-input__error-message--hidden": typeof i.value != "string" }])
      }, S(i.value), 3)
    ], 10, Eu));
  }
}), pm = /* @__PURE__ */ K({
  __name: "RemoveButton",
  props: {
    invertColors: { type: Boolean }
  },
  setup(e) {
    return (n, t) => (v(), g("div", et({
      class: ["remove-button", {
        "remove-button--inverted": e.invertColors
      }]
    }, n.$attrs), [...t[0] || (t[0] = [
      w("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        w("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8.94794 12.0508L0 2.92971L3.52911 0L12.0329 8.66831L20.4446 0.093811L23.9737 3.02353L15.0258 12.1446L23.9737 21.2657L20.4446 24.1954L11.9408 15.5271L3.5291 24.1016L-1.52588e-05 21.1719L8.94794 12.0508Z",
          fill: "black"
        })
      ], -1)
    ])], 16));
  }
}), nn = /* @__PURE__ */ K({
  __name: "ToggleSwitch",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = N(t.modelValue);
    return re(() => t.modelValue, () => {
      a.value = t.modelValue;
    }), re(a, () => {
      t.disabled ? a.value = t.modelValue : a.value != t.modelValue && r("update:modelValue", a.value);
    }), (o, l) => (v(), g("div", {
      class: j(["toggle-switch", {
        "toggle-switch--on": a.value,
        "toggle-switch--off": !a.value,
        "toggle-switch--disabled": e.disabled
      }])
    }, [
      be(w("input", {
        type: "checkbox",
        class: "toggle-switch__input",
        "onUpdate:modelValue": l[0] || (l[0] = (i) => a.value = i)
      }, null, 512), [
        [jr, a.value]
      ])
    ], 2));
  }
}), Su = { class: "expandable__label-value" }, Mu = { class: "expandable__content-margin" }, gm = /* @__PURE__ */ K({
  __name: "Expandable",
  props: /* @__PURE__ */ De({
    label: {},
    flip: { type: Boolean },
    modelValue: { type: Boolean },
    mode: {}
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ De(["update:modelValue"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, r = Me(e, "modelValue");
    function a() {
      r.value = !r.value;
    }
    const o = N(), l = N({});
    function i() {
      r.value = !1;
    }
    Nt(sn, i);
    let s;
    return re(r, (u) => {
      var c, f;
      if (!u) {
        clearTimeout(s), l.value = {
          maxHeight: ((c = o.value) == null ? void 0 : c.scrollHeight) + "px"
        }, s = setTimeout(() => {
          l.value = {};
        }, 0);
        return;
      }
      l.value = {
        maxHeight: ((f = o.value) == null ? void 0 : f.scrollHeight) + "px"
      }, s = setTimeout(() => {
        l.value = {
          maxHeight: "none"
        };
      }, 100);
    }), r.value && (l.value = {
      maxHeight: "none"
    }), (u, c) => (v(), g("div", {
      class: j(["expandable", {
        "expandable--expanded": r.value,
        "expandable--flipped": e.flip
      }])
    }, [
      w("div", {
        class: "expandable__label",
        onClick: a
      }, [
        w("div", Su, [
          ce(u.$slots, "label", {}, () => [
            he(S(t.label), 1)
          ])
        ]),
        e.mode === "toggle" ? (v(), Z(nn, {
          key: 0,
          modelValue: r.value,
          "onUpdate:modelValue": c[0] || (c[0] = (f) => r.value = f)
        }, null, 8, ["modelValue"])) : (v(), Z(gt, {
          key: 1,
          class: "expandable__arrow"
        }))
      ]),
      w("div", {
        class: "expandable__content",
        ref_key: "content",
        ref: o,
        style: xe(l.value)
      }, [
        w("div", Mu, [
          ce(u.$slots, "default")
        ])
      ], 4)
    ], 2));
  }
}), ym = /* @__PURE__ */ K({
  __name: "ToggleButton",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = N(t.modelValue);
    return re(() => t.modelValue, () => {
      a.value = t.modelValue;
    }), re(a, () => {
      t.disabled ? a.value = t.modelValue : a.value != t.modelValue && r("update:modelValue", a.value);
    }), (o, l) => (v(), g("label", {
      class: j(["btn btn-toggle", { "btn--pressed": a.value, "btn--disabled": e.disabled }])
    }, [
      be(w("input", {
        type: "checkbox",
        class: "toggle-button__checkbox",
        "onUpdate:modelValue": l[0] || (l[0] = (i) => a.value = i),
        style: {}
      }, null, 512), [
        [jr, a.value]
      ]),
      ce(o.$slots, "default")
    ], 2));
  }
}), Pu = ["value"], Iu = /* @__PURE__ */ K({
  __name: "RadioButton",
  props: /* @__PURE__ */ De({
    modelValue: {},
    value: {},
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ De(["update:modelValue"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = Me(e, "modelValue");
    return (r, a) => (v(), g("label", {
      class: j(["btn btn-toggle", { "btn--pressed": t.value === e.value, "btn--disabled": e.disabled }])
    }, [
      be(w("input", {
        type: "radio",
        class: "toggle-button__checkbox",
        "onUpdate:modelValue": a[0] || (a[0] = (o) => t.value = o),
        value: e.value,
        style: { visibility: "hidden", height: "0", width: "0" }
      }, null, 8, Pu), [
        [Zt, t.value]
      ]),
      ce(r.$slots, "default")
    ], 2));
  }
}), Fu = ["href"], bm = /* @__PURE__ */ K({
  __name: "ExternalLink",
  props: {
    href: {}
  },
  setup(e) {
    return (n, t) => (v(), g("a", {
      href: e.href,
      target: "_blank",
      class: "external-link"
    }, [
      ce(n.$slots, "default"),
      t[0] || (t[0] = w("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        class: "external-link__icon"
      }, [
        w("g", null, [
          w("path", {
            d: "M13.5,8v4.5a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1V1.5a1,1,0,0,1,1-1H6",
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          w("polyline", {
            points: "10 0.5 13.5 0.5 13.5 4",
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          w("line", {
            x1: "13.5",
            y1: "0.5",
            x2: "7",
            y2: "7",
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ])
      ], -1))
    ], 8, Fu));
  }
}), Au = {}, Lu = {
  class: "spinner",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ru(e, n) {
  return v(), g("svg", Lu, [...n[0] || (n[0] = [
    w("circle", {
      class: "spinner_dot",
      cx: "4",
      cy: "12",
      r: "3",
      fill: "currentColor"
    }, null, -1),
    w("circle", {
      class: "spinner_dot spinner_dot2",
      cx: "4",
      cy: "12",
      r: "3",
      fill: "currentColor"
    }, null, -1),
    w("circle", {
      class: "spinner_dot spinner_dot3",
      cx: "4",
      cy: "12",
      r: "3",
      fill: "currentColor"
    }, null, -1),
    w("circle", {
      class: "spinner_dot spinner_dot4",
      cx: "4",
      cy: "12",
      r: "3",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const Hn = /* @__PURE__ */ Y(Au, [["render", Ru]]), Ou = ["disabled"], wm = /* @__PURE__ */ K({
  __name: "LoadingArea",
  props: {
    loading: { type: Boolean }
  },
  setup(e) {
    return (n, t) => (v(), g("fieldset", {
      disabled: e.loading,
      class: "loading-area"
    }, [
      ce(n.$slots, "default"),
      w("div", {
        class: j(["loading-area__cover", {
          "loading-area__cover--loading": e.loading
        }])
      }, [
        z(Hn)
      ], 2)
    ], 8, Ou));
  }
}), Bu = ["title"], Vu = { class: "enum-label" }, Ku = {
  key: 0,
  class: "enum-remove"
}, Hu = /* @__PURE__ */ K({
  __name: "EnumValue",
  props: {
    value: {},
    touched: { type: Boolean },
    allowRemove: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = N(!1), r = N();
    function a() {
      t.value = !0;
    }
    const o = D(() => n.value.label ?? n.value.key);
    return (l, i) => (v(), g("div", {
      ref_key: "elem",
      ref: r,
      class: j(["enum btn--initial", {
        "show-label": e.touched,
        "btn--hover": e.touched && e.allowRemove,
        "btn--active": t.value && e.allowRemove,
        "has-hue": e.value.hue,
        "allow-remove": e.allowRemove
      }]),
      onMousedown: a,
      onMouseup: i[0] || (i[0] = () => t.value = !1),
      style: xe(e.value.hue ? `--color-hue: ${e.value.hue}` : null),
      title: o.value
    }, [
      w("span", Vu, S(o.value), 1),
      e.allowRemove ? (v(), g("div", Ku, [
        z(yt)
      ])) : I("", !0)
    ], 46, Bu));
  }
}), Gu = /* @__PURE__ */ Y(Hu, [["__scopeId", "data-v-4295669a"]]), Uu = {}, Wu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function Zu(e, n) {
  return v(), g("svg", Wu, [...n[0] || (n[0] = [
    w("line", {
      x1: "40",
      y1: "128",
      x2: "216",
      y2: "128",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("line", {
      x1: "128",
      y1: "40",
      x2: "128",
      y2: "216",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const hn = /* @__PURE__ */ Y(Uu, [["render", Zu]]), zu = { class: "enums-bar neat-scroll" }, ju = { class: "enum-set" }, Yu = { class: "enum-values" }, qu = ["onClick", "title"], Xu = /* @__PURE__ */ K({
  __name: "EnumsBar",
  props: {
    selectedValues: {},
    availableSets: {},
    onAdd: {},
    onRemove: {},
    disabled: { type: Boolean }
  },
  emits: ["add", "remove"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = Dt(), o = Ge("addButton"), l = Ge("addDropdown"), i = D(() => t.availableSets.map((b) => ({
      ...b,
      values: b.values.filter((C) => {
        var x;
        return !((x = t.selectedValues) != null && x.find((_) => _ === C.key));
      })
    })).filter((b) => Object.values(b.values).length > 0)), s = D(() => {
      var x, _;
      const b = Array.from(((x = t.selectedValues) == null ? void 0 : x.reduce((T, W) => (T.has(W) || T.add(W), T), /* @__PURE__ */ new Set())) ?? /* @__PURE__ */ new Set()), C = ((_ = t.availableSets) == null ? void 0 : _.reduce((T, W) => {
        for (const F of W.values)
          T[F.key] = F;
        return T;
      }, {})) ?? {};
      return b.map((T) => C[T] ?? {
        key: T
      });
    });
    function u() {
      var b;
      (b = l.value) == null || b.open();
    }
    function c(b) {
      r(
        "add",
        b
      );
    }
    function f(b) {
      r(
        "remove",
        b
      );
    }
    const d = N();
    function m(b, C) {
      d.value !== C && (b.stopPropagation(), b.preventDefault(), d.value = C);
    }
    function $() {
      d.value = void 0;
    }
    we(() => {
      window.addEventListener("click", $);
    }), lt(() => {
      window.removeEventListener("click", $);
    });
    const y = D(() => typeof t.onAdd == "function" && !t.disabled), p = D(() => typeof t.onRemove == "function" && !t.disabled), h = D(() => !!a.dropdown);
    return (b, C) => (v(), g("div", zu, [
      (v(!0), g(G, null, Q(s.value, (x) => (v(), Z(Gu, {
        key: x.key,
        value: x,
        onTouchstart: (_) => m(_, x.key),
        onMouseenter: (_) => m(_, x.key),
        onMouseleave: $,
        onClick: (_) => f(x),
        "allow-remove": p.value,
        touched: x.key === d.value
      }, null, 8, ["value", "onTouchstart", "onMouseenter", "onClick", "allow-remove", "touched"]))), 128)),
      y.value && (i.value.length > 0 || h.value) ? (v(), g("button", {
        key: 0,
        class: "btn-silent enums-add",
        ref_key: "addButton",
        ref: o,
        onClick: u
      }, [
        z(hn)
      ], 512)) : I("", !0),
      z(je, {
        target: o.value ?? { x: 0, y: 0 },
        ref_key: "addDropdown",
        ref: l
      }, {
        default: le(() => [
          (v(!0), g(G, null, Q(i.value, (x, _) => (v(), g(G, { key: _ }, [
            w("div", ju, S(x.label), 1),
            w("div", Yu, [
              (v(!0), g(G, null, Q(x.values, (T) => (v(), g("button", {
                key: T.key,
                onClick: (W) => c(T),
                class: j(["enum-value btn", {
                  "has-hue": T.hue
                }]),
                style: xe(T.hue ? `--color-hue: ${T.hue}` : null),
                title: T.label
              }, S(T.label), 15, qu))), 128))
            ])
          ], 64))), 128)),
          ce(b.$slots, "dropdown", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["target"])
    ]));
  }
}), Cm = /* @__PURE__ */ Y(Xu, [["__scopeId", "data-v-c36d7102"]]);
function Ft(e) {
  if (!e)
    return [];
  let n;
  typeof e == "string" ? n = e : n = JSON.stringify(e, null, 2);
  let t = n;
  return t.length > 30 && (t = t.substring(0, 20) + "..." + t.substring(t.length - 5)), [{
    label: `Copy '${t}'`,
    action: () => navigator.clipboard.writeText(n.normalize("NFKC"))
  }];
}
const Ju = /* @__PURE__ */ K({
  __name: "TableCellText",
  props: {
    provider: {},
    column: {},
    value: {}
  },
  setup(e) {
    const n = e, t = document.documentElement.dataset.formatting ?? navigator.language, r = D(() => n.value instanceof Date ? new Intl.DateTimeFormat(t, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }).format(n.value) : Ne.isDecimal(n.value) ? new Intl.NumberFormat(document.documentElement.dataset.formatting ?? navigator.language, {}).format(n.value.toNumber()) : typeof n.value == "number" ? new Intl.NumberFormat(document.documentElement.dataset.formatting ?? navigator.language, {}).format(n.value) : n.value), a = D(() => {
      var l, i;
      const o = [];
      if (n.column.canFilter) {
        const s = {
          label: `Show only '${r.value}'`,
          action: () => {
            var f, d;
            const c = [
              {
                type: "any",
                value: n.value
              }
            ];
            (d = (f = n.provider).setFilters) == null || d.call(f, n.column, c);
          }
        }, u = {
          label: `Hide '${r.value}'`,
          action: () => {
            var f, d;
            const c = [
              ...n.column.filters ?? [],
              {
                type: "not",
                value: n.value
              }
            ];
            (d = (f = n.provider).setFilters) == null || d.call(f, n.column, c);
          }
        };
        !n.column.filters || ((l = n.column.filters) == null ? void 0 : l.length) === 0 ? o.push(s, u) : n.column.filters && ((i = n.column.filters) == null ? void 0 : i.length) > 0 && o.push(u);
      }
      return [Ft(r.value), o];
    });
    return (o, l) => {
      const i = ze("context-menu");
      return be((v(), g("td", null, [
        he(S(r.value), 1)
      ])), [
        [i, a.value]
      ]);
    };
  }
}), Fr = /* @__PURE__ */ Y(Ju, [["__scopeId", "data-v-1495af37"]]), Qu = ["title"], ed = /* @__PURE__ */ K({
  __name: "TableCellEnum",
  props: {
    provider: {},
    column: {},
    value: {}
  },
  setup(e) {
    const n = e, t = N(), r = N(!1), a = D(() => n.column.values), o = D(() => {
      const d = [];
      return a.value.isArray || d.push("is-single"), r.value && d.push("is-overflowing"), d;
    }), l = D(() => {
      const d = [];
      if (!a.value.isArray)
        typeof n.value == "string" && d.push(c(n.value));
      else if (n.value && Symbol.iterator in Object(n.value) || Array.isArray(n.value))
        for (const m of n.value)
          d.push(c(m));
      return d;
    });
    re(() => n.value, s);
    const i = new ResizeObserver((d) => {
      s();
    });
    we(() => {
      i.observe(t.value);
    }), Ze(() => {
      i.disconnect();
    });
    function s() {
      r.value = !1, He(() => {
        if (t.value) {
          for (const d of Array.from(t.value.querySelectorAll(".enum-value")))
            if (d.scrollWidth > d.clientWidth) {
              r.value = !0;
              break;
            }
        }
      });
    }
    const u = D(() => {
      var d;
      return ((d = a.value.enums) == null ? void 0 : d.reduce((m, $) => [
        ...m,
        ...$.values
      ], [])) ?? [];
    });
    function c(d) {
      const m = u.value.find(($) => $.key === d);
      return {
        key: d,
        label: (m == null ? void 0 : m.label) ?? d,
        hue: m == null ? void 0 : m.hue
      };
    }
    function f(d) {
      var m;
      if (!d || !n.column.canFilter)
        return [];
      if (n.column.filters.find(($) => $.value === d.key))
        return [];
      if (a.value.isArray) {
        const $ = {
          label: `Hide '${d.label}'`,
          action: () => {
            var h, b;
            const p = [
              ...n.column.filters ?? [],
              {
                type: "not",
                value: d.key
              }
            ];
            (b = (h = n.provider).setFilters) == null || b.call(h, n.column, p);
          }
        }, y = {
          label: `Must contain '${d.label}'`,
          action: () => {
            var h, b;
            const p = [
              ...n.column.filters ?? [],
              {
                type: "all",
                value: d.key
              }
            ];
            (b = (h = n.provider).setFilters) == null || b.call(h, n.column, p);
          }
        };
        if (n.column.filters && n.column.filters.length > 0)
          switch (n.column.filters[0].type) {
            case "any":
              return [];
            case "not":
              return [$];
            case "all":
              return [y];
          }
        return [y, $];
      }
      return ((m = n.column.filters) == null ? void 0 : m.length) === 0 && !a.value.isArray ? [{
        label: `Show only '${d.label}'`,
        action: () => {
          var y, p;
          const $ = [
            ...n.column.filters ?? [],
            {
              type: "any",
              value: d.key
            }
          ];
          (p = (y = n.provider).setFilters) == null || p.call(y, n.column, $);
        }
      }] : [];
    }
    return (d, m) => {
      const $ = ze("context-menu");
      return v(), g("td", {
        class: j(o.value),
        ref_key: "elem",
        ref: t
      }, [
        (v(!0), g(G, null, Q(l.value, (y) => be((v(), g("div", {
          key: y.key,
          class: j(["enum-value", {
            "has-hue": y.hue
          }]),
          style: xe(y.hue ? `--enum-hue: ${y.hue}` : null),
          title: y.label
        }, [
          he(S(y.label), 1)
        ], 14, Qu)), [
          [$, [ee(Ft)(y.label), f(y)]]
        ])), 128))
      ], 2);
    };
  }
}), td = /* @__PURE__ */ Y(ed, [["__scopeId", "data-v-7afc8d15"]]), nd = /* @__PURE__ */ K({
  __name: "TableCellDate",
  props: {
    provider: {},
    column: {},
    value: {}
  },
  setup(e) {
    const n = e, t = document.documentElement.dataset.formatting ?? navigator.language, r = new Intl.DateTimeFormat(t, {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    }), a = D(() => {
      try {
        if (n.value)
          return r.format(n.value);
      } catch {
      }
      return "-";
    }), o = D(() => n.value ? [Ft(a.value)] : []);
    return (l, i) => {
      const s = ze("context-menu");
      return be((v(), g("td", null, [
        he(S(a.value), 1)
      ])), [
        [s, o.value]
      ]);
    };
  }
}), rd = /* @__PURE__ */ Y(nd, [["__scopeId", "data-v-41505759"]]), od = /* @__PURE__ */ K({
  __name: "TableCellDateTime",
  props: {
    provider: {},
    column: {},
    value: {}
  },
  setup(e) {
    const n = e, t = document.documentElement.dataset.formatting ?? navigator.language, r = new Intl.DateTimeFormat(t, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }), a = D(() => {
      try {
        if (n.value)
          return r.format(n.value);
      } catch {
      }
      return "-";
    }), o = D(() => n.value ? [Ft(a.value)] : []);
    return (l, i) => {
      const s = ze("context-menu");
      return be((v(), g("td", null, [
        he(S(a.value), 1)
      ])), [
        [s, o.value]
      ]);
    };
  }
}), ad = /* @__PURE__ */ Y(od, [["__scopeId", "data-v-626796f7"]]), ld = {
  class: "column-option",
  style: { cursor: "pointer" }
}, id = /* @__PURE__ */ K({
  __name: "ColumnOptionToggle",
  props: {
    provider: {},
    option: {}
  },
  setup(e) {
    const n = e, t = N(!1), r = D(() => n.provider.columns.value.filter((a) => a !== void 0));
    return Wn(() => {
      t.value = !!r.value.find((a) => a.key === n.option.key);
    }), re(t, () => {
      if (!!r.value.find((o) => o.key === n.option.key) != t.value)
        if (t.value) {
          if (!n.provider.addColumn) {
            console.warn("DataProvider.addColumn was called but was not implemented");
            return;
          }
          n.provider.addColumn(n.option);
        } else {
          if (!n.provider.removeColumn) {
            console.warn("DataProvider.removeColumn was called but was not implemented");
            return;
          }
          n.provider.removeColumn(n.option);
        }
    }), (a, o) => (v(), g("label", ld, [
      z(nn, {
        modelValue: t.value,
        "onUpdate:modelValue": o[0] || (o[0] = (l) => t.value = l)
      }, null, 8, ["modelValue"]),
      he(" " + S(e.option.label), 1)
    ]));
  }
}), sd = /* @__PURE__ */ Y(id, [["__scopeId", "data-v-cb4a075b"]]), ud = {
  "dataTable.filterEnum.anyOf": "Match any of",
  "dataTable.filterEnum.allOf": "Match all of",
  "dataTable.filterEnum.noneOf": "Match none of",
  "dataTable.filterEnum.any": "Has any value",
  "dataTable.filterEnum.none": "Has no values",
  "dataTable.filterEnum.clear": "Clear",
  "dataTable.filterEnum.selectAll": "Select all",
  "dataTable.filterBoolean.all": "All",
  "dataTable.filterBoolean.yes": "Yes",
  "dataTable.filterBoolean.no": "No",
  "dataTable.filterDate.clear": "Clear",
  "dataTable.filterDate.today": "Today",
  "dataTable.filterDate.yesterday": "Yesterday",
  "dataTable.filterDate.last7Days": "Last 7 Days",
  "dataTable.filterDate.last30Days": "Last 30 Days",
  "dataTable.filterDate.thisMonth": "This Month",
  "dataTable.filterDate.lastMonth": "Last Month",
  "dataTable.columnHint": "Click here to add columns",
  "dateInput.today": "Today",
  "dateInput.yesterday": "Yesterday",
  "dateInput.tomorrow": "Tomorrow",
  "dateInput.lastDays": "Last {count} days",
  "dateInput.nextDays": "Next {count} days",
  "dateInput.lastWeeks": "Last {count} weeks",
  "dateInput.nextWeeks": "Next {count} weeks",
  "dateInput.lastMonths": "Last {count} months",
  "dateInput.nextMonths": "Next {count} months",
  "dateInput.lastYears": "Last {count} years",
  "dateInput.nextYears": "Next {count} years"
}, xn = {
  en: ud
};
function ke(e, n) {
  var a;
  const t = [
    document.documentElement.lang,
    ...navigator.languages.map((o) => o.substring(0, 2))
  ];
  let r;
  for (const o of t)
    if ((a = xn[o]) != null && a[e]) {
      r = xn[o][e];
      break;
    }
  if (r || (r = xn.en[e]), !r)
    return e;
  if (n)
    for (const [o, l] of Object.entries(n))
      r = r.replace(`{${o}}`, String(l));
  return r;
}
const dd = ["disabled"], cd = {
  key: 2,
  class: "hint"
}, fd = /* @__PURE__ */ K({
  __name: "ColumnsButton",
  props: {
    provider: {}
  },
  setup(e) {
    const n = e, t = N(), r = Ge("addColumnMenu"), a = N(""), o = D(() => {
      var i;
      return ((i = n.provider.columnOptions) == null ? void 0 : i.value.reduce((s, u) => s + u.columns.length, 0)) ?? 0;
    }), l = D(() => {
      if (!n.provider.columnOptions)
        return [];
      if (o.value < 10 || a.value.trim().length === 0)
        return n.provider.columnOptions.value;
      const i = [];
      for (const s of n.provider.columnOptions.value) {
        const u = [];
        for (const c of s.columns)
          c.label.toLowerCase().indexOf(a.value.toLowerCase()) !== -1 && u.push(c);
        u.length > 0 && i.push({
          setLabel: s.setLabel,
          columns: u
        });
      }
      return i;
    });
    return (i, s) => (v(), g(G, null, [
      e.provider.columnOptions ? (v(), g("button", {
        key: 0,
        class: "btn-reset add-column",
        ref_key: "addColumnButton",
        ref: t,
        onClick: s[0] || (s[0] = () => {
          var u;
          return (u = r.value) == null ? void 0 : u.open();
        }),
        disabled: o.value <= 0
      }, [
        z(hn)
      ], 8, dd)) : I("", !0),
      e.provider.columnOptions ? (v(), Z(je, {
        key: 1,
        ref_key: "addColumnMenu",
        ref: r,
        target: t.value
      }, {
        default: le(() => [
          o.value > 10 ? (v(), g("div", {
            key: 0,
            onKeydown: s[2] || (s[2] = Ee(() => {
            }, ["stop"]))
          }, [
            z(Ve, {
              modelValue: a.value,
              "onUpdate:modelValue": s[1] || (s[1] = (u) => a.value = u),
              placeholder: "Filter columns"
            }, null, 8, ["modelValue"])
          ], 32)) : I("", !0),
          (v(!0), g(G, null, Q(l.value, (u, c) => {
            var f, d, m;
            return v(), g(G, { key: c }, [
              u.setLabel && ((f = n.provider.columnOptions) != null && f.value) && ((m = (d = n.provider.columnOptions) == null ? void 0 : d.value) == null ? void 0 : m.length) > 1 ? (v(), Z(Ie, {
                key: 0,
                class: "set-header"
              }, {
                default: le(() => [
                  he(S(u.setLabel), 1)
                ]),
                _: 2
              }, 1024)) : I("", !0),
              (v(!0), g(G, null, Q(u.columns, ($) => (v(), Z(sd, {
                key: $.key,
                provider: e.provider,
                option: $
              }, null, 8, ["provider", "option"]))), 128))
            ], 64);
          }), 128))
        ]),
        _: 1
      }, 8, ["target"])) : I("", !0),
      e.provider.columns.value.length === 0 ? (v(), g("div", cd, [
        s[3] || (s[3] = w("svg", {
          viewBox: "0 0 84 76",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          w("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M1.76001 75.17C0.809995 74.96 0.280012 73.88 0.520017 72.99C0.780012 72.03 1.74 71.56 2.68001 71.75H2.69002C2.67001 71.75 2.66 71.74 2.65001 71.74H2.80002C2.89171 71.7286 2.98343 71.7138 3.07701 71.6958C3.23132 71.6572 3.38568 71.6182 3.54001 71.57C4.02 71.39 4.49 71.18 4.95001 70.95C6.66958 70.0682 8.2803 69.0075 9.89187 67.9462C10.1078 67.804 10.3238 67.6618 10.54 67.52C10.8151 67.3285 11.0903 67.1374 11.3653 66.9464C12.5695 66.1098 13.7715 65.2747 14.96 64.42C15.86 63.77 16.76 63.12 17.67 62.47C18.1966 62.09 18.7055 61.6923 19.2144 61.2945C19.4688 61.0956 19.7233 60.8967 19.98 60.7C21.57 59.48 23.13 58.24 24.69 56.98L24.9572 56.7685C25.4501 56.3786 25.9458 55.9864 26.42 55.58C26.8743 55.1856 27.326 54.7913 27.7778 54.397C28.231 54.0013 28.6843 53.6057 29.14 53.21C29.6868 52.7281 30.2422 52.2462 30.7903 51.7722C31.2079 51.3798 31.6246 50.9874 32.0409 50.5954C32.9268 49.7611 33.8111 48.9283 34.7 48.1C35.5072 47.339 36.2789 46.5543 37.0515 45.7687L37.058 45.762C37.2883 45.5279 37.5186 45.2937 37.75 45.06C37.9835 44.8218 38.2181 44.5847 38.4526 44.3477L38.4577 44.3426C39.2259 43.5663 39.9934 42.7907 40.72 41.98C41.91 40.65 43.1 39.33 44.29 38.01C44.9394 37.2107 45.5913 36.4114 46.2433 35.6122C46.8964 34.8115 47.5494 34.0107 48.2 33.21C48.59 32.7327 48.9482 32.2237 49.3053 31.7165C49.4793 31.4693 49.653 31.2225 49.83 30.98C49.9279 30.8456 50.0261 30.7116 50.1247 30.5779C50.2312 30.4333 50.338 30.2889 50.4448 30.1446L50.4456 30.1435C50.9156 29.5083 51.3849 28.8738 51.83 28.22V28.24C53.37 25.96 54.78 23.62 56.03 21.17C56.91 19.39 57.67 17.56 58.34 15.7C58.96 13.91 59.45 12.11 59.93 10.28C60.151 9.44028 60.3251 8.60055 60.5007 7.75392L60.57 7.42L60.5852 7.31476L60.5855 7.31259C60.7003 6.5192 60.8139 5.73419 60.9 4.94001C60.261 5.40915 59.6416 5.91753 59.026 6.42285C58.8805 6.54226 58.7353 6.6615 58.59 6.78C57.83 7.41 57.07 8.03 56.29 8.64C56.1778 8.7287 56.0657 8.8175 55.9535 8.90638L55.6428 9.15285C54.3795 10.155 53.1139 11.159 51.79 12.09L50.17 13.23C50.0875 13.2878 50.0057 13.3471 49.9238 13.4064C49.7082 13.5627 49.4919 13.7196 49.26 13.85C49.1133 13.938 48.9669 14.026 48.8207 14.114C48.494 14.3106 48.1681 14.5071 47.8422 14.7037C47.369 14.9891 46.8957 15.2746 46.42 15.56C46.2175 15.68 45.9981 15.7831 45.7787 15.8863C45.7056 15.9206 45.6325 15.955 45.56 15.99C45.2403 16.1499 44.923 16.3098 44.6057 16.4696L44.6 16.4725C44.2841 16.6317 43.9683 16.7908 43.65 16.95C42.892 17.3337 42.1078 17.6736 41.3301 18.0106L41.17 18.08C38.57 19.22 35.92 20.3 33.21 21.13C30.41 21.98 27.53 22.35 24.63 22.64C23.67 22.73 22.77 22.11 22.63 21.12C22.51 20.19 23.18 19.22 24.15 19.13C24.99 19.04 25.83 18.95 26.67 18.85C27.6 18.73 28.53 18.58 29.45 18.42C31.05 18.08 32.61 17.63 34.16 17.09C34.1533 17.0929 34.1466 17.0956 34.1397 17.0983C34.1351 17.1001 34.1305 17.1019 34.1259 17.1037C36.4823 16.2579 38.7679 15.2617 41.0629 14.2614L41.64 14.01C41.605 14.03 41.57 14.0475 41.535 14.065C41.5 14.0825 41.465 14.1 41.43 14.12C41.9546 13.8552 42.4817 13.5904 43.0088 13.3256C43.5367 13.0604 44.0646 12.7952 44.59 12.53C44.9151 12.3643 45.228 12.1661 45.539 11.969C45.716 11.8569 45.8923 11.7452 46.07 11.64C46.54 11.35 47.01 11.07 47.48 10.79C47.898 10.4964 48.3134 10.2028 48.7289 9.90928L48.7343 9.90548C49.152 9.61032 49.5698 9.31516 49.99 9.02C50.5461 8.62376 51.0829 8.20337 51.6205 7.78232C51.8563 7.59768 52.0922 7.41292 52.33 7.23001C53.7891 6.11369 55.2194 4.93982 56.6396 3.77417L56.6406 3.77344L56.73 3.7C56.8438 3.60573 56.9576 3.51081 57.0717 3.41569C57.9496 2.68341 58.8411 1.93989 59.85 1.40001C60.58 1.00001 61.57 0.710005 62.4 0.990003C62.4245 0.998182 62.449 1.00644 62.4734 1.01482C62.8621 0.965185 63.2588 1.04024 63.6 1.24C64.01 1.48 64.26 1.85 64.41 2.3C64.4818 2.50876 64.528 2.72603 64.5737 2.94071C64.598 3.0551 64.6222 3.16876 64.65 3.28C64.72 3.57 64.78 3.85 64.84 4.14C64.9169 4.48812 64.9917 4.83624 65.0663 5.18344C65.1567 5.6042 65.2469 6.0236 65.34 6.44L65.3843 6.63504C65.9892 9.29953 66.5917 11.9531 67.48 14.54C67.4597 14.4927 67.444 14.4454 67.4267 14.3982C67.4184 14.3754 67.4097 14.3527 67.4 14.33C68.04 16.15 68.79 17.92 69.65 19.64C70.62 21.55 71.66 23.42 72.85 25.21C73.6 26.32 74.41 27.37 75.29 28.39C75.72 28.87 76.17 29.33 76.64 29.77C77.4434 30.4706 78.2816 31.1275 79.1547 31.7327C79.1532 31.7318 79.1516 31.7309 79.15 31.73C79.1581 31.7354 79.166 31.7407 79.174 31.7461C79.2292 31.7843 79.2845 31.8222 79.34 31.86C79.318 31.8453 79.296 31.8293 79.2735 31.8129C79.2715 31.8115 79.2694 31.81 79.2674 31.8085C80.2296 32.4507 81.2097 33.0753 82.1896 33.6998C83.0096 34.2098 83.33 35.27 82.83 36.12C82.51 36.67 81.89 37 81.27 37C80.97 36.99 80.67 36.91 80.4 36.75C79.54 36.21 78.69 35.67 77.85 35.11C75.9 33.81 74.07 32.39 72.53 30.61C70.98 28.82 69.64 26.88 68.44 24.84C67.17 22.68 66.03 20.42 65.06 18.11C64.2542 16.1832 63.6096 14.195 63.0655 12.179C63.0181 12.3522 62.9706 12.5256 62.9239 12.6995C62.9024 12.7796 62.8811 12.8597 62.86 12.94C62.34 14.9 61.69 16.83 60.95 18.72C59.97 21.24 58.75 23.65 57.4 25.99C56.42 27.7 55.35 29.39 54.19 30.98C53.9655 31.2873 53.7409 31.5955 53.5161 31.904C52.98 32.6396 52.4425 33.3773 51.9 34.11C51.8177 34.2226 51.736 34.3355 51.6542 34.4486L51.6524 34.451L51.6516 34.4522C51.3563 34.8604 51.0603 35.2693 50.74 35.66C50.3406 36.1542 49.9387 36.646 49.5368 37.1377L49.5335 37.1418C49.1315 37.6337 48.7295 38.1256 48.33 38.62C48.2776 38.685 48.2253 38.7502 48.173 38.8155C48.1031 38.903 48.0332 38.9908 47.9633 39.0786C47.5873 39.5508 47.21 40.0246 46.81 40.47C45.8398 41.542 44.8742 42.6185 43.9101 43.6935C43.4532 44.2029 42.9966 44.712 42.54 45.22C42.169 45.6274 41.7716 46.0188 41.3746 46.4098C41.2259 46.5563 41.0772 46.7028 40.93 46.85C40.48 47.305 40.03 47.7625 39.58 48.22C39.13 48.6775 38.68 49.135 38.23 49.59C37.2684 50.5585 36.268 51.4882 35.2694 52.4163C34.8348 52.8202 34.4006 53.2237 33.97 53.63C32.8844 54.6544 31.7521 55.6321 30.6222 56.6076C30.2741 56.9082 29.9262 57.2085 29.58 57.51C26.7833 59.9465 23.8427 62.2032 20.9033 64.4591L20.42 64.83C19.3786 65.6328 18.311 66.3937 17.2437 67.1544C16.8353 67.4455 16.4269 67.7366 16.02 68.03C14.5 69.12 12.96 70.17 11.4 71.2C11.2446 71.3013 11.0894 71.4028 10.9343 71.5042C9.97105 72.134 9.00906 72.763 8.01001 73.34C6.98001 73.94 5.90001 74.5 4.78001 74.9C4.08 75.15 3.39001 75.3 2.69002 75.3L2.60632 75.2911C2.34709 75.2637 2.05745 75.2331 1.76001 75.17ZM79.2674 31.8085C79.2318 31.7826 79.1949 31.7561 79.1547 31.7327C79.1612 31.7372 79.1676 31.7416 79.174 31.7461C79.205 31.7669 79.2363 31.7877 79.2674 31.8085ZM3.23123 71.6635C3.17912 71.6752 3.12771 71.686 3.07701 71.6958C3.10875 71.6882 3.13923 71.6821 3.16949 71.6761L3.19229 71.6716C3.20518 71.669 3.21812 71.6663 3.23123 71.6635ZM34.0499 17.13C34.0633 17.1256 34.0768 17.1211 34.0901 17.1165L33.94 17.17C33.975 17.155 34.0124 17.1425 34.0499 17.13ZM51.85 28.2C51.85 28.205 51.8475 28.2075 51.845 28.21C51.8425 28.2125 51.84 28.215 51.84 28.22C51.84 28.21 51.85 28.2 51.85 28.2Z",
            fill: "currentcolor"
          })
        ], -1)),
        he(" " + S(ee(ke)("dataTable.columnHint")), 1)
      ])) : I("", !0)
    ], 64));
  }
}), md = /* @__PURE__ */ Y(fd, [["__scopeId", "data-v-27219662"]]), vd = /* @__PURE__ */ K({
  __name: "TableCellNumber",
  props: {
    provider: {},
    column: {},
    value: {}
  },
  setup(e) {
    var i;
    const n = e;
    let t = {};
    ((i = n.column.values) == null ? void 0 : i.type) === "number" && (t = {
      maximumFractionDigits: n.column.values.maximumFractionDigits,
      minimumFractionDigits: n.column.values.minimumFractionDigits
    });
    const r = new Intl.NumberFormat(document.documentElement.dataset.formatting ?? navigator.language, t), a = D(() => Ne.isDecimal(n.value) ? [Ft(r.format(n.value.toNumber()))] : []), o = D(() => {
      var s;
      if (((s = n.column.values) == null ? void 0 : s.type) === "number")
        return n.column.values.unitLabel;
    }), l = D(() => {
      let s;
      return Ne.isDecimal(n.value) ? s = n.value.toNumber() : typeof n.value == "number" && (s = n.value), s ? r.format(s) + (o.value !== void 0 ? o.value : "") : "-";
    });
    return (s, u) => {
      const c = ze("context-menu");
      return be((v(), g("td", null, [
        he(S(l.value), 1)
      ])), [
        [c, a.value]
      ]);
    };
  }
}), $d = /* @__PURE__ */ Y(vd, [["__scopeId", "data-v-356ef13c"]]), hd = /* @__PURE__ */ K({
  __name: "TableCellBoolean",
  props: {
    provider: {},
    column: {},
    value: {}
  },
  setup(e) {
    const n = e, t = D(() => {
      var r;
      if (!n.column.canFilter)
        return [];
      if (((r = n.column.filters) == null ? void 0 : r.length) === 0)
        return [[{
          label: `Show only '${n.value ? ke("dataTable.filterBoolean.yes") : ke("dataTable.filterBoolean.no")}'`,
          action: () => {
            var o, l;
            const a = [
              ...n.column.filters ?? [],
              {
                type: "any",
                value: !!n.value
              }
            ];
            (l = (o = n.provider).setFilters) == null || l.call(o, n.column, a);
          }
        }]];
    });
    return (r, a) => {
      const o = ze("context-menu");
      return be((v(), g("td", null, [
        he(S(e.value ? ee(ke)("dataTable.filterBoolean.yes") : " "), 1)
      ])), [
        [o, t.value]
      ]);
    };
  }
}), pd = /* @__PURE__ */ Y(hd, [["__scopeId", "data-v-90eb3647"]]), gd = 1e3, yd = /* @__PURE__ */ K({
  __name: "TableRow",
  props: {
    provider: {},
    cellComponents: {},
    row: {},
    selected: {}
  },
  emits: ["mousedown", "dblclick"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = N(!1);
    we(() => {
      t.row.version && Date.now() - t.row.version < gd && (a.value = !0);
    }), re(() => t.row.version, (s, u) => {
      s && s !== u && (a.value = !0);
    });
    function o() {
      a.value = !1;
    }
    function l(s) {
      var c;
      const u = (c = t.provider.getRowHue) == null ? void 0 : c.bind(t.provider, s);
      if (u) {
        const f = u();
        return typeof f > "u" ? void 0 : typeof f == "number" ? `--color-hue: ${f}` : `--color-hue: var(${f})`;
      }
    }
    function i(s) {
      r("mousedown", s);
    }
    return (s, u) => {
      var c;
      return v(), g("tr", {
        onMousedown: i,
        onDblclick: u[0] || (u[0] = (f) => r("dblclick")),
        class: j({
          selected: (c = e.selected) == null ? void 0 : c.has(e.row.key),
          "has-hue": l(e.row) !== void 0,
          modified: a.value
        }),
        style: xe(l(e.row)),
        onAnimationend: o
      }, [
        (v(!0), g(G, null, Q(e.provider.columns.value.filter(
          (f) => f !== void 0
          /* Prevent crash from broken data provider */
        ), (f) => (v(), Z(tt(e.cellComponents[f.key]), {
          key: f.key,
          provider: e.provider,
          column: f,
          value: e.row.values[f.valueIdx]
        }, null, 8, ["provider", "column", "value"]))), 128)),
        u[1] || (u[1] = w("td", null, " ", -1))
      ], 38);
    };
  }
}), bd = /* @__PURE__ */ Y(yd, [["__scopeId", "data-v-3234ff56"]]), Ae = [];
for (let e = 0; e < 256; ++e)
  Ae.push((e + 256).toString(16).slice(1));
function wd(e, n = 0) {
  return (Ae[e[n + 0]] + Ae[e[n + 1]] + Ae[e[n + 2]] + Ae[e[n + 3]] + "-" + Ae[e[n + 4]] + Ae[e[n + 5]] + "-" + Ae[e[n + 6]] + Ae[e[n + 7]] + "-" + Ae[e[n + 8]] + Ae[e[n + 9]] + "-" + Ae[e[n + 10]] + Ae[e[n + 11]] + Ae[e[n + 12]] + Ae[e[n + 13]] + Ae[e[n + 14]] + Ae[e[n + 15]]).toLowerCase();
}
let _n;
const Cd = new Uint8Array(16);
function kd() {
  if (!_n) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    _n = crypto.getRandomValues.bind(crypto);
  }
  return _n(Cd);
}
const Nn = {};
function xd(e, n, t) {
  let r;
  {
    const a = Date.now(), o = kd();
    _d(Nn, a, o), r = Nd(o, Nn.msecs, Nn.seq, n, t);
  }
  return wd(r);
}
function _d(e, n, t) {
  return e.msecs ?? (e.msecs = -1 / 0), e.seq ?? (e.seq = 0), n > e.msecs ? (e.seq = t[6] << 23 | t[7] << 16 | t[8] << 8 | t[9], e.msecs = n) : (e.seq = e.seq + 1 | 0, e.seq === 0 && e.msecs++), e;
}
function Nd(e, n, t, r, a = 0) {
  if (e.length < 16)
    throw new Error("Random bytes length must be >= 16");
  if (!r)
    r = new Uint8Array(16), a = 0;
  else if (a < 0 || a + 16 > r.length)
    throw new RangeError(`UUID byte range ${a}:${a + 15} is out of buffer bounds`);
  return n ?? (n = Date.now()), t ?? (t = e[6] * 127 << 24 | e[7] << 16 | e[8] << 8 | e[9]), r[a++] = n / 1099511627776 & 255, r[a++] = n / 4294967296 & 255, r[a++] = n / 16777216 & 255, r[a++] = n / 65536 & 255, r[a++] = n / 256 & 255, r[a++] = n & 255, r[a++] = 112 | t >>> 28 & 15, r[a++] = t >>> 20 & 255, r[a++] = 128 | t >>> 14 & 63, r[a++] = t >>> 6 & 255, r[a++] = t << 2 & 255 | e[10] & 3, r[a++] = e[11], r[a++] = e[12], r[a++] = e[13], r[a++] = e[14], r[a++] = e[15], r;
}
const Dd = { class: "filter p" }, Ed = { key: 0 }, Td = { class: "filter-list" }, Sd = ["onClick"], Md = { key: 0 }, Pd = {
  key: 1,
  class: "filter-nothing"
}, Id = { key: 1 }, Fd = { class: "filter-list" }, Ad = ["onClick"], Ld = { key: 0 }, Rd = {
  key: 1,
  class: "filter-nothing"
}, Od = /* @__PURE__ */ K({
  __name: "FilterText",
  props: {
    provider: {},
    column: {}
  },
  setup(e) {
    const n = e, t = N(""), r = Ge("inputElem");
    we(() => {
      r.value.focus();
    });
    function a() {
      var f, d, m;
      n.provider.setFilters || console.warn("DataProvider.setFilters was called but was not implemented by provider"), n.column.filters || (n.column.canFilter && console.warn(`Column "${n.column.key}" has canFilter: true but filters array is missing. Initializing empty array.`), n.column.filters = []);
      let s = t.value.trim();
      const u = s.startsWith("!");
      u && (s = s.slice(1));
      const c = (f = n.column.filters) == null ? void 0 : f.find(($) => {
        var y;
        return ((y = $.value) == null ? void 0 : y.toLowerCase()) === s.toLowerCase();
      });
      c ? (c.type = u ? "not" : "any", c.value = s) : n.column.filters.push({
        type: u ? "not" : "any",
        value: s
      }), (m = (d = n.provider).setFilters) == null || m.call(d, n.column, n.column.filters), t.value = "";
    }
    function o(s) {
      var c, f;
      if (!n.column.filters)
        return;
      n.provider.setFilters || console.warn("DataProvider.setFilters was called but was not implemented by provider");
      const u = n.column.filters.indexOf(s);
      u !== -1 && (n.column.filters.splice(u, 1), (f = (c = n.provider).setFilters) == null || f.call(c, n.column, n.column.filters));
    }
    const l = D(() => n.column.filters ? n.column.filters.filter((s) => s.type === "any") : []), i = D(() => n.column.filters ? n.column.filters.filter((s) => s.type === "not") : []);
    return (s, u) => (v(), g("div", Dd, [
      l.value.length > 0 ? (v(), g("div", Ed, [
        u[1] || (u[1] = w("div", { class: "heading" }, "Include", -1)),
        w("ul", Td, [
          (v(!0), g(G, null, Q(l.value, (c, f) => (v(), g("li", {
            key: f,
            class: "btn filter-value",
            onClick: (d) => o(c)
          }, [
            c.value ? (v(), g("span", Md, ' "' + S(c.value) + '" ', 1)) : (v(), g("span", Pd, " Empty value ")),
            z(yt)
          ], 8, Sd))), 128))
        ])
      ])) : I("", !0),
      i.value.length > 0 ? (v(), g("div", Id, [
        u[2] || (u[2] = w("div", { class: "heading" }, "Exclude", -1)),
        w("ul", Fd, [
          (v(!0), g(G, null, Q(i.value, (c, f) => (v(), g("li", {
            key: f,
            class: "btn filter-value",
            onClick: (d) => o(c)
          }, [
            c.value ? (v(), g("span", Ld, ' "' + S(c.value) + '" ', 1)) : (v(), g("span", Rd, " Empty value ")),
            z(yt)
          ], 8, Ad))), 128))
        ])
      ])) : I("", !0),
      w("form", {
        class: "input-form",
        onSubmit: Ee(a, ["prevent", "stop"])
      }, [
        w("div", null, [
          z(ee(Ve), {
            modelValue: t.value,
            "onUpdate:modelValue": u[0] || (u[0] = (c) => t.value = c),
            ref_key: "inputElem",
            ref: r,
            placeholder: "Filter value",
            type: "search"
          }, null, 8, ["modelValue"])
        ]),
        u[3] || (u[3] = w("input", {
          type: "submit",
          class: "btn-primary",
          value: "Add"
        }, null, -1))
      ], 32),
      u[4] || (u[4] = an('<div class="hint" data-v-cc579d36><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" data-v-cc579d36><rect width="256" height="256" fill="none" data-v-cc579d36></rect><circle cx="128" cy="128" r="96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" data-v-cc579d36></circle><path d="M120,120a8,8,0,0,1,8,8v40a8,8,0,0,0,8,8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" data-v-cc579d36></path><circle cx="124" cy="84" r="12" data-v-cc579d36></circle></svg><p data-v-cc579d36>Put <span class="hint-example" data-v-cc579d36>!</span> first to exclude a value</p></div>', 1))
    ]));
  }
}), Bd = /* @__PURE__ */ Y(Od, [["__scopeId", "data-v-cc579d36"]]), bt = {
  info(...e) {
    process.env.NODE_ENV === "development" && console.log("[hantera/design-system]", ...e);
  },
  debug(...e) {
    process.env.NODE_ENV === "development" && console.debug("[hantera/design-system]", ...e);
  },
  warn(...e) {
    process.env.NODE_ENV === "development" && console.warn("[hantera/design-system]", ...e);
  }
}, Vd = { class: "filter" }, Kd = { class: "filter-type" }, Hd = ["disabled"], Gd = {
  key: 0,
  class: "set-label"
}, Ud = { class: "enum-values" }, Wd = ["title"], Zd = /* @__PURE__ */ K({
  __name: "FilterEnum",
  props: {
    provider: {},
    column: {}
  },
  setup(e) {
    const n = e, t = D(() => n.column.values), r = D(() => t.value.supportedFilterTypes ?? ["anyof", "allof", "not", "any", "none"]), a = D(() => r.value.length > 1 || !r.value.includes("any")), o = N({
      type: "any",
      sets: []
    });
    re(t.value.enums, () => {
      const c = n.column.filters || [];
      let f = !0;
      if (o.value.sets = t.value.enums.map((d) => ({
        label: d.label,
        values: d.values.map((m) => {
          const $ = c.find((y) => y.value === m.key) !== void 0;
          return $ || (f = !1), {
            key: m.key,
            label: m.label,
            hue: m.hue,
            isSelected: $
          };
        })
      })), c.length > 0 && c[0].type === "any" && f)
        o.value.type = "any";
      else if (c.length > 0 && c[0].type === "not" && f)
        o.value.type = "none";
      else
        switch (c.length > 0 ? c[0].type : "any") {
          case "any":
            o.value.type = "anyOf";
            break;
          case "all":
            o.value.type = "allOf";
            break;
          case "not":
            o.value.type = "noneOf";
            break;
        }
    }, {
      immediate: !0,
      deep: !0
    }), re(o, () => {
      if (!n.provider.setFilters) {
        bt.warn("DataProvider.setFilter was called but was not implemented by provider");
        return;
      }
      const c = [];
      if (o.value.type === "any") {
        for (const d of o.value.sets)
          for (const m of d.values)
            c.push({
              type: "any",
              value: m.key
            });
        n.provider.setFilters(n.column, c);
        return;
      }
      if (o.value.type === "none") {
        for (const d of o.value.sets)
          for (const m of d.values)
            c.push({
              type: "not",
              value: m.key
            });
        n.provider.setFilters(n.column, c);
        return;
      }
      let f;
      switch (o.value.type) {
        case "anyOf":
          f = "any";
          break;
        case "allOf":
          f = "all";
          break;
        case "noneOf":
          f = "not";
          break;
      }
      for (const d of o.value.sets)
        for (const m of d.values.filter(($) => $.isSelected))
          c.push({
            type: f,
            value: m.key
          });
      n.provider.setFilters(n.column, c);
    }, {
      deep: !0
    });
    const l = D(() => n.column.filters && n.column.filters.length > 0);
    function i() {
      for (const c of o.value.sets)
        for (const f of c.values.filter((d) => d.isSelected))
          f.isSelected = !1;
      o.value.type = "anyOf";
    }
    const s = D(() => {
      if (o.value.type !== "none" && o.value.type !== "any")
        return [[{
          label: ke("dataTable.filterEnum.selectAll"),
          action: () => {
            for (const c of o.value.sets)
              for (const f of c.values)
                f.isSelected = !0;
          }
        }]];
    }), u = N(!1);
    return (c, f) => {
      const d = ze("context-menu");
      return be((v(), g("div", Vd, [
        w("div", Kd, [
          a.value ? (v(), Z(dt, {
            key: 0,
            label: ee(ke)("dataTable.filterEnum." + o.value.type)
          }, {
            default: le(() => [
              r.value.includes("anyof") ? (v(), Z(Ie, {
                key: 0,
                onClick: f[0] || (f[0] = () => o.value.type = "anyOf")
              }, {
                default: le(() => [
                  he(S(ee(ke)("dataTable.filterEnum.anyOf")), 1)
                ]),
                _: 1
              })) : I("", !0),
              t.value.isArray && r.value.includes("allof") ? (v(), Z(Ie, {
                key: 1,
                onClick: f[1] || (f[1] = () => o.value.type = "allOf")
              }, {
                default: le(() => [
                  he(S(ee(ke)("dataTable.filterEnum.allOf")), 1)
                ]),
                _: 1
              })) : I("", !0),
              r.value.includes("not") ? (v(), Z(Ie, {
                key: 2,
                onClick: f[2] || (f[2] = () => o.value.type = "noneOf")
              }, {
                default: le(() => [
                  he(S(ee(ke)("dataTable.filterEnum.noneOf")), 1)
                ]),
                _: 1
              })) : I("", !0),
              t.value.isArray && r.value.includes("none") ? (v(), Z(Ie, {
                key: 3,
                onClick: f[3] || (f[3] = () => o.value.type = "none")
              }, {
                default: le(() => [
                  he(S(ee(ke)("dataTable.filterEnum.none")), 1)
                ]),
                _: 1
              })) : I("", !0),
              t.value.isArray && r.value.includes("any") ? (v(), Z(Ie, {
                key: 4,
                onClick: f[4] || (f[4] = () => o.value.type = "any")
              }, {
                default: le(() => [
                  he(S(ee(ke)("dataTable.filterEnum.any")), 1)
                ]),
                _: 1
              })) : I("", !0)
            ]),
            _: 1
          }, 8, ["label"])) : I("", !0),
          w("button", {
            class: "btn-danger",
            disabled: !l.value,
            onClick: i
          }, S(ee(ke)("dataTable.filterEnum.clear")), 9, Hd)
        ]),
        (v(!0), g(G, null, Q(o.value.sets.filter((m) => m.values.length > 0), (m, $) => (v(), g("div", { key: $ }, [
          m.label && o.value.sets.length > 1 ? (v(), g("div", Gd, S(m.label), 1)) : I("", !0),
          w("div", Ud, [
            (v(!0), g(G, null, Q(m.values, (y) => (v(), g("label", {
              key: y.key,
              class: "enum-label"
            }, [
              o.value.type !== "none" && o.value.type !== "any" ? (v(), Z(nn, {
                key: 0,
                modelValue: y.isSelected,
                "onUpdate:modelValue": (p) => y.isSelected = p
              }, null, 8, ["modelValue", "onUpdate:modelValue"])) : (v(), Z(nn, {
                key: 1,
                modelValue: u.value,
                "onUpdate:modelValue": f[5] || (f[5] = (p) => u.value = p),
                disabled: !0
              }, null, 8, ["modelValue"])),
              w("span", {
                class: j(["enum-value", {
                  "has-hue": y.hue
                }]),
                style: xe(typeof y.hue == "number" ? `--enum-hue: ${y.hue}` : null),
                title: y.label
              }, S(y.label), 15, Wd)
            ]))), 128))
          ])
        ]))), 128))
      ])), [
        [d, s.value]
      ]);
    };
  }
}), zd = /* @__PURE__ */ Y(Zd, [["__scopeId", "data-v-cd744d63"]]), jd = { class: "filter" }, Yd = { class: "shortcuts" }, qd = ["disabled"], Xd = /* @__PURE__ */ K({
  __name: "FilterDateRange",
  props: {
    provider: {},
    column: {}
  },
  setup(e) {
    const n = e, t = D(() => n.column.values), r = N();
    let a = !1;
    re(() => n.column.filters, () => {
      var $, y, p;
      if ((($ = n.column.filters) == null ? void 0 : $.length) !== 1) return;
      const f = n.column.filters[0], d = ye.fromDate(new Date(f.from)), m = ye.fromDate(new Date(f.to)).addDays(-1);
      (y = r.value) != null && y.from.equals(d) && ((p = r.value) != null && p.to.equals(m)) || (a = !0, r.value = { from: d, to: m }, a = !1);
    }, {
      immediate: !0,
      deep: !0
    }), re(r, () => {
      if (!a) {
        if (!n.provider.setFilters) {
          bt.warn("DataProvider.setFilters was called but was not implemented by provider");
          return;
        }
        if (!r.value) {
          n.provider.setFilters(n.column);
          return;
        }
        n.provider.setFilters(n.column, [{
          from: r.value.from.toDate(),
          to: r.value.to.addDays(1).toDate()
        }]);
      }
    });
    function o() {
      r.value = void 0;
    }
    function l(f) {
      const d = ye.today(), m = d.addDays(f);
      d.isBefore(m) ? r.value = { from: d, to: m } : r.value = { from: m, to: d };
    }
    function i(f) {
      const d = ye.today(), m = new ye(d.year, d.month + f, 1), $ = m.addMonths(1).addDays(-1);
      r.value = { from: m, to: $ };
    }
    const s = D(() => {
      if (t.value.min)
        return ye.fromDate(t.value.min);
    }), u = D(() => {
      if (t.value.max)
        return ye.fromDate(t.value.max);
    }), c = D(() => n.column.filters && n.column.filters.length > 0);
    return (f, d) => (v(), g("div", jd, [
      z(ee(fo), {
        "week-numbers": "firstFourDays",
        modelValue: r.value,
        "onUpdate:modelValue": d[0] || (d[0] = (m) => r.value = m),
        "min-date": s.value,
        "max-date": u.value
      }, null, 8, ["modelValue", "min-date", "max-date"]),
      w("div", Yd, [
        w("button", {
          class: "btn-danger clear",
          disabled: !c.value,
          onClick: o
        }, S(ee(ke)("dataTable.filterDate.clear")), 9, qd),
        w("button", {
          class: "btn-silent",
          onClick: d[1] || (d[1] = () => l(1))
        }, S(ee(ke)("dataTable.filterDate.today")), 1),
        w("button", {
          class: "btn-silent",
          onClick: d[2] || (d[2] = () => l(-1))
        }, S(ee(ke)("dataTable.filterDate.yesterday")), 1),
        w("button", {
          class: "btn-silent",
          onClick: d[3] || (d[3] = () => l(-7))
        }, S(ee(ke)("dataTable.filterDate.last7Days")), 1),
        w("button", {
          class: "btn-silent",
          onClick: d[4] || (d[4] = () => l(-30))
        }, S(ee(ke)("dataTable.filterDate.last30Days")), 1),
        w("button", {
          class: "btn-silent",
          onClick: d[5] || (d[5] = () => i(0))
        }, S(ee(ke)("dataTable.filterDate.thisMonth")), 1),
        w("button", {
          class: "btn-silent",
          onClick: d[6] || (d[6] = () => i(-1))
        }, S(ee(ke)("dataTable.filterDate.lastMonth")), 1)
      ])
    ]));
  }
}), Jd = /* @__PURE__ */ Y(Xd, [["__scopeId", "data-v-c252c111"]]), Qd = { class: "filter" }, ec = { class: "shortcuts" }, tc = ["disabled"], nc = /* @__PURE__ */ K({
  __name: "FilterInstantRange",
  props: {
    provider: {},
    column: {}
  },
  setup(e) {
    const n = e, t = D(() => n.column.values), r = N();
    let a = !1;
    re(() => n.column.filters, () => {
      var p;
      if (((p = n.column.filters) == null ? void 0 : p.length) !== 1) return;
      const m = n.column.filters[0], $ = new Date(m.from), y = new Date(m.to);
      r.value && r.value.from.getTime() === $.getTime() && r.value.to.getTime() === y.getTime() || (a = !0, r.value = { from: $, to: y }, a = !1);
    }, {
      immediate: !0,
      deep: !0
    }), re(r, () => {
      if (!a) {
        if (!n.provider.setFilters) {
          bt.warn("DataProvider.setFilters was called but was not implemented by provider");
          return;
        }
        if (!r.value) {
          n.provider.setFilters(n.column);
          return;
        }
        n.provider.setFilters(n.column, [{
          from: r.value.from,
          to: r.value.to
        }]);
      }
    });
    function o() {
      r.value = void 0;
    }
    function l(m) {
      const $ = new Date(m);
      return $.setHours(0, 0, 0, 0), $;
    }
    function i(m) {
      const $ = new Date(m);
      return $.setHours(23, 59, 59, 999), $;
    }
    function s(m) {
      const $ = /* @__PURE__ */ new Date(), y = new Date($);
      y.setDate(y.getDate() + m), $ < y ? r.value = { from: l($), to: i(y) } : r.value = { from: l(y), to: i($) };
    }
    function u(m) {
      const $ = /* @__PURE__ */ new Date(), y = new Date($.getFullYear(), $.getMonth() + m, 1), p = new Date($.getFullYear(), $.getMonth() + m + 1, 0);
      r.value = { from: l(y), to: i(p) };
    }
    const c = D(() => {
      if (t.value.min)
        return ye.fromDate(t.value.min);
    }), f = D(() => {
      if (t.value.max)
        return ye.fromDate(t.value.max);
    }), d = D(() => n.column.filters && n.column.filters.length > 0);
    return (m, $) => (v(), g("div", Qd, [
      z(ee(vo), {
        "week-numbers": "firstFourDays",
        "collapsible-time": "",
        modelValue: r.value,
        "onUpdate:modelValue": $[0] || ($[0] = (y) => r.value = y),
        "min-date": c.value,
        "max-date": f.value
      }, null, 8, ["modelValue", "min-date", "max-date"]),
      w("div", ec, [
        w("button", {
          class: "btn-danger clear",
          disabled: !d.value,
          onClick: o
        }, S(ee(ke)("dataTable.filterDate.clear")), 9, tc),
        w("button", {
          class: "btn-silent",
          onClick: $[1] || ($[1] = () => s(1))
        }, S(ee(ke)("dataTable.filterDate.today")), 1),
        w("button", {
          class: "btn-silent",
          onClick: $[2] || ($[2] = () => s(-1))
        }, S(ee(ke)("dataTable.filterDate.yesterday")), 1),
        w("button", {
          class: "btn-silent",
          onClick: $[3] || ($[3] = () => s(-7))
        }, S(ee(ke)("dataTable.filterDate.last7Days")), 1),
        w("button", {
          class: "btn-silent",
          onClick: $[4] || ($[4] = () => s(-30))
        }, S(ee(ke)("dataTable.filterDate.last30Days")), 1),
        w("button", {
          class: "btn-silent",
          onClick: $[5] || ($[5] = () => u(0))
        }, S(ee(ke)("dataTable.filterDate.thisMonth")), 1),
        w("button", {
          class: "btn-silent",
          onClick: $[6] || ($[6] = () => u(-1))
        }, S(ee(ke)("dataTable.filterDate.lastMonth")), 1)
      ])
    ]));
  }
}), rc = /* @__PURE__ */ Y(nc, [["__scopeId", "data-v-53813584"]]), oc = { class: "filter" }, ac = /* @__PURE__ */ K({
  __name: "FilterBoolean",
  props: {
    provider: {},
    column: {}
  },
  setup(e) {
    const n = e, t = N("all");
    return re(() => n.column.filters, () => {
      var a;
      if (((a = n.column.filters) == null ? void 0 : a.length) !== 1) {
        t.value = "all";
        return;
      }
      const r = n.column.filters[0];
      t.value = r.value ? "true" : "false";
    }, {
      immediate: !0,
      deep: !0
    }), re(t, () => {
      if (!n.provider.setFilters) {
        console.warn("DataProvider.setFilters was called but was not implemented by provider");
        return;
      }
      t.value === "true" ? n.provider.setFilters(n.column, [{
        type: "any",
        value: !0
      }]) : t.value === "false" ? n.provider.setFilters(n.column, [{
        type: "any",
        value: !1
      }]) : n.provider.setFilters(n.column);
    }), (r, a) => (v(), g("div", oc, [
      w("label", null, [
        be(w("input", {
          type: "radio",
          name: "filterValue",
          "onUpdate:modelValue": a[0] || (a[0] = (o) => t.value = o),
          value: "all"
        }, null, 512), [
          [Zt, t.value]
        ]),
        he(" " + S(ee(ke)("dataTable.filterBoolean.all")), 1)
      ]),
      w("label", null, [
        be(w("input", {
          type: "radio",
          name: "filterValue",
          "onUpdate:modelValue": a[1] || (a[1] = (o) => t.value = o),
          value: "true"
        }, null, 512), [
          [Zt, t.value]
        ]),
        he(" " + S(ee(ke)("dataTable.filterBoolean.yes")), 1)
      ]),
      w("label", null, [
        be(w("input", {
          type: "radio",
          name: "filterValue",
          "onUpdate:modelValue": a[2] || (a[2] = (o) => t.value = o),
          value: "false"
        }, null, 512), [
          [Zt, t.value]
        ]),
        he(" " + S(ee(ke)("dataTable.filterBoolean.no")), 1)
      ])
    ]));
  }
}), lc = /* @__PURE__ */ Y(ac, [["__scopeId", "data-v-b7709396"]]), ic = { class: "filter p" }, sc = /* @__PURE__ */ K({
  __name: "FilterNumber",
  props: {
    provider: {},
    column: {}
  },
  setup(e) {
    const n = e;
    N(!1);
    const t = N(""), r = Ge("inputElem"), a = new Intl.NumberFormat(document.documentElement.dataset.formatting ?? navigator.language, {}), o = a.format(1.1).substring(1, 2), l = new RegExp("[^\\d" + (o == "." ? "\\." : o) + "]", "g");
    we(() => {
      r.value.focus();
    }), re(() => n.column.filters, () => {
      var m;
      if (((m = n.column.filters) == null ? void 0 : m.length) !== 1) {
        t.value = "";
        return;
      }
      const c = n.column.filters[0], f = c.from, d = c.to;
      f.eq(d) ? t.value = i(f) : t.value = `${i(f)}:${i(d)}`;
    }, {
      immediate: !0,
      deep: !0
    });
    function i(c) {
      return a.format(c.toNumber()).normalize("NFKC").replace("−", "-");
    }
    function s() {
      var f, d, m, $, y, p;
      if (n.provider.setFilters || console.warn("DataProvider.setFilters was called but was not implemented by provider"), n.column.filters || (n.column.filters = []), !t.value.trim()) {
        (d = (f = n.provider).setFilters) == null || d.call(f, n.column);
        return;
      }
      const c = t.value.trim().split(":");
      if (c.length === 1) {
        const h = u(c[0]);
        h ? (($ = (m = n.provider).setFilters) == null || $.call(m, n.column, [{
          from: h,
          to: h
        }]), t.value = i(h)) : r.value.setError(`'${c[0]}' is not a valid number`);
      } else if (c.length === 2) {
        const h = u(c[0]), b = u(c[1]);
        h ? b ? ((p = (y = n.provider).setFilters) == null || p.call(y, n.column, [{
          from: h,
          to: b
        }]), t.value = `${i(h)}:${i(b)}`) : r.value.setError(`'${c[1]}' is not a valid number`) : r.value.setError(`'${c[0]} 'is not a valid number`);
      } else
        r.value.setError(`'${t.value.trim()}' is not a valid number`);
    }
    function u(c) {
      const f = c.length > 0 && c.substring(0, 1) === "-";
      if (c = c.replaceAll(l, ""), c = c.replaceAll(o, "."), c.length !== 0)
        return new Ne((f ? "-" : "") + c);
    }
    return (c, f) => (v(), g("div", ic, [
      w("form", {
        class: "input-form",
        onSubmit: Ee(s, ["prevent", "stop"])
      }, [
        w("div", null, [
          z(Ve, {
            modelValue: t.value,
            "onUpdate:modelValue": f[0] || (f[0] = (d) => t.value = d),
            ref_key: "inputElem",
            ref: r,
            placeholder: "Filter value",
            type: "search"
          }, null, 8, ["modelValue"])
        ]),
        f[1] || (f[1] = w("input", {
          type: "submit",
          class: "btn-primary",
          value: "Filter"
        }, null, -1))
      ], 32),
      f[2] || (f[2] = an('<div class="hint" data-v-0c47c8c3><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" data-v-0c47c8c3><rect width="256" height="256" fill="none" data-v-0c47c8c3></rect><circle cx="128" cy="128" r="96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" data-v-0c47c8c3></circle><path d="M120,120a8,8,0,0,1,8,8v40a8,8,0,0,0,8,8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" data-v-0c47c8c3></path><circle cx="124" cy="84" r="12" data-v-0c47c8c3></circle></svg><p data-v-0c47c8c3>Use <span class="hint-example" data-v-0c47c8c3>[num]:[num]</span> to select a range</p></div>', 1))
    ]));
  }
}), uc = /* @__PURE__ */ Y(sc, [["__scopeId", "data-v-0c47c8c3"]]), dc = /* @__PURE__ */ K({
  __name: "FilterDropdown",
  props: {
    provider: {}
  },
  setup(e, { expose: n }) {
    const t = e;
    n({
      open: u
    });
    const r = N(), a = N(), o = N(), l = N({}), i = D(() => t.provider.columns.value.find((m) => m && m.key === a.value)), s = D(() => {
      var m, $;
      switch (($ = (m = i.value) == null ? void 0 : m.values) == null ? void 0 : $.type) {
        case "text":
          return Bd;
        case "number":
          return uc;
        case "enum":
          return zd;
        case "date":
          return Jd;
        case "instant":
          return rc;
        case "boolean":
          return lc;
      }
    });
    function u(m, $) {
      o.value = m, a.value = $, f(), r.value.showModal();
    }
    function c(m) {
      o.value = void 0, a.value = void 0, r.value.close();
    }
    function f() {
      if (!o.value || !r.value) {
        l.value = {};
        return;
      }
      const m = o.value.getBoundingClientRect(), $ = r.value.parentElement.getBoundingClientRect().height - m.height - 10;
      m.left === 0 ? l.value = {
        left: `${m.left}px`,
        margin: "0",
        top: `${m.bottom}px`,
        maxHeight: `${$}px`
      } : l.value = {
        right: `${window.innerWidth - m.right}px`,
        top: `${m.bottom}px`,
        maxHeight: `${$}px`
      };
    }
    function d(m) {
      m.stopPropagation(), m.stopImmediatePropagation();
    }
    return we(() => {
      window.addEventListener("resize", f);
    }), Ze(() => {
      window.removeEventListener("resize", f);
    }), (m, $) => (v(), g("dialog", {
      ref_key: "dialogElem",
      ref: r,
      onMousedown: Ee(c, ["stop"]),
      class: "filter-drop-down",
      style: xe(l.value),
      onKeypress: $[1] || ($[1] = Ee(() => {
      }, ["stop"])),
      onKeydown: $[2] || ($[2] = Ee(() => {
      }, ["stop"])),
      onKeyup: $[3] || ($[3] = Ee(() => {
      }, ["stop"]))
    }, [
      i.value ? (v(), g("div", {
        key: 0,
        class: "filters-content",
        onClick: d,
        onMousedown: $[0] || ($[0] = Ee(() => {
        }, ["stop"]))
      }, [
        s.value ? (v(), Z(tt(s.value), {
          key: 0,
          column: i.value,
          provider: e.provider
        }, null, 8, ["column", "provider"])) : I("", !0)
      ], 32)) : I("", !0)
    ], 36));
  }
}), cc = /* @__PURE__ */ Y(dc, [["__scopeId", "data-v-667c9994"]]);
let Qe = {
  x: 0,
  y: 0
};
const $t = document.createElement("div");
$t.style.cursor = "grabbing";
$t.style.position = "fixed";
$t.style.top = "0";
$t.style.bottom = "0";
$t.style.right = "0";
$t.style.left = "0";
const $e = N(), kt = /* @__PURE__ */ new Map();
let fc = 1;
document.addEventListener("pointermove", (e) => {
  Qe.x = e.clientX, Qe.y = e.clientY, _o(), No();
});
window.addEventListener("contextmenu", (e) => {
  $e.value && ($e.value.payload.onClick = void 0, $e.value.dropTarget = void 0, Do());
});
window.addEventListener("pointerup", Do);
function At() {
  return {
    startDrag(e) {
      if ($e.value) {
        console.warn("An attempt to begin drag operation was made, but another operation is already active. Request has been ignored.");
        return;
      }
      bt.debug("startDrag", e);
      let n;
      if (e.sourceElement) {
        const t = [];
        for (const [r, a] of kt.entries())
          a.element.contains(e.sourceElement) && t.push({ id: r, el: a.element });
        t.sort((r, a) => r.el.contains(a.el) ? 1 : a.el.contains(r.el) ? -1 : 0), t.length > 0 && (n = t[0].id);
      }
      $e.value = {
        payload: e,
        startPointerPosition: {
          x: Qe.x,
          y: Qe.y
        },
        mode: e.mode ?? "hit",
        dragActive: !1,
        startZone: n
      }, e.onClick || _o(), No();
    },
    registerDropZone(e) {
      const n = fc++;
      return kt.set(n, e), bt.debug("Registered drop zone", n, e), n;
    },
    unregisterDropZone(e) {
      kt.delete(e);
    },
    getCurrentDropTarget() {
      var e;
      return (e = $e.value) == null ? void 0 : e.dropTarget;
    }
  };
}
function _o() {
  if (!$e.value || $e.value.dragActive)
    return;
  let e;
  $e.value.payload.sourceElement && (e = document.createElement("div"), e.classList.add("drag-ghost"), e.appendChild($e.value.payload.sourceElement.cloneNode(!0)), e.style.position = "absolute", e.style.pointerEvents = "none", e.style.userSelect = "none", e.style.opacity = "0.5", e.style.zIndex = "1000", document.body.appendChild(e)), $e.value.ghostElement = e, document.body.appendChild($t), $e.value.dragActive = !0;
}
function No() {
  $e.value && requestAnimationFrame(() => {
    var e;
    (e = $e.value) != null && e.ghostElement && ($e.value.ghostElement.style.top = Qe.y + 10 + "px", $e.value.ghostElement.style.left = Qe.x + 10 + "px"), mc();
  });
}
function mc() {
  var t;
  if (!((t = $e.value) != null && t.payload)) {
    Ht();
    return;
  }
  const e = [];
  for (const [r, a] of kt.entries()) {
    const o = a.element.getBoundingClientRect();
    if (vc(Qe, o) && Ar($e.value.payload.type, a.accepts)) {
      if ($e.value.mode === "closest" && r === $e.value.startZone)
        continue;
      e.push({ id: r, el: a.element });
    }
  }
  if (e.length === 0 && $e.value.mode === "closest") {
    let r;
    for (const [a, o] of kt.entries()) {
      if (!Ar($e.value.payload.type, o.accepts) || a === $e.value.startZone)
        continue;
      const l = o.element.getBoundingClientRect(), i = {
        x: l.left + l.width / 2,
        y: l.top + l.height / 2
      }, s = Math.abs(Qe.x - i.x), u = Math.abs(Qe.y - i.y), c = Math.sqrt(Math.pow(s, 2) + Math.pow(u, 2));
      (!r || r.distance > c) && (r = {
        distance: c,
        zone: { id: a, el: o.element }
      });
    }
    r && e.push(r.zone);
  }
  if (e.length === 0) {
    Ht();
    return;
  }
  e.sort((r, a) => r.el.contains(a.el) ? -1 : a.el.contains(r.el) ? 1 : 0);
  const n = e[e.length - 1];
  if (n.id === $e.value.startZone) {
    Ht();
    return;
  }
  Ht(n.id);
}
function Ht(e) {
  $e.value && (e !== $e.value.dropTarget && bt.debug("Drop zone target updated:", e), $e.value.dropTarget = e);
}
function vc(e, n) {
  return e.x >= n.left && e.x <= n.right && e.y >= n.top && e.y <= n.bottom;
}
function Ar(e, n) {
  return Array.isArray(n) ? n.includes(e) : e === n;
}
function Do() {
  if ($e.value) {
    if (bt.debug("endDrag"), $e.value.ghostElement && $e.value.ghostElement.remove(), $t.remove(), $e.value.payload.onClick && Math.abs($e.value.startPointerPosition.x - Qe.x) === 0 && Math.abs($e.value.startPointerPosition.y - Qe.y) === 0)
      $e.value.payload.onClick();
    else if ($e.value.dropTarget) {
      const e = kt.get($e.value.dropTarget);
      e && ($e.value.payload.onDrop && $e.value.payload.onDrop(e), e.onDrop && e.onDrop($e.value.payload));
    }
    $e.value = null;
  }
}
const $c = /* @__PURE__ */ K({
  __name: "DropZone",
  props: {
    accepts: {},
    metadata: {}
  },
  emits: ["drop"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = At(), o = Ge("element");
    let l;
    we(() => {
      if (!o.value) {
        console.error("DropZone: Could not find element");
        return;
      }
      l = a.registerDropZone({
        accepts: t.accepts,
        element: o.value,
        metadata: t.metadata,
        onDrop(s) {
          r("drop", s);
        }
      });
    }), Ze(() => {
      l && a.unregisterDropZone(l);
    });
    const i = D(() => {
      const s = a.getCurrentDropTarget();
      return s && s === l;
    });
    return (s, u) => (v(), g("div", {
      class: j(["drop-zone", {
        "drop-zone--target": i.value
      }]),
      ref_key: "element",
      ref: o
    }, [
      ce(s.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), rn = /* @__PURE__ */ Y($c, [["__scopeId", "data-v-faa8ec4a"]]), hc = {}, pc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function gc(e, n) {
  return v(), g("svg", pc, [...n[0] || (n[0] = [
    w("polyline", {
      points: "96 80 128 48 160 80",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("line", {
      x1: "128",
      y1: "208",
      x2: "128",
      y2: "48",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const Jn = /* @__PURE__ */ Y(hc, [["render", gc]]), yc = {}, bc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function wc(e, n) {
  return v(), g("svg", bc, [...n[0] || (n[0] = [
    w("polyline", {
      points: "112 176 80 208 48 176",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("line", {
      x1: "80",
      y1: "48",
      x2: "80",
      y2: "208",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("polyline", {
      points: "144 80 176 48 208 80",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("line", {
      x1: "176",
      y1: "208",
      x2: "176",
      y2: "48",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const Qn = /* @__PURE__ */ Y(yc, [["render", wc]]), Cc = {}, kc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  height: "14",
  width: "14"
};
function xc(e, n) {
  return v(), g("svg", kc, [...n[0] || (n[0] = [
    w("line", {
      x1: "64",
      y1: "136",
      x2: "192",
      y2: "136",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("line", {
      x1: "24",
      y1: "88",
      x2: "232",
      y2: "88",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("line", {
      x1: "104",
      y1: "184",
      x2: "152",
      y2: "184",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const Eo = /* @__PURE__ */ Y(Cc, [["render", xc]]), _c = ["title"], Nc = {
  key: 1,
  style: { visibility: "hidden" }
}, Dc = { class: "column-actions" }, Ec = /* @__PURE__ */ K({
  __name: "ColumnHeader",
  props: {
    provider: {},
    contextMenuProvider: {},
    column: {},
    idx: {},
    columnDragType: {},
    isMeasuringColumnWidths: { type: Boolean }
  },
  emits: ["beginColumnDrag", "refreshColumnWidths", "openFilter"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = N();
    function o(d) {
      if (!t.provider.setSort) {
        console.warn("DataProvider.setSort was called but was not implemented by the provider");
        return;
      }
      d.sort === "asc" ? t.provider.setSort(d, "desc") : d.sort === "desc" ? t.provider.setSort(d, void 0) : t.provider.setSort(d, "asc");
    }
    function l(d) {
      d.button === 0 && (d.stopPropagation(), d.preventDefault(), r("beginColumnDrag", d.target, t.column));
    }
    function i(d, m) {
      const y = d.target.parentElement.clientWidth;
      a.value = {
        startPos: d.x,
        startSize: y,
        columnKey: m.key
      }, document.addEventListener("mousemove", s), document.addEventListener("mouseup", u);
    }
    function s(d) {
      if (!a.value)
        return;
      a.value.cursorBlock || (a.value.cursorBlock = document.createElement("div"), a.value.cursorBlock.style.position = "fixed", a.value.cursorBlock.style.top = "0", a.value.cursorBlock.style.bottom = "0", a.value.cursorBlock.style.left = "0", a.value.cursorBlock.style.right = "0", a.value.cursorBlock.style.cursor = "ew-resize", document.body.appendChild(a.value.cursorBlock));
      const m = d.x - a.value.startPos;
      let $ = a.value.startSize + m;
      if ($ < 80 && ($ = 80), !t.provider.setColumnSize) {
        console.warn("DataProvider.setColumnSize was called but was not implemented by provider");
        return;
      }
      t.provider.setColumnSize(a.value.columnKey, $), r("refreshColumnWidths");
    }
    function u(d) {
      var m, $;
      ($ = (m = a.value) == null ? void 0 : m.cursorBlock) == null || $.remove(), a.value = void 0, document.removeEventListener("mousemove", s), document.removeEventListener("mouseup", u);
    }
    function c(d) {
      if (!t.provider.setColumnSize) {
        console.warn("DataProvider.setColumnSize was called but was not implemented by provider");
        return;
      }
      t.provider.setColumnSize(d.key), r("refreshColumnWidths");
    }
    const f = D(() => {
      var d, m;
      return (m = (d = t.contextMenuProvider) == null ? void 0 : d.forHeader) == null ? void 0 : m.call(d, t.column);
    });
    return (d, m) => {
      var y;
      const $ = ze("context-menu");
      return be((v(), g("th", null, [
        e.provider.setColumnOrder ? (v(), Z(rn, {
          key: e.column.key + e.idx,
          class: "column-drop-zone",
          accepts: e.columnDragType,
          metadata: { idx: e.idx }
        }, null, 8, ["accepts", "metadata"])) : I("", !0),
        w("div", {
          class: "column-label",
          title: e.column.label,
          onMousedown: l
        }, [
          !e.isMeasuringColumnWidths || e.provider.rows.value.length == 0 ? (v(), g(G, { key: 0 }, [
            he(S(e.column.label), 1)
          ], 64)) : (v(), g("span", Nc, "##"))
        ], 40, _c),
        w("div", Dc, [
          e.column.canSort && e.provider.setSort ? (v(), g("button", {
            key: 0,
            class: "btn-silent",
            onClick: m[0] || (m[0] = () => o(e.column))
          }, [
            e.column.sort ? (v(), Z(Jn, {
              key: 0,
              class: j(`sort--${e.column.sort}`)
            }, null, 8, ["class"])) : (v(), Z(Qn, { key: 1 }))
          ])) : I("", !0),
          e.column.canFilter && e.provider.setFilters ? (v(), g("button", {
            key: 1,
            class: j(e.column.filters && e.column.filters.length > 0 ? "btn-primary" : "btn-silent"),
            onClick: m[1] || (m[1] = (p) => r("openFilter", p.target, e.column))
          }, [
            z(Eo)
          ], 2)) : I("", !0)
        ]),
        e.provider.setColumnSize ? (v(), g("div", {
          key: 1,
          class: j(["column-resize", {
            "column-resize--active": ((y = a.value) == null ? void 0 : y.columnKey) === e.column.key
          }]),
          onMousedown: m[2] || (m[2] = (p) => i(p, e.column)),
          onDblclick: m[3] || (m[3] = () => c(e.column))
        }, null, 34)) : I("", !0)
      ])), [
        [$, f.value]
      ]);
    };
  }
}), Tc = /* @__PURE__ */ Y(Ec, [["__scopeId", "data-v-8a6a7146"]]);
function To(e, ...n) {
  const t = e.composedPath();
  return n.some((r) => r != null && t.includes(r));
}
function So(e, n) {
  function t(a) {
    To(a, ...e()) || n();
  }
  let r;
  we(() => {
    r = setTimeout(() => document.addEventListener("pointerdown", t, !0));
  }), Ze(() => {
    r && clearTimeout(r), document.removeEventListener("pointerdown", t, !0);
  });
}
function Mo(e) {
  var t;
  const n = (t = e.value) == null ? void 0 : t.$el;
  return n instanceof Element ? n : void 0;
}
const Sc = {
  key: 0,
  class: "errors-row"
}, Mc = {
  key: 0,
  class: "spacer-row"
}, Pc = {
  key: 1,
  class: "spacer-row"
}, Ic = {
  key: 0,
  class: "loading-more-indicator"
}, Fc = { key: 0 }, Ac = { class: "end-message" }, Lc = { class: "end-message-actions" }, Rc = ["onClick"], Oc = {
  key: 0,
  class: "no-hits"
}, Bc = { key: 0 }, ht = 29, Dn = 40, Vc = /* @__PURE__ */ K({
  __name: "DataTable",
  props: {
    provider: {},
    contextMenuProvider: {},
    selected: { default: /* @__PURE__ */ new Set() }
  },
  emits: ["update:selected", "defaultAction"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = At(), o = xd(), l = N(0), i = N(0), s = Ge("containerElem");
    let u = !1;
    const c = N([]), f = N(0), d = N(), m = Ge("filterDropdown"), $ = N(""), y = N(!1);
    let p = !1, h = !1;
    const b = new MutationObserver(() => {
      F(), P();
    }), C = new ResizeObserver((B) => {
      F(), P();
    }), x = new Intl.NumberFormat(document.documentElement.dataset.formatting ?? navigator.language, {}), _ = D(() => t.provider.columns.value.filter((B) => B !== void 0));
    we(async () => {
      var R;
      await t.provider.refresh(), h = !0, (R = d.value) == null || R.addEventListener("scroll", P), document.addEventListener("mousedown", L), document.addEventListener("keydown", J), F();
      let B = d.value.parentElement;
      for (; B && B.parentElement; )
        B = B.parentElement;
      B && b.observe(B, {
        attributes: !0,
        attributeFilter: ["style", "class"]
      }), s.value && C.observe(s.value);
    }), Ze(() => {
      var B;
      h = !1, (B = d.value) == null || B.removeEventListener("scroll", P), document.removeEventListener("mousedown", L), document.removeEventListener("keydown", J), b.disconnect(), C.disconnect();
    }), re(() => _.value.map((B) => B.key).join("#"), () => {
      F();
    }, {
      immediate: !0
    }), re(() => [_, t.provider.rows.value.length], () => {
      !p && t.provider.rows.value.length > 0 && F(), P();
      const B = Array.from(t.selected), R = B.map((te) => {
        if (t.provider.rows.value.find((ge) => ge.key === te))
          return te;
      }).filter((te) => te !== void 0);
      R.length !== B.length && r("update:selected", new Set(R));
    }, { deep: !0 }), re(() => {
      var B;
      return (B = t.provider.errors) == null ? void 0 : B.value;
    }, () => {
      !p && t.provider.rows.value.length > 0 && F(), P();
    });
    const T = N(!1);
    re(() => {
      var B;
      return [
        c.value,
        t.provider.rows.value.length,
        (B = t.provider.totalCount) == null ? void 0 : B.value
      ];
    }, () => {
      T.value = !0, setTimeout(() => {
        T.value = !1;
      }, 500);
    });
    const W = D(() => {
      const B = {};
      for (const R of _.value) {
        if (!R.values) {
          B[R.key] = Fr;
          continue;
        }
        let te = Fr;
        switch (R.values.type) {
          case "boolean":
            te = pd;
            break;
          case "number":
            te = $d;
            break;
          case "date":
            te = rd;
            break;
          case "instant":
            te = ad;
            break;
          case "enum":
            te = td;
            break;
        }
        B[R.key] = te;
      }
      return B;
    });
    function F() {
      const B = t.provider.rows.value.length > 0 ? "min-content" : "max-content";
      $.value = _.value.map((R) => R.size ? R.size + "px" : B).join(" "), ie() && (t.provider.rows.value.length > 0 && (y.value = !0, He(() => {
        const R = d.value.querySelectorAll("th"), te = [];
        for (const pe of Array.from(R).slice(0, -1)) {
          const ge = pe.clientWidth + 2;
          te.push(ge + "px");
        }
        $.value = te.join(" "), y.value = !1;
      })), p = !0);
    }
    function P() {
      if (!d.value) return;
      const B = d.value.scrollTop, R = Math.ceil(d.value.clientHeight / ht) + 1, te = Math.floor(B / ht);
      let pe = te * ht, ge = (t.provider.rows.value.length - te - R) * ht;
      const U = t.provider.rows.value.slice(te, te + R);
      pe < 0 && (pe = 0), ge < 0 && (ge = 0), ge < 300 && !t.provider.allLoaded.value && He(() => {
        t.provider.loadMore();
      }), l.value = pe, f.value = te, c.value = U, i.value = ge;
    }
    function E(B) {
      if (!B) {
        t.selected.size > 0 && r("update:selected", /* @__PURE__ */ new Set());
        return;
      }
      (t.selected.size != 1 || !t.selected.has(B)) && r("update:selected", /* @__PURE__ */ new Set([B]));
    }
    function L(B) {
      u = To(B, s.value);
    }
    function J(B) {
      var te, pe, ge, U, de;
      if (u) {
        let ne;
        if (B.key == "Escape")
          B.stopPropagation(), B.preventDefault(), E();
        else if (B.key == "Enter")
          B.stopPropagation(), B.preventDefault(), r("defaultAction");
        else if (B.key == "ArrowUp")
          B.stopPropagation(), B.preventDefault(), t.selected.size === 0 ? ne = f.value : ne = R().reduce((ue, Te) => ue === void 0 || Te < ue ? Te : ue) - 1;
        else if (B.key == "ArrowDown")
          if (B.stopPropagation(), B.preventDefault(), t.selected.size === 0) {
            const ue = Math.floor((((te = d.value) == null ? void 0 : te.clientHeight) ?? 0) / ht);
            ne = f.value + ue - 1;
          } else
            ne = R().reduce((ue, Te) => ue === void 0 || ue < Te ? Te : ue) + 1;
        if (typeof ne == "number" && ne >= 0 && ne < t.provider.rows.value.length) {
          E(t.provider.rows.value[ne].key);
          const ue = ne * ht + Dn, Te = ((pe = d.value) == null ? void 0 : pe.scrollTop) ?? 0, Ke = (((ge = d.value) == null ? void 0 : ge.clientHeight) ?? 0) - ht;
          ue - Dn < Te ? (U = d.value) == null || U.scrollTo(0, ue - Dn) : ue > Te + Ke && ((de = d.value) == null || de.scrollTo(0, ue - Ke));
        }
      }
      function R() {
        return Array.from(t.selected).map((ne) => {
          const ue = t.provider.rows.value.find((Te) => Te.key === ne);
          if (ue)
            return t.provider.rows.value.indexOf(ue);
        }).filter((ne) => ne !== void 0);
      }
    }
    function ie() {
      return !h || !d.value ? !1 : window.getComputedStyle(d.value).display !== "none";
    }
    function oe(B, R) {
      var te;
      (te = m.value) == null || te.open(B.closest("th"), R.key);
    }
    function O(B, R) {
      t.provider.setColumnOrder && a.startDrag({
        type: o,
        data: R,
        sourceElement: B,
        mode: "closest",
        onDrop(te) {
          if (!t.provider.setColumnOrder) {
            console.warn("DataProvider.setColumnOrder was called but was not implemented by the provider");
            return;
          }
          const pe = !te.metadata || te.metadata.idx < 0 ? _.value.length : te.metadata.idx, ge = _.value.findIndex((U) => U.key === R.key);
          pe == ge || pe == ge + 1 || t.provider.setColumnOrder(R, pe);
        }
      });
    }
    const H = D(() => {
      var B;
      return ((B = t.provider.errors) == null ? void 0 : B.value) && t.provider.errors.value.length > 0;
    });
    function X(B, R) {
      B.button === 0 && E(R);
    }
    return (B, R) => {
      var pe, ge, U, de;
      const te = ze("context-menu");
      return be((v(), g("div", {
        class: "data-table",
        ref_key: "containerElem",
        ref: s
      }, [
        z(md, { provider: e.provider }, null, 8, ["provider"]),
        w("table", {
          class: j(["neat-scroll", {
            "data-table--measuring": y.value,
            "supports-column-order": e.provider.setColumnOrder,
            scrolled: l.value > 0
          }]),
          style: xe(`grid-template-columns: ${$.value}`),
          ref_key: "tableBodyElem",
          ref: d
        }, [
          w("thead", null, [
            w("tr", null, [
              (v(!0), g(G, null, Q(e.provider.columns.value.filter(
                (ne) => ne !== void 0
                /* Make sure broken provide doesn't crash table */
              ), (ne, ue) => (v(), Z(Tc, {
                key: ne.key,
                provider: e.provider,
                column: ne,
                idx: ue,
                columnDragType: ee(o),
                contextMenuProvider: e.contextMenuProvider,
                isMeasuringColumnWidths: y.value,
                onOpenFilter: oe,
                onBeginColumnDrag: O,
                onRefreshColumnWidths: F
              }, null, 8, ["provider", "column", "idx", "columnDragType", "contextMenuProvider", "isMeasuringColumnWidths"]))), 128)),
              w("th", {
                style: xe(e.provider.columnOptions ? "min-width: 39px" : null)
              }, [
                e.provider.setColumnOrder ? (v(), Z(rn, {
                  key: 0,
                  class: "column-drop-zone",
                  accepts: ee(o),
                  metadata: { idx: -1 }
                }, null, 8, ["accepts"])) : I("", !0),
                R[1] || (R[1] = he("   ", -1))
              ], 4)
            ]),
            H.value ? (v(), g("tr", Sc, [
              w("td", null, [
                (v(!0), g(G, null, Q(e.provider.errors.value, (ne, ue) => (v(), g("div", { key: ue }, [
                  ne.message ? (v(), g(G, { key: 0 }, [
                    he(S(ne.message) + " (Code: " + S(ne.code) + ") ", 1)
                  ], 64)) : (v(), g(G, { key: 1 }, [
                    he(" An unexpected error occurred (Code: " + S(ne.code) + ") ", 1)
                  ], 64))
                ]))), 128))
              ])
            ])) : I("", !0)
          ]),
          w("tbody", {
            class: j(["neat-scroll", {
              "no-hits-body": e.provider.rows.value.length === 0
            }])
          }, [
            e.provider.rows.value.length > 0 ? (v(), g("tr", Mc, [
              w("td", {
                style: xe(`height:${l.value}px`),
                class: "query-table__spacer"
              }, null, 4)
            ])) : I("", !0),
            (v(!0), g(G, null, Q(c.value, (ne) => {
              var ue, Te;
              return be((v(), Z(bd, {
                key: ne.key,
                onMousedown: (Ke) => X(Ke, ne.key),
                onDblclick: R[0] || (R[0] = (Ke) => r("defaultAction")),
                provider: e.provider,
                row: ne,
                cellComponents: W.value,
                selected: e.selected
              }, null, 8, ["onMousedown", "provider", "row", "cellComponents", "selected"])), [
                [te, (Te = (ue = e.contextMenuProvider) == null ? void 0 : ue.forRow) == null ? void 0 : Te.call(ue, ne)]
              ]);
            }), 128)),
            e.provider.rows.value.length > 0 ? (v(), g("tr", Pc, [
              w("td", {
                style: xe(`height:${i.value}px; border: none`),
                class: "query-table__spacer"
              }, null, 4)
            ])) : I("", !0)
          ], 2),
          w("tfoot", null, [
            w("tr", null, [
              !t.provider.allLoaded.value && !H.value ? (v(), g("td", Ic, [
                z(Hn, { class: "spinner" })
              ])) : I("", !0)
            ]),
            (pe = e.provider.endMessage) != null && pe.value ? (v(), g("tr", Fc, [
              w("td", Ac, [
                w("span", null, S(e.provider.endMessage.value.text), 1),
                w("div", Lc, [
                  (v(!0), g(G, null, Q(e.provider.endMessage.value.actions, (ne) => (v(), g("button", {
                    key: ne.label,
                    class: "btn-silent",
                    onClick: ne.onClick
                  }, S(ne.label), 9, Rc))), 128))
                ])
              ])
            ])) : I("", !0)
          ])
        ], 6),
        e.provider.rows.value.length === 0 && t.provider.allLoaded.value && e.provider.columns.value.length > 0 ? (v(), g("div", Oc, " No hits ")) : I("", !0),
        w("div", {
          class: j(["loading-indicator", {
            "loading-indicator--active": e.provider.isLoading.value
          }])
        }, [
          z(Hn, { class: "spinner" })
        ], 2),
        z(cc, {
          ref_key: "filterDropdown",
          ref: m,
          provider: e.provider
        }, null, 8, ["provider"]),
        e.provider.rows.value.length > 0 ? (v(), g("div", {
          key: 1,
          class: j(["row-count", {
            "row-count--show": T.value
          }])
        }, [
          w("span", null, " Viewing " + S(ee(x).format(f.value + 1)) + " to " + S(ee(x).format(Math.min(f.value + c.value.length, t.provider.rows.value.length))), 1),
          (U = (ge = t.provider.totalCount) == null ? void 0 : ge.value) != null && U.count ? (v(), g("span", Bc, " of " + S(ee(x).format(t.provider.totalCount.value.count) + (t.provider.totalCount.value.count >= (t.provider.totalCount.value.cap ?? 0) ? "+" : "")), 1)) : I("", !0)
        ], 2)) : I("", !0)
      ])), [
        [te, (de = e.contextMenuProvider) == null ? void 0 : de.table]
      ]);
    };
  }
}), Kc = /* @__PURE__ */ Y(Vc, [["__scopeId", "data-v-b675db80"]]);
function km() {
  return Zn({
    cells: /* @__PURE__ */ new Map(),
    addedRows: [],
    removedRowKeys: /* @__PURE__ */ new Set(),
    errors: /* @__PURE__ */ new Map(),
    rowErrors: /* @__PURE__ */ new Map(),
    get hasChanges() {
      return this.cells.size > 0 || this.addedRows.length > 0 || this.removedRowKeys.size > 0;
    },
    clear() {
      this.cells.clear(), this.addedRows.splice(0, this.addedRows.length), this.removedRowKeys.clear(), this.errors.clear(), this.rowErrors.clear();
    },
    clearErrors() {
      this.errors.clear(), this.rowErrors.clear();
    }
  });
}
function Hc(e, n, t) {
  var r;
  return (r = e.cells.get(n)) == null ? void 0 : r.get(t);
}
function Gt(e, n, t, r, a) {
  if (Gc(e, n, t), Uc(r, a)) {
    const i = e.cells.get(n);
    i == null || i.delete(t), i && i.size === 0 && e.cells.delete(n);
    return;
  }
  let o = e.cells.get(n);
  o || (o = /* @__PURE__ */ new Map(), e.cells.set(n, o));
  const l = o.get(t);
  o.set(t, {
    value: r,
    originalValue: l ? l.originalValue : a
  });
}
function En(e, n, t, r) {
  let a = e.errors.get(n);
  a || (a = /* @__PURE__ */ new Map(), e.errors.set(n, a)), a.set(t, r);
}
function Gc(e, n, t) {
  const r = e.errors.get(n);
  r && (r.delete(t), r.size === 0 && e.errors.delete(n));
}
function Uc(e, n) {
  return e === n || e == null && n == null ? !0 : e instanceof Date && n instanceof Date ? e.getTime() === n.getTime() : !1;
}
function Wc(e) {
  const n = Zn({
    active: null,
    ranges: [],
    editing: null
  });
  function t(h) {
    return e.getRowKeys().indexOf(h);
  }
  function r(h) {
    return e.getColumns().findIndex((b) => b.key === h);
  }
  function a(h, b) {
    const C = e.getRowKeys(), x = e.getColumns();
    return h < 0 || h >= C.length || b < 0 || b >= x.length ? null : { rowKey: C[h], columnKey: x[b].key };
  }
  function o(h, b = !1) {
    if (!h) {
      n.active = null, n.ranges = [];
      return;
    }
    if (n.active = { ...h }, b && n.ranges.length > 0) {
      const C = n.ranges[n.ranges.length - 1].start;
      n.ranges = [{ start: { ...C }, end: { ...h } }];
    } else
      n.ranges = [{ start: { ...h }, end: { ...h } }];
  }
  function l(h) {
    n.active = { ...h }, n.ranges.push({ start: { ...h }, end: { ...h } });
  }
  function i() {
    n.active = null, n.ranges = [], n.editing = null;
  }
  function s(h, b = !1) {
    if (!n.active) {
      const T = a(0, 0);
      return T && o(T), n.active;
    }
    let C = t(n.active.rowKey), x = r(n.active.columnKey);
    switch (h) {
      case "up":
        C -= 1;
        break;
      case "down":
        C += 1;
        break;
      case "left":
        x -= 1;
        break;
      case "right":
        x += 1;
        break;
    }
    const _ = a(C, x);
    return _ && o(_, b), n.active;
  }
  function u(h) {
    if (!n.active)
      return null;
    const b = e.getRowKeys(), C = e.getColumns();
    if (C.filter((W) => W.editable).length === 0)
      return n.active;
    let _ = t(n.active.rowKey), T = r(n.active.columnKey);
    for (let W = 0; W < b.length * C.length; W++) {
      T += h ? 1 : -1, T >= C.length ? (T = 0, _ += 1) : T < 0 && (T = C.length - 1, _ -= 1);
      const F = a(_, T);
      if (!F)
        return n.active;
      if (C[T].editable)
        return o(F), n.active;
    }
    return n.active;
  }
  function c(h) {
    if (!n.active)
      return;
    const b = e.getColumns(), C = h ? b.length - 1 : 0, x = a(t(n.active.rowKey), C);
    x && o(x);
  }
  function f(h) {
    const b = e.getRowKeys(), C = e.getColumns(), x = h ? a(b.length - 1, C.length - 1) : a(0, 0);
    x && o(x);
  }
  function d(h) {
    const b = h ?? n.active;
    b && (n.editing = { ...b });
  }
  function m() {
    n.editing = null;
  }
  function $(h, b) {
    const C = t(h), x = r(b);
    return C < 0 || x < 0 ? !1 : n.ranges.some((_) => {
      const T = t(_.start.rowKey), W = t(_.end.rowKey), F = r(_.start.columnKey), P = r(_.end.columnKey);
      return C >= Math.min(T, W) && C <= Math.max(T, W) && x >= Math.min(F, P) && x <= Math.max(F, P);
    });
  }
  function y(h, b) {
    var C, x;
    return ((C = n.active) == null ? void 0 : C.rowKey) === h && ((x = n.active) == null ? void 0 : x.columnKey) === b;
  }
  function p(h, b) {
    var C, x;
    return ((C = n.editing) == null ? void 0 : C.rowKey) === h && ((x = n.editing) == null ? void 0 : x.columnKey) === b;
  }
  return {
    state: n,
    setActive: o,
    addRange: l,
    clear: i,
    move: s,
    moveToEditable: u,
    moveToRowEdge: c,
    moveToGridEdge: f,
    startEditing: d,
    stopEditing: m,
    isInRange: $,
    isActive: y,
    isEditing: p
  };
}
function Zc(e) {
  const n = N([]), t = new Intl.Collator(
    typeof document < "u" ? document.documentElement.dataset.formatting ?? navigator.language : void 0,
    { numeric: !0, sensitivity: "base" }
  );
  function r(u) {
    var c;
    return (c = n.value.find((f) => f.columnKey === u)) == null ? void 0 : c.direction;
  }
  function a(u, c) {
    const f = n.value.find((m) => m.columnKey === u);
    if (!c) {
      f ? f.direction === "asc" ? n.value = [{ columnKey: u, direction: "desc" }] : n.value = [] : n.value = [{ columnKey: u, direction: "asc" }];
      return;
    }
    const d = n.value.filter((m) => m.columnKey !== u);
    f ? f.direction === "asc" && d.push({ columnKey: u, direction: "desc" }) : d.push({ columnKey: u, direction: "asc" }), n.value = d;
  }
  function o(u, c) {
    n.value = [{ columnKey: u, direction: c }];
  }
  function l(u) {
    n.value = n.value.filter((c) => c.columnKey !== u);
  }
  function i(u, c, f) {
    var $, y, p, h;
    const d = u == null || u === "", m = c == null || c === "";
    if (d && m)
      return 0;
    if (d)
      return 1;
    if (m)
      return -1;
    switch (f.type) {
      case "number":
        return Number(u) - Number(c);
      case "boolean":
        return (u ? 1 : 0) - (c ? 1 : 0);
      case "date":
      case "instant": {
        const b = u instanceof Date ? u.getTime() : new Date(u).getTime(), C = c instanceof Date ? c.getTime() : new Date(c).getTime();
        return b - C;
      }
      case "enum": {
        const b = ((y = ($ = f.enumValues) == null ? void 0 : $.find((x) => x.key === u)) == null ? void 0 : y.label) ?? String(u), C = ((h = (p = f.enumValues) == null ? void 0 : p.find((x) => x.key === c)) == null ? void 0 : h.label) ?? String(c);
        return t.compare(b, C);
      }
      default:
        return t.compare(String(u), String(c));
    }
  }
  function s(u) {
    if (n.value.length === 0)
      return u;
    const c = e(), f = new Map(c.map((d) => [d.key, d]));
    return u.map((d, m) => ({ row: d, index: m })).sort((d, m) => {
      for (const $ of n.value) {
        const y = f.get($.columnKey);
        if (!y)
          continue;
        const p = i(
          d.row.values[$.columnKey],
          m.row.values[$.columnKey],
          y
        );
        if (p !== 0)
          return $.direction === "asc" ? p : -p;
      }
      return d.index - m.index;
    }).map((d) => d.row);
  }
  return {
    sortState: n,
    directionFor: r,
    toggleSort: a,
    setSort: o,
    clearSort: l,
    sortRows: s
  };
}
function zc(e) {
  function n(l) {
    const i = e.getRowKeys(), s = e.getColumns(), u = i.indexOf(l.start.rowKey), c = i.indexOf(l.end.rowKey), f = s.findIndex((m) => m.key === l.start.columnKey), d = s.findIndex((m) => m.key === l.end.columnKey);
    return {
      rowFrom: Math.min(u, c),
      rowTo: Math.max(u, c),
      colFrom: Math.min(f, d),
      colTo: Math.max(f, d)
    };
  }
  function t(l) {
    const i = e.getRowKeys(), s = e.getColumns(), u = n(l), c = [];
    for (let f = u.rowFrom; f <= u.rowTo; f++) {
      const d = [];
      for (let m = u.colFrom; m <= u.colTo; m++) {
        const $ = s[m], y = e.getValue(i[f], $.key);
        d.push(e.formatValue(y, $));
      }
      c.push(d.join("	"));
    }
    return c.join(`
`);
  }
  async function r(l) {
    const i = t(l);
    await navigator.clipboard.writeText(i);
  }
  function a(l, i, s) {
    const u = e.getRowKeys(), c = e.getColumns(), f = u.indexOf(i), d = c.findIndex((p) => p.key === s);
    if (f < 0 || d < 0)
      return [];
    const $ = l.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(`
`);
    $.length > 1 && $[$.length - 1] === "" && $.pop();
    const y = [];
    return $.forEach((p, h) => {
      const b = u[f + h];
      b != null && p.split("	").forEach((C, x) => {
        const _ = c[d + x];
        _ && y.push({ rowKey: b, columnKey: _.key, text: C });
      });
    }), y;
  }
  async function o() {
    return navigator.clipboard.readText();
  }
  return {
    copy: r,
    copyRangeToTsv: t,
    parseTsvTargets: a,
    readClipboardText: o
  };
}
function jc(e, n, t) {
  if (e.length === 0 || t <= 0)
    return [];
  switch (n.type) {
    case "number":
      return Yc(e, t);
    case "date":
    case "instant":
      return qc(e, t);
    default:
      return er(e, t);
  }
}
function er(e, n) {
  const t = [];
  for (let r = 0; r < n; r++)
    t.push(e[r % e.length]);
  return t;
}
function Yc(e, n) {
  const t = e.map((o) => typeof o == "number" ? o : Number(o));
  if (t.some((o) => Number.isNaN(o)))
    return er(e, n);
  if (t.length === 1)
    return Array.from({ length: n }, () => t[0]);
  const r = (t[t.length - 1] - t[0]) / (t.length - 1), a = t[t.length - 1];
  return Array.from({ length: n }, (o, l) => a + r * (l + 1));
}
function qc(e, n) {
  const t = e.map((o) => o instanceof Date ? o : new Date(o));
  if (t.some((o) => Number.isNaN(o.getTime())))
    return er(e, n);
  if (t.length === 1)
    return Array.from({ length: n }, () => new Date(t[0].getTime()));
  const r = (t[t.length - 1].getTime() - t[0].getTime()) / (t.length - 1), a = t[t.length - 1].getTime();
  return Array.from({ length: n }, (o, l) => new Date(a + r * (l + 1)));
}
const Xc = ["title"], Jc = { class: "label-text" }, Qc = {
  key: 0,
  class: "required-marker"
}, e1 = {
  key: 1,
  style: { visibility: "hidden" }
}, t1 = {
  key: 2,
  class: "sort-indicator"
}, n1 = /* @__PURE__ */ K({
  __name: "SpreadsheetColumnHeader",
  props: {
    column: {},
    sortDirection: {},
    sortable: { type: Boolean },
    isMeasuring: { type: Boolean },
    contextMenu: {}
  },
  emits: ["toggle-sort", "resize", "resize-reset"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = N();
    function o(s) {
      const u = s.target.parentElement;
      a.value = { startPos: s.x, startSize: u.clientWidth }, document.addEventListener("mousemove", l), document.addEventListener("mouseup", i);
    }
    function l(s) {
      if (!a.value)
        return;
      if (!a.value.cursorBlock) {
        const c = document.createElement("div");
        c.style.cssText = "position:fixed;inset:0;cursor:ew-resize;z-index:9999", document.body.appendChild(c), a.value.cursorBlock = c;
      }
      const u = Math.max(60, a.value.startSize + (s.x - a.value.startPos));
      r("resize", t.column.key, u);
    }
    function i() {
      var s, u;
      (u = (s = a.value) == null ? void 0 : s.cursorBlock) == null || u.remove(), a.value = void 0, document.removeEventListener("mousemove", l), document.removeEventListener("mouseup", i);
    }
    return (s, u) => {
      const c = ze("context-menu");
      return be((v(), g("th", null, [
        w("div", {
          class: "column-label",
          title: e.column.label,
          onClick: u[0] || (u[0] = (f) => e.sortable && r("toggle-sort", { shiftKey: f.shiftKey }))
        }, [
          e.isMeasuring ? (v(), g("span", e1, "##")) : (v(), g(G, { key: 0 }, [
            w("span", Jc, S(e.column.label), 1),
            e.column.required ? (v(), g("span", Qc, "*")) : I("", !0)
          ], 64)),
          e.sortable ? (v(), g("span", t1, [
            e.sortDirection ? (v(), Z(Jn, {
              key: 0,
              class: j(`sort--${e.sortDirection}`)
            }, null, 8, ["class"])) : (v(), Z(Qn, {
              key: 1,
              class: "sort--none"
            }))
          ])) : I("", !0)
        ], 8, Xc),
        w("div", {
          class: "column-resize",
          onMousedown: Ee(o, ["stop"]),
          onDblclick: u[1] || (u[1] = Ee((f) => r("resize-reset", e.column.key), ["stop"]))
        }, null, 32)
      ])), [
        [c, e.contextMenu ?? []]
      ]);
    };
  }
}), r1 = /* @__PURE__ */ Y(n1, [["__scopeId", "data-v-f370d80a"]]), o1 = /* @__PURE__ */ K({
  __name: "CellEditorText",
  props: {
    value: {},
    column: {},
    initialChar: {}
  },
  emits: ["commit", "cancel", "move"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = N(), o = N(t.initialChar ?? (t.value != null ? String(t.value) : ""));
    we(() => {
      var u, c, f;
      (u = a.value) == null || u.focus();
      const s = ((c = a.value) == null ? void 0 : c.value.length) ?? 0;
      (f = a.value) == null || f.setSelectionRange(s, s);
    });
    function l() {
      r("commit", o.value);
    }
    function i(s) {
      switch (s.key) {
        case "Enter":
          s.preventDefault(), r("commit", o.value), r("move", s.shiftKey ? "up" : "down");
          break;
        case "Tab":
          s.preventDefault(), r("commit", o.value), r("move", s.shiftKey ? "prev" : "next");
          break;
        case "Escape":
          s.preventDefault(), r("cancel");
          break;
      }
    }
    return (s, u) => be((v(), g("input", {
      ref_key: "input",
      ref: a,
      "onUpdate:modelValue": u[0] || (u[0] = (c) => o.value = c),
      type: "text",
      class: "cell-editor",
      onKeydown: i,
      onBlur: l
    }, null, 544)), [
      [pt, o.value]
    ]);
  }
}), a1 = /* @__PURE__ */ Y(o1, [["__scopeId", "data-v-4fc37441"]]), l1 = /* @__PURE__ */ K({
  __name: "CellEditorNumber",
  props: {
    value: {},
    column: {},
    initialChar: {}
  },
  emits: ["commit", "cancel", "move"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = N(), o = N(t.initialChar ?? (t.value != null ? String(t.value) : ""));
    we(() => {
      var f, d, m, $;
      if ((f = a.value) == null || f.focus(), t.initialChar) {
        const y = ((d = a.value) == null ? void 0 : d.value.length) ?? 0;
        (m = a.value) == null || m.setSelectionRange(y, y);
      } else
        ($ = a.value) == null || $.select();
    });
    function l(f) {
      const d = f.trim();
      if (d === "")
        return null;
      const m = d.replace(",", "."), $ = Number(m);
      return Number.isNaN($) ? null : i($);
    }
    function i(f) {
      let d = f;
      return t.column.min != null && (d = Math.max(d, t.column.min)), t.column.max != null && (d = Math.min(d, t.column.max)), d;
    }
    function s() {
      r("commit", l(o.value));
    }
    function u(f) {
      const d = l(o.value) ?? 0;
      o.value = String(i(d + f));
    }
    function c(f) {
      switch (f.key) {
        case "Enter":
          f.preventDefault(), r("commit", l(o.value)), r("move", f.shiftKey ? "up" : "down");
          break;
        case "Tab":
          f.preventDefault(), r("commit", l(o.value)), r("move", f.shiftKey ? "prev" : "next");
          break;
        case "Escape":
          f.preventDefault(), r("cancel");
          break;
        case "ArrowUp":
          f.preventDefault(), u(1);
          break;
        case "ArrowDown":
          f.preventDefault(), u(-1);
          break;
      }
    }
    return (f, d) => be((v(), g("input", {
      ref_key: "input",
      ref: a,
      "onUpdate:modelValue": d[0] || (d[0] = (m) => o.value = m),
      type: "text",
      inputmode: "decimal",
      class: "cell-editor",
      onKeydown: c,
      onBlur: s
    }, null, 544)), [
      [pt, o.value]
    ]);
  }
}), i1 = /* @__PURE__ */ Y(l1, [["__scopeId", "data-v-bebce337"]]), s1 = ["onMousedown", "onMouseenter"], u1 = /* @__PURE__ */ K({
  __name: "CellEditorEnum",
  props: {
    value: {},
    column: {}
  },
  emits: ["commit", "cancel", "move"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = N(), o = N(), l = D(() => t.column.enumValues ?? []), i = N(Math.max(0, l.value.findIndex((b) => b.key === t.value)));
    let s = !1, u = "", c;
    const f = D(() => {
      const b = l.value.find((C) => C.key === t.value);
      return b ? { label: b.label ?? b.key, hue: b.hue } : t.value != null ? { label: String(t.value), hue: void 0 } : null;
    });
    we(() => {
      var b, C;
      (b = o.value) == null || b.open(), (C = a.value) == null || C.focus();
    }), So(
      () => [Mo(o), a.value],
      () => r("cancel")
    );
    function d(b) {
      return b.label ?? b.key;
    }
    function m(b) {
      var C;
      s = !0, (C = o.value) == null || C.close(), r("commit", b);
    }
    function $(b) {
      m(b.key);
    }
    function y() {
      s || r("cancel");
    }
    function p(b) {
      switch (b.key) {
        case "ArrowDown":
          b.preventDefault(), i.value = Math.min(i.value + 1, l.value.length - 1);
          break;
        case "ArrowUp":
          b.preventDefault(), i.value = Math.max(i.value - 1, 0);
          break;
        case "Enter":
          b.preventDefault(), l.value[i.value] && (m(l.value[i.value].key), r("move", "down"));
          break;
        case "Tab":
          b.preventDefault(), l.value[i.value] && m(l.value[i.value].key), r("move", b.shiftKey ? "prev" : "next");
          break;
        case "Escape":
          b.preventDefault(), r("cancel");
          break;
        default:
          b.key.length === 1 && h(b.key);
      }
    }
    function h(b) {
      u += b.toLowerCase(), c && clearTimeout(c), c = setTimeout(() => {
        u = "";
      }, 600);
      const C = l.value.findIndex((x) => d(x).toLowerCase().startsWith(u));
      C >= 0 && (i.value = C);
    }
    return (b, C) => (v(), g("div", {
      ref_key: "anchor",
      ref: a,
      class: "enum-anchor",
      tabindex: "-1",
      onKeydown: p
    }, [
      f.value ? (v(), g("span", {
        key: 0,
        class: j(["enum-badge", { "has-hue": f.value.hue != null }]),
        style: xe(f.value.hue != null ? `--enum-hue: ${f.value.hue}` : void 0)
      }, S(f.value.label), 7)) : I("", !0),
      z(je, {
        ref_key: "dropdown",
        ref: o,
        popover: "",
        target: a.value,
        onClose: y
      }, {
        default: le(() => [
          (v(!0), g(G, null, Q(l.value, (x, _) => (v(), g("li", {
            key: x.key,
            class: j(["enum-option", { highlighted: _ === i.value, selected: x.key === e.value }]),
            style: xe(x.hue != null ? `--enum-hue: ${x.hue}` : void 0),
            onMousedown: Ee((T) => $(x), ["prevent", "stop"]),
            onMouseenter: (T) => i.value = _
          }, [
            w("span", {
              class: j(["enum-badge", { "has-hue": x.hue != null }])
            }, S(d(x)), 3)
          ], 46, s1))), 128))
        ]),
        _: 1
      }, 8, ["target"])
    ], 544));
  }
}), d1 = /* @__PURE__ */ Y(u1, [["__scopeId", "data-v-dc929d59"]]), c1 = { class: "boolean-placeholder" }, f1 = /* @__PURE__ */ K({
  __name: "CellEditorBoolean",
  props: {
    value: {},
    column: {}
  },
  emits: ["commit", "cancel", "move"],
  setup(e, { emit: n }) {
    const t = e, r = n;
    return we(() => {
      r("commit", !t.value);
    }), (a, o) => (v(), g("span", c1));
  }
}), m1 = /* @__PURE__ */ Y(f1, [["__scopeId", "data-v-39882d82"]]), v1 = { class: "date-text" }, $1 = /* @__PURE__ */ K({
  __name: "CellEditorDate",
  props: {
    value: {},
    column: {}
  },
  emits: ["commit", "cancel", "move"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = D(() => t.column.type === "instant"), o = N(), l = N();
    let i = !1;
    function s(_) {
      if (_ == null || _ === "")
        return;
      const T = _ instanceof Date ? _ : new Date(_);
      return Number.isNaN(T.getTime()) ? void 0 : T;
    }
    const u = N(s(t.value)), c = D({
      get: () => u.value ? ye.fromDate(u.value) : void 0,
      set: (_) => {
        u.value = _ == null ? void 0 : _.toDate();
      }
    }), f = D(() => {
      const _ = document.documentElement.dataset.formatting ?? navigator.language;
      return new Intl.DateTimeFormat(
        _,
        a.value ? { dateStyle: "short", timeStyle: "short" } : { dateStyle: "short" }
      );
    }), d = D(() => u.value ? f.value.format(u.value) : ""), m = D(() => t.column.min != null ? y(t.column.min) : void 0), $ = D(() => t.column.max != null ? y(t.column.max) : void 0);
    function y(_) {
      const T = s(_);
      return T ? ye.fromDate(T) : void 0;
    }
    we(() => {
      var _, T;
      (_ = l.value) == null || _.open(), (T = o.value) == null || T.focus();
    }), So(
      () => [Mo(l), o.value],
      () => h()
    );
    function p(_) {
      i = !0, r("commit", _);
    }
    function h() {
      u.value ? p(u.value) : r("cancel");
    }
    function b(_) {
      c.value = _, !a.value && u.value && p(u.value);
    }
    function C() {
      i || r("cancel");
    }
    function x(_) {
      switch (_.key) {
        case "Enter":
          _.preventDefault(), h(), r("move", "down");
          break;
        case "Tab":
          _.preventDefault(), h(), r("move", _.shiftKey ? "prev" : "next");
          break;
        case "Escape":
          _.preventDefault(), r("cancel");
          break;
      }
    }
    return (_, T) => (v(), g("div", {
      ref_key: "anchor",
      ref: o,
      class: "date-anchor",
      tabindex: "-1",
      onKeydown: x
    }, [
      w("span", v1, S(d.value), 1),
      z(je, {
        ref_key: "dropdown",
        ref: l,
        popover: "",
        target: o.value,
        onClose: C
      }, {
        default: le(() => [
          w("li", {
            class: "date-picker-item",
            onMousedown: T[1] || (T[1] = Ee(() => {
            }, ["prevent", "stop"])),
            onClick: T[2] || (T[2] = Ee(() => {
            }, ["stop"])),
            onKeydown: Ee(x, ["stop"])
          }, [
            a.value ? (v(), Z(mo, {
              key: 0,
              modelValue: u.value,
              "onUpdate:modelValue": T[0] || (T[0] = (W) => u.value = W),
              "min-date": m.value,
              "max-date": $.value
            }, null, 8, ["modelValue", "min-date", "max-date"])) : (v(), Z(co, {
              key: 1,
              "model-value": c.value,
              "min-date": m.value,
              "max-date": $.value,
              "onUpdate:modelValue": b
            }, null, 8, ["model-value", "min-date", "max-date"]))
          ], 32)
        ]),
        _: 1
      }, 8, ["target"])
    ], 544));
  }
}), h1 = /* @__PURE__ */ Y($1, [["__scopeId", "data-v-adfa6fc0"]]), p1 = /* @__PURE__ */ K({
  __name: "FillHandle",
  emits: ["fill-start"],
  setup(e, { emit: n }) {
    const t = n;
    return (r, a) => (v(), g("div", {
      class: "fill-handle",
      onMousedown: a[0] || (a[0] = Ee((o) => t("fill-start", o), ["stop", "prevent"]))
    }, null, 32));
  }
}), g1 = /* @__PURE__ */ Y(p1, [["__scopeId", "data-v-6ebc8218"]]), y1 = ["data-column-key", "title"], b1 = {
  key: 1,
  class: "cell-text"
}, w1 = /* @__PURE__ */ K({
  __name: "SpreadsheetCell",
  props: {
    row: {},
    column: {},
    isActive: { type: Boolean },
    isSelected: { type: Boolean },
    isEditing: { type: Boolean },
    isFillTarget: { type: Boolean },
    showFillHandle: { type: Boolean },
    error: {},
    isDirty: { type: Boolean },
    initialChar: {}
  },
  emits: ["commit", "cancel", "move", "mousedown", "mouseenter", "dblclick", "contextmenu", "fill-start"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = D(() => t.column.type ?? "text"), o = D(() => t.row.values[t.column.key]), l = D(() => a.value !== "number" ? null : new Intl.NumberFormat(document.documentElement.dataset.formatting ?? navigator.language, {
      minimumFractionDigits: t.column.minimumFractionDigits,
      maximumFractionDigits: t.column.maximumFractionDigits
    })), i = D(() => {
      if (a.value !== "date" && a.value !== "instant")
        return null;
      const m = document.documentElement.dataset.formatting ?? navigator.language;
      return new Intl.DateTimeFormat(
        m,
        a.value === "instant" ? { dateStyle: "short", timeStyle: "short" } : { dateStyle: "short" }
      );
    }), s = D(() => {
      var $;
      if (a.value !== "enum")
        return null;
      const m = ($ = t.column.enumValues) == null ? void 0 : $.find((y) => y.key === o.value);
      return m ? { label: m.label ?? m.key, hue: m.hue } : o.value != null ? { label: String(o.value), hue: void 0 } : null;
    }), u = D(() => {
      const m = o.value;
      if (m == null || m === "")
        return "";
      switch (a.value) {
        case "number": {
          const $ = typeof m == "number" ? m : Number(m);
          return Number.isNaN($) ? String(m) : l.value.format($) + (t.column.unitLabel ?? "");
        }
        case "boolean":
          return m ? "✓" : "";
        case "date":
        case "instant": {
          const $ = m instanceof Date ? m : new Date(m);
          return Number.isNaN($.getTime()) ? String(m) : i.value.format($);
        }
        default:
          return String(m);
      }
    }), c = D(() => {
      if (t.column.editor)
        return t.column.editor;
      switch (a.value) {
        case "number":
          return i1;
        case "enum":
          return d1;
        case "boolean":
          return m1;
        case "date":
        case "instant":
          return h1;
        default:
          return a1;
      }
    }), f = D(() => ({
      "cell--active": t.isActive,
      "cell--selected": t.isSelected,
      "cell--editing": t.isEditing,
      "cell--dirty": t.isDirty,
      "cell--error": t.error != null,
      "cell--readonly": !t.column.editable,
      "cell--number": a.value === "number",
      "cell--boolean": a.value === "boolean",
      "cell--fill-target": t.isFillTarget
    }));
    function d(m) {
      r("commit", m);
    }
    return (m, $) => (v(), g("td", {
      class: j(f.value),
      "data-column-key": e.column.key,
      title: e.error ?? void 0,
      onMousedown: $[3] || ($[3] = (y) => r("mousedown", y)),
      onMouseenter: $[4] || ($[4] = (y) => r("mouseenter")),
      onDblclick: $[5] || ($[5] = (y) => r("dblclick")),
      onContextmenu: $[6] || ($[6] = (y) => r("contextmenu"))
    }, [
      e.isEditing ? (v(), Z(tt(c.value), {
        key: 0,
        value: o.value,
        column: e.column,
        "initial-char": e.initialChar,
        onCommit: d,
        onCancel: $[0] || ($[0] = (y) => r("cancel")),
        onMove: $[1] || ($[1] = (y) => r("move", y))
      }, null, 40, ["value", "column", "initial-char"])) : (v(), g(G, { key: 1 }, [
        a.value === "enum" && s.value ? (v(), g("span", {
          key: 0,
          class: j(["enum-badge", { "has-hue": s.value.hue != null }]),
          style: xe(s.value.hue != null ? `--enum-hue: ${s.value.hue}` : void 0)
        }, S(s.value.label), 7)) : (v(), g("span", b1, S(u.value), 1))
      ], 64)),
      e.showFillHandle ? (v(), Z(g1, {
        key: 2,
        onFillStart: $[2] || ($[2] = (y) => r("fill-start", y))
      })) : I("", !0)
    ], 42, y1));
  }
}), C1 = /* @__PURE__ */ Y(w1, [["__scopeId", "data-v-1aa8bac1"]]), k1 = ["data-row-key"], x1 = {
  key: 0,
  class: "row-error"
}, _1 = /* @__PURE__ */ K({
  __name: "SpreadsheetRow",
  props: {
    row: {},
    columns: {},
    isActive: { type: Function },
    isSelected: { type: Function },
    isEditing: { type: Function },
    isFillTarget: { type: Function },
    showFillHandle: { type: Function },
    editingInitialChar: {},
    contextMenu: {}
  },
  emits: ["cell-mousedown", "cell-mouseenter", "cell-dblclick", "cell-contextmenu", "cell-fill-start", "cell-commit", "cell-cancel", "cell-move"],
  setup(e, { emit: n }) {
    const t = n;
    return (r, a) => {
      const o = ze("context-menu");
      return be((v(), g("tr", {
        "data-row-key": e.row.key,
        class: j(["spreadsheet-row", {
          "row--new": e.row.status === "new",
          "row--removed": e.row.status === "removed"
        }])
      }, [
        (v(!0), g(G, null, Q(e.columns, (l) => (v(), Z(C1, {
          key: l.key,
          row: e.row,
          column: l,
          "is-active": e.isActive(e.row.key, l.key),
          "is-selected": e.isSelected(e.row.key, l.key),
          "is-editing": e.isEditing(e.row.key, l.key),
          "is-fill-target": e.isFillTarget(e.row.key, l.key),
          "show-fill-handle": e.showFillHandle(e.row.key, l.key),
          "is-dirty": e.row.dirtyColumns.has(l.key),
          error: e.row.cellErrors.get(l.key),
          "initial-char": e.isEditing(e.row.key, l.key) ? e.editingInitialChar : void 0,
          onMousedown: (i) => t("cell-mousedown", { rowKey: e.row.key, columnKey: l.key, event: i }),
          onMouseenter: (i) => t("cell-mouseenter", { rowKey: e.row.key, columnKey: l.key }),
          onDblclick: (i) => t("cell-dblclick", { rowKey: e.row.key, columnKey: l.key }),
          onContextmenu: (i) => t("cell-contextmenu", { rowKey: e.row.key, columnKey: l.key }),
          onFillStart: (i) => t("cell-fill-start", { rowKey: e.row.key, columnKey: l.key, event: i }),
          onCommit: (i) => t("cell-commit", { rowKey: e.row.key, columnKey: l.key, value: i }),
          onCancel: a[0] || (a[0] = (i) => t("cell-cancel")),
          onMove: a[1] || (a[1] = (i) => t("cell-move", i))
        }, null, 8, ["row", "column", "is-active", "is-selected", "is-editing", "is-fill-target", "show-fill-handle", "is-dirty", "error", "initial-char", "onMousedown", "onMouseenter", "onDblclick", "onContextmenu", "onFillStart", "onCommit"]))), 128)),
        e.row.rowError ? (v(), g("div", x1, S(e.row.rowError), 1)) : I("", !0)
      ], 10, k1)), [
        [o, e.contextMenu ?? []]
      ]);
    };
  }
}), N1 = /* @__PURE__ */ Y(_1, [["__scopeId", "data-v-26c16658"]]), D1 = /* @__PURE__ */ K({
  __name: "NewRowIndicator",
  props: {
    label: {}
  },
  emits: ["add-row"],
  setup(e, { emit: n }) {
    const t = n;
    return (r, a) => (v(), g("div", {
      class: "new-row-indicator",
      role: "row",
      onClick: a[0] || (a[0] = (o) => t("add-row"))
    }, [
      z(hn, { class: "plus-icon" }),
      w("span", null, S(e.label ?? "Add row"), 1)
    ]));
  }
}), E1 = /* @__PURE__ */ Y(D1, [["__scopeId", "data-v-70a8aa31"]]), T1 = {
  class: "spreadsheet-grid",
  role: "rowgroup"
}, S1 = {
  class: "header-row",
  role: "row"
}, M1 = /* @__PURE__ */ K({
  __name: "Spreadsheet",
  props: {
    columns: {},
    rows: {},
    changeset: {},
    minRowHeight: { default: 29 },
    allowAddRows: { type: Boolean, default: !1 },
    allowRemoveRows: { type: Boolean, default: !1 }
  },
  emits: ["cell-change", "row-add", "row-remove"],
  setup(e, { expose: n, emit: t }) {
    const r = e, a = t, o = N(), l = N(), i = N(/* @__PURE__ */ new Map()), s = D(() => r.columns), u = D(() => {
      const k = /* @__PURE__ */ new Map();
      for (const M of r.rows)
        k.set(M.key, M);
      return k;
    }), c = D(() => {
      const k = [...r.rows, ...r.changeset.addedRows], M = new Set(r.changeset.addedRows.map((A) => A.key));
      return k.map((A) => {
        const q = r.changeset.cells.get(A.key), me = new Set(q ? q.keys() : []), ve = { ...A.values };
        if (q)
          for (const [Fe, ot] of q)
            ve[Fe] = ot.value;
        const Se = new Map(r.changeset.errors.get(A.key) ?? []);
        let Ce = "clean";
        return r.changeset.removedRowKeys.has(A.key) ? Ce = "removed" : M.has(A.key) ? Ce = "new" : me.size > 0 && (Ce = "dirty"), {
          key: A.key,
          values: ve,
          status: Ce,
          dirtyColumns: me,
          cellErrors: Se,
          rowError: r.changeset.rowErrors.get(A.key)
        };
      });
    }), f = Zc(() => s.value), d = D(() => f.sortRows(c.value)), m = D(() => d.value.map((k) => k.key)), $ = Wc({
      getRowKeys: () => m.value,
      getColumns: () => s.value
    });
    function y(k, M) {
      f.toggleSort(k, M);
    }
    const p = D(
      () => s.value.map((k) => {
        const M = i.value.get(k.key) ?? k.size;
        return M != null ? `${M}px` : "minmax(80px, 1fr)";
      }).join(" ")
    );
    function h(k, M) {
      var q;
      const A = Hc(r.changeset, k, M);
      return A ? A.value : (q = u.value.get(k)) == null ? void 0 : q.values[M];
    }
    function b(k, M) {
      var A;
      return (A = u.value.get(k)) == null ? void 0 : A.values[M];
    }
    function C(k) {
      return s.value.find((M) => M.key === k);
    }
    function x(k, M) {
      var A;
      if (k == null)
        return "";
      if (M.type === "enum") {
        const q = (A = M.enumValues) == null ? void 0 : A.find((me) => me.key === k);
        return (q == null ? void 0 : q.label) ?? String(k);
      }
      return (M.type === "date" || M.type === "instant") && k instanceof Date ? k.toISOString() : String(k);
    }
    function _(k, M) {
      var q, me;
      const A = k.trim();
      switch (M.type) {
        case "number": {
          if (A === "")
            return { value: null };
          const ve = Number(A.replace(",", "."));
          return Number.isNaN(ve) ? { value: k, error: "Not a number" } : { value: ve };
        }
        case "boolean":
          return { value: /^(true|1|yes|✓)$/i.test(A) };
        case "enum": {
          const ve = (q = M.enumValues) == null ? void 0 : q.find((Fe) => Fe.key === A), Se = (me = M.enumValues) == null ? void 0 : me.find((Fe) => (Fe.label ?? Fe.key).toLowerCase() === A.toLowerCase()), Ce = ve ?? Se;
          return Ce ? { value: Ce.key } : { value: k, error: "Invalid option" };
        }
        case "date":
        case "instant": {
          if (A === "")
            return { value: null };
          const ve = new Date(A);
          return Number.isNaN(ve.getTime()) ? { value: k, error: "Invalid date" } : { value: ve };
        }
        default:
          return { value: k };
      }
    }
    const T = zc({
      getColumns: () => s.value,
      getRowKeys: () => m.value,
      getValue: (k, M) => h(k, M),
      formatValue: x
    });
    async function W() {
      const k = $.state.ranges[0];
      if (k)
        try {
          await T.copy(k);
        } catch {
        }
    }
    async function F() {
      const k = $.state.active;
      if (!k)
        return;
      let M;
      try {
        M = await T.readClipboardText();
      } catch {
        return;
      }
      const A = T.parseTsvTargets(M, k.rowKey, k.columnKey);
      for (const q of A) {
        const me = C(q.columnKey);
        if (!(me != null && me.editable))
          continue;
        const ve = _(q.text, me);
        if (ve.error) {
          En(r.changeset, q.rowKey, q.columnKey, ve.error);
          continue;
        }
        Gt(r.changeset, q.rowKey, q.columnKey, ve.value, b(q.rowKey, q.columnKey)), a("cell-change", {
          rowKey: q.rowKey,
          columnKey: q.columnKey,
          value: ve.value,
          previousValue: void 0
        });
      }
    }
    function P() {
      const k = `__new_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`, M = {};
      for (const q of s.value)
        q.defaultValue !== void 0 && (M[q.key] = typeof q.defaultValue == "function" ? q.defaultValue() : q.defaultValue);
      r.changeset.addedRows.push({ key: k, values: M });
      const A = r.changeset.addedRows[r.changeset.addedRows.length - 1];
      a("row-add", { rowKey: k, row: A });
    }
    function E(k) {
      const M = m.value.filter(
        (A) => s.value.some((q) => $.isInRange(A, q.key))
      );
      return M.includes(k) ? M : [k];
    }
    function L(k) {
      const M = k.every((A) => r.changeset.removedRowKeys.has(A));
      for (const A of k)
        M ? r.changeset.removedRowKeys.delete(A) : r.changeset.removedRowKeys.has(A) || (r.changeset.removedRowKeys.add(A), a("row-remove", { rowKey: A }));
    }
    const J = N(!1);
    function ie(k) {
      var me;
      const { rowKey: M, columnKey: A, event: q } = k;
      if (!$.isEditing(M, A)) {
        if (q.shiftKey)
          $.setActive({ rowKey: M, columnKey: A }, !0);
        else if (q.ctrlKey || q.metaKey)
          $.addRange({ rowKey: M, columnKey: A });
        else {
          if ($.isActive(M, A) && ((me = C(A)) != null && me.editable)) {
            q.preventDefault(), Bt({ rowKey: M, columnKey: A });
            return;
          }
          $.setActive({ rowKey: M, columnKey: A }), J.value = !0, window.addEventListener("mouseup", O);
        }
        Et();
      }
    }
    function oe(k) {
      if (H.value) {
        X.value = { ...k };
        return;
      }
      J.value && $.setActive(k, !0);
    }
    function O() {
      J.value = !1, window.removeEventListener("mouseup", O);
    }
    const H = N(!1), X = N(null);
    function B(k) {
      return m.value.indexOf(k);
    }
    function R(k) {
      return s.value.findIndex((M) => M.key === k);
    }
    function te(k) {
      const M = B(k.start.rowKey), A = B(k.end.rowKey), q = R(k.start.columnKey), me = R(k.end.columnKey);
      return {
        rowFrom: Math.min(M, A),
        rowTo: Math.max(M, A),
        colFrom: Math.min(q, me),
        colTo: Math.max(q, me)
      };
    }
    const pe = D(() => {
      const k = $.state.ranges[0];
      return k ? te(k) : null;
    }), ge = D(() => {
      const k = pe.value, M = X.value;
      if (!k || !M)
        return null;
      const A = B(M.rowKey), q = R(M.columnKey);
      if (A < 0 || q < 0)
        return null;
      const me = Math.max(0, A - k.rowTo), ve = Math.max(0, k.rowFrom - A), Se = Math.max(0, q - k.colTo), Ce = Math.max(0, k.colFrom - q), Fe = Math.max(me, ve), ot = Math.max(Se, Ce);
      return Fe === 0 && ot === 0 ? null : Fe >= ot ? {
        rowFrom: Math.min(k.rowFrom, A),
        rowTo: Math.max(k.rowTo, A),
        colFrom: k.colFrom,
        colTo: k.colTo,
        axis: "vertical",
        forward: me >= ve
      } : {
        rowFrom: k.rowFrom,
        rowTo: k.rowTo,
        colFrom: Math.min(k.colFrom, q),
        colTo: Math.max(k.colTo, q),
        axis: "horizontal",
        forward: Se >= Ce
      };
    });
    function U(k) {
      var M;
      for (let A = k.colFrom; A <= k.colTo; A++)
        if ((M = s.value[A]) != null && M.editable)
          return !0;
      return !1;
    }
    function de(k, M) {
      if ($.state.editing || H.value)
        return !1;
      const A = pe.value;
      return !A || !U(A) ? !1 : B(k) === A.rowTo && R(M) === A.colTo;
    }
    function ne(k, M) {
      const A = ge.value, q = pe.value;
      if (!A || !q)
        return !1;
      const me = B(k), ve = R(M), Se = me >= A.rowFrom && me <= A.rowTo && ve >= A.colFrom && ve <= A.colTo, Ce = me >= q.rowFrom && me <= q.rowTo && ve >= q.colFrom && ve <= q.colTo;
      return Se && !Ce;
    }
    function ue() {
      pe.value && (H.value = !0, X.value = null, window.addEventListener("mouseup", Te));
    }
    function Te() {
      window.removeEventListener("mouseup", Te), Ke(), H.value = !1, X.value = null;
    }
    function Ke() {
      const k = ge.value, M = pe.value;
      if (!k || !M)
        return;
      const A = m.value, q = s.value;
      if (k.axis === "vertical") {
        const me = k.forward ? Ye(M.rowTo + 1, k.rowTo) : Ye(k.rowFrom, M.rowFrom - 1).reverse(), ve = k.forward ? Ye(M.rowFrom, M.rowTo) : Ye(M.rowFrom, M.rowTo).reverse();
        for (let Se = M.colFrom; Se <= M.colTo; Se++) {
          const Ce = q[Se];
          if (!(Ce != null && Ce.editable))
            continue;
          const Fe = ve.map((Tt) => h(A[Tt], Ce.key)), ot = jc(Fe, Ce, me.length);
          me.forEach((Tt, Go) => it(A[Tt], Ce, ot[Go]));
        }
      } else {
        const me = k.forward ? Ye(M.colTo + 1, k.colTo) : Ye(k.colFrom, M.colFrom - 1).reverse(), ve = k.forward ? Ye(M.colFrom, M.colTo) : Ye(M.colFrom, M.colTo).reverse();
        for (let Se = M.rowFrom; Se <= M.rowTo; Se++)
          for (let Ce = 0; Ce < me.length; Ce++) {
            const Fe = q[me[Ce]];
            if (!(Fe != null && Fe.editable))
              continue;
            const ot = q[ve[Ce % ve.length]];
            if ((Fe.type ?? "text") !== (ot.type ?? "text"))
              continue;
            const Tt = h(A[Se], ot.key);
            it(A[Se], Fe, Tt);
          }
      }
    }
    function it(k, M, A) {
      const q = c.value.find((ve) => ve.key === k);
      if (M.validate && q) {
        const ve = M.validate(A, { key: k, values: q.values });
        if (ve) {
          En(r.changeset, k, M.key, ve);
          return;
        }
      }
      const me = h(k, M.key);
      Gt(r.changeset, k, M.key, A, b(k, M.key)), a("cell-change", { rowKey: k, columnKey: M.key, value: A, previousValue: me });
    }
    function Ye(k, M) {
      const A = [];
      for (let q = k; q <= M; q++)
        A.push(q);
      return A;
    }
    function Lt(k) {
      $.isInRange(k.rowKey, k.columnKey) ? $.state.active = { ...k } : $.setActive(k);
    }
    function Rt(k) {
      const A = [[
        { label: "Copy", shortcut: "Ctrl+C", action: () => W() },
        { label: "Paste", shortcut: "Ctrl+V", action: () => F() },
        {
          label: "Clear",
          shortcut: "Del",
          action: () => {
            const q = $.state.active;
            q && tr(q);
          }
        }
      ]];
      if (r.allowRemoveRows) {
        const q = E(k), me = q.every((Se) => r.changeset.removedRowKeys.has(Se)), ve = q.length > 1 ? `${q.length} Rows` : "Row";
        A.push([
          {
            label: `${me ? "Undo Delete" : "Delete"} ${ve}`,
            action: () => L(q)
          }
        ]);
      }
      return A;
    }
    function Ot(k) {
      return [
        [
          {
            label: "Sort Ascending",
            checked: f.directionFor(k) === "asc",
            action: () => f.setSort(k, "asc")
          },
          {
            label: "Sort Descending",
            checked: f.directionFor(k) === "desc",
            action: () => f.setSort(k, "desc")
          },
          {
            label: "Clear Sort",
            action: () => f.clearSort(k)
          }
        ]
      ];
    }
    function pn(k) {
      const M = C(k.columnKey);
      M != null && M.editable && Bt(k);
    }
    function Bt(k, M) {
      const A = C(k.columnKey);
      A != null && A.editable && (l.value = M, $.setActive(k), $.startEditing(k));
    }
    function Ao(k) {
      const { rowKey: M, columnKey: A, value: q } = k, me = C(A);
      if (!me)
        return;
      const ve = c.value.find((Ce) => Ce.key === M), Se = h(M, A);
      if (me.validate && ve) {
        const Ce = me.validate(q, { key: M, values: ve.values });
        if (Ce) {
          En(r.changeset, M, A, Ce);
          return;
        }
      }
      Gt(r.changeset, M, A, q, b(M, A)), $.stopEditing(), l.value = void 0, a("cell-change", { rowKey: M, columnKey: A, value: q, previousValue: Se }), Et();
    }
    function Lo() {
      $.stopEditing(), l.value = void 0, Et();
    }
    function Ro(k) {
      switch ($.stopEditing(), k) {
        case "next":
          $.moveToEditable(!0);
          break;
        case "prev":
          $.moveToEditable(!1);
          break;
        case "up":
          $.move("up");
          break;
        case "down":
          $.move("down");
          break;
      }
      rt(), Et();
    }
    function Oo(k) {
      var A, q;
      if ($.state.editing)
        return;
      if ((k.ctrlKey || k.metaKey) && k.key.toLowerCase() === "c") {
        k.preventDefault(), W();
        return;
      }
      if ((k.ctrlKey || k.metaKey) && k.key.toLowerCase() === "v") {
        k.preventDefault(), F();
        return;
      }
      if (r.allowAddRows && (k.ctrlKey || k.metaKey) && k.shiftKey && (k.key === "+" || k.key === "=")) {
        k.preventDefault(), P();
        return;
      }
      if (!$.state.active)
        return;
      const M = $.state.active;
      if (r.allowRemoveRows && (k.ctrlKey || k.metaKey) && k.key === "-") {
        k.preventDefault(), L(E(M.rowKey));
        return;
      }
      if (r.allowRemoveRows && (k.ctrlKey || k.metaKey) && k.key.toLowerCase() === "z") {
        const me = E(M.rowKey).filter(
          (ve) => r.changeset.removedRowKeys.has(ve)
        );
        if (me.length > 0) {
          k.preventDefault();
          for (const ve of me)
            r.changeset.removedRowKeys.delete(ve);
          return;
        }
      }
      switch (k.key) {
        case "ArrowUp":
          k.preventDefault(), $.move("up", k.shiftKey), rt();
          break;
        case "ArrowDown":
          k.preventDefault(), $.move("down", k.shiftKey), rt();
          break;
        case "ArrowLeft":
          k.preventDefault(), $.move("left", k.shiftKey), rt();
          break;
        case "ArrowRight":
          k.preventDefault(), $.move("right", k.shiftKey), rt();
          break;
        case "Tab":
          k.preventDefault(), $.moveToEditable(!k.shiftKey), rt();
          break;
        case "Home":
          k.preventDefault(), k.ctrlKey ? $.moveToGridEdge(!1) : $.moveToRowEdge(!1), rt();
          break;
        case "End":
          k.preventDefault(), k.ctrlKey ? $.moveToGridEdge(!0) : $.moveToRowEdge(!0), rt();
          break;
        case "Enter":
        case "F2":
          k.preventDefault(), (A = C(M.columnKey)) != null && A.editable && Bt(M);
          break;
        case "Escape":
          k.preventDefault(), $.clear();
          break;
        case "Delete":
        case "Backspace":
          k.preventDefault(), tr(M);
          break;
        default:
          k.key.length === 1 && !k.ctrlKey && !k.metaKey && !k.altKey && (q = C(M.columnKey)) != null && q.editable && (k.preventDefault(), Bt(M, k.key));
      }
    }
    function tr(k) {
      const M = C(k.columnKey);
      if (!(M != null && M.editable))
        return;
      const A = h(k.rowKey, k.columnKey);
      Gt(r.changeset, k.rowKey, k.columnKey, null, b(k.rowKey, k.columnKey)), a("cell-change", { rowKey: k.rowKey, columnKey: k.columnKey, value: null, previousValue: A });
    }
    function Bo(k, M) {
      i.value.set(k, M), i.value = new Map(i.value);
    }
    function Vo(k) {
      i.value.delete(k), i.value = new Map(i.value);
    }
    function Et() {
      He(() => {
        var k;
        $.state.editing || (k = o.value) == null || k.focus();
      });
    }
    function rt() {
      He(() => {
        const k = $.state.active;
        if (!k || !o.value)
          return;
        const M = o.value.querySelector(
          `[data-row-key="${gn(k.rowKey)}"] [data-column-key="${gn(k.columnKey)}"]`
        );
        M == null || M.scrollIntoView({ block: "nearest", inline: "nearest" });
      });
    }
    function gn(k) {
      return typeof CSS < "u" && CSS.escape ? CSS.escape(k) : k.replace(/["\\]/g, "\\$&");
    }
    function Ko(k, M) {
      $.setActive({ rowKey: k, columnKey: M }), rt(), Et();
    }
    function Ho(k) {
      He(() => {
        var M, A;
        (A = (M = o.value) == null ? void 0 : M.querySelector(`[data-row-key="${gn(k)}"]`)) == null || A.scrollIntoView({ block: "nearest" });
      });
    }
    return n({ focusCell: Ko, scrollToRow: Ho }), (k, M) => (v(), g("div", {
      ref_key: "tableRef",
      ref: o,
      class: "spreadsheet neat-scroll",
      tabindex: "0",
      role: "grid",
      style: xe({ "--grid-columns": p.value, "--min-row-height": `${e.minRowHeight}px` }),
      onKeydown: Oo
    }, [
      w("div", T1, [
        w("div", S1, [
          (v(!0), g(G, null, Q(s.value, (A) => (v(), Z(r1, {
            key: A.key,
            column: A,
            sortable: !0,
            "sort-direction": ee(f).directionFor(A.key),
            "is-measuring": !1,
            "context-menu": Ot(A.key),
            onToggleSort: (q) => y(A.key, q.shiftKey),
            onResize: Bo,
            onResizeReset: Vo
          }, null, 8, ["column", "sort-direction", "context-menu", "onToggleSort"]))), 128))
        ]),
        (v(!0), g(G, null, Q(d.value, (A) => (v(), Z(N1, {
          key: A.key,
          row: A,
          columns: s.value,
          "is-active": ee($).isActive,
          "is-selected": ee($).isInRange,
          "is-editing": ee($).isEditing,
          "is-fill-target": ne,
          "show-fill-handle": de,
          "editing-initial-char": l.value,
          "context-menu": Rt(A.key),
          onCellMousedown: ie,
          onCellMouseenter: oe,
          onCellDblclick: pn,
          onCellContextmenu: Lt,
          onCellFillStart: ue,
          onCellCommit: Ao,
          onCellCancel: Lo,
          onCellMove: Ro
        }, null, 8, ["row", "columns", "is-active", "is-selected", "is-editing", "editing-initial-char", "context-menu"]))), 128)),
        e.allowAddRows ? (v(), Z(E1, {
          key: 0,
          onAddRow: P
        })) : I("", !0)
      ])
    ], 36));
  }
}), xm = /* @__PURE__ */ Y(M1, [["__scopeId", "data-v-ac34b0f2"]]), P1 = { class: "label-tags" }, I1 = ["title"], F1 = /* @__PURE__ */ K({
  __name: "LabelTags",
  props: {
    tags: {}
  },
  setup(e) {
    const n = e, t = D(() => Yr(n.tags) ? n.tags.value : n.tags);
    return (r, a) => (v(), g("span", P1, [
      (v(!0), g(G, null, Q(t.value, (o) => (v(), g("span", {
        key: `${o.value}-${o.style}`,
        class: j(["label-tag", {
          "label-tag--primary": o.style === "primary",
          "label-tag--success": o.style === "success",
          "label-tag--warning": o.style === "warning",
          "label-tag--danger": o.style === "danger",
          "label-tag--neutral": o.style === "neutral",
          "label-tag--custom": o.style === "custom" && o.hue !== void 0
        }]),
        style: xe(o.style === "custom" && o.hue !== void 0 ? `--color-hue: ${o.hue}` : ""),
        title: o.title
      }, S(o.value), 15, I1))), 128))
    ]));
  }
}), xt = /* @__PURE__ */ Y(F1, [["__scopeId", "data-v-a03ea5b8"]]), A1 = { class: "item" }, L1 = { class: "item" }, R1 = { class: "item" }, O1 = /* @__PURE__ */ K({
  __name: "NavigationBar",
  props: /* @__PURE__ */ De({
    items: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = Me(e, "modelValue"), r = N(), a = N(!1), o = new ResizeObserver(i);
    we(() => {
      i(), r.value && o.observe(r.value);
    }), lt(() => {
      o.disconnect();
    });
    const l = D(() => n.items.find((s) => s.id === t.value) ?? {
      label: "-",
      id: "-"
    });
    function i() {
      if (!r.value)
        return;
      const s = r.value.scrollWidth, u = r.value.getBoundingClientRect().width;
      a.value = Math.round(u) < Math.round(s);
    }
    return (s, u) => (v(), g("div", {
      class: j(["navigation-bar", {
        "navigation-bar--collapsed": a.value
      }])
    }, [
      w("div", {
        class: "items btn-group",
        ref_key: "itemsElem",
        ref: r
      }, [
        (v(!0), g(G, null, Q(e.items, (c) => (v(), Z(Iu, {
          key: c.id,
          modelValue: t.value,
          "onUpdate:modelValue": u[0] || (u[0] = (f) => t.value = f),
          value: c.id
        }, {
          default: le(() => [
            w("div", A1, [
              w("div", null, S(c.label), 1),
              z(xt, {
                tags: c.tags
              }, null, 8, ["tags"])
            ])
          ]),
          _: 2
        }, 1032, ["modelValue", "value"]))), 128))
      ], 512),
      z(dt, { class: "dropdown" }, {
        label: le(() => [
          w("div", L1, [
            w("div", null, S(l.value.label), 1),
            z(xt, {
              tags: l.value.tags
            }, null, 8, ["tags"])
          ])
        ]),
        default: le(() => [
          (v(!0), g(G, null, Q(e.items, (c) => (v(), Z(Ie, {
            key: c.id,
            onClick: (f) => t.value = c.id
          }, {
            default: le(() => [
              w("div", R1, [
                w("div", null, S(c.label), 1),
                z(xt, {
                  tags: c.tags
                }, null, 8, ["tags"])
              ])
            ]),
            _: 2
          }, 1032, ["onClick"]))), 128))
        ]),
        _: 1
      })
    ], 2));
  }
}), B1 = /* @__PURE__ */ Y(O1, [["__scopeId", "data-v-21008b13"]]), V1 = /* @__PURE__ */ K({
  __name: "Badge",
  props: {
    variant: { default: "neutral" },
    hue: {},
    uppercase: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (v(), g("span", {
      class: j(["badge", {
        "badge--primary": e.variant === "primary",
        "badge--success": e.variant === "success",
        "badge--warning": e.variant === "warning",
        "badge--danger": e.variant === "danger",
        "badge--neutral": e.variant === "neutral",
        "badge--custom": e.variant === "custom" && e.hue !== void 0,
        "badge--uppercase": e.uppercase
      }]),
      style: xe(e.variant === "custom" && e.hue !== void 0 ? `--badge-hue: ${e.hue}` : "")
    }, [
      ce(n.$slots, "default", {}, void 0, !0)
    ], 6));
  }
}), _m = /* @__PURE__ */ Y(V1, [["__scopeId", "data-v-7289064d"]]), K1 = { class: "rendered-message" }, H1 = {
  key: 1,
  class: "variable"
}, G1 = /* @__PURE__ */ K({
  __name: "RenderedMessage",
  props: {
    messageTemplate: {},
    values: {}
  },
  setup(e) {
    const n = e, t = document.documentElement.dataset.formatting ?? navigator.language, r = new Intl.DateTimeFormat(t, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    });
    function a(i) {
      const s = [], u = /{([^}]+)}/g;
      let c = 0, f;
      for (; (f = u.exec(i)) !== null; )
        f.index > c && s.push({ type: "text", value: i.slice(c, f.index) }), s.push({ type: "variable", value: f[1] }), c = u.lastIndex;
      return c < i.length && s.push({ type: "text", value: i.slice(c) }), s;
    }
    const o = D(() => a(n.messageTemplate));
    function l(i) {
      const s = n.values[i];
      return s instanceof Date ? r.format(s) : s ? s.toString() : "";
    }
    return (i, s) => (v(), g("div", K1, [
      (v(!0), g(G, null, Q(o.value, (u, c) => (v(), g(G, { key: c }, [
        u.type === "text" ? (v(), g(G, { key: 0 }, [
          he(S(u.value), 1)
        ], 64)) : (v(), g("span", H1, S(l(u.value)), 1))
      ], 64))), 128))
    ]));
  }
}), U1 = /* @__PURE__ */ Y(G1, [["__scopeId", "data-v-8f43e83f"]]), W1 = /* @__PURE__ */ K({
  __name: "MessageEntry",
  props: {
    entry: {}
  },
  setup(e) {
    return (n, t) => (v(), Z(U1, {
      "message-template": e.entry.messageTemplate,
      values: e.entry.dynamic
    }, null, 8, ["message-template", "values"]));
  }
}), Z1 = { class: "entry-meta" }, z1 = { class: "time" }, j1 = { class: "hour-minute" }, Y1 = { class: "second" }, q1 = {
  key: 0,
  class: "user"
}, X1 = { class: "entry" }, J1 = /* @__PURE__ */ K({
  __name: "LogEntry",
  props: {
    entry: {},
    componentMapper: { type: Function }
  },
  setup(e) {
    const n = e, t = D(() => {
      let s;
      return n.componentMapper && (s = n.componentMapper(n.entry)), s || (s = W1), s;
    }), r = document.documentElement.dataset.formatting ?? navigator.language, a = new Intl.DateTimeFormat(r, {
      hour: "numeric",
      minute: "numeric"
    }), o = new Intl.DateTimeFormat(r, {
      second: "numeric"
    }), l = D(() => a.format(n.entry.createdAt)), i = D(() => o.format(n.entry.createdAt).padStart(2, "0"));
    return (s, u) => {
      var c;
      return v(), g(G, null, [
        w("div", Z1, [
          w("div", z1, [
            w("span", j1, S(l.value), 1),
            w("span", Y1, ":" + S(i.value), 1)
          ]),
          (c = e.entry.identity) != null && c.name ? (v(), g("div", q1, S(e.entry.identity.name), 1)) : I("", !0)
        ]),
        w("div", X1, [
          (v(), Z(tt(t.value), { entry: e.entry }, null, 8, ["entry"]))
        ])
      ], 64);
    };
  }
}), Q1 = /* @__PURE__ */ Y(J1, [["__scopeId", "data-v-133661f1"]]), e0 = { class: "activity-log" }, t0 = { class: "entries" }, n0 = { class: "date-header" }, r0 = /* @__PURE__ */ K({
  __name: "ActivityLog",
  props: {
    entries: {},
    componentMapper: { type: Function }
  },
  setup(e) {
    const n = e, t = document.documentElement.dataset.formatting ?? navigator.language, r = new Intl.DateTimeFormat(t, {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    }), a = D(() => {
      const o = {};
      for (const s of n.entries)
        i(s);
      const l = Array.from(Object.values(o));
      return l.sort((s, u) => u.date.getTime() - s.date.getTime()), l.forEach((s) => s.entries.sort((u, c) => c.createdAt.getTime() - u.createdAt.getTime())), l;
      function i(s) {
        const u = r.format(s.createdAt);
        let c = o[u];
        c ? c.entries.push(s) : (c = {
          date: s.createdAt,
          entries: [s]
        }, o[u] = c);
      }
    });
    return (o, l) => (v(), g("div", e0, [
      w("div", t0, [
        (v(!0), g(G, null, Q(a.value, (i) => (v(), g(G, {
          key: i.date.getTime()
        }, [
          w("div", n0, S(ee(r).format(i.date)), 1),
          (v(!0), g(G, null, Q(i.entries, (s) => (v(), Z(Q1, {
            key: s.activityLogId,
            entry: s,
            "component-mapper": e.componentMapper
          }, null, 8, ["entry", "component-mapper"]))), 128))
        ], 64))), 128))
      ])
    ]));
  }
}), Nm = /* @__PURE__ */ Y(r0, [["__scopeId", "data-v-8b1667dd"]]), o0 = 6;
function on(e, n) {
  return e.color ?? `var(--chart-${n % o0 + 1})`;
}
function a0(e) {
  return String(e);
}
function l0(e) {
  return e;
}
let wt;
function i0() {
  return wt !== void 0 ? wt : typeof document > "u" ? (wt = null, wt) : (wt = document.createElement("canvas").getContext("2d"), wt);
}
const Lr = /* @__PURE__ */ new Map(), s0 = 6.5;
function Rr(e, n) {
  if (e.length === 0) return 0;
  const t = `${n}\0${e}`, r = Lr.get(t);
  if (r !== void 0) return r;
  const a = i0();
  if (!a) return e.length * s0;
  a.font = n;
  const o = a.measureText(e).width;
  return Lr.set(t, o), o;
}
const Or = "sans-serif";
function Br(e, n) {
  if (!e || typeof window > "u")
    return `${n}px ${Or}`;
  const t = window.getComputedStyle(e).fontFamily || Or;
  return `${n}px ${t}`;
}
function Gn(e) {
  if (e <= 0) return 0;
  const n = Math.floor(Math.log10(e)), t = Math.pow(10, n), r = e / t;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * t;
}
function u0(e) {
  return e >= 0 ? 0 : -Gn(Math.abs(e));
}
function d0(e) {
  if (!e.some((a) => a.points.some((o) => o.x != null))) {
    const a = /* @__PURE__ */ new Set(), o = [];
    for (const l of e)
      for (const i of l.points)
        a.has(i.label) || (a.add(i.label), o.push({ label: i.label, x: null }));
    return { keys: o, isLinear: !1 };
  }
  const t = /* @__PURE__ */ new Map();
  for (const a of e)
    for (const o of a.points)
      o.x != null && (t.has(o.x) || t.set(o.x, o.label));
  return { keys: Array.from(t.keys()).sort((a, o) => a - o).map((a) => ({ label: t.get(a), x: a })), isLinear: !0 };
}
function Un(e, n) {
  const t = e.points.find((r) => n.x != null ? r.x === n.x : r.label === n.label);
  return (t == null ? void 0 : t.value) ?? null;
}
function c0(e, n) {
  let t = 0, r = 0;
  for (const a of n) {
    let o = 0, l = 0;
    for (const i of e) {
      const s = Un(i, a);
      s != null && (s >= 0 ? o += s : l += s);
    }
    r = Math.max(r, o), t = Math.min(t, l);
  }
  return { min: t, max: r };
}
function f0(e, n) {
  const t = /* @__PURE__ */ new Map(), r = [];
  for (const l of e)
    if (l.stackGroup) {
      const i = t.get(l.stackGroup) ?? [];
      i.push(l), t.set(l.stackGroup, i);
    } else
      r.push(l);
  let a = 0, o = 0;
  for (const l of n) {
    for (const i of t.values()) {
      let s = 0, u = 0;
      for (const c of i) {
        const f = Un(c, l);
        f != null && (f >= 0 ? s += f : u += f);
      }
      o = Math.max(o, s), a = Math.min(a, u);
    }
    for (const i of r) {
      const s = Un(i, l);
      s != null && (o = Math.max(o, s), a = Math.min(a, s));
    }
  }
  return { min: a, max: o };
}
function m0(e) {
  let n = 0, t = 0;
  for (const r of e)
    for (const a of r.points)
      a.value != null && (t = Math.max(t, a.value), n = Math.min(n, a.value));
  return { min: n, max: t };
}
function v0(e, n, t, r) {
  return D(() => {
    const a = e.value ?? [], { keys: o, isLinear: l } = d0(a), i = r != null && r.value ? f0(a, o) : t != null && t.value ? c0(a, o) : m0(a), s = Math.max(1, Math.floor(n.value ?? 4)), u = i.max - i.min, c = u > 0 ? Gn(u / s) : 0, f = c > 0 ? Math.ceil(i.max / c) * c : Gn(i.max), d = c > 0 ? Math.floor(i.min / c) * c : u0(i.min), m = f - d, $ = [];
    if (m === 0 || c === 0)
      $.push(0);
    else {
      const C = Math.round(m / c);
      for (let x = 0; x <= C; x++) {
        const _ = d + c * x;
        $.push(Math.abs(_) < c / 1e6 ? 0 : _);
      }
    }
    const y = o.map((C) => C.x), p = y.filter((C) => C != null), h = l ? Math.min(...p) : 0, b = l ? Math.max(...p) : 0;
    return {
      labels: o.map((C) => C.label),
      xValues: y,
      isLinear: l,
      xMin: h,
      xMax: b,
      min: d,
      max: f,
      ticks: $,
      normalize(C) {
        return m === 0 ? 0 : (C - d) / m;
      },
      xPosition(C) {
        return !l || b === h ? 0.5 : (C - h) / (b - h);
      }
    };
  });
}
const $0 = ["id"], h0 = {
  key: 1,
  class: "chart-legend"
}, p0 = ["aria-pressed", "onClick"], g0 = {
  key: 3,
  class: "chart-plot"
}, y0 = ["height", "viewBox", "aria-labelledby", "aria-describedby"], b0 = ["id"], w0 = { class: "chart-gridlines" }, C0 = ["x1", "x2", "y1", "y2"], k0 = { class: "chart-tick-labels" }, x0 = ["x", "y"], _0 = {
  key: 0,
  class: "chart-reference-lines"
}, N0 = ["x1", "x2", "y1", "y2", "stroke"], D0 = ["x", "y", "fill"], E0 = ["x1", "x2", "y1", "y2"], T0 = { class: "chart-tick-labels" }, S0 = ["x", "y"], M0 = { class: "chart-tooltip-series" }, P0 = { class: "chart-tooltip-label" }, I0 = { class: "chart-tooltip-value" }, F0 = { class: "chart-a11y-hider" }, A0 = {
  key: 0,
  class: "chart-a11y-table"
}, L0 = { key: 0 }, Vr = 11, Tn = 8, Kr = 12, R0 = 20, Hr = 8, O0 = 8, B0 = /* @__PURE__ */ K({
  __name: "ChartFrame",
  props: /* @__PURE__ */ De({
    series: {},
    title: {},
    formatValue: {},
    formatLabel: {},
    yTicks: { default: 4 },
    legend: { type: Boolean },
    emptyText: { default: "No data" },
    height: { default: 220 },
    stacked: { type: Boolean, default: !1 },
    stackGroups: { type: Boolean, default: !1 },
    referenceLines: { default: () => [] }
  }, {
    selected: { default: null },
    selectedModifiers: {}
  }),
  emits: ["update:selected"],
  setup(e) {
    const n = e, t = Me(e, "selected"), r = Mn(), a = Mn(), o = N(), l = N(0), i = N(Br(null, Vr));
    let s;
    we(() => {
      o.value && (i.value = Br(o.value, Vr), l.value = o.value.clientWidth, s = new ResizeObserver((X) => {
        for (const B of X)
          l.value = B.contentRect.width;
      }), s.observe(o.value));
    }), Ze(() => {
      s == null || s.disconnect(), s = void 0;
    });
    const u = D(() => n.formatValue ?? a0), c = D(() => n.formatLabel ?? l0), f = D(() => n.series ?? []), d = D(() => n.yTicks), m = D(() => n.stacked), $ = D(() => n.stackGroups), y = v0(f, d, m, $), p = D(
      () => f.value.some((X) => X.points.some((B) => B.value != null))
    ), h = D(() => n.legend ?? f.value.length > 1), b = D(() => {
      const X = y.value.ticks.reduce((B, R) => Math.max(B, Rr(u.value(R), i.value)), 0);
      return Math.ceil(X) + Tn;
    }), C = D(() => {
      const X = b.value, B = Math.max(0, l.value - X - O0), R = Math.max(0, n.height - Hr - R0);
      return {
        x: X,
        y: Hr,
        width: B,
        height: R
      };
    }), x = D(() => {
      const X = y.value.labels.length;
      return X > 0 ? C.value.width / X : 0;
    });
    function _(X) {
      return C.value.x + x.value * X;
    }
    function T(X) {
      return _(X) + x.value / 2;
    }
    function W(X) {
      return C.value.y + C.value.height * (1 - y.value.normalize(X));
    }
    const F = D(() => W(Math.max(y.value.min, 0)));
    function P(X) {
      return C.value.x + C.value.width * y.value.xPosition(X);
    }
    const E = D(
      () => y.value.labels.map(
        (X, B) => Rr(c.value(X, B), i.value)
      )
    ), L = D(() => {
      const X = y.value.labels;
      if (X.length === 0 || l.value <= 0) return [];
      const B = E.value.reduce((de, ne) => Math.max(de, ne), 0);
      if (B <= 0) return [];
      const R = (de) => {
        if (y.value.isLinear) {
          const ne = y.value.xValues[de];
          return ne == null ? 0 : C.value.x + C.value.width * y.value.xPosition(ne);
        }
        return T(de);
      }, te = (de) => {
        const ne = E.value[de] / 2, ue = R(de);
        return ue - ne >= 0 && ue + ne <= l.value;
      }, pe = [];
      if (y.value.isLinear) {
        const de = X.length - 1;
        let ne = -1 / 0;
        for (let ue = 0; ue < X.length; ue++) {
          const Te = ue === 0 || ue === de;
          if (!Te && !te(ue)) continue;
          const Ke = R(ue), it = E.value[ue] / 2;
          (Te || Ke - it >= ne) && (pe.push({ label: X[ue], index: ue, x: Ke }), ne = Ke + it + Kr);
        }
        return pe;
      }
      const ge = Math.max(1, Math.ceil((B + Kr) / x.value));
      let U = 0;
      for (; U < X.length && !te(U); )
        U++;
      for (let de = U; de < X.length; de += ge)
        te(de) && pe.push({ label: X[de], index: de, x: R(de) });
      return pe;
    }), J = N(null);
    function ie(X) {
      J.value = X;
    }
    function oe(X) {
      t.value = t.value === X ? null : X;
    }
    const O = D(() => {
      const X = J.value;
      return X ? {
        seriesLabel: X.seriesLabel,
        color: X.color,
        label: c.value(X.label, X.index),
        value: u.value(X.value),
        x: X.x,
        y: Math.min(Math.max(X.y, 0), n.height),
        // Flipping at the midpoint keeps the tooltip inside the chart without
        // measuring it, which would cost a layout pass on every pointer move.
        flipped: X.x > l.value / 2
      } : null;
    }), H = D(() => p.value ? `${f.value.map((B) => B.label).join(", ")}. Values from ${u.value(y.value.min)} to ${u.value(y.value.max)}.` : n.emptyText);
    return (X, B) => (v(), g("div", {
      class: "chart-frame",
      ref_key: "wrapper",
      ref: o
    }, [
      e.title ? (v(), g("div", {
        key: 0,
        class: "chart-title",
        id: ee(r)
      }, S(e.title), 9, $0)) : I("", !0),
      h.value && p.value ? (v(), g("div", h0, [
        (v(!0), g(G, null, Q(e.series, (R, te) => (v(), g("button", {
          key: R.label,
          type: "button",
          class: j(["chart-legend-item", { "is-dimmed": t.value != null && t.value !== R.label }]),
          "aria-pressed": t.value === R.label,
          onClick: (pe) => oe(R.label)
        }, [
          w("span", {
            class: "chart-legend-swatch",
            style: xe({ backgroundColor: ee(on)(R, te) })
          }, null, 4),
          he(" " + S(R.label), 1)
        ], 10, p0))), 128))
      ])) : I("", !0),
      p.value ? (v(), g("div", g0, [
        l.value > 0 ? (v(), g("svg", {
          key: 0,
          class: "chart-svg",
          height: e.height,
          viewBox: `0 0 ${l.value} ${e.height}`,
          preserveAspectRatio: "none",
          role: "img",
          "aria-labelledby": e.title ? ee(r) : void 0,
          "aria-describedby": ee(a)
        }, [
          w("desc", { id: ee(a) }, S(H.value), 9, b0),
          ce(X.$slots, "background", {
            plot: C.value,
            scale: ee(y),
            valueY: W,
            zeroY: F.value,
            selected: t.value
          }, void 0, !0),
          w("g", w0, [
            (v(!0), g(G, null, Q(ee(y).ticks, (R) => (v(), g("line", {
              key: `grid-${R}`,
              x1: C.value.x,
              x2: C.value.x + C.value.width,
              y1: W(R),
              y2: W(R)
            }, null, 8, C0))), 128))
          ]),
          w("g", k0, [
            (v(!0), g(G, null, Q(ee(y).ticks, (R) => (v(), g("text", {
              key: `ytick-${R}`,
              x: C.value.x - Tn,
              y: W(R),
              "text-anchor": "end",
              "dominant-baseline": "middle"
            }, S(u.value(R)), 9, x0))), 128))
          ]),
          ce(X.$slots, "default", {
            plot: C.value,
            scale: ee(y),
            bandWidth: x.value,
            bandStart: _,
            bandCenter: T,
            valueY: W,
            zeroY: F.value,
            selected: t.value,
            setHover: ie,
            toggleSelected: oe
          }, void 0, !0),
          ee(y).isLinear ? (v(), g("g", _0, [
            (v(!0), g(G, null, Q(e.referenceLines, (R, te) => (v(), g("g", {
              key: `ref-${te}`
            }, [
              w("line", {
                class: "chart-reference-line",
                x1: P(R.x),
                x2: P(R.x),
                y1: C.value.y,
                y2: C.value.y + C.value.height,
                stroke: R.color ?? "var(--muted-foreground)"
              }, null, 8, N0),
              R.label ? (v(), g("text", {
                key: 0,
                class: "chart-reference-label",
                x: P(R.x),
                y: C.value.y - 2,
                "text-anchor": "middle",
                fill: R.color ?? "var(--muted-foreground)"
              }, S(R.label), 9, D0)) : I("", !0)
            ]))), 128))
          ])) : I("", !0),
          w("line", {
            class: "chart-axis",
            x1: C.value.x,
            x2: C.value.x + C.value.width,
            y1: F.value,
            y2: F.value
          }, null, 8, E0),
          w("g", T0, [
            (v(!0), g(G, null, Q(L.value, (R) => (v(), g("text", {
              key: `xtick-${R.index}`,
              x: R.x,
              y: C.value.y + C.value.height + Tn,
              "text-anchor": "middle",
              "dominant-baseline": "hanging"
            }, S(c.value(R.label, R.index)), 9, S0))), 128))
          ])
        ], 8, y0)) : I("", !0),
        O.value ? (v(), g("div", {
          key: 1,
          class: j(["chart-tooltip", { "is-flipped": O.value.flipped }]),
          style: xe({ left: `${O.value.x}px`, top: `${O.value.y}px` })
        }, [
          w("div", M0, [
            w("span", {
              class: "chart-tooltip-swatch",
              style: xe({ backgroundColor: O.value.color })
            }, null, 4),
            he(" " + S(O.value.seriesLabel), 1)
          ]),
          w("div", P0, S(O.value.label), 1),
          w("div", I0, S(O.value.value), 1)
        ], 6)) : I("", !0)
      ])) : (v(), g("div", {
        key: 2,
        class: "chart-empty",
        style: xe({ height: `${e.height}px` })
      }, S(e.emptyText), 5)),
      w("div", F0, [
        p.value ? (v(), g("table", A0, [
          e.title ? (v(), g("caption", L0, S(e.title), 1)) : I("", !0),
          w("thead", null, [
            w("tr", null, [
              B[0] || (B[0] = w("th", null, null, -1)),
              (v(!0), g(G, null, Q(e.series, (R) => (v(), g("th", {
                key: R.label
              }, S(R.label), 1))), 128))
            ])
          ]),
          w("tbody", null, [
            (v(!0), g(G, null, Q(ee(y).labels, (R, te) => (v(), g("tr", { key: R }, [
              w("th", null, S(c.value(R, te)), 1),
              (v(!0), g(G, null, Q(e.series, (pe) => {
                var ge;
                return v(), g("td", {
                  key: pe.label
                }, S(((ge = pe.points.find((U) => U.label === R)) == null ? void 0 : ge.value) != null ? u.value(pe.points.find((U) => U.label === R).value) : "—"), 1);
              }), 128))
            ]))), 128))
          ])
        ])) : I("", !0)
      ])
    ], 512));
  }
}), Po = /* @__PURE__ */ Y(B0, [["__scopeId", "data-v-8f9f5f4c"]]), V0 = { class: "chart-bars" }, K0 = ["x", "y", "width", "height", "fill", "onPointerenter", "onPointerleave", "onClick"], Gr = 0.15, Sn = 1, H0 = /* @__PURE__ */ K({
  __name: "BarChart",
  props: /* @__PURE__ */ De({
    series: {},
    title: {},
    formatValue: {},
    formatLabel: {},
    yTicks: { default: 4 },
    legend: { type: Boolean },
    emptyText: { default: "No data" },
    height: { default: 220 },
    mode: { default: "grouped" },
    barGap: { default: 2 }
  }, {
    selected: { default: null },
    selectedModifiers: {}
  }),
  emits: ["update:selected"],
  setup(e) {
    const n = e, t = Me(e, "selected"), r = D(() => n.mode === "stacked" && n.series.length > 1);
    function a(i, s) {
      var u;
      return ((u = i.points.find((c) => c.label === s)) == null ? void 0 : u.value) ?? null;
    }
    function o(i, s, u, c, f) {
      const d = [];
      if (s <= 0) return d;
      const m = s * (1 - Gr * 2), $ = s * Gr;
      return i.forEach((y, p) => {
        const h = u(p) + $;
        if (r.value) {
          let _ = 0, T = 0;
          n.series.forEach((W, F) => {
            const P = a(W, y);
            if (P == null) return;
            const E = P >= 0 ? _ : T, L = E + P, J = c(E), ie = c(L);
            d.push({
              key: `${y}-${W.label}-${F}`,
              x: h,
              y: Math.min(J, ie),
              width: m,
              height: Math.max(Math.abs(ie - J), Sn),
              color: on(W, F),
              seriesLabel: W.label,
              label: y,
              index: p,
              value: P
            }), P >= 0 ? _ = L : T = L;
          });
          return;
        }
        const b = n.series.length, C = n.barGap * Math.max(0, b - 1), x = Math.max((m - C) / Math.max(b, 1), Sn);
        n.series.forEach((_, T) => {
          const W = a(_, y);
          if (W == null) return;
          const F = c(W);
          d.push({
            key: `${y}-${_.label}-${T}`,
            x: h + T * (x + n.barGap),
            y: Math.min(F, f),
            width: x,
            height: Math.max(Math.abs(f - F), Sn),
            color: on(_, T),
            seriesLabel: _.label,
            label: y,
            index: p,
            value: W
          });
        });
      }), d;
    }
    function l(i) {
      return {
        seriesLabel: i.seriesLabel,
        color: i.color,
        label: i.label,
        index: i.index,
        value: i.value,
        x: i.x + i.width / 2,
        y: i.y
      };
    }
    return (i, s) => (v(), Z(Po, {
      selected: t.value,
      "onUpdate:selected": s[0] || (s[0] = (u) => t.value = u),
      series: e.series,
      title: e.title,
      "format-value": e.formatValue,
      "format-label": e.formatLabel,
      "y-ticks": e.yTicks,
      legend: e.legend,
      "empty-text": e.emptyText,
      height: e.height,
      stacked: r.value
    }, {
      default: le(({ scale: u, bandWidth: c, bandStart: f, valueY: d, zeroY: m, selected: $, setHover: y, toggleSelected: p }) => [
        w("g", V0, [
          (v(!0), g(G, null, Q(o(u.labels, c, f, d, m), (h) => (v(), g("rect", {
            key: h.key,
            class: j({ "is-dimmed": $ != null && $ !== h.seriesLabel }),
            x: h.x,
            y: h.y,
            width: h.width,
            height: h.height,
            fill: h.color,
            onPointerenter: (b) => y(l(h)),
            onPointerleave: (b) => y(null),
            onClick: (b) => p(h.seriesLabel)
          }, null, 42, K0))), 128))
        ])
      ]),
      _: 1
    }, 8, ["selected", "series", "title", "format-value", "format-label", "y-ticks", "legend", "empty-text", "height", "stacked"]));
  }
}), Dm = /* @__PURE__ */ Y(H0, [["__scopeId", "data-v-f84c12e9"]]), G0 = ["d", "fill"], U0 = ["d", "stroke"], W0 = ["cx", "cy", "fill"], Z0 = ["cx", "cy", "onPointerenter", "onPointerleave", "onClick"], Ut = 0.2, z0 = 10, j0 = /* @__PURE__ */ K({
  __name: "LineChart",
  props: /* @__PURE__ */ De({
    series: {},
    title: {},
    formatValue: {},
    formatLabel: {},
    yTicks: { default: 4 },
    legend: { type: Boolean },
    emptyText: { default: "No data" },
    height: { default: 220 },
    showPoints: { type: Boolean, default: !0 },
    smooth: { type: Boolean, default: !1 },
    stepped: { type: Boolean, default: !1 },
    referenceLines: { default: () => [] }
  }, {
    selected: { default: null },
    selectedModifiers: {}
  }),
  emits: ["update:selected"],
  setup(e) {
    const n = e, t = Me(e, "selected"), r = D(() => n.series.some((f) => f.stackGroup != null));
    function a(f) {
      return f.map((d, m) => `${m === 0 ? "M" : "L"}${d.x},${d.y}`).join(" ");
    }
    function o(f) {
      let d = `M${f[0].x},${f[0].y}`;
      for (let m = 1; m < f.length; m++) {
        const $ = f[m - 1], y = f[m];
        d += ` L${y.x},${$.y} L${y.x},${y.y}`;
      }
      return d;
    }
    function l(f) {
      if (f.length < 3) return a(f);
      let d = `M${f[0].x},${f[0].y}`;
      for (let m = 0; m < f.length - 1; m++) {
        const $ = f[m - 1] ?? f[m], y = f[m], p = f[m + 1], h = f[m + 2] ?? p, b = y.x + (p.x - $.x) * Ut, C = y.y + (p.y - $.y) * Ut, x = p.x - (h.x - y.x) * Ut, _ = p.y - (h.y - y.y) * Ut;
        d += ` C${b},${C} ${x},${_} ${p.x},${p.y}`;
      }
      return d;
    }
    function i(f) {
      return n.stepped ? o(f) : n.smooth ? l(f) : a(f);
    }
    function s(f) {
      if (f.length < 2) return "";
      const d = i(f), m = f[f.length - 1];
      let $ = `L${m.x},${m.yBottom}`;
      if (n.stepped)
        for (let y = f.length - 1; y >= 1; y--) {
          const p = f[y - 1];
          $ += ` L${f[y].x},${p.yBottom} L${p.x},${p.yBottom}`;
        }
      else
        for (let y = f.length - 2; y >= 0; y--)
          $ += ` L${f[y].x},${f[y].yBottom}`;
      return `${d} ${$} Z`;
    }
    function u(f, d, m) {
      const $ = f.labels.map((_, T) => ({
        label: _,
        x: f.xValues[T],
        index: T
      })), y = (_) => {
        if (f.isLinear && _.x != null)
          return d.x + d.width * f.xPosition(_.x);
        const T = d.width / f.labels.length;
        return d.x + T * _.index + T / 2;
      }, p = (_, T) => {
        const W = _.points.find((F) => T.x != null ? F.x === T.x : F.label === T.label);
        return (W == null ? void 0 : W.value) ?? null;
      }, h = /* @__PURE__ */ new Map(), b = [];
      n.series.forEach((_, T) => {
        if (_.stackGroup) {
          const W = h.get(_.stackGroup) ?? [];
          W.push({ series: _, index: T }), h.set(_.stackGroup, W);
        } else
          b.push({ series: _, index: T });
      });
      const C = [], x = (_, T, W) => {
        const F = [];
        let P = [];
        $.forEach((J, ie) => {
          const oe = p(_, J);
          if (oe == null) {
            P.length > 0 && (F.push(P), P = []);
            return;
          }
          const O = W ? W[ie] : 0, H = O + oe, X = y(J);
          P.push({
            x: X,
            y: m(H),
            yBottom: m(O),
            label: J.label,
            index: J.index,
            value: oe
          }), W && (W[ie] = H);
        }), P.length > 0 && F.push(P);
        const E = F.map((J) => i(J)), L = _.area ? F.filter((J) => J.length > 1).map((J) => s(J)) : [];
        C.push({
          key: `${_.label}-${T}`,
          label: _.label,
          color: on(_, T),
          paths: E,
          areas: L,
          points: F.flat()
        });
      };
      for (const _ of h.values()) {
        const T = new Array($.length).fill(0);
        for (const { series: W, index: F } of _)
          x(W, F, T);
      }
      for (const { series: _, index: T } of b)
        x(_, T, null);
      return C;
    }
    function c(f, d) {
      return {
        seriesLabel: f.label,
        color: f.color,
        label: d.label,
        index: d.index,
        value: d.value,
        x: d.x,
        y: d.y
      };
    }
    return (f, d) => (v(), Z(Po, {
      selected: t.value,
      "onUpdate:selected": d[0] || (d[0] = (m) => t.value = m),
      series: e.series,
      title: e.title,
      "format-value": e.formatValue,
      "format-label": e.formatLabel,
      "y-ticks": e.yTicks,
      legend: e.legend,
      "empty-text": e.emptyText,
      height: e.height,
      "stack-groups": r.value,
      "reference-lines": e.referenceLines
    }, {
      background: le(({ scale: m, plot: $, valueY: y, selected: p }) => [
        (v(!0), g(G, null, Q(u(m, $, y), (h) => (v(), g("g", {
          key: `bg-${h.key}`,
          class: j(["chart-series", { "is-dimmed": p != null && p !== h.label }])
        }, [
          (v(!0), g(G, null, Q(h.areas, (b, C) => (v(), g("path", {
            key: `area-${C}`,
            class: "chart-area",
            d: b,
            fill: h.color
          }, null, 8, G0))), 128))
        ], 2))), 128))
      ]),
      default: le(({ scale: m, plot: $, valueY: y, selected: p, setHover: h, toggleSelected: b }) => [
        (v(!0), g(G, null, Q(u(m, $, y), (C) => (v(), g("g", {
          key: C.key,
          class: j(["chart-series", {
            "is-selected": p === C.label,
            "is-dimmed": p != null && p !== C.label
          }])
        }, [
          (v(!0), g(G, null, Q(C.paths, (x, _) => (v(), g("path", {
            key: `line-${_}`,
            class: "chart-line",
            d: x,
            stroke: C.color
          }, null, 8, U0))), 128)),
          (v(!0), g(G, null, Q(e.showPoints ? C.points : [], (x, _) => (v(), g("circle", {
            key: `point-${_}`,
            class: "chart-point",
            cx: x.x,
            cy: x.y,
            r: "2.5",
            fill: C.color
          }, null, 8, W0))), 128)),
          (v(!0), g(G, null, Q(C.points, (x, _) => (v(), g("circle", {
            key: `hit-${_}`,
            class: "chart-point-hit",
            cx: x.x,
            cy: x.y,
            r: z0,
            onPointerenter: (T) => h(c(C, x)),
            onPointerleave: (T) => h(null),
            onClick: (T) => b(C.label)
          }, null, 40, Z0))), 128))
        ], 2))), 128))
      ]),
      _: 1
    }, 8, ["selected", "series", "title", "format-value", "format-label", "y-ticks", "legend", "empty-text", "height", "stack-groups", "reference-lines"]));
  }
}), Em = /* @__PURE__ */ Y(j0, [["__scopeId", "data-v-7fe6231b"]]), Y0 = ["novalidate"], Tm = /* @__PURE__ */ K({
  __name: "Form",
  props: {
    disabled: { type: Boolean, default: !1 },
    nativeValidation: { type: Boolean, default: !1 }
  },
  emits: ["submit", "reset"],
  setup(e, { emit: n }) {
    const t = e, r = n;
    Jr({
      disabled: zo(t, "disabled")
    });
    function a(l) {
      r("submit", l);
    }
    function o(l) {
      r("reset", l);
    }
    return (l, i) => (v(), g("form", {
      class: "form",
      novalidate: !e.nativeValidation,
      onSubmit: Ee(a, ["prevent"]),
      onReset: o
    }, [
      ce(l.$slots, "default")
    ], 40, Y0));
  }
}), q0 = ["disabled"], Sm = /* @__PURE__ */ K({
  __name: "FormFieldSet",
  props: {
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = Qo(), r = D(() => n.disabled || ((t == null ? void 0 : t.disabled.value) ?? !1));
    return Jr({
      disabled: r
    }), (a, o) => (v(), g("fieldset", {
      class: "form-fieldset",
      disabled: r.value
    }, [
      ce(a.$slots, "default")
    ], 8, q0));
  }
}), X0 = { class: "form-legend" }, Mm = /* @__PURE__ */ K({
  __name: "FormLegend",
  setup(e) {
    return (n, t) => (v(), g("legend", X0, [
      ce(n.$slots, "default")
    ]));
  }
}), Pm = /* @__PURE__ */ K({
  __name: "FormGroup",
  props: {
    columns: { default: 1 }
  },
  setup(e) {
    const n = e, t = D(() => ({
      "--form-group-columns": String(n.columns)
    }));
    return (r, a) => (v(), g("div", {
      class: "form-group",
      role: "group",
      style: xe(t.value)
    }, [
      ce(r.$slots, "default")
    ], 4));
  }
}), Im = /* @__PURE__ */ K({
  __name: "FormField",
  props: {
    orientation: { default: "vertical" },
    invalid: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = Mn(), r = `field-${t}`, a = `field-${t}-description`, o = `field-${t}-error`, l = N(n.invalid);
    re(() => n.invalid, (c) => {
      l.value = c;
    });
    const i = N(!1), s = N(!1);
    Jo({
      fieldId: r,
      descriptionId: a,
      errorId: o,
      invalid: l,
      hasDescription: i,
      hasError: s
    });
    const u = D(() => [
      "form-field",
      `form-field--${n.orientation}`,
      { "form-field--invalid": l.value }
    ]);
    return (c, f) => (v(), g("div", {
      class: j(u.value)
    }, [
      ce(c.$slots, "default", {
        fieldId: r,
        descriptionId: a,
        errorId: o,
        invalid: l.value
      })
    ], 2));
  }
}), J0 = ["for"], Fm = /* @__PURE__ */ K({
  __name: "FormLabel",
  props: {
    for: {}
  },
  setup(e) {
    const n = e, t = ln(), r = D(() => n.for ?? (t == null ? void 0 : t.fieldId)), a = D(() => (t == null ? void 0 : t.invalid.value) ?? !1);
    return (o, l) => (v(), g("label", {
      class: j(["form-label", { "form-label--invalid": a.value }]),
      for: r.value
    }, [
      ce(o.$slots, "default")
    ], 10, J0));
  }
}), Q0 = { class: "form-field-content" }, Am = /* @__PURE__ */ K({
  __name: "FormFieldContent",
  setup(e) {
    return (n, t) => (v(), g("div", Q0, [
      ce(n.$slots, "default")
    ]));
  }
}), e2 = ["id"], Lm = /* @__PURE__ */ K({
  __name: "FormDescription",
  setup(e) {
    const n = ln();
    return we(() => {
      n && (n.hasDescription.value = !0);
    }), lt(() => {
      n && (n.hasDescription.value = !1);
    }), (t, r) => {
      var a;
      return v(), g("p", {
        class: "form-description",
        id: (a = ee(n)) == null ? void 0 : a.descriptionId
      }, [
        ce(t.$slots, "default")
      ], 8, e2);
    };
  }
}), t2 = {
  class: "form-separator",
  role: "separator"
}, Rm = /* @__PURE__ */ K({
  __name: "FormSeparator",
  setup(e) {
    return (n, t) => (v(), g("hr", t2));
  }
}), n2 = ["id"], Om = /* @__PURE__ */ K({
  __name: "FormError",
  props: {
    message: {}
  },
  setup(e) {
    const n = e, t = ln(), r = Dt(), a = D(() => !!n.message || !!r.default);
    return re(a, (o) => {
      t && (t.hasError.value = o, t.invalid.value = o);
    }, { immediate: !0 }), we(() => {
      t && a.value && (t.hasError.value = !0, t.invalid.value = !0);
    }), lt(() => {
      t && (t.hasError.value = !1, t.invalid.value = !1);
    }), (o, l) => {
      var i;
      return a.value ? (v(), g("div", {
        key: 0,
        class: "form-error",
        role: "alert",
        "aria-live": "polite",
        id: (i = ee(t)) == null ? void 0 : i.errorId
      }, [
        ce(o.$slots, "default", {}, () => [
          he(S(e.message), 1)
        ])
      ], 8, n2)) : I("", !0);
    };
  }
}), r2 = { class: "layout" }, o2 = { class: "separator" }, a2 = { class: "content" }, l2 = 768, Ur = 250, i2 = /* @__PURE__ */ K({
  __name: "SidebarLayout",
  props: {
    cacheKey: {}
  },
  setup(e) {
    const n = e, t = N(Ur), r = `sidebar__${n.cacheKey || "default"}__width`;
    o(), we(() => {
      addEventListener("storage", o), addEventListener("resize", l);
    }), lt(() => {
      removeEventListener("storage", o), removeEventListener("resize", l);
    });
    const a = N({});
    re(t, l, { immediate: !0 });
    function o($) {
      $ && $.key !== r || localStorage.getItem(r) && (t.value = parseFloat(localStorage.getItem(r) || Ur.toString()));
    }
    function l() {
      t.value < 100 && (t.value = 100);
      const $ = Math.max(window.innerWidth * 0.6, window.innerWidth - 375);
      t.value > $ && (t.value = $), window.innerWidth < l2 ? a.value.width = "100%" : a.value.width = t.value + "px";
    }
    const i = N(!1);
    let s = 0;
    function u($) {
      $.stopPropagation(), $.preventDefault(), i.value = !0, s = t.value - $.clientX, document.addEventListener("mousemove", f), document.addEventListener("mouseup", m);
    }
    function c($) {
      $.stopPropagation(), $.preventDefault(), i.value = !0, s = t.value - $.touches[0].clientX, document.addEventListener("touchmove", d), document.addEventListener("touchend", m);
    }
    function f($) {
      t.value = $.clientX + s;
    }
    function d($) {
      t.value = $.touches[0].clientX + s;
    }
    function m() {
      document.removeEventListener("mousemove", f), document.removeEventListener("touchmove", d), document.removeEventListener("mouseup", m), document.removeEventListener("touchend", m), localStorage.setItem(r, t.value.toString()), i.value = !1;
    }
    return ($, y) => (v(), g("div", r2, [
      w("div", {
        class: "sidebar neat-scroll",
        style: xe(a.value)
      }, [
        ce($.$slots, "sidebar", {}, void 0, !0)
      ], 4),
      w("div", o2, [
        w("div", {
          class: j(["separator-handle", {
            "separator-handle--dragging": i.value
          }]),
          onMousedown: u,
          onTouchstart: c
        }, null, 34)
      ]),
      w("div", a2, [
        ce($.$slots, "content", {}, void 0, !0)
      ])
    ]));
  }
}), Bm = /* @__PURE__ */ Y(i2, [["__scopeId", "data-v-b2f03c9a"]]), s2 = {}, u2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.07 -0.07 18.7 18.64",
  fill: "currentcolor"
};
function d2(e, n) {
  return v(), g("svg", u2, [...n[0] || (n[0] = [
    w("path", { d: "M-.031 18.43l3 .022.07-13.446h4 3l.014 2.5 3 .023-.014-3.523L7.11-.017.039 4.006-.031 18.43z" }, null, -1),
    w("path", {
      "fill-rule": "evenodd",
      d: "M5.084 9.593v3h10l-1 3h2.5l1.963-4.534-1.963-4.966h-2.5l1 3.5h-10zh0z"
    }, null, -1),
    w("path", { d: "M10 14.506l-.031 4 3 .022.03-3.999L10 14.506z" }, null, -1)
  ])]);
}
const c2 = /* @__PURE__ */ Y(s2, [["render", d2]]), f2 = {}, m2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.07 -0.066 17.704 18.633",
  fill: "currentcolor"
};
function v2(e, n) {
  return v(), g("svg", m2, [...n[0] || (n[0] = [
    w("path", {
      "fill-rule": "evenodd",
      d: "M17.54 12.435v-3h-10l1-3h-2.5l-1.962 4.533 1.962 4.967h2.5l-1-3.5h10zh0z"
    }, null, -1),
    w("path", { d: "M.04 18.434l3 .023V4.935h4 3v3h3v-4L7.18-.012.04 3.935v14.499zm10.03-3.924l-.03 4 3 .023.03-4-3-.023z" }, null, -1)
  ])]);
}
const $2 = /* @__PURE__ */ Y(f2, [["render", v2]]), h2 = {}, p2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11.5",
  height: "16.5",
  viewBox: "-1 -1 13 18",
  fill: "currentcolor"
};
function g2(e, n) {
  return v(), g("svg", p2, [...n[0] || (n[0] = [
    w("path", { d: "M0 4l2.5 1s1-2.5 3-2.5c1.667 0 3.5.5 3.5 3s-2 3-4.5 3V12h3v-1.5c1 0 4-1 4-5C11.5 3 9.5 0 6 0 1.5 0 0 4 0 4zm4.5 9.5h3v3h-3v-3z" }, null, -1)
  ])]);
}
const y2 = /* @__PURE__ */ Y(h2, [["render", g2]]), b2 = {}, w2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function C2(e, n) {
  return v(), g("svg", w2, [...n[0] || (n[0] = [
    an('<rect width="256" height="256" fill="none"></rect><polyline points="168 96 216 96 216 48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><path d="M216,96,187.72,67.72A88,88,0,0,0,64,67" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path><polyline points="88 160 40 160 40 208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><path d="M40,160l28.28,28.28A88,88,0,0,0,192,189" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>', 5)
  ])]);
}
const k2 = /* @__PURE__ */ Y(b2, [["render", C2]]), x2 = {}, _2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function N2(e, n) {
  return v(), g("svg", _2, [...n[0] || (n[0] = [
    w("polyline", {
      points: "168 152 232 152 232 88",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("path", {
      d: "M32,184a96,96,0,0,1,163.88-67.88L232,152",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const D2 = /* @__PURE__ */ Y(x2, [["render", N2]]), E2 = {}, T2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function S2(e, n) {
  return v(), g("svg", T2, [...n[0] || (n[0] = [
    w("polyline", {
      points: "88 152 24 152 24 88",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("path", {
      d: "M224,184A96,96,0,0,0,60.12,116.12L24,152",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const M2 = /* @__PURE__ */ Y(E2, [["render", S2]]), P2 = {}, I2 = {
  viewBox: "0 -1 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function F2(e, n) {
  return v(), g("svg", I2, [...n[0] || (n[0] = [
    w("g", { "fill-rule": "evenodd" }, [
      w("path", {
        d: "M19 8H1a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2Zm0 8H1a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2ZM1 2h18a1 1 0 1 0 0-2H1a1 1 0 0 0 0 2Z",
        fill: "currentcolor"
      })
    ], -1)
  ])]);
}
const A2 = /* @__PURE__ */ Y(P2, [["render", F2]]), L2 = {}, R2 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function O2(e, n) {
  return v(), g("svg", R2, [...n[0] || (n[0] = [
    w("path", { d: "M240.26,186.1,152.81,34.23h0a28.74,28.74,0,0,0-49.62,0L15.74,186.1a27.45,27.45,0,0,0,0,27.71A28.31,28.31,0,0,0,40.55,228h174.9a28.31,28.31,0,0,0,24.79-14.19A27.45,27.45,0,0,0,240.26,186.1Zm-20.8,15.7a4.46,4.46,0,0,1-4,2.2H40.55a4.46,4.46,0,0,1-4-2.2,3.56,3.56,0,0,1,0-3.73L124,46.2a4.77,4.77,0,0,1,8,0l87.44,151.87A3.56,3.56,0,0,1,219.46,201.8ZM116,136V104a12,12,0,0,1,24,0v32a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,176Z" }, null, -1)
  ])]);
}
const B2 = /* @__PURE__ */ Y(L2, [["render", O2]]), V2 = {}, K2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function H2(e, n) {
  return v(), g("svg", K2, [...n[0] || (n[0] = [
    w("rect", {
      x: "40",
      y: "40",
      width: "176",
      height: "176",
      rx: "8",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }, null, -1)
  ])]);
}
const G2 = /* @__PURE__ */ Y(V2, [["render", H2]]), U2 = {}, W2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function Z2(e, n) {
  return v(), g("svg", W2, [...n[0] || (n[0] = [
    w("rect", {
      x: "48",
      y: "48",
      width: "160",
      height: "160",
      rx: "8",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }, null, -1),
    w("line", {
      x1: "128",
      y1: "48",
      x2: "128",
      y2: "208",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }, null, -1)
  ])]);
}
const z2 = /* @__PURE__ */ Y(U2, [["render", Z2]]), j2 = {}, Y2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function q2(e, n) {
  return v(), g("svg", Y2, [...n[0] || (n[0] = [
    w("rect", {
      x: "48",
      y: "48",
      width: "160",
      height: "160",
      rx: "8",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }, null, -1),
    w("line", {
      x1: "48",
      y1: "128",
      x2: "208",
      y2: "128",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }, null, -1)
  ])]);
}
const X2 = /* @__PURE__ */ Y(j2, [["render", q2]]), J2 = {}, Q2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function ef(e, n) {
  return v(), g("svg", Q2, [...n[0] || (n[0] = [
    w("polyline", {
      points: "40 144 96 200 224 72",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "24"
    }, null, -1)
  ])]);
}
const Io = /* @__PURE__ */ Y(J2, [["render", ef]]), tf = {}, nf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function rf(e, n) {
  return v(), g("svg", nf, [...n[0] || (n[0] = [
    w("path", { d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z" }, null, -1)
  ])]);
}
const of = /* @__PURE__ */ Y(tf, [["render", rf]]), af = {}, lf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function sf(e, n) {
  return v(), g("svg", lf, [...n[0] || (n[0] = [
    w("path", { d: "M208,136H48a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A16,16,0,0,0,208,136Zm0,56H48V152H208v40Zm0-144H48A16,16,0,0,0,32,64v40a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V64A16,16,0,0,0,208,48Zm0,56H48V64H208v40Z" }, null, -1)
  ])]);
}
const uf = /* @__PURE__ */ Y(af, [["render", sf]]), df = {}, cf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function ff(e, n) {
  return v(), g("svg", cf, [...n[0] || (n[0] = [
    w("path", {
      d: "M224,88V200.89a7.11,7.11,0,0,1-7.11,7.11H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33a8,8,0,0,1,4.8,1.6L128,80h88A8,8,0,0,1,224,88Z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const mf = /* @__PURE__ */ Y(df, [["render", ff]]), vf = {}, $f = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function hf(e, n) {
  return v(), g("svg", $f, [...n[0] || (n[0] = [
    w("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    w("line", {
      x1: "128",
      y1: "144",
      x2: "128",
      y2: "32",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("polyline", {
      points: "216 144 216 208 40 208 40 144",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("polyline", {
      points: "168 104 128 144 88 104",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const pf = /* @__PURE__ */ Y(vf, [["render", hf]]), gf = {}, yf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function bf(e, n) {
  return v(), g("svg", yf, [...n[0] || (n[0] = [
    w("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    w("line", {
      x1: "96",
      y1: "160",
      x2: "160",
      y2: "96",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("path", {
      d: "M112,76.11l30.06-30a48,48,0,0,1,67.88,67.88L179.88,144",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    w("path", {
      d: "M76.11,112l-30,30.06a48,48,0,0,0,67.88,67.88L144,179.88",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const wf = /* @__PURE__ */ Y(gf, [["render", bf]]), Le = /* @__PURE__ */ K({
  __name: "Icon",
  props: {
    name: {}
  },
  setup(e) {
    const n = e, t = D(() => {
      switch (n.name) {
        case "close":
          return yt;
        case "check":
          return Io;
        case "plus":
          return hn;
        case "chevron":
          return gt;
        case "folder":
          return mf;
        case "outbound":
          return c2;
        case "inbound":
          return $2;
        case "question":
          return y2;
        case "reload":
          return k2;
        case "filter":
          return Eo;
        case "redo":
          return D2;
        case "undo":
          return M2;
        case "hamburger":
          return A2;
        case "warning":
          return B2;
        case "arrow":
          return Jn;
        case "arrows":
          return Qn;
        case "square":
          return G2;
        case "squareSplitHorizontal":
          return z2;
        case "squareSplitVertical":
          return X2;
        case "home":
          return of;
        case "blocks":
          return uf;
        case "calendar":
          return It;
        case "download":
          return pf;
        case "link":
          return wf;
        default:
          return;
      }
    });
    return (r, a) => t.value ? (v(), Z(tt(t.value), { key: 0 })) : I("", !0);
  }
}), Cf = { class: "toolbar-items" }, kf = { class: "toolbar-section toolbar-section--left" }, xf = ["disabled", "title", "onClick"], _f = {
  key: 0,
  class: "icon"
}, Nf = { key: 1 }, Df = ["disabled", "title", "onClick"], Ef = {
  key: 0,
  class: "icon"
}, Tf = { key: 1 }, Sf = {
  key: 0,
  class: "icon"
}, Mf = { key: 1 }, Pf = { class: "icon" }, If = ["disabled", "title"], Ff = {
  key: 0,
  class: "icon"
}, Af = { key: 1 }, Lf = ["disabled", "title"], Rf = {
  key: 0,
  class: "icon"
}, Of = { key: 1 }, Bf = {
  key: 0,
  class: "icon"
}, Vf = { key: 1 }, Kf = { class: "toolbar-section toolbar-section--right" }, Hf = ["disabled", "title", "onClick"], Gf = {
  key: 0,
  class: "icon"
}, Uf = { key: 1 }, Wf = ["disabled", "title", "onClick"], Zf = {
  key: 0,
  class: "icon"
}, zf = { key: 1 }, jf = {
  key: 0,
  class: "icon"
}, Yf = { key: 1 }, qf = { class: "icon" }, Xf = { class: "icon" }, Jf = { class: "icon" }, Qf = { class: "icon" }, e3 = /* @__PURE__ */ K({
  __name: "Toolbar",
  props: {
    items: {}
  },
  setup(e) {
    const n = e, t = N(), r = N(/* @__PURE__ */ new Map()), a = N(/* @__PURE__ */ new Set()), o = N([]), l = N(), i = D(() => n.items.filter(($) => $.align !== "right")), s = D(() => n.items.filter(($) => $.align === "right"));
    function u() {
      if (!t.value) return;
      const $ = t.value.offsetWidth, y = 5, p = 32 + y;
      let h = 0;
      s.value.forEach((P) => {
        const E = r.value.get(P.id);
        E && (h += E.offsetWidth + y);
      });
      let b = 0;
      i.value.forEach((P) => {
        const E = r.value.get(P.id);
        E && (b += E.offsetWidth + y);
      });
      const x = $ - h - p - y - 10, _ = /* @__PURE__ */ new Set(), T = [];
      s.value.forEach((P) => _.add(P.id));
      let W = 0;
      const F = [];
      for (const P of i.value) {
        const E = r.value.get(P.id);
        if (E) {
          const L = E.offsetWidth + y;
          W + L <= x ? (W += L, F.push(P), _.add(P.id)) : T.push(P);
        }
      }
      for (; F.length > 0 && F[F.length - 1].type === "separator"; ) {
        const P = F.pop();
        _.delete(P.id), T.unshift(P);
      }
      a.value = _, o.value = T;
    }
    we(() => {
      t.value && (setTimeout(() => u(), 0), l.value = new ResizeObserver(() => {
        u();
      }), l.value.observe(t.value));
    }), lt(() => {
      l.value && t.value && (l.value.unobserve(t.value), l.value.disconnect());
    }), re(() => n.items, () => {
      setTimeout(() => u(), 0);
    }, { deep: !0 });
    function c($) {
      const y = ["toolbar-button"];
      return !$.buttonStyle || $.buttonStyle === "default" ? y.push("btn") : y.push(`btn-${$.buttonStyle}`), y.join(" ");
    }
    function f($, y) {
      y && r.value.set($, y);
    }
    function d($, y) {
      y != null && y.$el && r.value.set($, y.$el);
    }
    function m($) {
      return a.value.has($);
    }
    return ($, y) => (v(), g("div", {
      class: "toolbar",
      ref_key: "toolbarRef",
      ref: t
    }, [
      w("div", Cf, [
        w("div", kf, [
          (v(!0), g(G, null, Q(i.value, (p) => (v(), g(G, {
            key: p.id
          }, [
            p.type === "button" && m(p.id) ? (v(), g("button", {
              key: 0,
              ref_for: !0,
              ref: (h) => f(p.id, h),
              class: j(c(p)),
              disabled: p.disabled,
              title: p.title,
              onClick: p.onClick
            }, [
              p.icon ? (v(), g("div", _f, [
                z(Le, {
                  name: p.icon
                }, null, 8, ["name"])
              ])) : I("", !0),
              p.label ? (v(), g("span", Nf, S(p.label), 1)) : I("", !0)
            ], 10, xf)) : p.type === "button-group" && m(p.id) ? (v(), g("div", {
              key: 1,
              ref_for: !0,
              ref: (h) => f(p.id, h),
              class: "btn-group"
            }, [
              (v(!0), g(G, null, Q(p.buttons, (h) => (v(), g("button", {
                key: h.id,
                class: j(c(h)),
                disabled: h.disabled,
                title: h.title,
                onClick: h.onClick
              }, [
                h.icon ? (v(), g("div", Ef, [
                  z(Le, {
                    name: h.icon
                  }, null, 8, ["name"])
                ])) : I("", !0),
                h.label ? (v(), g("span", Tf, S(h.label), 1)) : I("", !0)
              ], 10, Df))), 128))
            ], 512)) : p.type === "separator" && m(p.id) ? (v(), g("div", {
              key: 2,
              ref_for: !0,
              ref: (h) => f(p.id, h),
              class: "toolbar-separator"
            }, null, 512)) : p.type === "dropdown" && m(p.id) ? (v(), Z(dt, {
              key: 3,
              ref_for: !0,
              ref: (h) => d(p.id, h),
              "button-style": p.buttonStyle,
              disabled: p.disabled,
              title: p.title,
              class: "toolbar-button"
            }, {
              label: le(() => [
                p.icon ? (v(), g("div", Sf, [
                  z(Le, {
                    name: p.icon
                  }, null, 8, ["name"])
                ])) : I("", !0),
                p.label ? (v(), g("span", Mf, S(p.label), 1)) : I("", !0)
              ]),
              default: le(() => [
                (v(!0), g(G, null, Q(p.options, (h) => (v(), Z(Ie, {
                  key: h.id,
                  onClick: h.onClick,
                  disabled: h.disabled,
                  title: h.title
                }, {
                  default: le(() => [
                    w("div", Pf, [
                      h.icon ? (v(), Z(Le, {
                        key: 0,
                        name: h.icon
                      }, null, 8, ["name"])) : I("", !0)
                    ]),
                    he(" " + S(h.label || h.title || "Action"), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled", "title"]))), 128))
              ]),
              _: 2
            }, 1032, ["button-style", "disabled", "title"])) : I("", !0),
            p.type === "button" && !m(p.id) ? (v(), g("button", {
              key: 4,
              ref_for: !0,
              ref: (h) => f(p.id, h),
              class: j([c(p), "toolbar-item--hidden"]),
              disabled: p.disabled,
              title: p.title,
              "aria-hidden": "true"
            }, [
              p.icon ? (v(), g("div", Ff, [
                z(Le, {
                  name: p.icon
                }, null, 8, ["name"])
              ])) : I("", !0),
              p.label ? (v(), g("span", Af, S(p.label), 1)) : I("", !0)
            ], 10, If)) : p.type === "button-group" && !m(p.id) ? (v(), g("div", {
              key: 5,
              ref_for: !0,
              ref: (h) => f(p.id, h),
              class: "btn-group toolbar-item--hidden",
              "aria-hidden": "true"
            }, [
              (v(!0), g(G, null, Q(p.buttons, (h) => (v(), g("button", {
                key: h.id,
                class: j(c(h)),
                disabled: h.disabled,
                title: h.title
              }, [
                h.icon ? (v(), g("div", Rf, [
                  z(Le, {
                    name: h.icon
                  }, null, 8, ["name"])
                ])) : I("", !0),
                h.label ? (v(), g("span", Of, S(h.label), 1)) : I("", !0)
              ], 10, Lf))), 128))
            ], 512)) : p.type === "separator" && !m(p.id) ? (v(), g("div", {
              key: 6,
              ref_for: !0,
              ref: (h) => f(p.id, h),
              class: "toolbar-separator toolbar-item--hidden",
              "aria-hidden": "true"
            }, null, 512)) : p.type === "dropdown" && !m(p.id) ? (v(), Z(dt, {
              key: 7,
              ref_for: !0,
              ref: (h) => d(p.id, h),
              class: "toolbar-item--hidden",
              "button-style": p.buttonStyle,
              disabled: p.disabled,
              title: p.title,
              "aria-hidden": "true"
            }, {
              label: le(() => [
                p.icon ? (v(), g("div", Bf, [
                  z(Le, {
                    name: p.icon
                  }, null, 8, ["name"])
                ])) : I("", !0),
                p.label ? (v(), g("span", Vf, S(p.label), 1)) : I("", !0)
              ]),
              _: 2
            }, 1032, ["button-style", "disabled", "title"])) : I("", !0)
          ], 64))), 128))
        ]),
        w("div", Kf, [
          (v(!0), g(G, null, Q(s.value, (p) => (v(), g(G, {
            key: p.id
          }, [
            p.type === "button" ? (v(), g("button", {
              key: 0,
              ref_for: !0,
              ref: (h) => f(p.id, h),
              class: j(c(p)),
              disabled: p.disabled,
              title: p.title,
              onClick: p.onClick
            }, [
              p.icon ? (v(), g("div", Gf, [
                z(Le, {
                  name: p.icon
                }, null, 8, ["name"])
              ])) : I("", !0),
              p.label ? (v(), g("span", Uf, S(p.label), 1)) : I("", !0)
            ], 10, Hf)) : p.type === "button-group" ? (v(), g("div", {
              key: 1,
              ref_for: !0,
              ref: (h) => f(p.id, h),
              class: "btn-group"
            }, [
              (v(!0), g(G, null, Q(p.buttons, (h) => (v(), g("button", {
                key: h.id,
                class: j(c(h)),
                disabled: h.disabled,
                title: h.title,
                onClick: h.onClick
              }, [
                h.icon ? (v(), g("div", Zf, [
                  z(Le, {
                    name: h.icon
                  }, null, 8, ["name"])
                ])) : I("", !0),
                h.label ? (v(), g("span", zf, S(h.label), 1)) : I("", !0)
              ], 10, Wf))), 128))
            ], 512)) : p.type === "separator" ? (v(), g("div", {
              key: 2,
              ref_for: !0,
              ref: (h) => f(p.id, h),
              class: "toolbar-separator"
            }, null, 512)) : p.type === "dropdown" ? (v(), Z(dt, {
              key: 3,
              ref_for: !0,
              ref: (h) => d(p.id, h),
              "button-style": p.buttonStyle,
              disabled: p.disabled,
              title: p.title,
              class: "toolbar-button"
            }, {
              label: le(() => [
                p.icon ? (v(), g("div", jf, [
                  z(Le, {
                    name: p.icon
                  }, null, 8, ["name"])
                ])) : I("", !0),
                p.label ? (v(), g("span", Yf, S(p.label), 1)) : I("", !0)
              ]),
              default: le(() => [
                (v(!0), g(G, null, Q(p.options, (h) => (v(), Z(Ie, {
                  key: h.id,
                  onClick: h.onClick,
                  disabled: h.disabled,
                  title: h.title
                }, {
                  default: le(() => [
                    w("div", qf, [
                      h.icon ? (v(), Z(Le, {
                        key: 0,
                        name: h.icon
                      }, null, 8, ["name"])) : I("", !0)
                    ]),
                    he(" " + S(h.label || h.title || "Action"), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled", "title"]))), 128))
              ]),
              _: 2
            }, 1032, ["button-style", "disabled", "title"])) : I("", !0)
          ], 64))), 128))
        ])
      ]),
      w("div", {
        class: j(["toolbar-overflow-container", { "toolbar-overflow-container--hidden": o.value.length === 0 }])
      }, [
        o.value.length > 0 ? (v(), Z(dt, {
          key: 0,
          class: "toolbar-overflow",
          "button-style": "silent",
          title: "More options"
        }, {
          default: le(() => [
            (v(!0), g(G, null, Q(o.value, (p) => (v(), g(G, {
              key: p.id
            }, [
              p.type === "button" ? (v(), Z(Ie, {
                key: 0,
                onClick: p.onClick,
                disabled: p.disabled
              }, {
                default: le(() => [
                  w("div", Xf, [
                    p.icon ? (v(), Z(Le, {
                      key: 0,
                      name: p.icon
                    }, null, 8, ["name"])) : I("", !0)
                  ]),
                  he(" " + S(p.label || p.title || "Action"), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"])) : p.type === "button-group" ? (v(!0), g(G, { key: 1 }, Q(p.buttons, (h) => (v(), Z(Ie, {
                key: h.id,
                onClick: h.onClick,
                disabled: h.disabled
              }, {
                default: le(() => [
                  w("div", Jf, [
                    h.icon ? (v(), Z(Le, {
                      key: 0,
                      name: h.icon
                    }, null, 8, ["name"])) : I("", !0)
                  ]),
                  he(" " + S(h.label || h.title || "Action"), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"]))), 128)) : p.type === "dropdown" ? (v(!0), g(G, { key: 2 }, Q(p.options, (h) => (v(), Z(Ie, {
                key: h.id,
                onClick: h.onClick,
                disabled: h.disabled
              }, {
                default: le(() => [
                  w("div", Qf, [
                    h.icon ? (v(), Z(Le, {
                      key: 0,
                      name: h.icon
                    }, null, 8, ["name"])) : I("", !0)
                  ]),
                  he(" " + S(h.label || h.title || "Action"), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"]))), 128)) : I("", !0)
            ], 64))), 128))
          ]),
          _: 1
        })) : I("", !0)
      ], 2)
    ], 512));
  }
}), t3 = /* @__PURE__ */ Y(e3, [["__scopeId", "data-v-71d56e91"]]), n3 = ["title"], r3 = {
  key: 1,
  class: "title"
}, o3 = {
  key: 2,
  class: "labels"
}, a3 = ["title"], l3 = { class: "content" }, i3 = { class: "details" }, s3 = { class: "toolbar" }, u3 = { class: "tab-content neat-scroll" }, d3 = 768, c3 = /* @__PURE__ */ K({
  __name: "InspectorLayout",
  props: {
    provider: {}
  },
  setup(e) {
    const n = e, t = Ge("layoutElem"), r = N(!1), a = N();
    function o() {
      r.value = t.value.getBoundingClientRect().width < d3, !r.value && n.provider.selectedTab === "_first" && (n.provider.tabs.length > 0 ? (console.log("setting tab", n.provider.tabs[0].id), n.provider.selectedTab = n.provider.tabs[0].id) : n.provider.selectedTab = void 0);
    }
    const l = new ResizeObserver(o);
    we(() => {
      l.observe(t.value), o(), n.provider.selectedTab || (r.value ? n.provider.selectedTab = "_first" : n.provider.tabs.length > 0 && (n.provider.selectedTab = n.provider.tabs[0].id));
    }), Ze(() => {
      l.disconnect();
    });
    const i = D(() => {
      if (n.provider.selectedTab !== "_first")
        return n.provider.tabs.find((d) => d.id === n.provider.selectedTab);
    }), s = D(() => {
      const d = [...n.provider.tabs];
      return r.value && d.unshift({
        label: n.provider.summaryLabel ?? "Summary",
        id: "_first",
        component: n.provider.summary
      }), d;
    }), u = D(() => r.value && n.provider.selectedTab == "_first");
    function c(d) {
      return d && typeof d == "object" ? d.tooltip : void 0;
    }
    function f(d) {
      return d && typeof d == "object" ? d.label : d;
    }
    return (d, m) => {
      var $, y;
      return v(), g("div", {
        class: "inspector-layout",
        ref_key: "layoutElem",
        ref: t
      }, [
        w("div", {
          class: j(["header", {
            "has-state": e.provider.state !== void 0
          }])
        }, [
          e.provider.state ? (v(), g("div", {
            key: 0,
            class: j(["state", {
              "has-hue": e.provider.state.hue !== void 0
            }]),
            style: xe(e.provider.state.hue !== void 0 ? `--color-hue: ${typeof e.provider.state.hue == "string" ? `var(${e.provider.state.hue})` : e.provider.state.hue}` : ""),
            title: e.provider.state.label
          }, null, 14, n3)) : I("", !0),
          e.provider.title ? (v(), g("div", r3, S(e.provider.title), 1)) : I("", !0),
          e.provider.labels ? (v(), g("div", o3, [
            (v(!0), g(G, null, Q(e.provider.labels, (p, h) => (v(), g("div", {
              key: h,
              title: c(p)
            }, S(f(p)), 9, a3))), 128))
          ])) : I("", !0),
          ce(d.$slots, "header", {}, void 0, !0)
        ], 2),
        w("div", l3, [
          w("div", {
            class: "sidebar neat-scroll",
            ref_key: "sidebarElem",
            ref: a
          }, null, 512),
          w("div", i3, [
            w("div", s3, [
              z(ee(B1), {
                items: s.value,
                modelValue: e.provider.selectedTab,
                "onUpdate:modelValue": m[0] || (m[0] = (p) => e.provider.selectedTab = p)
              }, null, 8, ["items", "modelValue"])
            ]),
            w("div", {
              class: j(["tab-body", {
                "bg-90": r.value && e.provider.selectedTab === "_first",
                "has-toolbar": (($ = i.value) == null ? void 0 : $.toolbar) && !u.value
              }])
            }, [
              w("div", {
                class: j(["summary-tab p tab-content neat-scroll", {
                  hide: !u.value
                }])
              }, [
                a.value ? (v(), Z(jo, {
                  key: 0,
                  to: a.value,
                  disabled: r.value
                }, [
                  (v(), Z(tt(e.provider.summary)))
                ], 8, ["to", "disabled"])) : I("", !0)
              ], 2),
              (y = i.value) != null && y.toolbar ? (v(), Z(t3, {
                key: 0,
                items: i.value.toolbar
              }, null, 8, ["items"])) : I("", !0),
              w("div", u3, [
                i.value ? (v(), Z(tt(i.value.component), Yo(et({ key: 0 }, i.value.props)), null, 16)) : I("", !0)
              ])
            ], 2)
          ])
        ])
      ], 512);
    };
  }
}), Vm = /* @__PURE__ */ Y(c3, [["__scopeId", "data-v-5353242e"]]), f3 = {
  key: 0,
  class: "toolbar"
}, m3 = { class: "separator" }, v3 = {
  key: 0,
  class: "detail"
}, $3 = { class: "toolbar detail-toolbar" }, h3 = { class: "detail-toolbar-slot" }, p3 = { class: "detail-toolbar-pager" }, g3 = { class: "btn-group" }, y3 = { class: "detail-component neat-scroll" }, Wt = 300, b3 = /* @__PURE__ */ K({
  __name: "ListDetailLayout",
  props: {
    cacheKey: {},
    provider: {},
    detailComponent: {},
    selection: {},
    dataTableContextMenuProvider: {}
  },
  emits: ["update:selection"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = Dt(), o = N("horizontal");
    function l(U) {
      return t.provider.toSelection ? t.provider.toSelection(U) : U.key;
    }
    function i(U) {
      if (U != null)
        return t.provider.toDetail ? t.provider.toDetail(U) : String(U);
    }
    function s(U, de) {
      if (U.size !== de.size) return !1;
      for (const ne of U)
        if (!de.has(ne)) return !1;
      return !0;
    }
    const u = N(t.selection);
    re(() => t.selection, (U) => {
      U !== u.value && (u.value = U);
    });
    const c = D(() => i(u.value)), f = N(/* @__PURE__ */ new Set());
    re(c, (U) => {
      const de = U === void 0 ? /* @__PURE__ */ new Set() : /* @__PURE__ */ new Set([U]);
      s(de, f.value) || (f.value = de);
    }, { immediate: !0 });
    function d(U) {
      U !== u.value && (u.value = U, r("update:selection", U));
    }
    function m(U) {
      const de = U.values().next().value;
      if (de === void 0 && c.value !== void 0 && !t.provider.rows.value.some((ue) => ue.key === c.value)) {
        f.value = /* @__PURE__ */ new Set([c.value]);
        return;
      }
      if (f.value = U, de !== c.value)
        if (de === void 0)
          d(void 0);
        else {
          const ne = t.provider.rows.value.find((ue) => ue.key === de);
          d(ne ? l(ne) : de);
        }
    }
    const $ = N(), y = N(Wt), p = N(Wt), h = N(""), b = `listDetail__${t.cacheKey || "default"}__mode`, C = `listDetail__${t.cacheKey || "default"}__width`, x = `listDetail__${t.cacheKey || "default"}__height`;
    T();
    const _ = new ResizeObserver(W);
    we(() => {
      addEventListener("storage", T), _.observe($.value);
    }), lt(() => {
      removeEventListener("storage", T), _.disconnect();
    }), re(o, () => {
      localStorage.setItem(b, o.value), W();
    });
    function T(U) {
      if (!(U && U.key !== C && U.key !== x && U.key !== b) && (localStorage.getItem(C) && (y.value = parseFloat(localStorage.getItem(C) || Wt.toString())), localStorage.getItem(x) && (p.value = parseFloat(localStorage.getItem(x) || Wt.toString())), localStorage.getItem(b)))
        switch (localStorage.getItem(b)) {
          case "vertical":
            o.value = "vertical";
            break;
          case "single":
            o.value = "single";
            break;
          default:
            o.value = "horizontal";
        }
    }
    function W() {
      const U = $.value.getBoundingClientRect();
      switch (o.value) {
        case "horizontal":
          let de = y.value;
          y.value > U.width - 350 && (de = U.width - 350), h.value = `--split: ${de}px;`;
          break;
        case "vertical":
          let ne = p.value;
          p.value > U.height - 250 && (ne = U.height - 250), h.value = `--split: ${ne}px;`;
      }
    }
    const F = D(() => a["list-toolbar"]), P = D(() => {
      const U = ["list-detail-layout"];
      return o.value === "single" ? U.push("mode--single") : (U.push("mode--split"), U.push("mode--" + o.value)), E.value && U.push("detail-open"), U;
    }), E = D(() => c.value !== void 0), L = D(() => {
      var ue, Te, Ke, it, Ye, Lt, Rt, Ot;
      if (!E.value)
        return;
      const U = t.provider.rows.value.findIndex((pn) => pn.key === c.value), de = (Te = (ue = t.provider.totalCount) == null ? void 0 : ue.value) == null ? void 0 : Te.count;
      let ne = (U >= 0 ? U + 1 : "–") + " / " + (de ?? "–");
      return (it = (Ke = t.provider.totalCount) == null ? void 0 : Ke.value) != null && it.cap && ((Lt = (Ye = t.provider.totalCount) == null ? void 0 : Ye.value) == null ? void 0 : Lt.count) === ((Ot = (Rt = t.provider.totalCount) == null ? void 0 : Rt.value) == null ? void 0 : Ot.cap) && (ne += "+"), ne;
    }), J = D(() => {
      if (E.value)
        return t.provider.rows.value.find((U) => U.key === c.value);
    });
    function ie() {
      const U = t.provider.rows.value.findIndex((de) => de.key === c.value);
      U > 0 && d(l(t.provider.rows.value[U - 1]));
    }
    function oe() {
      const U = t.provider.rows.value.findIndex((de) => de.key === c.value);
      U >= 0 && U < t.provider.rows.value.length - 1 && d(l(t.provider.rows.value[U + 1]));
    }
    const O = D(() => [[{
      label: "Split horizontally",
      checked: o.value === "horizontal",
      icon: "squareSplitHorizontal",
      action: () => {
        o.value = "horizontal";
      }
    }, {
      label: "Split vertically",
      checked: o.value === "vertical",
      icon: "squareSplitVertical",
      action: () => {
        o.value = "vertical";
      }
    }, {
      label: "Do not split",
      checked: o.value === "single",
      icon: "square",
      action: () => {
        o.value = "single";
      }
    }]]), H = N(!1);
    let X = 0;
    function B(U) {
      switch (U.stopPropagation(), U.preventDefault(), H.value = !0, o.value) {
        case "horizontal":
          X = y.value - U.clientX;
          break;
        case "vertical":
          X = p.value - U.clientY;
          break;
      }
      document.addEventListener("mousemove", te), document.addEventListener("mouseup", ge);
    }
    function R(U) {
      switch (U.stopPropagation(), U.preventDefault(), H.value = !0, o.value) {
        case "horizontal":
          X = y.value - U.touches[0].clientX;
          break;
        case "vertical":
          X = p.value - U.touches[0].clientY;
          break;
      }
      document.addEventListener("touchmove", pe), document.addEventListener("touchend", ge);
    }
    function te(U) {
      switch (o.value) {
        case "horizontal":
          y.value = U.clientX + X;
          break;
        case "vertical":
          p.value = U.clientY + X;
          break;
      }
      W();
    }
    function pe(U) {
      switch (o.value) {
        case "horizontal":
          y.value = U.touches[0].clientX + X;
          break;
        case "vertical":
          p.value = U.touches[0].clientY + X;
          break;
      }
      W();
    }
    function ge() {
      switch (document.removeEventListener("mousemove", te), document.removeEventListener("touchmove", pe), document.removeEventListener("mouseup", ge), document.removeEventListener("touchend", ge), o.value) {
        case "horizontal":
          localStorage.setItem(C, y.value.toString());
          break;
        case "vertical":
          localStorage.setItem(x, p.value.toString());
          break;
      }
      H.value = !1;
    }
    return (U, de) => {
      const ne = ze("context-menu");
      return v(), g("div", {
        class: "container",
        ref_key: "containerElem",
        ref: $
      }, [
        be((v(), g("div", {
          class: j(P.value),
          style: xe(h.value)
        }, [
          w("div", {
            class: j(["list", {
              "list--with-toolbar": F.value
            }])
          }, [
            F.value ? (v(), g("div", f3, [
              ce(U.$slots, "list-toolbar", {}, void 0, !0)
            ])) : I("", !0),
            z(ee(Kc), {
              provider: e.provider,
              selected: f.value,
              "context-menu-provider": e.dataTableContextMenuProvider,
              "onUpdate:selected": m
            }, null, 8, ["provider", "selected", "context-menu-provider"])
          ], 2),
          w("div", m3, [
            w("div", {
              class: j(["separator-handle", {
                "separator-handle--dragging": H.value
              }]),
              onMousedown: B,
              onTouchstart: R
            }, null, 34)
          ]),
          E.value ? (v(), g("div", v3, [
            w("div", $3, [
              w("button", {
                class: "btn-icon",
                onClick: de[0] || (de[0] = (ue) => d(void 0))
              }, [
                z(yt)
              ]),
              w("div", h3, [
                ce(U.$slots, "detail-toolbar", {}, void 0, !0)
              ]),
              w("div", p3, [
                w("div", null, S(L.value), 1),
                w("div", g3, [
                  w("button", {
                    class: "btn-icon prev",
                    onClick: ie
                  }, [
                    z(gt)
                  ]),
                  w("button", {
                    class: "btn-icon next",
                    onClick: oe
                  }, [
                    z(gt)
                  ])
                ])
              ])
            ]),
            w("div", y3, [
              (v(), Z(tt(e.detailComponent), {
                selection: u.value,
                row: J.value,
                key: c.value
              }, null, 8, ["selection", "row"]))
            ])
          ])) : I("", !0)
        ], 6)), [
          [ne, O.value]
        ])
      ], 512);
    };
  }
}), Km = /* @__PURE__ */ Y(b3, [["__scopeId", "data-v-abc6a7c7"]]), w3 = { class: "tree-node__indent-level" }, Wr = /* @__PURE__ */ K({
  __name: "TreeNodeIndent",
  props: {
    depth: {}
  },
  setup(e) {
    return (n, t) => (v(!0), g(G, null, Q(e.depth, (r) => (v(), g("div", w3))), 256));
  }
}), C3 = ["data-node-id"], k3 = {
  key: 1,
  class: "tree-node__expander-spacer"
}, x3 = {
  key: 2,
  class: "tree-node__icon"
}, _3 = {
  key: 3,
  class: "tree-node__rename"
}, N3 = ["title"], D3 = ["title"], E3 = {
  key: 0,
  class: "tree-node__empty"
}, T3 = /* @__PURE__ */ K({
  __name: "TreeNodeComponent",
  props: {
    parent: {},
    node: {},
    rootNodes: {},
    depth: {},
    state: {},
    getDropTarget: { type: Function },
    clickableParents: { type: Boolean },
    sort: {}
  },
  emits: ["move"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = At(), o = D(() => t.state.expandedNodes.indexOf(t.node.id) >= 0), l = N(), i = N(), s = N(), u = D(() => {
      let E = t.node.sort ?? t.sort;
      return E === "none" ? t.node.children : t.node.children ? t.node.children.toSorted((L, J) => {
        if (E === "caz") {
          if (L.children && !J.children)
            return -1;
          if (!L.children && J.children)
            return 1;
        }
        const ie = typeof L.label == "string" ? L.label : L.label.value, oe = typeof J.label == "string" ? J.label : J.label.value;
        return ie.localeCompare(oe);
      }) : [];
    }), c = D(() => {
      var E, L;
      return ((L = (E = t.node).isSelected) == null ? void 0 : L.call(E)) || !1;
    }), f = D(() => t.node.id && t.state.renaming === t.node.id), d = D(() => {
      const E = a.getCurrentDropTarget();
      return x && E && E === x;
    }), m = D(() => typeof t.node.label == "string" ? t.node.label : t.node.label.value);
    function $() {
      var E, L, J;
      if (!f.value)
        if (typeof t.node.children == "object") {
          if (t.clickableParents && i.value !== _ && !((E = i.value) != null && E.contains(_))) {
            (J = (L = t.node).onClick) == null || J.call(L);
            return;
          }
          o.value ? t.state.expandedNodes = t.state.expandedNodes.filter((ie) => ie !== t.node.id) : t.state.expandedNodes.push(t.node.id);
        } else t.node.onClick && t.node.onClick();
    }
    const y = N("");
    re(() => f.value, (E) => {
      E && (y.value = m.value, He(() => {
        setTimeout(() => {
          var L, J;
          (L = l.value) == null || L.focus(), (J = l.value) == null || J.select();
        }, 0);
      }));
    }, {
      immediate: !0
    }), re(() => t.state.renaming, (E) => {
      E && h(t.node, E) && p();
    });
    function p() {
      typeof t.node.children == "object" && (o.value || t.state.expandedNodes.push(t.node.id));
    }
    function h(E, L) {
      if (E.children) {
        for (const J of E.children)
          if (J.id === L || h(J, L))
            return !0;
      }
      return !1;
    }
    async function b() {
      var L;
      if (t.state.renaming === void 0)
        return;
      if (y.value === t.node.label) {
        t.state.renaming = void 0;
        return;
      }
      if (y.value.trim().length === 0) {
        y.value = m.value, t.state.renaming = void 0;
        return;
      }
      const E = {
        node: t.node,
        parentNode: t.parent
      };
      if (t.node.onRename)
        if (await t.node.onRename(y.value, E))
          typeof t.node.label == "string" && !nr(t.node) && (t.node.label = y.value), t.state.renaming = void 0;
        else {
          (L = l.value) == null || L.focus();
          return;
        }
      else
        typeof t.node.label == "string" && !nr(t.node) && (t.node.label = y.value), t.state.renaming = void 0;
      t.node.onRenamed && await t.node.onRenamed(y.value, E);
    }
    function C(E) {
      E.key === "Enter" ? (E.preventDefault(), E.stopPropagation(), b()) : E.key === "Escape" && (y.value = m.value, t.state.renaming = void 0);
    }
    let x;
    we(() => {
      var E, L;
      if (!s.value) {
        console.error("TreeNodeComponent: Could not find element");
        return;
      }
      (E = t.node.dropZone) != null && E.accepts && (x = a.registerDropZone({
        accepts: t.node.dropZone.accepts,
        element: s.value,
        metadata: (L = t.node.dropZone) == null ? void 0 : L.metadata,
        onDrop(J) {
          var ie, oe;
          (oe = (ie = t.node.dropZone) == null ? void 0 : ie.onDrop) == null || oe.call(ie, J);
        }
      }));
    }), Ze(() => {
      x && a.unregisterDropZone(x);
    });
    let _;
    function T(E) {
      if (_ = E.target, !t.node.draggable) {
        document.addEventListener("pointerup", W);
        return;
      }
      E.stopImmediatePropagation(), E.stopPropagation(), E.preventDefault(), a.startDrag({
        type: t.node.draggable.type,
        data: t.node.draggable.data,
        metadata: t.node.draggable.metadata,
        sourceElement: E.target.closest(".tree-node"),
        onClick() {
          $();
        },
        mode: "hit"
      });
    }
    function W(E) {
      document.removeEventListener("pointerup", W), E.target === _ && $();
    }
    function F() {
      typeof t.node.children == "object" && (o.value ? t.state.expandedNodes = t.state.expandedNodes.filter((E) => E !== t.node.id) : t.state.expandedNodes.push(t.node.id));
    }
    const P = D(() => Yr(t.node.tags) ? t.node.tags.value : t.node.tags);
    return (E, L) => {
      const J = zr("TreeNodeComponent", !0), ie = ze("context-menu");
      return be((v(), g("div", {
        class: j(["tree-node__area", { "tree-node__area--drop-target": d.value }]),
        "data-node-id": e.node.id,
        ref_key: "nodeAreaElem",
        ref: s
      }, [
        w("div", {
          class: j(["tree-node", {
            "tree-node--root": typeof e.depth > "u",
            "tree-node--selected": c.value
          }])
        }, [
          z(Wr, {
            depth: e.depth || 0
          }, null, 8, ["depth"]),
          L[4] || (L[4] = w("div", { class: "tree-node__margin" }, null, -1)),
          typeof e.node.children == "object" ? (v(), g("div", {
            key: 0,
            class: "tree-node__expander",
            ref_key: "expanderElem",
            ref: i,
            onClick: F
          }, [
            (v(), g("svg", {
              class: j(["tree-node__arrow", {
                "tree-node__arrow--expanded": o.value,
                "tree-node__arrow--collapsed": !o.value
              }]),
              width: "25",
              height: "16",
              viewBox: "0 0 25 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [...L[3] || (L[3] = [
              w("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0.174789 3.04115L12.2077 15.3069L24.1485 3.13496L20.6194 0.205244L12.2077 8.77975L3.7039 0.111435L0.174789 3.04115Z",
                fill: "black"
              }, null, -1)
            ])], 2))
          ], 512)) : (v(), g("div", k3)),
          e.node.icon ? (v(), g("div", x3, [
            z(ee(Le), {
              name: e.node.icon
            }, null, 8, ["name"])
          ])) : I("", !0),
          f.value ? (v(), g("div", _3, [
            z(Ve, {
              modelValue: y.value,
              "onUpdate:modelValue": L[0] || (L[0] = (oe) => y.value = oe),
              ref_key: "renameInput",
              ref: l,
              class: "tree-node__rename-input",
              onBlur: b,
              onKeydown: C,
              onMousedown: L[1] || (L[1] = Ee(() => {
              }, ["stop"]))
            }, null, 8, ["modelValue"])
          ])) : (v(), g("div", {
            key: 4,
            class: "tree-node__label",
            title: m.value,
            onMousedown: Ee(T, ["left"]),
            onTouchstart: T
          }, [
            w("div", {
              class: j(`tree-node__label--${e.node.style || "default"}`)
            }, S(m.value), 3),
            (v(!0), g(G, null, Q(P.value, (oe) => (v(), g("div", {
              key: `${oe.value}-${oe.style}`,
              class: j(["label-tag", {
                "label-tag--primary": oe.style === "primary",
                "label-tag--secondary": oe.style === "secondary" || oe.style === "hue" && oe.hue === void 0,
                "label-tag--tertiary": oe.style === "tertiary",
                "label-tag--hue": oe.style === "hue" && !!oe.hue
              }]),
              style: xe(oe.hue ? `--color-hue: ${oe.style}` : ""),
              title: oe.title
            }, S(oe.value), 15, D3))), 128))
          ], 40, N3))
        ], 2),
        typeof e.node.children == "object" && e.node.children.length === 0 && o.value ? (v(), g("div", E3, [
          z(Wr, {
            depth: (e.depth || 0) + 1
          }, null, 8, ["depth"]),
          L[5] || (L[5] = w("div", { class: "tree-node__empty-label" }, "Empty", -1))
        ])) : I("", !0),
        o.value ? (v(!0), g(G, { key: 1 }, Q(u.value, (oe) => (v(), Z(J, {
          key: oe.id,
          node: oe,
          depth: (e.depth || 0) + 1,
          state: e.state,
          "root-nodes": e.rootNodes,
          "get-drop-target": e.getDropTarget,
          parent: e.node,
          "clickable-parents": e.clickableParents,
          onMove: L[2] || (L[2] = (O, H) => r("move", O, H)),
          sort: e.sort
        }, null, 8, ["node", "depth", "state", "root-nodes", "get-drop-target", "parent", "clickable-parents", "sort"]))), 128)) : I("", !0)
      ], 10, C3)), [
        [ie, e.node.contextMenu]
      ]);
    };
  }
}), Hm = /* @__PURE__ */ K({
  __name: "Tree",
  props: {
    cacheKey: {},
    nodes: {},
    getDropTarget: {},
    clickableParents: { type: Boolean },
    sort: { default: "az" }
  },
  emits: ["move"],
  setup(e, { expose: n, emit: t }) {
    const r = e;
    n({
      rename: i
    });
    const a = t, o = Zn({
      expandedNodes: []
    }), l = `tree__${r.cacheKey}__expanded`;
    localStorage.getItem(l) && (o.expandedNodes = JSON.parse(localStorage.getItem(l) || "[]")), re(() => o.expandedNodes, () => {
      localStorage.setItem(l, JSON.stringify(o.expandedNodes));
    }, { deep: !0 });
    function i(s) {
      if (typeof s == "string") {
        o.renaming = s;
        return;
      }
      o.renaming = s.id;
    }
    return (s, u) => (v(), g("div", {
      class: j(["tree", {
        "tree--dragging": o.isDragging,
        "tree--not-dragging": !o.isDragging
      }])
    }, [
      (v(!0), g(G, null, Q(e.nodes, (c) => (v(), Z(T3, {
        key: c.id,
        node: c,
        state: o,
        "root-nodes": e.nodes,
        "get-drop-target": e.getDropTarget,
        onMove: (f, d) => a("move", f, d),
        "clickable-parents": e.clickableParents ?? !1,
        sort: e.sort
      }, null, 8, ["node", "state", "root-nodes", "get-drop-target", "onMove", "clickable-parents", "sort"]))), 128))
    ], 2));
  }
}), S3 = { ref: "draggable" }, Gm = /* @__PURE__ */ K({
  __name: "Draggable",
  props: {
    type: {},
    data: {},
    metadata: {},
    handleSelector: {},
    allowDrag: { type: Boolean },
    mode: {}
  },
  emits: ["dropped"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = At(), o = Ge("draggable");
    let l;
    we(() => {
      if (!o.value) {
        console.error("Could not find draggable element. This should not happen.");
        return;
      }
      t.handleSelector && (l = o.value.querySelector(t.handleSelector)), l || (l = o.value), window.addEventListener("pointerdown", i);
    }), Ze(() => {
      window.removeEventListener("pointerdown", i);
    });
    function i(s) {
      !t.allowDrag || !s.target || !l || !l.contains(s.target) || (s.stopPropagation(), s.preventDefault(), s.stopImmediatePropagation(), a.startDrag({
        type: t.type,
        data: t.data,
        metadata: t.metadata,
        sourceElement: o.value,
        onDrop(u) {
          r("dropped", u);
        },
        mode: t.mode
      }));
    }
    return (s, u) => (v(), g("div", S3, [
      ce(s.$slots, "default")
    ], 512));
  }
}), M3 = {
  ref: "draggable",
  class: "draggable"
}, P3 = /* @__PURE__ */ K({
  __name: "DraggableListItem",
  props: {
    type: {},
    data: {},
    metadata: {},
    handleSelector: {},
    mode: {}
  },
  emits: ["dropped", "dropBefore", "dropAfter"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = At(), o = Ge("draggable");
    let l;
    we(() => {
      if (!o.value) {
        console.error("Could not find draggable element. This should not happen.");
        return;
      }
      t.handleSelector && (l = o.value.querySelector(t.handleSelector)), l || (l = o.value), window.addEventListener("pointerdown", i);
    }), Ze(() => {
      window.removeEventListener("pointerdown", i);
    });
    function i(c) {
      !c.target || !l || !l.contains(c.target) || (c.stopPropagation(), c.preventDefault(), c.stopImmediatePropagation(), a.startDrag({
        type: t.type,
        data: t.data,
        metadata: t.metadata,
        sourceElement: o.value,
        onDrop(f) {
          r("dropped", f);
        },
        mode: t.mode
      }));
    }
    function s(c) {
      r("dropBefore", c);
    }
    function u(c) {
      r("dropAfter", c);
    }
    return (c, f) => (v(), g("div", M3, [
      z(rn, {
        accepts: t.type,
        drop: s,
        class: "drop-zone-before",
        onDrop: s
      }, null, 8, ["accepts"]),
      ce(c.$slots, "default", {}, void 0, !0),
      z(rn, {
        accepts: t.type,
        drop: u,
        class: "drop-zone-after",
        onDrop: u
      }, null, 8, ["accepts"])
    ], 512));
  }
}), Um = /* @__PURE__ */ Y(P3, [["__scopeId", "data-v-fa1e8c2f"]]), I3 = {
  key: 0,
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "436 474 20.506 15.556",
  style: { "-webkit-print-color-adjust": "exact" },
  fill: "none",
  version: "1.1",
  class: "dropdown-checkbox__checkmark"
}, F3 = { class: "dropdown-checkbox__label" }, Wm = /* @__PURE__ */ K({
  __name: "DropdownCheckbox",
  props: /* @__PURE__ */ De({
    closeOnClick: { type: Boolean }
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ De(["click"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, r = Me(e, "modelValue"), a = n;
    function o(l) {
      t.closeOnClick || l(), r.value = !r.value, a("click");
    }
    return (l, i) => (v(), Z(Ie, {
      class: "dropdown-checkbox",
      onClick: o
    }, {
      default: le(() => [
        r.value ? (v(), g("svg", I3, [...i[0] || (i[0] = [
          w("g", { id: "shape-3f758990-e504-8035-8002-756125698a49" }, [
            w("g", {
              class: "fills",
              id: "fills-3f758990-e504-8035-8002-756125698a49"
            }, [
              w("path", {
                rx: "0",
                ry: "0",
                d: "M456.506,476.828L453.678,474.000L443.778,483.900L438.828,478.950L436.000,481.778L443.778,489.556L456.506,476.828ZL456.506,476.828Z",
                style: { fill: "currentColor" }
              })
            ])
          ], -1)
        ])])) : I("", !0),
        w("div", F3, [
          ce(l.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), A3 = {
  key: 0,
  class: "dropdown-group"
}, Zm = /* @__PURE__ */ K({
  __name: "DropdownGroup",
  props: {
    title: {}
  },
  setup(e) {
    return (n, t) => (v(), g(G, null, [
      e.title ? (v(), g("li", A3, S(e.title), 1)) : I("", !0),
      ce(n.$slots, "default")
    ], 64));
  }
}), L3 = { class: "tab-panel" }, R3 = ["onClick"], O3 = { class: "tab-label" }, B3 = { class: "collapsed-selector" }, V3 = { class: "tab-label" }, K3 = { class: "content" }, H3 = /* @__PURE__ */ K({
  __name: "TabPanel",
  props: /* @__PURE__ */ De({
    tabs: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = Me(e, "modelValue"), r = N(), a = N(null), o = N(), l = N(!1);
    let i;
    const s = D(() => n.tabs.find(($) => $.id === t.value) ?? n.tabs[0]);
    we(() => {
      typeof ResizeObserver < "u" && (i = new ResizeObserver(c)), c(), r.value && i && i.observe(r.value);
    }), lt(() => {
      i == null || i.disconnect();
    }), re(
      () => n.tabs,
      () => {
        u(), He(c);
      },
      {
        deep: !0,
        immediate: !0
      }
    ), re(
      () => t.value,
      () => {
        u();
      }
    ), re(l, ($) => {
      var y;
      !$ && ((y = o.value) != null && y.isOpen()) && o.value.close();
    });
    function u() {
      if (n.tabs.length === 0)
        return;
      n.tabs.some((y) => y.id === t.value) || (t.value = n.tabs[0].id);
    }
    function c() {
      if (!r.value)
        return;
      const $ = r.value.scrollWidth, y = r.value.getBoundingClientRect().width;
      l.value = Math.round(y) < Math.round($);
    }
    function f($) {
      t.value = $;
    }
    function d($) {
      return ee($.label);
    }
    function m() {
      var $, y;
      if (($ = o.value) != null && $.isOpen()) {
        o.value.close();
        return;
      }
      (y = o.value) == null || y.open();
    }
    return ($, y) => {
      var p;
      return v(), g("div", L3, [
        w("div", {
          class: j(["bar", {
            "bar--collapsed": l.value
          }])
        }, [
          w("div", {
            ref_key: "itemsElement",
            ref: r,
            class: "items"
          }, [
            (v(!0), g(G, null, Q(e.tabs, (h) => (v(), g("button", {
              key: h.id,
              class: j(["tab btn-reset", {
                "tab--selected": h.id === t.value
              }]),
              type: "button",
              onClick: (b) => f(h.id)
            }, [
              w("span", O3, S(d(h)), 1),
              h.tags ? (v(), Z(xt, {
                key: 0,
                tags: h.tags
              }, null, 8, ["tags"])) : I("", !0)
            ], 10, R3))), 128))
          ], 512),
          w("div", B3, [
            w("button", {
              ref_key: "collapsedMenuTarget",
              ref: a,
              class: "tab tab--selected collapsed-trigger btn-reset",
              type: "button",
              onClick: m
            }, [
              w("span", null, [
                w("span", V3, S(s.value ? d(s.value) : ""), 1),
                (p = s.value) != null && p.tags ? (v(), Z(xt, {
                  key: 0,
                  tags: s.value.tags
                }, null, 8, ["tags"])) : I("", !0)
              ]),
              z(Le, {
                name: "chevron",
                class: "tab-chevron"
              })
            ], 512),
            z(je, {
              ref_key: "collapsedMenu",
              ref: o,
              target: a.value ?? void 0
            }, {
              default: le(() => [
                (v(!0), g(G, null, Q(e.tabs, (h) => (v(), Z(Ie, {
                  key: h.id,
                  onClick: (b) => f(h.id)
                }, {
                  default: le(() => [
                    w("span", null, S(d(h)), 1),
                    h.tags ? (v(), Z(xt, {
                      key: 0,
                      tags: h.tags
                    }, null, 8, ["tags"])) : I("", !0)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))), 128))
              ]),
              _: 1
            }, 8, ["target"])
          ])
        ], 2),
        w("div", K3, [
          (v(!0), g(G, null, Q(e.tabs, (h) => be((v(), Z(tt(h.component), et({
            key: h.id
          }, { ref_for: !0 }, h.props, { class: "content-item" }), null, 16)), [
            [qo, h.id === t.value]
          ])), 128))
        ])
      ]);
    };
  }
}), zm = /* @__PURE__ */ Y(H3, [["__scopeId", "data-v-d636dfb4"]]), Fo = Symbol("selectedTab"), G3 = { class: "tab-bar" }, U3 = { class: "tab-bar__actions" }, W3 = { class: "tab-bar__items neat-scroll" }, Z3 = { class: "tab-bar__filler" }, jm = /* @__PURE__ */ K({
  __name: "TabBar",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = N(t.modelValue);
    return re(() => t.modelValue, () => {
      a.value = t.modelValue;
    }), Nt(Fo, a), re(a, () => {
      r("update:modelValue", a.value);
    }), (o, l) => (v(), g("div", G3, [
      w("div", U3, [
        ce(o.$slots, "actions")
      ]),
      w("div", W3, [
        ce(o.$slots, "default")
      ]),
      w("div", Z3, [
        ce(o.$slots, "filler")
      ])
    ]));
  }
}), z3 = { class: "tab__label" }, j3 = {
  key: 0,
  class: "tab__count"
}, Ym = /* @__PURE__ */ K({
  __name: "TabItem",
  props: {
    label: {},
    count: {},
    value: {},
    onClose: {}
  },
  emits: ["close"],
  setup(e, { emit: n }) {
    const t = e, r = n, a = Dt(), o = Pt(Fo, N("")), l = D(() => o.value === t.value), i = D(() => typeof t.onClose < "u"), s = N(), u = N({ x: 0, y: 0 });
    function c(m) {
      o.value = t.value;
    }
    function f(m) {
      var $;
      a.default && (m.stopPropagation(), m.preventDefault(), u.value.x = m.clientX, u.value.y = m.clientY, ($ = s.value) == null || $.open());
    }
    function d(m) {
      m.button === 1 && i.value && (m.stopPropagation(), m.preventDefault(), r("close"));
    }
    return (m, $) => (v(), g(G, null, [
      w("div", et(m.$attrs, {
        onClick: c,
        onAuxclick: d,
        onContextmenu: f,
        class: {
          tab: !0,
          "tab--selected": l.value,
          "tab--with-close": i.value
        }
      }), [
        ce(m.$slots, "content", {}, () => [
          w("span", z3, S(e.label), 1),
          e.count ? (v(), g("span", j3, S(e.count), 1)) : I("", !0)
        ]),
        i.value ? (v(), g("div", {
          key: 0,
          class: "tab__close",
          onClick: $[0] || ($[0] = Ee(() => r("close"), ["stop", "prevent"]))
        }, [
          z(yt)
        ])) : I("", !0)
      ], 16),
      ee(a).default ? (v(), Z(je, {
        key: 0,
        ref_key: "contextMenu",
        ref: s,
        target: u.value
      }, {
        default: le(() => [
          ce(m.$slots, "default")
        ]),
        _: 3
      }, 8, ["target"])) : I("", !0)
    ], 64));
  }
}), Y3 = { class: "context-menu-app__section" }, q3 = ["onClick"], X3 = { class: "context-menu-app__item-label" }, J3 = {
  key: 1,
  class: "context-menu-app__item-shortcut"
}, Q3 = /* @__PURE__ */ K({
  __name: "ContextMenuApp",
  setup(e) {
    const n = Pt("state", N({})), t = N(), r = N({});
    let a = !1;
    re(n, () => {
      var d;
      n.value.isOpen ? (a = !1, r.value = {}, t.value.showModal(), He(() => {
        const m = t.value.getBoundingClientRect();
        n.value.x + m.width > window.innerWidth ? r.value.left = `${Math.max(16, n.value.x - m.width)}px` : r.value.left = `${n.value.x}px`, n.value.pointerType === "touch" ? r.value.top = `${Math.max(0, n.value.y - m.height)}px` : n.value.y + m.height > window.innerHeight ? r.value.top = `${Math.max(0, n.value.y - m.height)}px` : r.value.top = `${n.value.y}px`;
      })) : ((d = t.value) == null || d.close(), document.body.classList.remove("context-menu--open"));
    }, {
      deep: !0
    });
    function o() {
      n.value.isOpen = !1;
    }
    function l(d) {
      d.pointerType !== "touch" && (n.value.isOpen = !1, He(() => {
        const m = document.elementFromPoint(d.clientX, d.clientY);
        m == null || m.dispatchEvent(new MouseEvent("mousedown", {
          bubbles: !0,
          cancelable: !0,
          clientX: d.clientX,
          clientY: d.clientY,
          button: 2
        })), m == null || m.dispatchEvent(new MouseEvent("contextmenu", {
          bubbles: !0,
          cancelable: !0,
          clientX: d.clientX,
          clientY: d.clientY
        }));
      }));
    }
    let i = N();
    function s(d) {
      var m;
      d.preventDefault(), d.stopPropagation(), i.value = d.currentTarget, (m = i.value) == null || m.classList.add("context-menu-app__item--touching");
    }
    function u(d) {
      var $, y;
      if (i.value === void 0)
        return;
      d.preventDefault(), d.stopPropagation();
      let m = document.elementFromPoint(d.touches[0].clientX, d.touches[0].clientY);
      m.classList.contains("context-menu-app__item") || (m = m.closest(".context-menu-app__item")), m !== i.value && (m != null && m.classList.contains("context-menu-app__item")) && (($ = i.value) == null || $.classList.remove("context-menu-app__item--touching"), i.value = m, (y = i.value) == null || y.classList.add("context-menu-app__item--touching"));
    }
    function c(d) {
      var $;
      if (d.pointerType !== "touch")
        return;
      d.preventDefault(), d.stopPropagation();
      let m = document.elementFromPoint(d.clientX, d.clientY);
      m.classList.contains("context-menu-app__item") || (m = m.closest(".context-menu-app__item")), ($ = i.value) == null || $.classList.remove("context-menu-app__item--touching"), i.value = void 0, m != null && m.classList.contains("context-menu-app__item") && m.click();
    }
    function f(d) {
      a || d.action === void 0 || d.disabled || (a = !0, d.action());
    }
    return (d, m) => (v(), g("dialog", {
      ref_key: "menuElem",
      ref: t,
      onClick: Ee(o, ["stop"]),
      onContextmenu: Ee(l, ["stop", "prevent"]),
      onTouchmove: u,
      onPointerup: c,
      class: j(["context-menu-app neat-scroll", {
        "context-menu-app--touch": ee(n).pointerType === "touch"
      }]),
      style: xe(r.value)
    }, [
      (v(!0), g(G, null, Q(ee(n).sections, ($) => (v(), g("div", Y3, [
        (v(!0), g(G, null, Q($, (y) => (v(), g("div", {
          onClick: (p) => f(y),
          onTouchstart: s,
          class: j(["context-menu-app__item", {
            "context-menu-app__item--disabled": y.disabled
          }])
        }, [
          y.checked ? (v(), Z(Io, {
            key: 0,
            class: "context-menu-app__item-icon"
          })) : I("", !0),
          w("span", X3, S(y.label), 1),
          y.shortcut ? (v(), g("span", J3, S(y.shortcut), 1)) : I("", !0),
          y.icon ? (v(), Z(ee(Le), {
            key: 2,
            name: y.icon,
            class: "context-menu-app__item-icon"
          }, null, 8, ["name"])) : I("", !0)
        ], 42, q3))), 256))
      ]))), 256))
    ], 38));
  }
});
if (typeof window < "u" && window.__contextMenu === void 0) {
  let e = function(i) {
    const s = [];
    for (const u of i) {
      if (!(u instanceof HTMLElement) || !u.dataset.contextMenu)
        continue;
      const c = u.dataset.contextMenu, f = window.__contextMenues.get(c);
      if (f)
        for (const d of f) {
          const m = d.filter(($) => !$.hidden || $.hidden && o);
          m.length != 0 && (d.key ? (m.key = d.key, s.find(($) => $.key === d.key) || s.push(m)) : s.push(m));
        }
    }
    return s;
  }, n = function(i, s, u, c, f) {
    document.body.classList.add("context-menu--open"), a.value = {
      x: s,
      y: u,
      isOpen: !0,
      sections: c,
      pointerType: f
    };
  };
  window.__contextMenu = !0;
  const t = document.createElement("div");
  t.style.position = "fixed", t.style.top = "0", t.style.left = "0", t.style.width = "0", t.style.height = "0", document.body.appendChild(t);
  const r = Xo(Q3), a = N({
    x: 0,
    y: 0,
    isOpen: !1,
    sections: [],
    pointerType: "mouse"
  });
  r.provide("state", a), r.mount(t);
  let o = !1;
  window.addEventListener("keydown", (i) => {
    i.key === "Shift" && (o = !0);
  }), window.addEventListener("keyup", (i) => {
    i.key === "Shift" && (o = !1);
  }), window.addEventListener("contextmenu", (i) => {
    const s = e(i.composedPath());
    s.length !== 0 && (i.preventDefault(), i.stopPropagation(), !(i instanceof PointerEvent && i.pointerType === "touch") && n(i.target, i.clientX, i.clientY, s, "mouse"));
  });
  let l;
  window.addEventListener("pointerdown", (i) => {
    if (i.pointerType === "touch") {
      const s = e(i.composedPath());
      if (s.length === 0)
        return;
      i.preventDefault(), i.stopPropagation(), i.stopImmediatePropagation(), l && clearTimeout(l), l = setTimeout(() => {
        n(i.target, i.clientX, i.clientY, s, "touch"), i.target.dispatchEvent(new PointerEvent("contextmenu", i));
      }, 500);
    }
  }), window.addEventListener("pointermove", (i) => {
    i.pointerType === "touch" && l && (i.preventDefault(), i.stopPropagation(), i.stopImmediatePropagation(), clearTimeout(l), l = void 0);
  }), window.addEventListener("pointerup", (i) => {
    i.pointerType === "touch" && l && (i.preventDefault(), i.stopPropagation(), i.stopImmediatePropagation(), clearTimeout(l), l = void 0);
  });
}
function em() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
let tm = 0;
const nm = {
  deep: !0,
  mounted(e, n) {
    if (!window)
      return;
    window.__contextMenues || (window.__contextMenues = /* @__PURE__ */ new Map());
    const t = `c${tm++}`;
    window.__contextMenues.set(t, n.value), e.dataset.contextMenu = t, em() && (e.style.webkitUserSelect = "none", e.style.userSelect = "none");
  },
  updated(e, n) {
    const t = e.dataset.contextMenu;
    t && window.__contextMenues.set(t, n.value);
  },
  unmounted(e) {
    const n = e.dataset.contextMenu;
    n && window.__contextMenues.delete(n);
  }
};
if (typeof window < "u") {
  if (!document.documentElement.dataset.theme) {
    const e = localStorage.getItem("theme");
    e ? document.documentElement.dataset.theme = e : window.matchMedia("(prefers-color-scheme: dark)").matches ? document.documentElement.dataset.theme = "dark" : document.documentElement.dataset.theme = "light", window.addEventListener("storage", (n) => {
      n.key === "theme" && (n.newValue === "dark" ? document.documentElement.dataset.theme = "dark" : document.documentElement.dataset.theme = "light");
    });
  }
  window.setTheme = (e) => {
    if (e === "system")
      localStorage.removeItem("theme"), document.documentElement.dataset.theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    else if (e === "light" || e === "dark")
      localStorage.setItem("theme", e), document.documentElement.dataset.theme = e;
    else
      throw new Error(`Invalid theme value: ${e}`);
  };
}
const qm = {
  install: (e, n) => {
    e.directive("context-menu", nm);
  }
};
export {
  Nm as ActivityLog,
  cm as AddressEditor,
  _m as Badge,
  Dm as BarChart,
  uu as COUNTRY_CODES,
  wu as ContextMenuButton,
  fu as CountrySelect,
  Kc as DataTable,
  am as DateInput,
  ye as DateOnly,
  co as DatePicker,
  lm as DateRangeInput,
  fo as DateRangePicker,
  dm as DecimalInput,
  Gm as Draggable,
  Um as DraggableListItem,
  rn as DropZone,
  dt as DropdownButton,
  Wm as DropdownCheckbox,
  lr as DropdownDivider,
  Zm as DropdownGroup,
  Ie as DropdownItem,
  je as DropdownMenu,
  um as ElasticInput,
  Cm as EnumsBar,
  gm as Expandable,
  bm as ExternalLink,
  vm as FloatingPanel,
  Tm as Form,
  Lm as FormDescription,
  Om as FormError,
  Im as FormField,
  Am as FormFieldContent,
  Sm as FormFieldSet,
  Pm as FormGroup,
  Fm as FormLabel,
  Mm as FormLegend,
  Rm as FormSeparator,
  Le as Icon,
  Jn as IconArrow,
  Qn as IconArrows,
  Io as IconCheck,
  gt as IconChevron,
  yt as IconClose,
  Eo as IconFilter,
  A2 as IconHamburger,
  $2 as IconInbound,
  c2 as IconOutbound,
  hn as IconPlus,
  y2 as IconQuestion,
  D2 as IconRedo,
  k2 as IconReload,
  G2 as IconSquare,
  z2 as IconSquareSplitHorizontal,
  X2 as IconSquareSplitVertical,
  M2 as IconUndo,
  B2 as IconWarning,
  hm as InlineInput,
  Vm as InspectorLayout,
  im as InstantInput,
  mo as InstantPicker,
  sm as InstantRangeInput,
  vo as InstantRangePicker,
  xt as LabelTags,
  Em as LineChart,
  Km as ListDetailLayout,
  fm as ListLink,
  wm as LoadingArea,
  B1 as NavigationBar,
  mm as Panel,
  $m as PanelContent,
  su as PhoneInput,
  ir as ROLLING_PRESETS,
  Iu as RadioButton,
  pm as RemoveButton,
  U1 as RenderedMessage,
  Bm as SidebarLayout,
  Hn as Spinner,
  xm as Spreadsheet,
  jm as TabBar,
  Ym as TabItem,
  zm as TabPanel,
  Ve as TextInput,
  ym as ToggleButton,
  nn as ToggleSwitch,
  t3 as Toolbar,
  Hm as Tree,
  Gc as clearCellError,
  km as createChangeset,
  qm as default,
  Kt as formatRolling,
  Hc as getCellChange,
  Vl as isSameRollingSpan,
  Hl as parseRollingText,
  Bl as resolveRolling,
  sr as rollingRange,
  Gt as setCellChange,
  En as setCellError,
  oa as useClose,
  At as useDragContext,
  Qo as useForm,
  ln as useFormField,
  vu as validatePostalCode
};
